import _objectDestructuringEmpty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["scope", "children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["scope", "children"],
  _excluded5 = ["asChild"],
  _excluded6 = ["__scopeCollapsible", "open", "defaultOpen", "disabled", "onOpenChange"],
  _excluded7 = ["__scopeCollapsible"],
  _excluded8 = ["forceMount"],
  _excluded9 = ["__scopeCollapsible", "present", "children"],
  _excluded10 = ["type"],
  _excluded11 = ["value", "defaultValue", "onValueChange", "collapsible"],
  _excluded12 = ["value", "defaultValue", "onValueChange"],
  _excluded13 = ["__scopeAccordion", "disabled", "dir", "orientation"],
  _excluded14 = ["__scopeAccordion", "value"],
  _excluded15 = ["__scopeAccordion"],
  _excluded16 = ["__scopeAccordion"],
  _excluded17 = ["__scopeAccordion"],
  _excluded18 = ["className", "contrast", "sentiment"],
  _excluded19 = ["children", "className", "as", "maxHeight"],
  _excluded20 = ["children", "className", "as"],
  _excluded21 = ["as", "className", "color", "size"],
  _excluded22 = ["children", "as", "size", "className"],
  _excluded23 = ["children"],
  _excluded24 = ["className"],
  _excluded25 = ["children", "className"],
  _excluded26 = ["as", "children", "className"],
  _excluded27 = ["as", "children", "className", "border"],
  _excluded28 = ["children"],
  _excluded29 = ["as", "borderColor", "borderRadius", "bgColor", "children", "className", "display", "height", "padding", "style", "width"],
  _excluded30 = ["src", "size", "className"],
  _excluded31 = ["className", "type", "disabled", "icon", "size", "variant"],
  _excluded32 = ["as", "onClick", "icon", "className"],
  _excluded33 = ["as", "children", "className", "color", "size", "variant", "wrap"],
  _excluded34 = ["className", "icon", "children", "disabled", "color"],
  _excluded35 = ["as", "children", "className", "disabled", "href", "variant"],
  _excluded36 = ["children", "onEdit", "className"],
  _excluded37 = ["className", "size"],
  _excluded38 = ["className"],
  _excluded39 = ["as", "variant", "size", "children", "className", "disabled", "type", "loading"],
  _excluded40 = ["children", "as", "size", "variant"],
  _excluded41 = ["as", "variant", "children", "className"],
  _excluded42 = ["as", "children", "onBlur", "onChange", "onInvalid"],
  _excluded43 = ["className"],
  _excluded44 = ["className", "disabled", "id", "indeterminate"],
  _excluded45 = ["pressed", "defaultPressed", "onPressedChange"],
  _excluded46 = ["as", "children", "className", "disabled", "size", "trailingIcon", "pressed"],
  _excluded47 = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"],
  _excluded48 = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"],
  _excluded49 = ["container"],
  _excluded50 = ["__scopeDialog"],
  _excluded51 = ["forceMount"],
  _excluded52 = ["__scopeDialog"],
  _excluded53 = ["forceMount"],
  _excluded54 = ["__scopeDialog", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus"],
  _excluded55 = ["__scopeDialog"],
  _excluded56 = ["__scopeDialog"],
  _excluded57 = ["as", "children"],
  _excluded58 = ["align", "center", "children", "direction", "flex", "gap", "inline", "justify", "placeSelf", "style", "wrap"],
  _excluded59 = ["children"],
  _excluded60 = ["children", "className", "as"],
  _excluded61 = ["children", "as"],
  _excluded62 = ["children"],
  _excluded63 = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
  _excluded64 = ["strategy"],
  _excluded65 = ["mainAxis", "crossAxis", "limiter"],
  _excluded66 = ["apply"],
  _excluded67 = ["children", "width", "height"],
  _excluded68 = ["__scopePopper", "virtualRef"],
  _excluded69 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "avoidCollisions", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "updatePositionStrategy", "onPlaced"],
  _excluded70 = ["__scopePopper"],
  _excluded71 = ["__scopePopover"],
  _excluded72 = ["__scopePopover"],
  _excluded73 = ["forceMount"],
  _excluded74 = ["__scopePopover", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus", "disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside"],
  _excluded75 = ["__scopePopover"],
  _excluded76 = ["__scopePopover"],
  _excluded77 = ["children", "className", "endAligned", "size"],
  _excluded78 = ["className", "disabled", "id"],
  _excluded79 = ["resize", "size", "className", "disabled", "id"],
  _excluded80 = ["as", "color", "type", "className", "style"],
  _excluded81 = ["type"],
  _excluded82 = ["type"],
  _excluded83 = ["type"],
  _excluded84 = ["type"],
  _excluded85 = ["type"],
  _excluded86 = ["type"],
  _excluded87 = ["type"],
  _excluded88 = ["value", "setValue", "min", "max", "placeholder", "className", "onFinish", "onFocus", "translations"],
  _excluded89 = ["__scopeRovingFocusGroup", "orientation", "loop", "dir", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus"],
  _excluded90 = ["__scopeRovingFocusGroup", "focusable", "active", "tabStopId"],
  _excluded91 = ["type"],
  _excluded92 = ["value", "defaultValue", "onValueChange"],
  _excluded93 = ["value", "defaultValue", "onValueChange"],
  _excluded94 = ["__scopeToggleGroup", "disabled", "rovingFocus", "orientation", "dir", "loop"],
  _excluded95 = ["__scopeToggleGroup", "value"],
  _excluded96 = ["children", "as", "className"],
  _excluded97 = ["children", "onValueChange", "value", "defaultValue", "size"],
  _excluded98 = ["className", "value", "onChange", "hourCycle", "translations"],
  _excluded99 = ["className", "style", "dayPickerProps", "defaultValue", "disabled", "inputFormat", "max", "min", "onBlur", "onChange", "onFocus", "outputFormat", "placeholder", "popoverClassName", "range", "rangePresets", "size", "translations", "time", "timezone", "value", "hourCycle"],
  _excluded100 = ["as", "children", "className"],
  _excluded101 = ["accentColor", "as", "children", "className", "closeLabel", "size", "style", "minHeight", "hideCloseIcon", "radixProps"],
  _excluded102 = ["as", "children", "className"],
  _excluded103 = ["as", "children", "className"],
  _excluded104 = ["children", "className"],
  _excluded105 = ["as", "className", "children"],
  _excluded106 = ["as", "variant", "style", "color", "className", "children"],
  _excluded107 = ["as", "className", "children"],
  _excluded108 = ["as", "className", "children"],
  _excluded109 = ["children"],
  _excluded110 = ["row", "className"],
  _excluded111 = ["children", "className", "disabled", "onChange", "onInvalid", "onReset", "onSubmit"],
  _excluded112 = ["areas", "center", "children", "cols", "gap", "grid", "placeContent", "placeItems", "rows", "style", "width"],
  _excluded113 = ["children", "onChange", "value", "onInputChange", "inputValue", "defaultValue", "disabled", "className"],
  _excluded114 = ["children", "className"],
  _excluded115 = ["placeholder", "renderTag"],
  _excluded116 = ["children", "className", "htmlFor"],
  _excluded117 = ["children", "className"],
  _excluded118 = ["as", "children", "className", "disabled", "href", "color", "size", "variant"],
  _excluded119 = ["className"],
  _excluded120 = ["as", "className", "children", "direction"],
  _excluded121 = ["as", "children", "className"],
  _excluded122 = ["as", "children", "className", "disabled"],
  _excluded123 = ["__scopeMenu"],
  _excluded124 = ["forceMount"],
  _excluded125 = ["__scopeMenu", "loop", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus", "disableOutsidePointerEvents", "onEntryFocus", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss", "disableOutsideScroll"],
  _excluded126 = ["disabled", "onSelect"],
  _excluded127 = ["__scopeMenu", "disabled", "textValue"],
  _excluded128 = ["__scopeDropdownMenu", "disabled"],
  _excluded129 = ["__scopeDropdownMenu"],
  _excluded130 = ["__scopeDropdownMenu"],
  _excluded131 = ["__scopeDropdownMenu"],
  _excluded132 = ["align", "children", "className", "alignOffset", "sideOffset", "collisionPadding"],
  _excluded133 = ["children", "className", "onSelect", "textValue", "disabled"],
  _excluded134 = ["as", "children", "className"],
  _excluded135 = ["children"],
  _excluded136 = ["children", "className", "flow"],
  _excluded137 = ["children", "className", "onDismiss", "sentiment", "size"],
  _excluded138 = ["className", "type", "page", "selected", "as"],
  _excluded139 = ["className", "children"],
  _excluded140 = ["children", "className", "centered"],
  _excluded141 = ["as", "className", "children", "containerClassName", "containerFlexDirection"],
  _excluded142 = ["className", "children"],
  _excluded143 = ["children", "className", "persistent", "autoClose", "as", "border"],
  _excluded144 = ["as", "className", "children"],
  _excluded145 = ["as", "variant", "style", "color", "className", "children", "disableClose"],
  _excluded146 = ["as", "className", "children"],
  _excluded147 = ["as", "className", "children"],
  _excluded148 = ["as", "className"],
  _excluded149 = ["children"],
  _excluded150 = ["as", "children"],
  _excluded151 = ["children", "className", "portal", "showArrow", "sideOffset", "size"],
  _excluded152 = ["className", "children"],
  _excluded153 = ["className", "children", "close"],
  _excluded154 = ["as", "className", "children"],
  _excluded155 = ["__scopeProgress", "value", "max", "getValueLabel"],
  _excluded156 = ["__scopeProgress"],
  _excluded157 = ["className", "value", "max", "indicatorColor", "style"],
  _excluded158 = ["className", "disabled", "id"],
  _excluded159 = ["children"],
  _excluded160 = ["className", "size", "variant", "clearProps"],
  _excluded161 = ["className", "children", "collisionPadding", "lockWidthToAnchor"],
  _excluded162 = ["as", "children", "className", "context", "options", "type"],
  _excluded163 = ["children", "className"],
  _excluded164 = ["children", "className"],
  _excluded165 = ["maxHeight", "maxWidth", "className", "itemClassName"],
  _excluded166 = ["className"],
  _excluded167 = ["size", "className", "placeholder"],
  _excluded168 = ["className", "placeholder", "size", "type"],
  _excluded169 = ["valueToString", "options", "searchFilter"],
  _excluded170 = ["className", "noHover", "children"],
  _excluded171 = ["children", "disabled", "labelToNode", "renderTag"],
  _excluded172 = ["as", "children", "className"],
  _excluded173 = ["as", "children", "className", "label"],
  _excluded174 = ["as", "className"],
  _excluded175 = ["active", "as", "className", "children", "disabled", "href"],
  _excluded176 = ["className", "onClick", "ariaLabelFloating", "ariaLabelLocked"],
  _excluded177 = ["as", "avatar", "avatarBgColor", "children", "className", "company", "name"],
  _excluded178 = ["as", "className"],
  _excluded179 = ["as", "icon", "alwaysShow", "onClick"],
  _excluded180 = ["children", "size", "center", "className", "style"],
  _excluded181 = ["children", "className", "sentiment"],
  _excluded182 = ["children", "className", "columnSpan"],
  _excluded183 = ["children", "className"],
  _excluded184 = ["children", "className"],
  _excluded185 = ["children", "className", "gap", "columns", "minWidth", "vertical", "list", "noBorder"],
  _excluded186 = ["children"],
  _excluded187 = ["children"],
  _excluded188 = ["__scopeSwitch", "name", "checked", "defaultChecked", "required", "disabled", "value", "onCheckedChange"],
  _excluded189 = ["__scopeSwitch"],
  _excluded190 = ["control", "checked", "bubbles"],
  _excluded191 = ["checked", "className", "size"],
  _excluded192 = ["checked", "children", "className", "disabled", "onChange", "size"],
  _excluded193 = ["children", "labelPlacement", "onChange", "size"],
  _excluded194 = ["children", "as", "className", "align"],
  _excluded195 = ["width", "children", "className", "align", "as", "sentiment", "style"],
  _excluded196 = ["className", "checkboxProps"],
  _excluded197 = ["children", "as", "className", "align"],
  _excluded198 = ["children", "as", "align", "className"],
  _excluded199 = ["children", "as", "className"],
  _excluded200 = ["children", "className", "align", "sticky", "noBorder", "interactive", "as", "hover", "tableLayout", "style"],
  _excluded201 = ["as", "children", "className", "isSelected"],
  _excluded202 = ["__scopeTabs", "value", "onValueChange", "defaultValue", "orientation", "dir", "activationMode"],
  _excluded203 = ["__scopeTabs", "loop"],
  _excluded204 = ["__scopeTabs", "value", "disabled"],
  _excluded205 = ["__scopeTabs", "value", "forceMount", "children"],
  _excluded206 = ["as", "value"],
  _excluded207 = ["as", "className", "value"],
  _excluded208 = ["children", "label"],
  _excluded209 = ["as", "className"],
  _excluded210 = ["as", "className", "defaultValue", "onValueChange", "size", "value", "noGap"],
  _excluded211 = ["children", "defaultTab"],
  _excluded212 = ["__scopeToast", "hotkey", "label"],
  _excluded213 = ["__scopeToast", "onFocusFromOutsideViewport"],
  _excluded214 = ["forceMount", "open", "defaultOpen", "onOpenChange"],
  _excluded215 = ["__scopeToast", "type", "duration", "open", "onClose", "onEscapeKeyDown", "onPause", "onResume", "onSwipeStart", "onSwipeMove", "onSwipeCancel", "onSwipeEnd"],
  _excluded216 = ["__scopeToast", "children"],
  _excluded217 = ["__scopeToast"],
  _excluded218 = ["__scopeToast"],
  _excluded219 = ["altText"],
  _excluded220 = ["__scopeToast"],
  _excluded221 = ["__scopeToast", "altText"],
  _excluded222 = ["className"],
  _excluded223 = ["className", "children"],
  _excluded224 = ["className", "children"],
  _excluded225 = ["className"],
  _excluded226 = ["className", "children"],
  _excluded227 = ["as", "children", "className", "dismissable", "icon", "sentiment"],
  _excluded228 = ["__scopeTooltip"],
  _excluded229 = ["forceMount", "side"],
  _excluded230 = ["__scopeTooltip", "children", "aria-label", "onEscapeKeyDown", "onPointerDownOutside"],
  _excluded231 = ["__scopeTooltip"],
  _excluded232 = ["as", "children", "className", "side", "sideOffset", "mode", "portalProps"],
  _excluded233 = ["className"],
  _excluded234 = ["as", "children"],
  _excluded235 = ["children", "disabled", "delayDuration", "open"],
  _excluded236 = ["percentage", "trend", "mode", "className"],
  _excluded237 = ["as", "children", "className", "if", "sentiment"],
  _excluded238 = ["children", "as", "className"],
  _excluded239 = ["children", "as", "className"],
  _excluded240 = ["children"],
  _excluded241 = ["children", "tableProps", "header", "footer", "onItemsRendered", "itemCount"];
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as ee from "react";
import $, { createContext as he, useMemo as Ne, createElement as C, useContext as ce, useCallback as X, forwardRef as x, Children as at, isValidElement as Dr, cloneElement as va, Fragment as Wt, useRef as k, useEffect as V, useState as te, useLayoutEffect as pa, useReducer as ma, useImperativeHandle as sf, PureComponent as cf } from "react";
import * as lf from "react-dom";
import uf, { flushSync as bc, createPortal as yc } from "react-dom";
import { ChevronDown as Br, Close as Dt, ChevronRight as ha, Edit as df, Check as wc, ChevronLeft as xc, Globe as ff, Calendar as vf, ArrowRight as pf, ExclamationTriangleSolid as Ho, InfoCircleSolid as $c, CheckCircleSolid as Cc, PanelOpen as mf, PanelClose as hf, Search as gf, ChevronsLeft as bf, Menu as yf, CloseCircleSolid as wf } from "@primer-io/goat-icons";
function xf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $f(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function (r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), n;
}
var Tc = {
    exports: {}
  },
  Bn = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var es = Object.getOwnPropertySymbols,
  Cf = Object.prototype.hasOwnProperty,
  Tf = Object.prototype.propertyIsEnumerable;
function _f(e) {
  if (e == null) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function If() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
    for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(t).map(function (a) {
      return t[a];
    });
    if (r.join("") !== "0123456789") return !1;
    var o = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (a) {
      o[a] = a;
    }), Object.keys(Object.assign({}, o)).join("") === "abcdefghijklmnopqrst";
  } catch (_unused) {
    return !1;
  }
}
If();
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pf = $,
  _c = 60103;
Bn.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var ts = Symbol.for;
  _c = ts("react.element"), Bn.Fragment = ts("react.fragment");
}
var Df = Pf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  Sf = Object.prototype.hasOwnProperty,
  Ef = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function Ic(e, t, n) {
  var r,
    o = {},
    a = null,
    i = null;
  n !== void 0 && (a = "" + n), t.key !== void 0 && (a = "" + t.key), t.ref !== void 0 && (i = t.ref);
  for (r in t) Sf.call(t, r) && !Ef.hasOwnProperty(r) && (o[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) o[r] === void 0 && (o[r] = t[r]);
  return {
    $$typeof: _c,
    type: e,
    key: a,
    ref: i,
    props: o,
    _owner: Df.current
  };
}
Bn.jsx = Ic;
Bn.jsxs = Ic;
Tc.exports = Bn;
var p = Tc.exports;
function S() {
  return S = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S.apply(this, arguments);
}
function Ke(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = [];
  function r(a, i) {
    var s = /* @__PURE__ */he(i),
      c = n.length;
    n = [].concat(_toConsumableArray(n), [i]);
    function l(d) {
      var f = d.scope,
        m = d.children,
        h = _objectWithoutProperties(d, _excluded),
        v = (f == null ? void 0 : f[e][c]) || s,
        g = Ne(function () {
          return h;
        }, Object.values(h));
      return /* @__PURE__ */C(v.Provider, {
        value: g
      }, m);
    }
    function u(d, f) {
      var m = (f == null ? void 0 : f[e][c]) || s,
        h = ce(m);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error("`".concat(d, "` must be used within `").concat(a, "`"));
    }
    return l.displayName = a + "Provider", [l, u];
  }
  var o = function o() {
    var a = n.map(function (i) {
      return /* @__PURE__ */he(i);
    });
    return function (s) {
      var c = (s == null ? void 0 : s[e]) || a;
      return Ne(function () {
        return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, e, c)));
      }, [s, c]);
    };
  };
  return o.scopeName = e, [r, Of.apply(void 0, [o].concat(_toConsumableArray(t)))];
}
function Of() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  var t = e[0];
  if (e.length === 1) return t;
  var n = function n() {
    var r = e.map(function (o) {
      return {
        useScope: o(),
        scopeName: o.scopeName
      };
    });
    return function (a) {
      var i = r.reduce(function (s, _ref2) {
        var c = _ref2.useScope,
          l = _ref2.scopeName;
        var d = c(a)["__scope".concat(l)];
        return _objectSpread(_objectSpread({}, s), d);
      }, {});
      return Ne(function () {
        return _defineProperty({}, "__scope".concat(t.scopeName), i);
      }, [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Mf(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ga() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  return function (t) {
    return e.forEach(function (n) {
      return Mf(n, t);
    });
  };
}
function Ce() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }
  return X(ga.apply(void 0, e), e);
}
var qt = /* @__PURE__ */x(function (e, t) {
  var n = e.children,
    r = _objectWithoutProperties(e, _excluded2),
    o = at.toArray(n),
    a = o.find(Nf);
  if (a) {
    var i = a.props.children,
      s = o.map(function (c) {
        return c === a ? at.count(i) > 1 ? at.only(null) : /* @__PURE__ */Dr(i) ? i.props.children : null : c;
      });
    return /* @__PURE__ */C(Bo, S({}, r, {
      ref: t
    }), /* @__PURE__ */Dr(i) ? /* @__PURE__ */va(i, void 0, s) : null);
  }
  return /* @__PURE__ */C(Bo, S({}, r, {
    ref: t
  }), n);
});
qt.displayName = "Slot";
var Bo = /* @__PURE__ */x(function (e, t) {
  var n = e.children,
    r = _objectWithoutProperties(e, _excluded3);
  return /* @__PURE__ */Dr(n) ? /* @__PURE__ */va(n, _objectSpread(_objectSpread({}, kf(r, n.props)), {}, {
    ref: t ? ga(t, n.ref) : n.ref
  })) : at.count(n) > 1 ? at.only(null) : null;
});
Bo.displayName = "SlotClone";
var Pc = function Pc(_ref4) {
  var e = _ref4.children;
  return /* @__PURE__ */C(Wt, null, e);
};
function Nf(e) {
  return /* @__PURE__ */Dr(e) && e.type === Pc;
}
function kf(e, t) {
  var n = _objectSpread({}, t);
  var _loop = function _loop() {
    var o = e[r],
      a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = function () {
      a.apply(void 0, arguments), o.apply(void 0, arguments);
    } : o && (n[r] = o) : r === "style" ? n[r] = _objectSpread(_objectSpread({}, o), a) : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  };
  for (var r in t) {
    _loop();
  }
  return _objectSpread(_objectSpread({}, e), n);
}
function Vr(e) {
  var t = e + "CollectionProvider",
    _Ke = Ke(t),
    _Ke2 = _slicedToArray(_Ke, 2),
    n = _Ke2[0],
    r = _Ke2[1],
    _n2 = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    _n3 = _slicedToArray(_n2, 2),
    o = _n3[0],
    a = _n3[1],
    i = function i(m) {
      var h = m.scope,
        v = m.children,
        g = $.useRef(null),
        b = $.useRef( /* @__PURE__ */new Map()).current;
      return /* @__PURE__ */$.createElement(o, {
        scope: h,
        itemMap: b,
        collectionRef: g
      }, v);
    },
    s = e + "CollectionSlot",
    c = /* @__PURE__ */$.forwardRef(function (m, h) {
      var v = m.scope,
        g = m.children,
        b = a(s, v),
        y = Ce(h, b.collectionRef);
      return /* @__PURE__ */$.createElement(qt, {
        ref: y
      }, g);
    }),
    l = e + "CollectionItemSlot",
    u = "data-radix-collection-item",
    d = /* @__PURE__ */$.forwardRef(function (m, h) {
      var _$$createElement;
      var v = m.scope,
        g = m.children,
        b = _objectWithoutProperties(m, _excluded4),
        y = $.useRef(null),
        w = Ce(h, y),
        I = a(l, v);
      return $.useEffect(function () {
        return I.itemMap.set(y, _objectSpread({
          ref: y
        }, b)), function () {
          return void I.itemMap.delete(y);
        };
      }), /* @__PURE__ */$.createElement(qt, (_$$createElement = {}, _defineProperty(_$$createElement, u, ""), _defineProperty(_$$createElement, "ref", w), _$$createElement), g);
    });
  function f(m) {
    var h = a(e + "CollectionConsumer", m);
    return $.useCallback(function () {
      var g = h.collectionRef.current;
      if (!g) return [];
      var b = Array.from(g.querySelectorAll("[".concat(u, "]")));
      return Array.from(h.itemMap.values()).sort(function (I, P) {
        return b.indexOf(I.ref.current) - b.indexOf(P.ref.current);
      });
    }, [h.collectionRef, h.itemMap]);
  }
  return [{
    Provider: i,
    Slot: c,
    ItemSlot: d
  }, f, r];
}
function Z(e, t) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref5$checkForDefault = _ref5.checkForDefaultPrevented,
    n = _ref5$checkForDefault === void 0 ? !0 : _ref5$checkForDefault;
  return function (o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function Xe(e) {
  var t = k(e);
  return V(function () {
    t.current = e;
  }), Ne(function () {
    return function () {
      var _r2;
      var r;
      for (var _len4 = arguments.length, n = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        n[_key4] = arguments[_key4];
      }
      return (r = t.current) === null || r === void 0 ? void 0 : (_r2 = r).call.apply(_r2, [t].concat(n));
    };
  }, []);
}
function Ze(_ref6) {
  var e = _ref6.prop,
    t = _ref6.defaultProp,
    _ref6$onChange = _ref6.onChange,
    n = _ref6$onChange === void 0 ? function () {} : _ref6$onChange;
  var _Rf = Rf({
      defaultProp: t,
      onChange: n
    }),
    _Rf2 = _slicedToArray(_Rf, 2),
    r = _Rf2[0],
    o = _Rf2[1],
    a = e !== void 0,
    i = a ? e : r,
    s = Xe(n),
    c = X(function (l) {
      if (a) {
        var d = typeof l == "function" ? l(e) : l;
        d !== e && s(d);
      } else o(l);
    }, [a, e, o, s]);
  return [i, c];
}
function Rf(_ref7) {
  var e = _ref7.defaultProp,
    t = _ref7.onChange;
  var n = te(e),
    _n4 = _slicedToArray(n, 1),
    r = _n4[0],
    o = k(r),
    a = Xe(t);
  return V(function () {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
var Af = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"],
  ie = Af.reduce(function (e, t) {
    var n = /* @__PURE__ */x(function (r, o) {
      var a = r.asChild,
        i = _objectWithoutProperties(r, _excluded5),
        s = a ? qt : t;
      return V(function () {
        window[Symbol.for("radix-ui")] = !0;
      }, []), /* @__PURE__ */C(s, S({}, i, {
        ref: o
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {});
function ba(e, t) {
  e && bc(function () {
    return e.dispatchEvent(t);
  });
}
var jt = globalThis != null && globalThis.document ? pa : function () {};
function Lf(e, t) {
  return ma(function (n, r) {
    var o = t[n][r];
    return o !== null && o !== void 0 ? o : n;
  }, e);
}
var et = function et(e) {
  var t = e.present,
    n = e.children,
    r = jf(t),
    o = typeof n == "function" ? n({
      present: r.isPresent
    }) : at.only(n),
    a = Ce(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */va(o, {
    ref: a
  }) : null;
};
et.displayName = "Presence";
function jf(e) {
  var _te = te(),
    _te2 = _slicedToArray(_te, 2),
    t = _te2[0],
    n = _te2[1],
    r = k({}),
    o = k(e),
    a = k("none"),
    i = e ? "mounted" : "unmounted",
    _Lf = Lf(i, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    }),
    _Lf2 = _slicedToArray(_Lf, 2),
    s = _Lf2[0],
    c = _Lf2[1];
  return V(function () {
    var l = pr(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), jt(function () {
    var l = r.current,
      u = o.current;
    if (u !== e) {
      var f = a.current,
        m = pr(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), jt(function () {
    if (t) {
      var l = function l(d) {
          var m = pr(r.current).includes(d.animationName);
          d.target === t && m && bc(function () {
            return c("ANIMATION_END");
          });
        },
        u = function u(d) {
          d.target === t && (a.current = pr(r.current));
        };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), function () {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: X(function (l) {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function pr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
var Ff = ee["useId".toString()] || function () {};
var Wf = 0;
function it(e) {
  var _ee$useState = ee.useState(Ff()),
    _ee$useState2 = _slicedToArray(_ee$useState, 2),
    t = _ee$useState2[0],
    n = _ee$useState2[1];
  return jt(function () {
    e || n(function (r) {
      return r !== null && r !== void 0 ? r : String(Wf++);
    });
  }, [e]), e || (t ? "radix-".concat(t) : "");
}
var Dc = "Collapsible",
  _Ke3 = Ke(Dc),
  _Ke4 = _slicedToArray(_Ke3, 2),
  Hf = _Ke4[0],
  Sc = _Ke4[1],
  _Hf = Hf(Dc),
  _Hf2 = _slicedToArray(_Hf, 2),
  Bf = _Hf2[0],
  ya = _Hf2[1],
  Ec = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeCollapsible,
      r = e.open,
      o = e.defaultOpen,
      a = e.disabled,
      i = e.onOpenChange,
      s = _objectWithoutProperties(e, _excluded6),
      _Ze = Ze({
        prop: r,
        defaultProp: o,
        onChange: i
      }),
      _Ze2 = _slicedToArray(_Ze, 2),
      _Ze2$ = _Ze2[0],
      c = _Ze2$ === void 0 ? !1 : _Ze2$,
      l = _Ze2[1];
    return /* @__PURE__ */C(Bf, {
      scope: n,
      disabled: a,
      contentId: it(),
      open: c,
      onOpenToggle: X(function () {
        return l(function (u) {
          return !u;
        });
      }, [l])
    }, /* @__PURE__ */C(ie.div, S({
      "data-state": wa(c),
      "data-disabled": a ? "" : void 0
    }, s, {
      ref: t
    })));
  }),
  Vf = "CollapsibleTrigger",
  Oc = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeCollapsible,
      r = _objectWithoutProperties(e, _excluded7),
      o = ya(Vf, n);
    return /* @__PURE__ */C(ie.button, S({
      type: "button",
      "aria-controls": o.contentId,
      "aria-expanded": o.open || !1,
      "data-state": wa(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      disabled: o.disabled
    }, r, {
      ref: t,
      onClick: Z(e.onClick, o.onOpenToggle)
    }));
  }),
  Mc = "CollapsibleContent",
  Nc = /* @__PURE__ */x(function (e, t) {
    var n = e.forceMount,
      r = _objectWithoutProperties(e, _excluded8),
      o = ya(Mc, e.__scopeCollapsible);
    return /* @__PURE__ */C(et, {
      present: n || o.open
    }, function (_ref) {
      var a = _ref.present;
      return /* @__PURE__ */C(Uf, S({}, r, {
        ref: t,
        present: a
      }));
    });
  }),
  Uf = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeCollapsible,
      r = e.present,
      o = e.children,
      a = _objectWithoutProperties(e, _excluded9),
      i = ya(Mc, n),
      _te3 = te(r),
      _te4 = _slicedToArray(_te3, 2),
      s = _te4[0],
      c = _te4[1],
      l = k(null),
      u = Ce(t, l),
      d = k(0),
      f = d.current,
      m = k(0),
      h = m.current,
      v = i.open || s,
      g = k(v),
      b = k();
    return V(function () {
      var y = requestAnimationFrame(function () {
        return g.current = !1;
      });
      return function () {
        return cancelAnimationFrame(y);
      };
    }, []), jt(function () {
      var y = l.current;
      if (y) {
        b.current = b.current || {
          transitionDuration: y.style.transitionDuration,
          animationName: y.style.animationName
        }, y.style.transitionDuration = "0s", y.style.animationName = "none";
        var w = y.getBoundingClientRect();
        d.current = w.height, m.current = w.width, g.current || (y.style.transitionDuration = b.current.transitionDuration, y.style.animationName = b.current.animationName), c(r);
      }
    }, [i.open, r]), /* @__PURE__ */C(ie.div, S({
      "data-state": wa(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !v
    }, a, {
      ref: u,
      style: _objectSpread({
        "--radix-collapsible-content-height": f ? "".concat(f, "px") : void 0,
        "--radix-collapsible-content-width": h ? "".concat(h, "px") : void 0
      }, e.style)
    }), v && o);
  });
function wa(e) {
  return e ? "open" : "closed";
}
var Yf = Ec,
  Kf = Oc,
  Gf = Nc,
  zf = /* @__PURE__ */he(void 0);
function Vn(e) {
  var t = ce(zf);
  return e || t || "ltr";
}
var Ht = "Accordion",
  qf = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"],
  _Vr = Vr(Ht),
  _Vr2 = _slicedToArray(_Vr, 3),
  xa = _Vr2[0],
  Xf = _Vr2[1],
  Qf = _Vr2[2],
  _Ke5 = Ke(Ht, [Qf, Sc]),
  _Ke6 = _slicedToArray(_Ke5, 2),
  Ur = _Ke6[0],
  kT = _Ke6[1],
  $a = Sc(),
  kc = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.type,
      r = _objectWithoutProperties(e, _excluded10),
      o = r,
      a = r;
    return /* @__PURE__ */$.createElement(xa.Provider, {
      scope: e.__scopeAccordion
    }, n === "multiple" ? /* @__PURE__ */$.createElement(tv, S({}, a, {
      ref: t
    })) : /* @__PURE__ */$.createElement(ev, S({}, o, {
      ref: t
    })));
  });
kc.propTypes = {
  type: function type(e) {
    var t = e.value || e.defaultValue;
    return e.type && !["single", "multiple"].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
var _Ur = Ur(Ht),
  _Ur2 = _slicedToArray(_Ur, 2),
  Rc = _Ur2[0],
  Zf = _Ur2[1],
  _Ur3 = Ur(Ht, {
    collapsible: !1
  }),
  _Ur4 = _slicedToArray(_Ur3, 2),
  Ac = _Ur4[0],
  Jf = _Ur4[1],
  ev = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.value,
      r = e.defaultValue,
      _e$onValueChange = e.onValueChange,
      o = _e$onValueChange === void 0 ? function () {} : _e$onValueChange,
      _e$collapsible = e.collapsible,
      a = _e$collapsible === void 0 ? !1 : _e$collapsible,
      i = _objectWithoutProperties(e, _excluded11),
      _Ze3 = Ze({
        prop: n,
        defaultProp: r,
        onChange: o
      }),
      _Ze4 = _slicedToArray(_Ze3, 2),
      s = _Ze4[0],
      c = _Ze4[1];
    return /* @__PURE__ */$.createElement(Rc, {
      scope: e.__scopeAccordion,
      value: s ? [s] : [],
      onItemOpen: c,
      onItemClose: $.useCallback(function () {
        return a && c("");
      }, [a, c])
    }, /* @__PURE__ */$.createElement(Ac, {
      scope: e.__scopeAccordion,
      collapsible: a
    }, /* @__PURE__ */$.createElement(Lc, S({}, i, {
      ref: t
    }))));
  }),
  tv = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.value,
      r = e.defaultValue,
      _e$onValueChange2 = e.onValueChange,
      o = _e$onValueChange2 === void 0 ? function () {} : _e$onValueChange2,
      a = _objectWithoutProperties(e, _excluded12),
      _Ze5 = Ze({
        prop: n,
        defaultProp: r,
        onChange: o
      }),
      _Ze6 = _slicedToArray(_Ze5, 2),
      _Ze6$ = _Ze6[0],
      i = _Ze6$ === void 0 ? [] : _Ze6$,
      s = _Ze6[1],
      c = $.useCallback(function (u) {
        return s(function () {
          var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return [].concat(_toConsumableArray(d), [u]);
        });
      }, [s]),
      l = $.useCallback(function (u) {
        return s(function () {
          var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return d.filter(function (f) {
            return f !== u;
          });
        });
      }, [s]);
    return /* @__PURE__ */$.createElement(Rc, {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: c,
      onItemClose: l
    }, /* @__PURE__ */$.createElement(Ac, {
      scope: e.__scopeAccordion,
      collapsible: !0
    }, /* @__PURE__ */$.createElement(Lc, S({}, a, {
      ref: t
    }))));
  }),
  _Ur5 = Ur(Ht),
  _Ur6 = _slicedToArray(_Ur5, 2),
  nv = _Ur6[0],
  Yr = _Ur6[1],
  Lc = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeAccordion,
      r = e.disabled,
      o = e.dir,
      _e$orientation = e.orientation,
      a = _e$orientation === void 0 ? "vertical" : _e$orientation,
      i = _objectWithoutProperties(e, _excluded13),
      s = $.useRef(null),
      c = Ce(s, t),
      l = Xf(n),
      d = Vn(o) === "ltr",
      f = Z(e.onKeyDown, function (m) {
        var h;
        if (!qf.includes(m.key)) return;
        var v = m.target,
          g = l().filter(function (O) {
            var A;
            return !((A = O.ref.current) !== null && A !== void 0 && A.disabled);
          }),
          b = g.findIndex(function (O) {
            return O.ref.current === v;
          }),
          y = g.length;
        if (b === -1) return;
        m.preventDefault();
        var w = b;
        var I = 0,
          P = y - 1,
          D = function D() {
            w = b + 1, w > P && (w = I);
          },
          E = function E() {
            w = b - 1, w < I && (w = P);
          };
        switch (m.key) {
          case "Home":
            w = I;
            break;
          case "End":
            w = P;
            break;
          case "ArrowRight":
            a === "horizontal" && (d ? D() : E());
            break;
          case "ArrowDown":
            a === "vertical" && D();
            break;
          case "ArrowLeft":
            a === "horizontal" && (d ? E() : D());
            break;
          case "ArrowUp":
            a === "vertical" && E();
            break;
        }
        var _ = w % y;
        (h = g[_].ref.current) === null || h === void 0 || h.focus();
      });
    return /* @__PURE__ */$.createElement(nv, {
      scope: n,
      disabled: r,
      direction: o,
      orientation: a
    }, /* @__PURE__ */$.createElement(xa.Slot, {
      scope: n
    }, /* @__PURE__ */$.createElement(ie.div, S({}, i, {
      "data-orientation": a,
      ref: c,
      onKeyDown: r ? void 0 : f
    }))));
  }),
  Vo = "AccordionItem",
  _Ur7 = Ur(Vo),
  _Ur8 = _slicedToArray(_Ur7, 2),
  rv = _Ur8[0],
  Ca = _Ur8[1],
  ov = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeAccordion,
      r = e.value,
      o = _objectWithoutProperties(e, _excluded14),
      a = Yr(Vo, n),
      i = Zf(Vo, n),
      s = $a(n),
      c = it(),
      l = r && i.value.includes(r) || !1,
      u = a.disabled || e.disabled;
    return /* @__PURE__ */$.createElement(rv, {
      scope: n,
      open: l,
      disabled: u,
      triggerId: c
    }, /* @__PURE__ */$.createElement(Yf, S({
      "data-orientation": a.orientation,
      "data-state": jc(l)
    }, s, o, {
      ref: t,
      disabled: u,
      open: l,
      onOpenChange: function onOpenChange(d) {
        d ? i.onItemOpen(r) : i.onItemClose(r);
      }
    })));
  }),
  av = "AccordionHeader",
  iv = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeAccordion,
      r = _objectWithoutProperties(e, _excluded15),
      o = Yr(Ht, n),
      a = Ca(av, n);
    return /* @__PURE__ */$.createElement(ie.h3, S({
      "data-orientation": o.orientation,
      "data-state": jc(a.open),
      "data-disabled": a.disabled ? "" : void 0
    }, r, {
      ref: t
    }));
  }),
  ns = "AccordionTrigger",
  sv = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeAccordion,
      r = _objectWithoutProperties(e, _excluded16),
      o = Yr(Ht, n),
      a = Ca(ns, n),
      i = Jf(ns, n),
      s = $a(n);
    return /* @__PURE__ */$.createElement(xa.ItemSlot, {
      scope: n
    }, /* @__PURE__ */$.createElement(Kf, S({
      "aria-disabled": a.open && !i.collapsible || void 0,
      "data-orientation": o.orientation,
      id: a.triggerId
    }, s, r, {
      ref: t
    })));
  }),
  cv = "AccordionContent",
  lv = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeAccordion,
      r = _objectWithoutProperties(e, _excluded17),
      o = Yr(Ht, n),
      a = Ca(cv, n),
      i = $a(n);
    return /* @__PURE__ */$.createElement(Gf, S({
      role: "region",
      "aria-labelledby": a.triggerId,
      "data-orientation": o.orientation
    }, i, r, {
      ref: t,
      style: _objectSpread({
        "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
        "--radix-accordion-content-width": "var(--radix-collapsible-content-width)"
      }, e.style)
    }));
  });
function jc(e) {
  return e ? "open" : "closed";
}
var uv = kc,
  RT = ["neutral", "positive", "negative", "informative", "attentive"],
  AT = ["high", "low"];
function T() {
  var t = "";
  for (var n = 0, r; n < arguments.length; n++) (r = dv(n < 0 || arguments.length <= n ? undefined : arguments[n])) && (t += (t && " ") + r);
  return t;
}
function dv(e) {
  if (typeof e == "string" || typeof e == "number") return e;
  if (Array.isArray(e)) return T.apply(void 0, _toConsumableArray(e));
  var t = "";
  for (var n in e) e[n] && (t += (t && " ") + n);
  return t;
}
function Uo(e, t) {
  var r;
  var n = e.value;
  e.value = t, (r = e._valueTracker) == null || r.setValue(n), e.dispatchEvent(new InputEvent("change", {
    bubbles: !0
  }));
}
function fv(e) {
  var t = {};
  for (var n in e) t[n] = e[n];
  return t;
}
function Fc(e, t) {
  for (var n in t) if (e[n] !== t[n]) return !1;
  return !0;
}
var LT = function LT(e) {
    return "var(--goat-animation-timing-function-".concat(e, ")");
  },
  vv = function vv(e) {
    return "var(--goat-radius-".concat(e, ")");
  },
  yn = function yn(e) {
    return "var(--goat-color-".concat(e, ")");
  },
  pv = "base",
  Wc = function Wc(e) {
    return "calc(var(--goat-space-".concat(pv, ") * ").concat(e, ")");
  },
  mv = "base",
  jT = function jT(e) {
    return "calc(var(--goat-time-".concat(mv, ") * ").concat(e, ")");
  },
  hv = function hv(e) {
    return e.replace(/([A-Z])/g, function (t) {
      return "-".concat(t.toLowerCase());
    });
  },
  gv = function gv(e) {
    return Object.entries(e).map(function (_ref3) {
      var _ref8 = _slicedToArray(_ref3, 2),
        t = _ref8[0],
        n = _ref8[1];
      return "".concat(hv(t), ": ").concat(n, ";");
    }).join("\n");
  },
  FT = function FT(e) {
    var t = function t(r) {
        return "var(--goat-typography-".concat(e, "-").concat(r, ")");
      },
      n = {
        font: t("font"),
        letterSpacing: t("letter-spacing"),
        textTransform: t("text-transform"),
        fontStyle: t("font-style")
      };
    return Object.defineProperty(n, "toString", {
      value: function value() {
        return gv(n);
      }
    }), n;
  },
  bv = function bv(e) {
    return e == null ? [] : Array.isArray(e) ? e : [e];
  },
  yv = function yv(e) {
    return typeof e == "string" ? e : bv(e).map(Wc).join(" ");
  },
  wv = function wv(e) {
    return e && yn(e);
  },
  xv = function xv(e) {
    return e && vv(e);
  },
  $v = {
    color: {
      properties: ["borderColor", "backgroundColor"],
      transformer: wv
    },
    space: {
      properties: ["padding", "gap", "rowGap", "columnGap"],
      transformer: yv
    },
    radius: {
      properties: ["borderRadius"],
      transformer: xv
    }
  },
  Ta = function Ta(e) {
    var t = _objectSpread({}, e);
    for (var _i2 = 0, _Object$values = Object.values($v); _i2 < _Object$values.length; _i2++) {
      var _Object$values$_i = _Object$values[_i2],
        n = _Object$values$_i.properties,
        r = _Object$values$_i.transformer;
      var _iterator = _createForOfIteratorHelper(n),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var o = _step.value;
          o in e && (t[o] = r(e[o]));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return t;
  };
function Cv(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function _a() {
  for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    e[_key5] = arguments[_key5];
  }
  return function (t) {
    return e.forEach(function (n) {
      return Cv(n, t);
    });
  };
}
function Kr() {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }
  return X(_a.apply(void 0, e), e);
}
function Ia(e) {
  var t = k(e);
  return V(function () {
    t.current = e;
  }), Ne(function () {
    return function () {
      var _r3;
      var r;
      for (var _len7 = arguments.length, n = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        n[_key7] = arguments[_key7];
      }
      return (r = t.current) === null || r === void 0 ? void 0 : (_r3 = r).call.apply(_r3, [t].concat(n));
    };
  }, []);
}
var Tv = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  useCallbackRef: Ia
}, Symbol.toStringTag, {
  value: "Module"
}));
function rs(_ref9) {
  var e = _ref9.prop,
    t = _ref9.defaultProp,
    _ref9$onChange = _ref9.onChange,
    n = _ref9$onChange === void 0 ? function () {} : _ref9$onChange;
  var _v2 = _v({
      defaultProp: t,
      onChange: n
    }),
    _v3 = _slicedToArray(_v2, 2),
    r = _v3[0],
    o = _v3[1],
    a = e !== void 0,
    i = a ? e : r,
    s = Ia(n),
    c = X(function (l) {
      if (a) {
        var d = typeof l == "function" ? l(e) : l;
        d !== e && s(d);
      } else o(l);
    }, [a, e, o, s]);
  return [i, c];
}
function _v(_ref10) {
  var e = _ref10.defaultProp,
    t = _ref10.onChange;
  var n = te(e),
    _n5 = _slicedToArray(n, 1),
    r = _n5[0],
    o = k(r),
    a = Ia(t);
  return V(function () {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
function Iv(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = k(),
    r = k(e);
  return V(function () {
    r.current = e;
  }, [e]), X(function () {
    for (var _len8 = arguments.length, o = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      o[_key8] = arguments[_key8];
    }
    clearTimeout(n.current), typeof window < "u" && (n.current = window.setTimeout(function () {
      return r.current.apply(r, o);
    }, t));
  }, [t]
  // Ensure that the function updates when the delay time changes.
  );
}

function Pa(e) {
  var t = k(null);
  return V(function () {
    e instanceof Function ? e(t.current) : e && (e.current = t.current);
  }, []), t;
}
function Hc(e) {
  var t = k({
    value: e,
    previous: e
  });
  return Ne(function () {
    return t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous;
  }, [e]);
}
function Bc() {
  var _ma = ma(function () {
      return {};
    }, {}),
    _ma2 = _slicedToArray(_ma, 2),
    e = _ma2[1];
  return e;
}
function WT(e) {
  var t = Bc();
  V(t, e);
}
var Vc = function Vc(_ref11) {
  var e = _ref11.className,
    _ref11$contrast = _ref11.contrast,
    t = _ref11$contrast === void 0 ? "high" : _ref11$contrast,
    _ref11$sentiment = _ref11.sentiment,
    n = _ref11$sentiment === void 0 ? "neutral" : _ref11$sentiment,
    r = _objectWithoutProperties(_ref11, _excluded18);
  return /* @__PURE__ */p.jsx("span", _objectSpread(_objectSpread({}, r), {}, {
    className: T("goat-Badge", "goat-Badge_".concat(n), "goat-Badge_".concat(t), e)
  }));
};
var Pv = x(function (_ref12, i) {
    var t = _ref12.children,
      n = _ref12.className,
      _ref12$as = _ref12.as,
      r = _ref12$as === void 0 ? "div" : _ref12$as,
      o = _ref12.maxHeight,
      a = _objectWithoutProperties(_ref12, _excluded19);
    return /* @__PURE__ */p.jsx(lv, _objectSpread(_objectSpread({}, a), {}, {
      ref: i,
      asChild: !0,
      style: o ? {
        "--radix-accordion-content-height": o,
        "--radix-collapsible-content-height": o
      } : {},
      className: T("goat-AccordionContent", n),
      children: /* @__PURE__ */p.jsx(r, {
        children: /* @__PURE__ */p.jsx("div", {
          className: T("goat-AccordionContentWrapper"),
          children: t
        })
      })
    }));
  }),
  Dv = x(function (_ref13, a) {
    var t = _ref13.children,
      n = _ref13.className,
      _ref13$as = _ref13.as,
      r = _ref13$as === void 0 ? "div" : _ref13$as,
      o = _objectWithoutProperties(_ref13, _excluded20);
    return /* @__PURE__ */p.jsx(ov, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      asChild: !0,
      className: T("goat-AccordionItem", n),
      children: /* @__PURE__ */p.jsx(r, {
        children: t
      })
    }));
  });
var Uc = he({}),
  Yc = Uc.Provider,
  Sv = function Sv() {
    return ce(Uc);
  },
  Ev = "medium",
  je = x(function (_ref14, i) {
    var _ref15, _t$l;
    var _ref14$as = _ref14.as,
      t = _ref14$as === void 0 ? "svg" : _ref14$as,
      n = _ref14.className,
      r = _ref14.color,
      o = _ref14.size,
      a = _objectWithoutProperties(_ref14, _excluded21);
    var s = Sv(),
      c = r !== null && r !== void 0 ? r : s.color,
      l = (_ref15 = o !== null && o !== void 0 ? o : s.size) !== null && _ref15 !== void 0 ? _ref15 : Ev,
      u = (_t$l = t[l]) !== null && _t$l !== void 0 ? _t$l : t;
    return u ? /* @__PURE__ */p.jsx(u, _objectSpread(_objectSpread({}, a), {}, {
      ref: i,
      className: T("goat-Icon", "goat-Icon_".concat(l), n),
      style: _objectSpread({
        color: c ? yn(c) : void 0
      }, a.style)
    })) : null;
  }),
  Ov = x(function (_ref16, i) {
    var t = _ref16.children,
      _ref16$as = _ref16.as,
      n = _ref16$as === void 0 ? "span" : _ref16$as,
      _ref16$size = _ref16.size,
      r = _ref16$size === void 0 ? "medium" : _ref16$size,
      o = _ref16.className,
      a = _objectWithoutProperties(_ref16, _excluded22);
    return /* @__PURE__ */p.jsx(iv, _objectSpread(_objectSpread({}, a), {}, {
      asChild: !0,
      ref: i,
      className: T("goat-AccordionTrigger", o),
      children: /* @__PURE__ */p.jsx(n, {
        children: /* @__PURE__ */p.jsxs(sv, {
          className: T("goat-AccordionButton", "goat-AccordionButton_".concat(r), {
            "goat-AccordionButton_text": typeof t == "string"
          }),
          children: [t, /* @__PURE__ */p.jsx(je, {
            as: Br,
            size: r,
            className: "goat-AccordionIcon"
          })]
        })
      })
    }));
  }),
  Gr = function Gr(_ref17) {
    var e = _ref17.children,
      t = _objectWithoutProperties(_ref17, _excluded23);
    return /* @__PURE__ */p.jsx(uv, _objectSpread(_objectSpread({}, t), {}, {
      children: e
    }));
  };
Gr.Trigger = Ov;
Gr.Item = Dv;
Gr.Content = Pv;
Gr.Badge = function (_ref18) {
  var t = _ref18.className,
    n = _objectWithoutProperties(_ref18, _excluded24);
  return /* @__PURE__ */p.jsx(Vc, _objectSpread(_objectSpread({}, n), {}, {
    className: T("goat-AccordionBadge", t)
  }));
};
var Kc = function Kc(_ref19) {
  var e = _ref19.children,
    t = _ref19.className,
    n = _objectWithoutProperties(_ref19, _excluded25);
  return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, n), {}, {
    className: T("goat-Topbar__Actions", t),
    children: e
  }));
};
var Gc = x(function (_ref20, a) {
  var _ref20$as = _ref20.as,
    t = _ref20$as === void 0 ? "span" : _ref20$as,
    n = _ref20.children,
    r = _ref20.className,
    o = _objectWithoutProperties(_ref20, _excluded26);
  return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
    className: T("goat-Topbar__Logo", r),
    ref: a,
    children: n
  }));
});
var zc = he({
    portalRef: null,
    border: !1
  }),
  qc = function qc() {
    var e = ce(zc);
    if (e === void 0) throw new Error("useAppTopbarContextRef must be used within a AppTopbarContextRef");
    return e;
  },
  Xc = he(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function () {}),
  Mv = function Mv() {
    var e = ce(Xc);
    if (e === void 0) throw new Error("useAppTopbarContextSetRef must be used within a AppTopbarContextSetRef");
    return e;
  },
  Qc = he(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function () {}),
  Nv = function Nv() {
    var e = ce(Qc);
    if (e === void 0) throw new Error("useAppTopbarContextSetVariant must be used within a AppTopbarContextSetVariant");
    return e;
  },
  kv = function kv(_ref21) {
    var e = _ref21.children,
      _ref21$border = _ref21.border,
      t = _ref21$border === void 0 ? !1 : _ref21$border;
    var _qc = qc(),
      n = _qc.portalRef,
      r = _qc.border,
      o = Nv();
    return V(function () {
      t !== r && o(t);
    }, [t, r, o]), V(function () {
      return function () {
        o(!1);
      };
    }, [o]), n ? yc(e, n) : null;
  };
var Da = x(function (_ref22, i) {
  var _ref22$as = _ref22.as,
    t = _ref22$as === void 0 ? "nav" : _ref22$as,
    n = _ref22.children,
    r = _ref22.className,
    o = _ref22.border,
    a = _objectWithoutProperties(_ref22, _excluded27);
  return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, a), {}, {
    className: T("goat-Topbar", {
      "goat-Topbar_border": o
    }, r),
    ref: i,
    children: n
  }));
});
Da.Actions = Kc;
Da.Logo = Gc;
var Rv = x(function (_ref23, r) {
    var t = _ref23.children,
      n = _objectWithoutProperties(_ref23, _excluded28);
    var _qc2 = qc(),
      o = _qc2.border,
      a = Mv(),
      _te5 = te(null),
      _te6 = _slicedToArray(_te5, 2),
      i = _te6[0],
      s = _te6[1];
    return V(function () {
      a(i);
    }, [i, a]), /* @__PURE__ */p.jsxs(Da, _objectSpread(_objectSpread({}, n), {}, {
      ref: r,
      border: o,
      children: [t, /* @__PURE__ */p.jsx("div", {
        ref: s,
        className: "goat-AppTopbarPortal"
      })]
    }));
  }),
  zr = function zr(_ref24) {
    var e = _ref24.children;
    var _te7 = te(null),
      _te8 = _slicedToArray(_te7, 2),
      t = _te8[0],
      n = _te8[1],
      _te9 = te(!1),
      _te10 = _slicedToArray(_te9, 2),
      r = _te10[0],
      o = _te10[1];
    return /* @__PURE__ */p.jsx(Xc.Provider, {
      value: n,
      children: /* @__PURE__ */p.jsx(Qc.Provider, {
        value: o,
        children: /* @__PURE__ */p.jsx(zc.Provider, {
          value: {
            portalRef: t,
            border: r
          },
          children: e
        })
      })
    });
  };
zr.Actions = Kc;
zr.Logo = Gc;
zr.Portal = kv;
zr.Root = Rv;
var Sa = x(function (_ref25, m) {
  var _ref25$as = _ref25.as,
    t = _ref25$as === void 0 ? "div" : _ref25$as,
    n = _ref25.borderColor,
    r = _ref25.borderRadius,
    o = _ref25.bgColor,
    a = _ref25.children,
    i = _ref25.className,
    s = _ref25.display,
    c = _ref25.height,
    l = _ref25.padding,
    u = _ref25.style,
    d = _ref25.width,
    f = _objectWithoutProperties(_ref25, _excluded29);
  return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, f), {}, {
    className: i,
    style: Ta(_objectSpread(_objectSpread({
      backgroundColor: o
    }, n && {
      // can't use `border` directly as it wouldn't be transformed by `sx`
      borderColor: n,
      borderStyle: "solid",
      borderWidth: 1
    }), {}, {
      borderRadius: r,
      display: s,
      height: c,
      padding: l,
      width: d
    }, u)),
    ref: m,
    children: a
  }));
});
var Av = function Av(_ref26) {
  var e = _ref26.src,
    _ref26$size = _ref26.size,
    t = _ref26$size === void 0 ? "small" : _ref26$size,
    n = _ref26.className,
    r = _objectWithoutProperties(_ref26, _excluded30);
  var o = T("goat-BrandIcon_".concat(t), n);
  return /* @__PURE__ */p.jsx("img", _objectSpread(_objectSpread({
    alt: "",
    className: o
  }, r), {}, {
    src: e
  }));
};
var Qe = x(function (_ref27, c) {
    var t = _ref27.className,
      _ref27$type = _ref27.type,
      n = _ref27$type === void 0 ? "button" : _ref27$type,
      r = _ref27.disabled,
      o = _ref27.icon,
      _ref27$size = _ref27.size,
      a = _ref27$size === void 0 ? "medium" : _ref27$size,
      _ref27$variant = _ref27.variant,
      i = _ref27$variant === void 0 ? "ghost" : _ref27$variant,
      s = _objectWithoutProperties(_ref27, _excluded31);
    return /* @__PURE__ */p.jsx("button", _objectSpread(_objectSpread({}, s), {}, {
      className: T("goat-IconButton", "goat-IconButton_".concat(i), t),
      disabled: r,
      ref: c,
      type: n,
      children: /* @__PURE__ */p.jsx(je, {
        as: o,
        size: a
      })
    }));
  }),
  Lv = function Lv(e) {
    return /* @__PURE__ */p.jsx(je, _objectSpread(_objectSpread({}, e), {}, {
      className: "goat-Tag__Icon",
      size: "small"
    }));
  },
  Ea = x(function (_ref28, i) {
    var _ref28$as = _ref28.as,
      t = _ref28$as === void 0 ? Qe : _ref28$as,
      n = _ref28.onClick,
      _ref28$icon = _ref28.icon,
      r = _ref28$icon === void 0 ? Dt : _ref28$icon,
      o = _ref28.className,
      a = _objectWithoutProperties(_ref28, _excluded32);
    var s = T("goat-Tag__Remove", o);
    return n ? /* @__PURE__ */p.jsx(t, _objectSpread({
      className: s,
      ref: i,
      size: "small",
      icon: r,
      onClick: n
    }, a)) : /* @__PURE__ */p.jsx(je, {
      as: Dt,
      className: s,
      size: "small"
    });
  }),
  vn = x(function (_ref29, l) {
    var _ref29$as = _ref29.as,
      t = _ref29$as === void 0 ? "span" : _ref29$as,
      n = _ref29.children,
      r = _ref29.className,
      _ref29$color = _ref29.color,
      o = _ref29$color === void 0 ? "gray" : _ref29$color,
      _ref29$size = _ref29.size,
      a = _ref29$size === void 0 ? "medium" : _ref29$size,
      _ref29$variant = _ref29.variant,
      i = _ref29$variant === void 0 ? "contained" : _ref29$variant,
      s = _ref29.wrap,
      c = _objectWithoutProperties(_ref29, _excluded33);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, c), {}, {
      className: T("goat-Tag", "goat-Tag_".concat(o), "goat-Tag_".concat(a), "goat-Tag_".concat(i), {
        "goat-Tag_wrap": s,
        "goat-disabled": c.disabled
      }, r),
      ref: l,
      children: n
    }));
  });
vn.Icon = Lv;
vn.Remove = Ea;
var jv = x(function (_ref30, s) {
  var t = _ref30.className,
    n = _ref30.icon,
    r = _ref30.children,
    _ref30$disabled = _ref30.disabled,
    o = _ref30$disabled === void 0 ? !1 : _ref30$disabled,
    _ref30$color = _ref30.color,
    a = _ref30$color === void 0 ? "gray" : _ref30$color,
    i = _objectWithoutProperties(_ref30, _excluded34);
  var c = T("goat-BrandTag", {
    "goat-BrandTag_disabled": o
  }, t);
  return /* @__PURE__ */p.jsxs(vn, _objectSpread(_objectSpread({}, i), {}, {
    color: a,
    variant: "contained",
    className: c,
    ref: s,
    children: [n && /* @__PURE__ */p.jsx(Av, {
      src: n,
      className: T("goat-BrandTag__BrandIcon", {
        "goat-BrandTag__BrandIcon_disabled": o
      })
    }), r]
  }));
});
jv.Remove = Ea;
var Fv = x(function (_ref31, c) {
    var _ref31$as = _ref31.as,
      t = _ref31$as === void 0 ? "a" : _ref31$as,
      n = _ref31.children,
      r = _ref31.className,
      o = _ref31.disabled,
      a = _ref31.href,
      _ref31$variant = _ref31.variant,
      i = _ref31$variant === void 0 ? "body" : _ref31$variant,
      s = _objectWithoutProperties(_ref31, _excluded35);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, s), {}, {
      ref: c,
      className: T("goat-Breadcrumb__Item", "goat-Breadcrumb__Item_".concat(i), {
        "goat-disabled": o
      }, r),
      href: o ? void 0 : a,
      children: n
    }));
  }),
  Zc = function Zc(e) {
    var t = e.children,
      n = e.onEdit,
      r = e.className,
      o = _objectWithoutProperties(e, _excluded36),
      a = at.toArray(t).filter(Boolean),
      i = !!n,
      s = a.length;
    return /* @__PURE__ */p.jsxs("div", _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Breadcrumb", r),
      children: [a.map(function (c, l) {
        return /* @__PURE__ */p.jsxs(p.Fragment, {
          children: [c, l < s - 1 && /* @__PURE__ */p.jsx(je, {
            as: ha
          })]
        });
      }), i && s > 1 && /* @__PURE__ */p.jsx(Qe, {
        onClick: n,
        icon: df
      })]
    }));
  };
Zc.Item = Fv;
var Wv = Zc;
Wv.displayName = "Breadcrumb";
var Hv = function Hv(_ref32) {
  var e = _ref32.className,
    _ref32$size = _ref32.size,
    t = _ref32$size === void 0 ? "medium" : _ref32$size,
    n = _objectWithoutProperties(_ref32, _excluded37);
  return /* @__PURE__ */p.jsx("span", _objectSpread(_objectSpread({}, n), {}, {
    className: T("goat-Loader", "goat-Loader_".concat(t), e)
  }));
};
function Bv(e) {
  return /* @__PURE__ */p.jsxs("svg", _objectSpread(_objectSpread({}, e), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 50",
    children: [/* @__PURE__ */p.jsx("clipPath", {
      id: "a",
      children: /* @__PURE__ */p.jsx("path", {
        d: "M0 0h30v50H0z"
      })
    }), /* @__PURE__ */p.jsxs("g", {
      clipPath: "url(#a)",
      children: [/* @__PURE__ */p.jsx("path", {
        stroke: "#e0e0e0",
        d: "M26.48 14.932h-7.664a3.949 3.949 0 01-3.948-3.947V7.967A6.966 6.966 0 007.9 1C4.053 1 .934 4.119.934 7.967s3.119 6.967 6.967 6.967h3.019a3.948 3.948 0 013.947 3.948v7.198a3.946 3.946 0 01-3.947 3.947H7.9a6.966 6.966 0 00-6.967 6.967v5.04A6.966 6.966 0 007.901 49a6.966 6.966 0 006.967-6.967v-8.057a3.949 3.949 0 013.948-3.949h7.664a2.323 2.323 0 002.323-2.323v-10.45a2.324 2.324 0 00-2.323-2.322z"
      }), /* @__PURE__ */p.jsxs("path", {
        stroke: "#212121",
        d: "M26.48 14.932h-7.664a3.949 3.949 0 01-3.948-3.947V7.967A6.966 6.966 0 007.9 1C4.053 1 .934 4.119.934 7.967s3.119 6.967 6.967 6.967h3.019a3.948 3.948 0 013.947 3.948v7.198a3.946 3.946 0 01-3.947 3.947H7.9a6.966 6.966 0 00-6.967 6.967v5.04A6.966 6.966 0 007.901 49a6.966 6.966 0 006.967-6.967v-8.057a3.949 3.949 0 013.948-3.949h7.664a2.323 2.323 0 002.323-2.323v-10.45a2.324 2.324 0 00-2.323-2.322z",
        children: [/* @__PURE__ */p.jsx("animate", {
          attributeName: "stroke-dasharray",
          dur: "3s",
          repeatCount: "indefinite",
          values: "155 0;77.5 77.5;155 0"
        }), /* @__PURE__ */p.jsx("animate", {
          attributeName: "stroke-dashoffset",
          dur: "3s",
          repeatCount: "indefinite",
          values: "-155;-77.5;0;77.5;155"
        })]
      })]
    })]
  }));
}
function Vv(_ref33) {
  var e = _ref33.className,
    t = _objectWithoutProperties(_ref33, _excluded38);
  return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, t), {}, {
    className: T("goat-PremierLoader", e)
  }));
}
var HT = Object.assign(Vv, {
  Icon: Bv
});
var Yo = {
    variant: "contained",
    size: "medium"
  },
  Jc = he(Yo),
  Uv = function Uv() {
    return ce(Jc);
  },
  Yv = function Yv(_ref34) {
    var e = _ref34.children,
      t = _ref34.value;
    return /* @__PURE__ */p.jsx(Jc.Provider, {
      value: t,
      children: e
    });
  },
  Fe = x(function (_ref35, u) {
    var _ref36, _ref37;
    var _ref35$as = _ref35.as,
      t = _ref35$as === void 0 ? "button" : _ref35$as,
      n = _ref35.variant,
      r = _ref35.size,
      o = _ref35.children,
      a = _ref35.className,
      i = _ref35.disabled,
      s = _ref35.type,
      _ref35$loading = _ref35.loading,
      c = _ref35$loading === void 0 ? !1 : _ref35$loading,
      l = _objectWithoutProperties(_ref35, _excluded39);
    var _Uv = Uv(),
      d = _Uv.variant,
      f = _Uv.size,
      m = (_ref36 = n !== null && n !== void 0 ? n : d) !== null && _ref36 !== void 0 ? _ref36 : Yo.variant,
      h = (_ref37 = r !== null && r !== void 0 ? r : f) !== null && _ref37 !== void 0 ? _ref37 : Yo.size,
      v = T("goat-Button", "goat-Button_".concat(m), "goat-Button_".concat(h), a, _defineProperty({
        "goat-Button_loading": c,
        "goat-Button_disabled": i
      }, "goat-Button_".concat(m, "_disabled"), i)),
      g = t === "button";
    return /* @__PURE__ */p.jsxs(t, _objectSpread(_objectSpread({}, l), {}, {
      ref: u,
      className: v,
      disabled: g ? c || i : void 0,
      type: g ? s || "button" : s,
      children: [/* @__PURE__ */p.jsx(Yc, {
        value: {
          size: h
        },
        children: at.map(o, function (b) {
          return typeof b == "string" ? /* @__PURE__ */p.jsx("span", {
            children: b
          }) : b;
        })
      }), c && /* @__PURE__ */p.jsx(Hv, {
        size: h
      })]
    }));
  });
Fe.Icon = je;
var ho = "goat-ButtonGroup",
  el = x(function (_ref38, a) {
    var e = _ref38.children,
      _ref38$as = _ref38.as,
      t = _ref38$as === void 0 ? "div" : _ref38$as,
      _ref38$size = _ref38.size,
      n = _ref38$size === void 0 ? "medium" : _ref38$size,
      _ref38$variant = _ref38.variant,
      r = _ref38$variant === void 0 ? "contained" : _ref38$variant,
      o = _objectWithoutProperties(_ref38, _excluded40);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: T([ho, "".concat(ho, "_").concat(n), "".concat(ho, "_").concat(r)]),
      children: /* @__PURE__ */p.jsx(Yv, {
        value: {
          size: n,
          variant: r
        },
        children: e
      })
    }));
  });
el.displayName = "ButtonGroup";
var Kv = x(function (_ref39, i) {
  var _ref39$as = _ref39.as,
    t = _ref39$as === void 0 ? "section" : _ref39$as,
    _ref39$variant = _ref39.variant,
    n = _ref39$variant === void 0 ? "outlined" : _ref39$variant,
    r = _ref39.children,
    o = _ref39.className,
    a = _objectWithoutProperties(_ref39, _excluded41);
  return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, a), {}, {
    className: T("goat-Card", "goat-Card_".concat(n), {
      "goat-Card_disabled": a.disabled
    }, o),
    ref: i,
    children: r
  }));
});
var tl = he({}),
  Gv = tl.Provider,
  nl = function nl() {
    return ce(tl);
  };
var zv = 0;
var rl = function rl() {
    return Ne(function () {
      return "goat-".concat(++zv);
    }, []);
  },
  ol = he({
    addDescribedById: Pn,
    describedBy: Pn,
    setTouched: Pn,
    setValidationMessage: Pn,
    setValidity: Pn,
    validity: {}
  }),
  qv = ol.Provider,
  al = function al() {
    return ce(ol);
  };
function Xv() {
  var e = nl(),
    _te11 = te(),
    _te12 = _slicedToArray(_te11, 2),
    _te12$ = _te12[0],
    t = _te12$ === void 0 ? e.touched : _te12$,
    n = _te12[1],
    _te13 = te({}),
    _te14 = _slicedToArray(_te13, 2),
    r = _te14[0],
    o = _te14[1],
    _te15 = te(),
    _te16 = _slicedToArray(_te15, 2),
    a = _te16[0],
    i = _te16[1],
    _te17 = te( /* @__PURE__ */new Set()),
    _te18 = _slicedToArray(_te17, 2),
    s = _te18[0],
    c = _te18[1];
  return {
    touched: t,
    validationMessage: a,
    validity: r,
    addDescribedById: function addDescribedById(l) {
      c(function (u) {
        return !l || u.has(l) ? u : /* @__PURE__ */new Set([].concat(_toConsumableArray(u), [l]));
      });
    },
    describedBy: function describedBy(l) {
      return [l["aria-describedby"]].concat(_toConsumableArray(s)).filter(Boolean).join(" ") || void 0;
    },
    setTouched: n,
    setValidationMessage: i,
    setValidity: function setValidity(l) {
      o(function (u) {
        return Fc(u, l) ? u : fv(l);
      });
    }
  };
}
function Pn() {}
var Oa = he({
    set: Qv
  }),
  Ma = Oa.Provider;
function dt(e) {
  var t = ce(Oa),
    n = nl(),
    r = al();
  return e && (e = Zv(e)), V(function () {
    e && t.set(e);
  }), V(function () {
    r.setTouched(!1);
  }, [n.resetToken]), _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, n), t), r), e), {}, {
    touched: n.touched || r.touched
  });
}
function Na() {
  var e = rl(),
    t = ce(Oa),
    _te19 = te({
      id: e
    }),
    _te20 = _slicedToArray(_te19, 2),
    n = _te20[0],
    r = _te20[1];
  return t.id ? t : _objectSpread(_objectSpread({}, n), {}, {
    id: e,
    set: function set(o) {
      r(function (a) {
        return Fc(a, o) ? a : _objectSpread(_objectSpread({}, a), o);
      });
    }
  });
}
function Qv() {}
var Zv = function Zv(e) {
    return Object.fromEntries(Object.entries(e).filter(function (_ref40) {
      var _ref41 = _slicedToArray(_ref40, 2),
        t = _ref41[1];
      return t != null;
    }));
  },
  il = x(function (_ref42, s) {
    var _ref42$as = _ref42.as,
      t = _ref42$as === void 0 ? "div" : _ref42$as,
      n = _ref42.children,
      r = _ref42.onBlur,
      o = _ref42.onChange,
      a = _ref42.onInvalid,
      i = _objectWithoutProperties(_ref42, _excluded42);
    var c = Xv();
    return /* @__PURE__ */p.jsx(qv, {
      value: c,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, i), {}, {
        ref: s,
        onBlur: function onBlur(l) {
          r == null || r(l), On(c, l, {
            touched: !0
          });
        },
        onChange: function onChange(l) {
          o == null || o(l), On(c, l);
        },
        onInvalid: function onInvalid(l) {
          a == null || a(l), On(c, l);
        },
        children: n
      }))
    });
  }),
  Jv = /* @__PURE__ */new Set(["INPUT", "SELECT", "TEXTAREA"]),
  ep = function ep(_ref43) {
    var e = _ref43.target;
    return Jv.has(e.nodeName);
  };
function On(e, t) {
  var _ref44 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    n = _ref44.touched;
  if (!ep(t)) return;
  var r = t.target;
  e.setValidationMessage(r.validationMessage), e.setValidity(r.validity), n != null && e.setTouched(n);
}
var BT = x(function (_ref45, r) {
  var t = _ref45.className,
    n = _objectWithoutProperties(_ref45, _excluded43);
  var o = Na();
  return /* @__PURE__ */p.jsx(Ma, {
    value: o,
    children: /* @__PURE__ */p.jsx(il, _objectSpread(_objectSpread({}, n), {}, {
      className: T("goat-Field", t),
      ref: r
    }))
  });
});
var sl = x(function (_ref46, i) {
  var t = _ref46.className,
    n = _ref46.disabled,
    r = _ref46.id,
    o = _ref46.indeterminate,
    a = _objectWithoutProperties(_ref46, _excluded44);
  var s = Pa(i),
    c = dt({
      disabled: n,
      id: r,
      inline: !0
    });
  return V(function () {
    s.current && (s.current.indeterminate = !s.current.checked && !!o);
  }, [o, s]), /* @__PURE__ */p.jsx("input", _objectSpread(_objectSpread({}, a), {}, {
    "aria-describedby": c.describedBy(a),
    className: T("goat-Checkbox", {
      "goat-touched": c.touched
    }, t),
    disabled: c.disabled,
    id: c.id,
    ref: s,
    type: "checkbox"
  }));
});
function tp(e, t, n) {
  return function (_ref47) {
    var r = _ref47.value;
    return {
      value: r,
      checked: e.has(r),
      onChange: function onChange(o) {
        var s;
        var a = o.currentTarget.value;
        e.has(a) ? e.delete(a) : e.add(a);
        var i = new Set(e);
        t(i), (s = n == null ? void 0 : n.onChange) == null || s.call(n, Array.from(i));
      },
      onBlur: n == null ? void 0 : n.onBlur
    };
  };
}
function np(e, t, n) {
  return function (_ref48) {
    var r = _ref48.allValues;
    return {
      indeterminate: e.size > 0 && e.size < r.length,
      checked: e.size === r.length,
      onChange: function onChange() {
        var o, a;
        if (e.size === r.length) t( /* @__PURE__ */new Set()), (o = n == null ? void 0 : n.onChange) == null || o.call(n, []);else {
          var i = new Set(r);
          t(i), (a = n == null ? void 0 : n.onChange) == null || a.call(n, Array.from(i));
        }
      },
      onBlur: n == null ? void 0 : n.onBlur
    };
  };
}
var VT = function VT(e) {
    var s;
    var _te21 = te( /* @__PURE__ */new Set()),
      _te22 = _slicedToArray(_te21, 2),
      t = _te22[0],
      n = _te22[1],
      r = (s = e == null ? void 0 : e.value) == null ? void 0 : s.toString(),
      o = Array.from(t).toString(),
      a = function a(c) {
        return t.has(c);
      },
      i = function i() {
        return n( /* @__PURE__ */new Set());
      };
    return V(function () {
      r != null && r !== o && n(new Set(e == null ? void 0 : e.value));
    }, [r, o]), {
      indeterminateProps: np(t, n, e),
      checkboxProps: tp(t, n, e),
      isChecked: a,
      reset: i,
      selected: Array.from(t)
    };
  },
  cl = /* @__PURE__ */x(function (e, t) {
    var n = e.pressed,
      _e$defaultPressed = e.defaultPressed,
      r = _e$defaultPressed === void 0 ? !1 : _e$defaultPressed,
      o = e.onPressedChange,
      a = _objectWithoutProperties(e, _excluded45),
      _Ze7 = Ze({
        prop: n,
        onChange: o,
        defaultProp: r
      }),
      _Ze8 = _slicedToArray(_Ze7, 2),
      _Ze8$ = _Ze8[0],
      i = _Ze8$ === void 0 ? !1 : _Ze8$,
      s = _Ze8[1];
    return /* @__PURE__ */C(ie.button, S({
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0
    }, a, {
      ref: t,
      onClick: Z(e.onClick, function () {
        e.disabled || s(!i);
      })
    }));
  }),
  rp = cl;
var UT = x(function (_ref49, l) {
  var _ref49$as = _ref49.as,
    t = _ref49$as === void 0 ? "button" : _ref49$as,
    n = _ref49.children,
    r = _ref49.className,
    o = _ref49.disabled,
    _ref49$size = _ref49.size,
    a = _ref49$size === void 0 ? "medium" : _ref49$size,
    i = _ref49.trailingIcon,
    s = _ref49.pressed,
    c = _objectWithoutProperties(_ref49, _excluded46);
  return /* @__PURE__ */p.jsx(rp, _objectSpread(_objectSpread({
    asChild: !0
  }, c), {}, {
    disabled: o,
    pressed: s,
    className: T("goat-Chip", "goat-Chip_".concat(a), {
      "goat-Chip_disabled": o
    }, {
      "goat-Chip_selected": s
    }, r),
    ref: l,
    children: /* @__PURE__ */p.jsxs(t, {
      children: [n, i && s && /* @__PURE__ */p.jsx(je, {
        as: wc
      })]
    })
  }));
});
function op(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  var n = Xe(e);
  V(function () {
    var r = function r(o) {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), function () {
      return t.removeEventListener("keydown", r);
    };
  }, [n, t]);
}
var Ko = "dismissableLayer.update",
  ap = "dismissableLayer.pointerDownOutside",
  ip = "dismissableLayer.focusOutside";
var os;
var ll = /* @__PURE__ */he({
    layers: /* @__PURE__ */new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
    branches: /* @__PURE__ */new Set()
  }),
  Un = /* @__PURE__ */x(function (e, t) {
    var n;
    var _e$disableOutsidePoin = e.disableOutsidePointerEvents,
      r = _e$disableOutsidePoin === void 0 ? !1 : _e$disableOutsidePoin,
      o = e.onEscapeKeyDown,
      a = e.onPointerDownOutside,
      i = e.onFocusOutside,
      s = e.onInteractOutside,
      c = e.onDismiss,
      l = _objectWithoutProperties(e, _excluded47),
      u = ce(ll),
      _te23 = te(null),
      _te24 = _slicedToArray(_te23, 2),
      d = _te24[0],
      f = _te24[1],
      m = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document,
      _te25 = te({}),
      _te26 = _slicedToArray(_te25, 2),
      h = _te26[1],
      v = Ce(t, function (_) {
        return f(_);
      }),
      g = Array.from(u.layers),
      _slice = _toConsumableArray(u.layersWithOutsidePointerEventsDisabled).slice(-1),
      _slice2 = _slicedToArray(_slice, 1),
      b = _slice2[0],
      y = g.indexOf(b),
      w = d ? g.indexOf(d) : -1,
      I = u.layersWithOutsidePointerEventsDisabled.size > 0,
      P = w >= y,
      D = cp(function (_) {
        var O = _.target,
          A = _toConsumableArray(u.branches).some(function (M) {
            return M.contains(O);
          });
        !P || A || (a == null || a(_), s == null || s(_), _.defaultPrevented || c == null || c());
      }, m),
      E = lp(function (_) {
        var O = _.target;
        _toConsumableArray(u.branches).some(function (M) {
          return M.contains(O);
        }) || (i == null || i(_), s == null || s(_), _.defaultPrevented || c == null || c());
      }, m);
    return op(function (_) {
      w === u.layers.size - 1 && (o == null || o(_), !_.defaultPrevented && c && (_.preventDefault(), c()));
    }, m), V(function () {
      if (d) return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (os = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), as(), function () {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = os);
      };
    }, [d, m, r, u]), V(function () {
      return function () {
        d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), as());
      };
    }, [d, u]), V(function () {
      var _ = function _() {
        return h({});
      };
      return document.addEventListener(Ko, _), function () {
        return document.removeEventListener(Ko, _);
      };
    }, []), /* @__PURE__ */C(ie.div, S({}, l, {
      ref: v,
      style: _objectSpread({
        pointerEvents: I ? P ? "auto" : "none" : void 0
      }, e.style),
      onFocusCapture: Z(e.onFocusCapture, E.onFocusCapture),
      onBlurCapture: Z(e.onBlurCapture, E.onBlurCapture),
      onPointerDownCapture: Z(e.onPointerDownCapture, D.onPointerDownCapture)
    }));
  }),
  sp = /* @__PURE__ */x(function (e, t) {
    var n = ce(ll),
      r = k(null),
      o = Ce(t, r);
    return V(function () {
      var a = r.current;
      if (a) return n.branches.add(a), function () {
        n.branches.delete(a);
      };
    }, [n.branches]), /* @__PURE__ */C(ie.div, S({}, e, {
      ref: o
    }));
  });
function cp(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  var n = Xe(e),
    r = k(!1),
    o = k(function () {});
  return V(function () {
    var a = function a(s) {
        if (s.target && !r.current) {
          var l = function l() {
            ul(ap, n, c, {
              discrete: !0
            });
          };
          var c = {
            originalEvent: s
          };
          s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
            once: !0
          })) : l();
        } else t.removeEventListener("click", o.current);
        r.current = !1;
      },
      i = window.setTimeout(function () {
        t.addEventListener("pointerdown", a);
      }, 0);
    return function () {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: function onPointerDownCapture() {
      return r.current = !0;
    }
  };
}
function lp(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  var n = Xe(e),
    r = k(!1);
  return V(function () {
    var o = function o(a) {
      a.target && !r.current && ul(ip, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), function () {
      return t.removeEventListener("focusin", o);
    };
  }, [t, n]), {
    onFocusCapture: function onFocusCapture() {
      return r.current = !0;
    },
    onBlurCapture: function onBlurCapture() {
      return r.current = !1;
    }
  };
}
function as() {
  var e = new CustomEvent(Ko);
  document.dispatchEvent(e);
}
function ul(e, t, n, _ref50) {
  var r = _ref50.discrete;
  var o = n.originalEvent.target,
    a = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? ba(o, a) : o.dispatchEvent(a);
}
var up = Un,
  dp = sp,
  go = "focusScope.autoFocusOnMount",
  bo = "focusScope.autoFocusOnUnmount",
  is = {
    bubbles: !1,
    cancelable: !0
  },
  ka = /* @__PURE__ */x(function (e, t) {
    var _e$loop = e.loop,
      n = _e$loop === void 0 ? !1 : _e$loop,
      _e$trapped = e.trapped,
      r = _e$trapped === void 0 ? !1 : _e$trapped,
      o = e.onMountAutoFocus,
      a = e.onUnmountAutoFocus,
      i = _objectWithoutProperties(e, _excluded48),
      _te27 = te(null),
      _te28 = _slicedToArray(_te27, 2),
      s = _te28[0],
      c = _te28[1],
      l = Xe(o),
      u = Xe(a),
      d = k(null),
      f = Ce(t, function (v) {
        return c(v);
      }),
      m = k({
        paused: !1,
        pause: function pause() {
          this.paused = !0;
        },
        resume: function resume() {
          this.paused = !1;
        }
      }).current;
    V(function () {
      if (r) {
        var v = function v(w) {
            if (m.paused || !s) return;
            var I = w.target;
            s.contains(I) ? d.current = I : At(d.current, {
              select: !0
            });
          },
          g = function g(w) {
            if (m.paused || !s) return;
            var I = w.relatedTarget;
            I !== null && (s.contains(I) || At(d.current, {
              select: !0
            }));
          },
          b = function b(w) {
            if (document.activeElement === document.body) {
              var _iterator2 = _createForOfIteratorHelper(w),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var P = _step2.value;
                  P.removedNodes.length > 0 && At(s);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          };
        document.addEventListener("focusin", v), document.addEventListener("focusout", g);
        var y = new MutationObserver(b);
        return s && y.observe(s, {
          childList: !0,
          subtree: !0
        }), function () {
          document.removeEventListener("focusin", v), document.removeEventListener("focusout", g), y.disconnect();
        };
      }
    }, [r, s, m.paused]), V(function () {
      if (s) {
        cs.add(m);
        var v = document.activeElement;
        if (!s.contains(v)) {
          var b = new CustomEvent(go, is);
          s.addEventListener(go, l), s.dispatchEvent(b), b.defaultPrevented || (fp(gp(dl(s)), {
            select: !0
          }), document.activeElement === v && At(s));
        }
        return function () {
          s.removeEventListener(go, l), setTimeout(function () {
            var b = new CustomEvent(bo, is);
            s.addEventListener(bo, u), s.dispatchEvent(b), b.defaultPrevented || At(v !== null && v !== void 0 ? v : document.body, {
              select: !0
            }), s.removeEventListener(bo, u), cs.remove(m);
          }, 0);
        };
      }
    }, [s, l, u, m]);
    var h = X(function (v) {
      if (!n && !r || m.paused) return;
      var g = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey,
        b = document.activeElement;
      if (g && b) {
        var y = v.currentTarget,
          _vp = vp(y),
          _vp2 = _slicedToArray(_vp, 2),
          w = _vp2[0],
          I = _vp2[1];
        w && I ? !v.shiftKey && b === I ? (v.preventDefault(), n && At(w, {
          select: !0
        })) : v.shiftKey && b === w && (v.preventDefault(), n && At(I, {
          select: !0
        })) : b === y && v.preventDefault();
      }
    }, [n, r, m.paused]);
    return /* @__PURE__ */C(ie.div, S({
      tabIndex: -1
    }, i, {
      ref: f,
      onKeyDown: h
    }));
  });
function fp(e) {
  var _ref51 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref51$select = _ref51.select,
    t = _ref51$select === void 0 ? !1 : _ref51$select;
  var n = document.activeElement;
  var _iterator3 = _createForOfIteratorHelper(e),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var r = _step3.value;
      if (At(r, {
        select: t
      }), document.activeElement !== n) return;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
function vp(e) {
  var t = dl(e),
    n = ss(t, e),
    r = ss(t.reverse(), e);
  return [n, r];
}
function dl(e) {
  var t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function acceptNode(r) {
        var o = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function ss(e, t) {
  var _iterator4 = _createForOfIteratorHelper(e),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var n = _step4.value;
      if (!pp(n, {
        upTo: t
      })) return n;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
function pp(e, _ref52) {
  var t = _ref52.upTo;
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e;) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function mp(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function At(e) {
  var _ref53 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref53$select = _ref53.select,
    t = _ref53$select === void 0 ? !1 : _ref53$select;
  if (e && e.focus) {
    var n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && mp(e) && t && e.select();
  }
}
var cs = hp();
function hp() {
  var e = [];
  return {
    add: function add(t) {
      var n = e[0];
      t !== n && (n == null || n.pause()), e = ls(e, t), e.unshift(t);
    },
    remove: function remove(t) {
      var n;
      e = ls(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function ls(e, t) {
  var n = _toConsumableArray(e),
    r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function gp(e) {
  return e.filter(function (t) {
    return t.tagName !== "A";
  });
}
var Yn = /* @__PURE__ */x(function (e, t) {
  var n;
  var _e$container = e.container,
    r = _e$container === void 0 ? globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body : _e$container,
    o = _objectWithoutProperties(e, _excluded49);
  return r ? /* @__PURE__ */uf.createPortal( /* @__PURE__ */C(ie.div, S({}, o, {
    ref: t
  })), r) : null;
});
var yo = 0;
function Ra() {
  V(function () {
    var e, t;
    var n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : us()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : us()), yo++, function () {
      yo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(function (r) {
        return r.remove();
      }), yo--;
    };
  }, []);
}
function us() {
  var e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var _tt = function tt() {
  return _tt = Object.assign || function (t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _tt.apply(this, arguments);
};
function fl(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function bp(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++) (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Tr = "right-scroll-bar-position",
  _r = "width-before-scroll-bar",
  yp = "with-scroll-bars-hidden",
  wp = "--removed-body-scroll-bar-size";
function xp(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function $p(e, t) {
  var n = te(function () {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function Cp(e, t) {
  return $p(t || null, function (n) {
    return e.forEach(function (r) {
      return xp(r, n);
    });
  });
}
function Tp(e) {
  return e;
}
function _p(e, t) {
  t === void 0 && (t = Tp);
  var n = [],
    r = !1,
    o = {
      read: function read() {
        if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return n.length ? n[n.length - 1] : e;
      },
      useMedium: function useMedium(a) {
        var i = t(a, r);
        return n.push(i), function () {
          n = n.filter(function (s) {
            return s !== i;
          });
        };
      },
      assignSyncMedium: function assignSyncMedium(a) {
        for (r = !0; n.length;) {
          var i = n;
          n = [], i.forEach(a);
        }
        n = {
          push: function push(s) {
            return a(s);
          },
          filter: function filter() {
            return n;
          }
        };
      },
      assignMedium: function assignMedium(a) {
        r = !0;
        var i = [];
        if (n.length) {
          var s = n;
          n = [], s.forEach(a), i = n;
        }
        var c = function c() {
            var u = i;
            i = [], u.forEach(a);
          },
          l = function l() {
            return Promise.resolve().then(c);
          };
        l(), n = {
          push: function push(u) {
            i.push(u), l();
          },
          filter: function filter(u) {
            return i = i.filter(u), n;
          }
        };
      }
    };
  return o;
}
function Ip(e) {
  e === void 0 && (e = {});
  var t = _p(null);
  return t.options = _tt({
    async: !0,
    ssr: !1
  }, e), t;
}
var vl = function vl(e) {
  var t = e.sideCar,
    n = fl(e, ["sideCar"]);
  if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r) throw new Error("Sidecar medium not found");
  return ee.createElement(r, _tt({}, n));
};
vl.isSideCarExport = !0;
function Pp(e, t) {
  return e.useMedium(t), vl;
}
var pl = Ip(),
  wo = function wo() {},
  qr = ee.forwardRef(function (e, t) {
    var n = ee.useRef(null),
      r = ee.useState({
        onScrollCapture: wo,
        onWheelCapture: wo,
        onTouchMoveCapture: wo
      }),
      o = r[0],
      a = r[1],
      i = e.forwardProps,
      s = e.children,
      c = e.className,
      l = e.removeScrollBar,
      u = e.enabled,
      d = e.shards,
      f = e.sideCar,
      m = e.noIsolation,
      h = e.inert,
      v = e.allowPinchZoom,
      g = e.as,
      b = g === void 0 ? "div" : g,
      y = fl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
      w = f,
      I = Cp([n, t]),
      P = _tt(_tt({}, y), o);
    return ee.createElement(ee.Fragment, null, u && ee.createElement(w, {
      sideCar: pl,
      removeScrollBar: l,
      shards: d,
      noIsolation: m,
      inert: h,
      setCallbacks: a,
      allowPinchZoom: !!v,
      lockRef: n
    }), i ? ee.cloneElement(ee.Children.only(s), _tt(_tt({}, P), {
      ref: I
    })) : ee.createElement(b, _tt({}, P, {
      className: c,
      ref: I
    }), s));
  });
qr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
qr.classNames = {
  fullWidth: _r,
  zeroRight: Tr
};
var ds,
  Dp = function Dp() {
    if (ds) return ds;
    if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
  };
function Sp() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Dp();
  return t && e.setAttribute("nonce", t), e;
}
function Ep(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Op(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Mp = function Mp() {
    var e = 0,
      t = null;
    return {
      add: function add(n) {
        e == 0 && (t = Sp()) && (Ep(t, n), Op(t)), e++;
      },
      remove: function remove() {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  Np = function Np() {
    var e = Mp();
    return function (t, n) {
      ee.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    };
  },
  ml = function ml() {
    var e = Np(),
      t = function t(n) {
        var r = n.styles,
          o = n.dynamic;
        return e(r, o), null;
      };
    return t;
  },
  kp = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  xo = function xo(e) {
    return parseInt(e || "", 10) || 0;
  },
  Rp = function Rp(e) {
    var t = window.getComputedStyle(document.body),
      n = t[e === "padding" ? "paddingLeft" : "marginLeft"],
      r = t[e === "padding" ? "paddingTop" : "marginTop"],
      o = t[e === "padding" ? "paddingRight" : "marginRight"];
    return [xo(n), xo(r), xo(o)];
  },
  Ap = function Ap(e) {
    if (e === void 0 && (e = "margin"), typeof window > "u") return kp;
    var t = Rp(e),
      n = document.documentElement.clientWidth,
      r = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, r - n + t[2] - t[0])
    };
  },
  Lp = ml(),
  jp = function jp(e, t, n, r) {
    var o = e.left,
      a = e.top,
      i = e.right,
      s = e.gap;
    return n === void 0 && (n = "margin"), "\n  .".concat(yp, " {\n   overflow: hidden ").concat(r, ";\n   padding-right: ").concat(s, "px ").concat(r, ";\n  }\n  body {\n    overflow: hidden ").concat(r, ";\n    overscroll-behavior: contain;\n    ").concat([t && "position: relative ".concat(r, ";"), n === "margin" && "\n    padding-left: ".concat(o, "px;\n    padding-top: ").concat(a, "px;\n    padding-right: ").concat(i, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(s, "px ").concat(r, ";\n    "), n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(Tr, " {\n    right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(_r, " {\n    margin-right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(Tr, " .").concat(Tr, " {\n    right: 0 ").concat(r, ";\n  }\n  \n  .").concat(_r, " .").concat(_r, " {\n    margin-right: 0 ").concat(r, ";\n  }\n  \n  body {\n    ").concat(wp, ": ").concat(s, "px;\n  }\n");
  },
  Fp = function Fp(e) {
    var t = e.noRelative,
      n = e.noImportant,
      r = e.gapMode,
      o = r === void 0 ? "margin" : r,
      a = ee.useMemo(function () {
        return Ap(o);
      }, [o]);
    return ee.createElement(Lp, {
      styles: jp(a, !t, o, n ? "" : "!important")
    });
  },
  Go = !1;
if (typeof window < "u") try {
  var mr = Object.defineProperty({}, "passive", {
    get: function get() {
      return Go = !0, !0;
    }
  });
  window.addEventListener("test", mr, mr), window.removeEventListener("test", mr, mr);
} catch (_unused2) {
  Go = !1;
}
var nn = Go ? {
    passive: !1
  } : !1,
  Wp = function Wp(e) {
    return e.tagName === "TEXTAREA";
  },
  hl = function hl(e, t) {
    var n = window.getComputedStyle(e);
    return (
      // not-not-scrollable
      n[t] !== "hidden" &&
      // contains scroll inside self
      !(n.overflowY === n.overflowX && !Wp(e) && n[t] === "visible")
    );
  },
  Hp = function Hp(e) {
    return hl(e, "overflowY");
  },
  Bp = function Bp(e) {
    return hl(e, "overflowX");
  },
  fs = function fs(e, t) {
    var n = t;
    do {
      typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
      var r = gl(e, n);
      if (r) {
        var o = bl(e, n),
          a = o[1],
          i = o[2];
        if (a > i) return !0;
      }
      n = n.parentNode;
    } while (n && n !== document.body);
    return !1;
  },
  Vp = function Vp(e) {
    var t = e.scrollTop,
      n = e.scrollHeight,
      r = e.clientHeight;
    return [t, n, r];
  },
  Up = function Up(e) {
    var t = e.scrollLeft,
      n = e.scrollWidth,
      r = e.clientWidth;
    return [t, n, r];
  },
  gl = function gl(e, t) {
    return e === "v" ? Hp(t) : Bp(t);
  },
  bl = function bl(e, t) {
    return e === "v" ? Vp(t) : Up(t);
  },
  Yp = function Yp(e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
  },
  Kp = function Kp(e, t, n, r, o) {
    var a = Yp(e, window.getComputedStyle(t).direction),
      i = a * r,
      s = n.target,
      c = t.contains(s),
      l = !1,
      u = i > 0,
      d = 0,
      f = 0;
    do {
      var m = bl(e, s),
        h = m[0],
        v = m[1],
        g = m[2],
        b = v - g - a * h;
      (h || b) && gl(e, s) && (d += b, f += h), s = s.parentNode;
    } while (
    // portaled content
    !c && s !== document.body ||
    // self content
    c && (t.contains(s) || t === s));
    return (u && (o && d === 0 || !o && i > d) || !u && (o && f === 0 || !o && -i > f)) && (l = !0), l;
  },
  hr = function hr(e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
  vs = function vs(e) {
    return [e.deltaX, e.deltaY];
  },
  ps = function ps(e) {
    return e && "current" in e ? e.current : e;
  },
  Gp = function Gp(e, t) {
    return e[0] === t[0] && e[1] === t[1];
  },
  zp = function zp(e) {
    return "\n  .block-interactivity-".concat(e, " {pointer-events: none;}\n  .allow-interactivity-").concat(e, " {pointer-events: all;}\n");
  },
  qp = 0,
  rn = [];
function Xp(e) {
  var t = ee.useRef([]),
    n = ee.useRef([0, 0]),
    r = ee.useRef(),
    o = ee.useState(qp++)[0],
    a = ee.useState(function () {
      return ml();
    })[0],
    i = ee.useRef(e);
  ee.useEffect(function () {
    i.current = e;
  }, [e]), ee.useEffect(function () {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = bp([e.lockRef.current], (e.shards || []).map(ps), !0).filter(Boolean);
      return v.forEach(function (g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function (g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = ee.useCallback(function (v, g) {
      if ("touches" in v && v.touches.length === 2) return !i.current.allowPinchZoom;
      var b = hr(v),
        y = n.current,
        w = "deltaX" in v ? v.deltaX : y[0] - b[0],
        I = "deltaY" in v ? v.deltaY : y[1] - b[1],
        P,
        D = v.target,
        E = Math.abs(w) > Math.abs(I) ? "h" : "v";
      if ("touches" in v && E === "h" && D.type === "range") return !1;
      var _ = fs(E, D);
      if (!_) return !0;
      if (_ ? P = E : (P = E === "v" ? "h" : "v", _ = fs(E, D)), !_) return !1;
      if (!r.current && "changedTouches" in v && (w || I) && (r.current = P), !P) return !0;
      var O = r.current || P;
      return Kp(O, g, v, O === "h" ? w : I, !0);
    }, []),
    c = ee.useCallback(function (v) {
      var g = v;
      if (!(!rn.length || rn[rn.length - 1] !== a)) {
        var b = "deltaY" in g ? vs(g) : hr(g),
          y = t.current.filter(function (P) {
            return P.name === g.type && P.target === g.target && Gp(P.delta, b);
          })[0];
        if (y && y.should) {
          g.cancelable && g.preventDefault();
          return;
        }
        if (!y) {
          var w = (i.current.shards || []).map(ps).filter(Boolean).filter(function (P) {
              return P.contains(g.target);
            }),
            I = w.length > 0 ? s(g, w[0]) : !i.current.noIsolation;
          I && g.cancelable && g.preventDefault();
        }
      }
    }, []),
    l = ee.useCallback(function (v, g, b, y) {
      var w = {
        name: v,
        delta: g,
        target: b,
        should: y
      };
      t.current.push(w), setTimeout(function () {
        t.current = t.current.filter(function (I) {
          return I !== w;
        });
      }, 1);
    }, []),
    u = ee.useCallback(function (v) {
      n.current = hr(v), r.current = void 0;
    }, []),
    d = ee.useCallback(function (v) {
      l(v.type, vs(v), v.target, s(v, e.lockRef.current));
    }, []),
    f = ee.useCallback(function (v) {
      l(v.type, hr(v), v.target, s(v, e.lockRef.current));
    }, []);
  ee.useEffect(function () {
    return rn.push(a), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, nn), document.addEventListener("touchmove", c, nn), document.addEventListener("touchstart", u, nn), function () {
      rn = rn.filter(function (v) {
        return v !== a;
      }), document.removeEventListener("wheel", c, nn), document.removeEventListener("touchmove", c, nn), document.removeEventListener("touchstart", u, nn);
    };
  }, []);
  var m = e.removeScrollBar,
    h = e.inert;
  return ee.createElement(ee.Fragment, null, h ? ee.createElement(a, {
    styles: zp(o)
  }) : null, m ? ee.createElement(Fp, {
    gapMode: "margin"
  }) : null);
}
var Qp = Pp(pl, Xp);
var yl = ee.forwardRef(function (e, t) {
  return ee.createElement(qr, _tt({}, e, {
    ref: t,
    sideCar: Qp
  }));
});
yl.classNames = qr.classNames;
var Aa = yl;
var Zp = function Zp(e) {
    if (typeof document > "u") return null;
    var t = Array.isArray(e) ? e[0] : e;
    return t.ownerDocument.body;
  },
  on = /* @__PURE__ */new WeakMap(),
  gr = /* @__PURE__ */new WeakMap(),
  br = {},
  $o = 0,
  wl = function wl(e) {
    return e && (e.host || wl(e.parentNode));
  },
  Jp = function Jp(e, t) {
    return t.map(function (n) {
      if (e.contains(n)) return n;
      var r = wl(n);
      return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
    }).filter(function (n) {
      return !!n;
    });
  },
  em = function em(e, t, n, r) {
    var o = Jp(t, Array.isArray(e) ? e : [e]);
    br[n] || (br[n] = /* @__PURE__ */new WeakMap());
    var a = br[n],
      i = [],
      s = /* @__PURE__ */new Set(),
      c = new Set(o),
      l = function l(d) {
        !d || s.has(d) || (s.add(d), l(d.parentNode));
      };
    o.forEach(l);
    var u = function u(d) {
      !d || c.has(d) || Array.prototype.forEach.call(d.children, function (f) {
        if (s.has(f)) u(f);else {
          var m = f.getAttribute(r),
            h = m !== null && m !== "false",
            v = (on.get(f) || 0) + 1,
            g = (a.get(f) || 0) + 1;
          on.set(f, v), a.set(f, g), i.push(f), v === 1 && h && gr.set(f, !0), g === 1 && f.setAttribute(n, "true"), h || f.setAttribute(r, "true");
        }
      });
    };
    return u(t), s.clear(), $o++, function () {
      i.forEach(function (d) {
        var f = on.get(d) - 1,
          m = a.get(d) - 1;
        on.set(d, f), a.set(d, m), f || (gr.has(d) || d.removeAttribute(r), gr.delete(d)), m || d.removeAttribute(n);
      }), $o--, $o || (on = /* @__PURE__ */new WeakMap(), on = /* @__PURE__ */new WeakMap(), gr = /* @__PURE__ */new WeakMap(), br = {});
    };
  },
  La = function La(e, t, n) {
    n === void 0 && (n = "data-aria-hidden");
    var r = Array.from(Array.isArray(e) ? e : [e]),
      o = t || Zp(e);
    return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), em(r, o, n, "aria-hidden")) : function () {
      return null;
    };
  };
var xl = "Dialog",
  _Ke7 = Ke(xl),
  _Ke8 = _slicedToArray(_Ke7, 2),
  $l = _Ke8[0],
  YT = _Ke8[1],
  _$l = $l(xl),
  _$l2 = _slicedToArray(_$l, 2),
  tm = _$l2[0],
  gt = _$l2[1],
  ja = function ja(e) {
    var t = e.__scopeDialog,
      n = e.children,
      r = e.open,
      o = e.defaultOpen,
      a = e.onOpenChange,
      _e$modal = e.modal,
      i = _e$modal === void 0 ? !0 : _e$modal,
      s = k(null),
      c = k(null),
      _Ze9 = Ze({
        prop: r,
        defaultProp: o,
        onChange: a
      }),
      _Ze10 = _slicedToArray(_Ze9, 2),
      _Ze10$ = _Ze10[0],
      l = _Ze10$ === void 0 ? !1 : _Ze10$,
      u = _Ze10[1];
    return /* @__PURE__ */C(tm, {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: it(),
      titleId: it(),
      descriptionId: it(),
      open: l,
      onOpenChange: u,
      onOpenToggle: X(function () {
        return u(function (d) {
          return !d;
        });
      }, [u]),
      modal: i
    }, n);
  },
  nm = "DialogTrigger",
  Cl = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded50),
      o = gt(nm, n),
      a = Ce(t, o.triggerRef);
    return /* @__PURE__ */C(ie.button, S({
      type: "button",
      "aria-haspopup": "dialog",
      "aria-expanded": o.open,
      "aria-controls": o.contentId,
      "data-state": Ba(o.open)
    }, r, {
      ref: a,
      onClick: Z(e.onClick, o.onOpenToggle)
    }));
  }),
  Tl = "DialogPortal",
  _$l3 = $l(Tl, {
    forceMount: void 0
  }),
  _$l4 = _slicedToArray(_$l3, 2),
  rm = _$l4[0],
  _l = _$l4[1],
  Il = function Il(e) {
    var t = e.__scopeDialog,
      n = e.forceMount,
      r = e.children,
      o = e.container,
      a = gt(Tl, t);
    return /* @__PURE__ */C(rm, {
      scope: t,
      forceMount: n
    }, at.map(r, function (i) {
      return /* @__PURE__ */C(et, {
        present: n || a.open
      }, /* @__PURE__ */C(Yn, {
        asChild: !0,
        container: o
      }, i));
    }));
  },
  zo = "DialogOverlay",
  Pl = /* @__PURE__ */x(function (e, t) {
    var n = _l(zo, e.__scopeDialog),
      _e$forceMount = e.forceMount,
      r = _e$forceMount === void 0 ? n.forceMount : _e$forceMount,
      o = _objectWithoutProperties(e, _excluded51),
      a = gt(zo, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */C(et, {
      present: r || a.open
    }, /* @__PURE__ */C(om, S({}, o, {
      ref: t
    }))) : null;
  }),
  om = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded52),
      o = gt(zo, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */
      C(Aa, {
        as: qt,
        allowPinchZoom: !0,
        shards: [o.contentRef]
      }, /* @__PURE__ */C(ie.div, S({
        "data-state": Ba(o.open)
      }, r, {
        ref: t,
        style: _objectSpread({
          pointerEvents: "auto"
        }, r.style)
      })))
    );
  }),
  kn = "DialogContent",
  Fa = /* @__PURE__ */x(function (e, t) {
    var n = _l(kn, e.__scopeDialog),
      _e$forceMount2 = e.forceMount,
      r = _e$forceMount2 === void 0 ? n.forceMount : _e$forceMount2,
      o = _objectWithoutProperties(e, _excluded53),
      a = gt(kn, e.__scopeDialog);
    return /* @__PURE__ */C(et, {
      present: r || a.open
    }, a.modal ? /* @__PURE__ */C(am, S({}, o, {
      ref: t
    })) : /* @__PURE__ */C(im, S({}, o, {
      ref: t
    })));
  }),
  am = /* @__PURE__ */x(function (e, t) {
    var n = gt(kn, e.__scopeDialog),
      r = k(null),
      o = Ce(t, n.contentRef, r);
    return V(function () {
      var a = r.current;
      if (a) return La(a);
    }, []), /* @__PURE__ */C(Dl, S({}, e, {
      ref: o,
      trapFocus: n.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: Z(e.onCloseAutoFocus, function (a) {
        var i;
        a.preventDefault(), (i = n.triggerRef.current) === null || i === void 0 || i.focus();
      }),
      onPointerDownOutside: Z(e.onPointerDownOutside, function (a) {
        var i = a.detail.originalEvent,
          s = i.button === 0 && i.ctrlKey === !0;
        (i.button === 2 || s) && a.preventDefault();
      }),
      onFocusOutside: Z(e.onFocusOutside, function (a) {
        return a.preventDefault();
      })
    }));
  }),
  im = /* @__PURE__ */x(function (e, t) {
    var n = gt(kn, e.__scopeDialog),
      r = k(!1),
      o = k(!1);
    return /* @__PURE__ */C(Dl, S({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: function onCloseAutoFocus(a) {
        var i;
        if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
          var s;
          r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
        }
        r.current = !1, o.current = !1;
      },
      onInteractOutside: function onInteractOutside(a) {
        var i, s;
        (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
        var c = a.target;
        ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
      }
    }));
  }),
  Dl = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDialog,
      r = e.trapFocus,
      o = e.onOpenAutoFocus,
      a = e.onCloseAutoFocus,
      i = _objectWithoutProperties(e, _excluded54),
      s = gt(kn, n),
      c = k(null),
      l = Ce(t, c);
    return Ra(), /* @__PURE__ */C(Wt, null, /* @__PURE__ */C(ka, {
      asChild: !0,
      loop: !0,
      trapped: r,
      onMountAutoFocus: o,
      onUnmountAutoFocus: a
    }, /* @__PURE__ */C(Un, S({
      role: "dialog",
      id: s.contentId,
      "aria-describedby": s.descriptionId,
      "aria-labelledby": s.titleId,
      "data-state": Ba(s.open)
    }, i, {
      ref: l,
      onDismiss: function onDismiss() {
        return s.onOpenChange(!1);
      }
    }))), !1);
  }),
  sm = "DialogTitle",
  Wa = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded55),
      o = gt(sm, n);
    return /* @__PURE__ */C(ie.h2, S({
      id: o.titleId
    }, r, {
      ref: t
    }));
  }),
  cm = "DialogClose",
  Ha = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDialog,
      r = _objectWithoutProperties(e, _excluded56),
      o = gt(cm, n);
    return /* @__PURE__ */C(ie.button, S({
      type: "button"
    }, r, {
      ref: t,
      onClick: Z(e.onClick, function () {
        return o.onOpenChange(!1);
      })
    }));
  });
function Ba(e) {
  return e ? "open" : "closed";
}
var lm = Cl,
  Va = x(function (_ref54, o) {
    var _ref54$as = _ref54.as,
      t = _ref54$as === void 0 ? Fe : _ref54$as,
      n = _ref54.children,
      r = _objectWithoutProperties(_ref54, _excluded57);
    return /* @__PURE__ */p.jsx(Cl, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, r), {}, {
        ref: o,
        children: n
      }))
    });
  }),
  Sl = x(function (_ref55, m) {
    var t = _ref55.align,
      n = _ref55.center,
      r = _ref55.children,
      o = _ref55.direction,
      a = _ref55.flex,
      i = _ref55.gap,
      s = _ref55.inline,
      c = _ref55.justify,
      l = _ref55.placeSelf,
      u = _ref55.style,
      d = _ref55.wrap,
      f = _objectWithoutProperties(_ref55, _excluded58);
    return /* @__PURE__ */p.jsx(Sa, _objectSpread(_objectSpread({}, f), {}, {
      ref: m,
      style: Ta(_objectSpread(_objectSpread(_objectSpread({}, u), {}, {
        // Do NOT allow overriding of these, there is no use case to allow this
        alignItems: n ? "center" : t,
        display: s ? "inline-flex" : "flex",
        flexDirection: o,
        justifyContent: n ? "center" : c,
        flex: a,
        flexWrap: d === "reverse" ? "wrap-reverse" : d ? "wrap" : "nowrap"
      }, Array.isArray(i) ? {
        rowGap: i[0],
        columnGap: i[1]
      } : {
        gap: i
      }), {}, {
        placeSelf: l
      })),
      children: r
    }));
  });
function KT(_ref56) {
  var e = _ref56.children,
    t = _objectWithoutProperties(_ref56, _excluded59);
  return /* @__PURE__ */p.jsx(Sl, _objectSpread(_objectSpread({}, t), {}, {
    direction: "column",
    children: e
  }));
}
var um = x(function (_ref57, a) {
    var t = _ref57.children,
      n = _ref57.className,
      _ref57$as = _ref57.as,
      r = _ref57$as === void 0 ? "div" : _ref57$as,
      o = _objectWithoutProperties(_ref57, _excluded60);
    return /* @__PURE__ */p.jsx(Nc, _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Collapsible", n),
      asChild: !0,
      ref: a,
      children: /* @__PURE__ */p.jsx(r, {
        children: t
      })
    }));
  }),
  dm = x(function (_ref58, o) {
    var t = _ref58.children,
      _ref58$as = _ref58.as,
      n = _ref58$as === void 0 ? Fe : _ref58$as,
      r = _objectWithoutProperties(_ref58, _excluded61);
    return /* @__PURE__ */p.jsx(Oc, _objectSpread(_objectSpread({}, r), {}, {
      asChild: !0,
      ref: o,
      children: /* @__PURE__ */p.jsx(n, {
        children: t
      })
    }));
  }),
  Kn = function Kn(_ref59) {
    var e = _ref59.children,
      t = _objectWithoutProperties(_ref59, _excluded62);
    return /* @__PURE__ */p.jsx(Ec, _objectSpread(_objectSpread({}, t), {}, {
      children: e
    }));
  };
Kn.Trigger = dm;
Kn.Content = um;
function wn(e) {
  return e.split("-")[1];
}
function Ua(e) {
  return e === "y" ? "height" : "width";
}
function Tt(e) {
  return e.split("-")[0];
}
function en(e) {
  return ["top", "bottom"].includes(Tt(e)) ? "x" : "y";
}
function ms(e, t, n) {
  var r = e.reference,
    o = e.floating;
  var a = r.x + r.width / 2 - o.width / 2,
    i = r.y + r.height / 2 - o.height / 2,
    s = en(t),
    c = Ua(s),
    l = r[c] / 2 - o[c] / 2,
    u = s === "x";
  var d;
  switch (Tt(t)) {
    case "top":
      d = {
        x: a,
        y: r.y - o.height
      };
      break;
    case "bottom":
      d = {
        x: a,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: i
      };
      break;
    case "left":
      d = {
        x: r.x - o.width,
        y: i
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (wn(t)) {
    case "start":
      d[s] -= l * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += l * (n && u ? -1 : 1);
  }
  return d;
}
var fm = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, n) {
    var _n$placement, r, _n$strategy, o, _n$middleware, a, i, s, c, l, _ms, u, d, f, m, h, v, _ms2, _s$v, g, b, _yield$b, y, w, I, P;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _n$placement = n.placement;
          r = _n$placement === void 0 ? "bottom" : _n$placement;
          _n$strategy = n.strategy;
          o = _n$strategy === void 0 ? "absolute" : _n$strategy;
          _n$middleware = n.middleware;
          a = _n$middleware === void 0 ? [] : _n$middleware;
          i = n.platform;
          s = a.filter(Boolean);
          _context.next = 10;
          return i.isRTL == null ? void 0 : i.isRTL(t);
        case 10:
          c = _context.sent;
          _context.next = 13;
          return i.getElementRects({
            reference: e,
            floating: t,
            strategy: o
          });
        case 13:
          l = _context.sent;
          _ms = ms(l, r, c);
          u = _ms.x;
          d = _ms.y;
          f = r;
          m = {};
          h = 0;
          v = 0;
        case 21:
          if (!(v < s.length)) {
            _context.next = 56;
            break;
          }
          _s$v = s[v];
          g = _s$v.name;
          b = _s$v.fn;
          _context.next = 27;
          return b({
            x: u,
            y: d,
            initialPlacement: r,
            placement: f,
            strategy: o,
            middlewareData: m,
            rects: l,
            platform: i,
            elements: {
              reference: e,
              floating: t
            }
          });
        case 27:
          _yield$b = _context.sent;
          y = _yield$b.x;
          w = _yield$b.y;
          I = _yield$b.data;
          P = _yield$b.reset;
          u = y !== null && y !== void 0 ? y : u;
          d = w !== null && w !== void 0 ? w : d;
          m = _objectSpread(_objectSpread({}, m), {}, _defineProperty({}, g, _objectSpread(_objectSpread({}, m[g]), I)));
          _context.t0 = P && h <= 50;
          if (!_context.t0) {
            _context.next = 53;
            break;
          }
          h++;
          _context.t1 = typeof P == "object";
          if (!_context.t1) {
            _context.next = 52;
            break;
          }
          P.placement && (f = P.placement);
          _context.t2 = P.rects;
          if (!_context.t2) {
            _context.next = 51;
            break;
          }
          if (!(P.rects === !0)) {
            _context.next = 49;
            break;
          }
          _context.next = 46;
          return i.getElementRects({
            reference: e,
            floating: t,
            strategy: o
          });
        case 46:
          _context.t3 = _context.sent;
          _context.next = 50;
          break;
        case 49:
          _context.t3 = P.rects;
        case 50:
          l = _context.t3;
        case 51:
          _ms2 = ms(l, f, c), u = _ms2.x, d = _ms2.y;
        case 52:
          v = -1;
        case 53:
          v++;
          _context.next = 21;
          break;
        case 56:
          return _context.abrupt("return", {
            x: u,
            y: d,
            placement: f,
            strategy: o,
            middlewareData: m
          });
        case 57:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fm(_x2, _x3, _x4) {
    return _ref60.apply(this, arguments);
  };
}();
function St(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function El(e) {
  return typeof e != "number" ? function (t) {
    return _objectSpread({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, t);
  }(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Sr(e) {
  return _objectSpread(_objectSpread({}, e), {}, {
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Rn(_x5, _x6) {
  return _Rn.apply(this, arguments);
}
function _Rn() {
  _Rn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e, t) {
    var n, r, o, a, i, s, c, _St6, _St6$boundary, l, _St6$rootBoundary, u, _St6$elementContext, d, _St6$altBoundary, f, _St6$padding, m, h, v, g, b, y, w, I;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          t === void 0 && (t = {});
          r = e.x;
          o = e.y;
          a = e.platform;
          i = e.rects;
          s = e.elements;
          c = e.strategy;
          _St6 = St(t, e);
          _St6$boundary = _St6.boundary;
          l = _St6$boundary === void 0 ? "clippingAncestors" : _St6$boundary;
          _St6$rootBoundary = _St6.rootBoundary;
          u = _St6$rootBoundary === void 0 ? "viewport" : _St6$rootBoundary;
          _St6$elementContext = _St6.elementContext;
          d = _St6$elementContext === void 0 ? "floating" : _St6$elementContext;
          _St6$altBoundary = _St6.altBoundary;
          f = _St6$altBoundary === void 0 ? !1 : _St6$altBoundary;
          _St6$padding = _St6.padding;
          m = _St6$padding === void 0 ? 0 : _St6$padding;
          h = El(m);
          v = s[f ? d === "floating" ? "reference" : "floating" : d];
          _context10.t0 = Sr;
          _context10.t1 = a;
          _context10.next = 24;
          return a.isElement == null ? void 0 : a.isElement(v);
        case 24:
          _context10.t3 = n = _context10.sent;
          _context10.t2 = _context10.t3 == null;
          if (_context10.t2) {
            _context10.next = 28;
            break;
          }
          _context10.t2 = n;
        case 28:
          if (!_context10.t2) {
            _context10.next = 32;
            break;
          }
          _context10.t4 = v;
          _context10.next = 38;
          break;
        case 32:
          _context10.t5 = v.contextElement;
          if (_context10.t5) {
            _context10.next = 37;
            break;
          }
          _context10.next = 36;
          return a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating);
        case 36:
          _context10.t5 = _context10.sent;
        case 37:
          _context10.t4 = _context10.t5;
        case 38:
          _context10.t6 = _context10.t4;
          _context10.t7 = l;
          _context10.t8 = u;
          _context10.t9 = c;
          _context10.t10 = {
            element: _context10.t6,
            boundary: _context10.t7,
            rootBoundary: _context10.t8,
            strategy: _context10.t9
          };
          _context10.next = 45;
          return _context10.t1.getClippingRect.call(_context10.t1, _context10.t10);
        case 45:
          _context10.t11 = _context10.sent;
          g = (0, _context10.t0)(_context10.t11);
          b = d === "floating" ? _objectSpread(_objectSpread({}, i.floating), {}, {
            x: r,
            y: o
          }) : i.reference;
          _context10.next = 50;
          return a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating);
        case 50:
          y = _context10.sent;
          _context10.next = 53;
          return a.isElement == null ? void 0 : a.isElement(y);
        case 53:
          _context10.t13 = _context10.sent;
          if (!_context10.t13) {
            _context10.next = 58;
            break;
          }
          _context10.next = 57;
          return a.getScale == null ? void 0 : a.getScale(y);
        case 57:
          _context10.t13 = _context10.sent;
        case 58:
          _context10.t12 = _context10.t13;
          if (_context10.t12) {
            _context10.next = 61;
            break;
          }
          _context10.t12 = {
            x: 1,
            y: 1
          };
        case 61:
          w = _context10.t12;
          _context10.t14 = Sr;
          if (!a.convertOffsetParentRelativeRectToViewportRelativeRect) {
            _context10.next = 69;
            break;
          }
          _context10.next = 66;
          return a.convertOffsetParentRelativeRectToViewportRelativeRect({
            rect: b,
            offsetParent: y,
            strategy: c
          });
        case 66:
          _context10.t15 = _context10.sent;
          _context10.next = 70;
          break;
        case 69:
          _context10.t15 = b;
        case 70:
          _context10.t16 = _context10.t15;
          I = (0, _context10.t14)(_context10.t16);
          return _context10.abrupt("return", {
            top: (g.top - I.top + h.top) / w.y,
            bottom: (I.bottom - g.bottom + h.bottom) / w.y,
            left: (g.left - I.left + h.left) / w.x,
            right: (I.right - g.right + h.right) / w.x
          });
        case 73:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _Rn.apply(this, arguments);
}
var An = Math.min,
  Kt = Math.max;
function qo(e, t, n) {
  return Kt(e, An(t, n));
}
var hs = function hs(e) {
    return {
      name: "arrow",
      options: e,
      fn: function fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _data, _ref62;
          var n, r, o, a, i, s, _ref61, c, _ref61$padding, l, u, d, f, m, h, v, g, b, y, w, I, P, D, E, _, O, A, M, B, G, N, j;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                n = t.x, r = t.y, o = t.placement, a = t.rects, i = t.platform, s = t.elements, _ref61 = St(e, t) || {}, c = _ref61.element, _ref61$padding = _ref61.padding, l = _ref61$padding === void 0 ? 0 : _ref61$padding;
                if (!(c == null)) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", {});
              case 3:
                u = El(l);
                d = {
                  x: n,
                  y: r
                };
                f = en(o);
                m = Ua(f);
                _context2.next = 9;
                return i.getDimensions(c);
              case 9:
                h = _context2.sent;
                v = f === "y";
                g = v ? "top" : "left";
                b = v ? "bottom" : "right";
                y = v ? "clientHeight" : "clientWidth";
                w = a.reference[m] + a.reference[f] - d[f] - a.floating[m];
                I = d[f] - a.reference[f];
                _context2.next = 18;
                return i.getOffsetParent == null ? void 0 : i.getOffsetParent(c);
              case 18:
                P = _context2.sent;
                D = P ? P[y] : 0;
                _context2.t0 = D;
                if (!_context2.t0) {
                  _context2.next = 25;
                  break;
                }
                _context2.next = 24;
                return i.isElement == null ? void 0 : i.isElement(P);
              case 24:
                _context2.t0 = _context2.sent;
              case 25:
                _context2.t1 = _context2.t0;
                if (_context2.t1) {
                  _context2.next = 28;
                  break;
                }
                D = s.floating[y] || a.floating[m];
              case 28:
                E = w / 2 - I / 2, _ = D / 2 - h[m] / 2 - 1, O = An(u[g], _), A = An(u[b], _), M = O, B = D - h[m] - A, G = D / 2 - h[m] / 2 + E, N = qo(M, G, B), j = wn(o) != null && G != N && a.reference[m] / 2 - (G < M ? O : A) - h[m] / 2 < 0 ? G < M ? M - G : B - G : 0;
                return _context2.abrupt("return", (_ref62 = {}, _defineProperty(_ref62, f, d[f] - j), _defineProperty(_ref62, "data", (_data = {}, _defineProperty(_data, f, N), _defineProperty(_data, "centerOffset", G - N + j), _data)), _ref62));
              case 30:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      }
    };
  },
  Ol = ["top", "right", "bottom", "left"];
Ol.reduce(function (e, t) {
  return e.concat(t, t + "-start", t + "-end");
}, []);
var vm = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Er(e) {
  return e.replace(/left|right|bottom|top/g, function (t) {
    return vm[t];
  });
}
function pm(e, t, n) {
  n === void 0 && (n = !1);
  var r = wn(e),
    o = en(e),
    a = Ua(o);
  var i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Er(i)), {
    main: i,
    cross: Er(i)
  };
}
var mm = {
  start: "end",
  end: "start"
};
function Co(e) {
  return e.replace(/start|end/g, function (t) {
    return mm[t];
  });
}
var hm = function hm(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    fn: function fn(t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var n, r, o, a, i, s, c, _St, _St$mainAxis, l, _St$crossAxis, u, d, _St$fallbackStrategy, f, _St$fallbackAxisSideD, m, _St$flipAlignment, h, v, g, b, y, w, I, P, D, E, _pm, M, B, _, O, _M, _B, G, A, N;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              r = t.placement;
              o = t.middlewareData;
              a = t.rects;
              i = t.initialPlacement;
              s = t.platform;
              c = t.elements;
              _St = St(e, t);
              _St$mainAxis = _St.mainAxis;
              l = _St$mainAxis === void 0 ? !0 : _St$mainAxis;
              _St$crossAxis = _St.crossAxis;
              u = _St$crossAxis === void 0 ? !0 : _St$crossAxis;
              d = _St.fallbackPlacements;
              _St$fallbackStrategy = _St.fallbackStrategy;
              f = _St$fallbackStrategy === void 0 ? "bestFit" : _St$fallbackStrategy;
              _St$fallbackAxisSideD = _St.fallbackAxisSideDirection;
              m = _St$fallbackAxisSideD === void 0 ? "none" : _St$fallbackAxisSideD;
              _St$flipAlignment = _St.flipAlignment;
              h = _St$flipAlignment === void 0 ? !0 : _St$flipAlignment;
              v = _objectWithoutProperties(_St, _excluded63);
              g = Tt(r);
              b = Tt(i) === i;
              _context3.next = 23;
              return s.isRTL == null ? void 0 : s.isRTL(c.floating);
            case 23:
              y = _context3.sent;
              w = d || (b || !h ? [Er(i)] : function (M) {
                var B = Er(M);
                return [Co(M), B, Co(B)];
              }(i));
              d || m === "none" || w.push.apply(w, _toConsumableArray(function (M, B, G, N) {
                var j = wn(M);
                var U = function (L, R, Y) {
                  var re = ["left", "right"],
                    ae = ["right", "left"],
                    se = ["top", "bottom"],
                    le = ["bottom", "top"];
                  switch (L) {
                    case "top":
                    case "bottom":
                      return Y ? R ? ae : re : R ? re : ae;
                    case "left":
                    case "right":
                      return R ? se : le;
                    default:
                      return [];
                  }
                }(Tt(M), G === "start", N);
                return j && (U = U.map(function (L) {
                  return L + "-" + j;
                }), B && (U = U.concat(U.map(Co)))), U;
              }(i, h, m, y)));
              I = [i].concat(_toConsumableArray(w));
              _context3.next = 29;
              return Rn(t, v);
            case 29:
              P = _context3.sent;
              D = [];
              E = ((n = o.flip) == null ? void 0 : n.overflows) || [];
              if (l && D.push(P[g]), u) {
                _pm = pm(r, a, y), M = _pm.main, B = _pm.cross;
                D.push(P[M], P[B]);
              }
              if (!(E = [].concat(_toConsumableArray(E), [{
                placement: r,
                overflows: D
              }]), !D.every(function (M) {
                return M <= 0;
              }))) {
                _context3.next = 48;
                break;
              }
              _M = (((_ = o.flip) == null ? void 0 : _.index) || 0) + 1, _B = I[_M];
              if (!_B) {
                _context3.next = 37;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  index: _M,
                  overflows: E
                },
                reset: {
                  placement: _B
                }
              });
            case 37:
              G = (O = E.filter(function (N) {
                return N.overflows[0] <= 0;
              }).sort(function (N, j) {
                return N.overflows[1] - j.overflows[1];
              })[0]) == null ? void 0 : O.placement;
              if (G) {
                _context3.next = 46;
                break;
              }
              _context3.t0 = f;
              _context3.next = _context3.t0 === "bestFit" ? 42 : _context3.t0 === "initialPlacement" ? 45 : 46;
              break;
            case 42:
              N = (A = E.map(function (j) {
                return [j.placement, j.overflows.filter(function (U) {
                  return U > 0;
                }).reduce(function (U, L) {
                  return U + L;
                }, 0)];
              }).sort(function (j, U) {
                return j[1] - U[1];
              })[0]) == null ? void 0 : A[0];
              N && (G = N);
              return _context3.abrupt("break", 46);
            case 45:
              G = i;
            case 46:
              if (!(r !== G)) {
                _context3.next = 48;
                break;
              }
              return _context3.abrupt("return", {
                reset: {
                  placement: G
                }
              });
            case 48:
              return _context3.abrupt("return", {});
            case 49:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  };
};
function gs(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function bs(e) {
  return Ol.some(function (t) {
    return e[t] >= 0;
  });
}
var gm = function gm(e) {
    return e === void 0 && (e = {}), {
      name: "hide",
      options: e,
      fn: function fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var n, _St2, _St2$strategy, r, o, a, _a2;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                n = t.rects, _St2 = St(e, t), _St2$strategy = _St2.strategy, r = _St2$strategy === void 0 ? "referenceHidden" : _St2$strategy, o = _objectWithoutProperties(_St2, _excluded64);
                _context4.t0 = r;
                _context4.next = _context4.t0 === "referenceHidden" ? 4 : _context4.t0 === "escaped" ? 11 : 18;
                break;
              case 4:
                _context4.t1 = gs;
                _context4.next = 7;
                return Rn(t, _objectSpread(_objectSpread({}, o), {}, {
                  elementContext: "reference"
                }));
              case 7:
                _context4.t2 = _context4.sent;
                _context4.t3 = n.reference;
                a = (0, _context4.t1)(_context4.t2, _context4.t3);
                return _context4.abrupt("return", {
                  data: {
                    referenceHiddenOffsets: a,
                    referenceHidden: bs(a)
                  }
                });
              case 11:
                _context4.t4 = gs;
                _context4.next = 14;
                return Rn(t, _objectSpread(_objectSpread({}, o), {}, {
                  altBoundary: !0
                }));
              case 14:
                _context4.t5 = _context4.sent;
                _context4.t6 = n.floating;
                _a2 = (0, _context4.t4)(_context4.t5, _context4.t6);
                return _context4.abrupt("return", {
                  data: {
                    escapedOffsets: _a2,
                    escaped: bs(_a2)
                  }
                });
              case 18:
                return _context4.abrupt("return", {});
              case 19:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }))();
      }
    };
  },
  bm = function bm(e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      fn: function fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var n, r, o;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                n = t.x;
                r = t.y;
                _context6.next = 4;
                return function () {
                  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(a, i) {
                    var s, c, l, u, d, f, m, h, v, g, _ref64, b, y, w;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          s = a.placement;
                          c = a.platform;
                          l = a.elements;
                          _context5.next = 5;
                          return c.isRTL == null ? void 0 : c.isRTL(l.floating);
                        case 5:
                          u = _context5.sent;
                          d = Tt(s);
                          f = wn(s);
                          m = en(s) === "x";
                          h = ["left", "top"].includes(d) ? -1 : 1;
                          v = u && m ? -1 : 1;
                          g = St(i, a);
                          _ref64 = typeof g == "number" ? {
                            mainAxis: g,
                            crossAxis: 0,
                            alignmentAxis: null
                          } : _objectSpread({
                            mainAxis: 0,
                            crossAxis: 0,
                            alignmentAxis: null
                          }, g), b = _ref64.mainAxis, y = _ref64.crossAxis, w = _ref64.alignmentAxis;
                          return _context5.abrupt("return", (f && typeof w == "number" && (y = f === "end" ? -1 * w : w), m ? {
                            x: y * v,
                            y: b * h
                          } : {
                            x: b * h,
                            y: y * v
                          }));
                        case 14:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  return function (_x7, _x8) {
                    return _ref63.apply(this, arguments);
                  };
                }()(t, e);
              case 4:
                o = _context6.sent;
                return _context6.abrupt("return", {
                  x: n + o.x,
                  y: r + o.y,
                  data: o
                });
              case 6:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }))();
      }
    };
  };
function Ml(e) {
  return e === "x" ? "y" : "x";
}
var ym = function ym(e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      fn: function fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var _objectSpread3;
          var n, r, o, _St3, _St3$mainAxis, a, _St3$crossAxis, i, _St3$limiter, s, c, l, u, d, f, m, h, g, _g2, v;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                n = t.x;
                r = t.y;
                o = t.placement;
                _St3 = St(e, t);
                _St3$mainAxis = _St3.mainAxis;
                a = _St3$mainAxis === void 0 ? !0 : _St3$mainAxis;
                _St3$crossAxis = _St3.crossAxis;
                i = _St3$crossAxis === void 0 ? !1 : _St3$crossAxis;
                _St3$limiter = _St3.limiter;
                s = _St3$limiter === void 0 ? {
                  fn: function fn(g) {
                    var b = g.x,
                      y = g.y;
                    return {
                      x: b,
                      y: y
                    };
                  }
                } : _St3$limiter;
                c = _objectWithoutProperties(_St3, _excluded65);
                l = {
                  x: n,
                  y: r
                };
                _context7.next = 14;
                return Rn(t, c);
              case 14:
                u = _context7.sent;
                d = en(Tt(o));
                f = Ml(d);
                m = l[d], h = l[f];
                if (a) {
                  g = d === "y" ? "bottom" : "right";
                  m = qo(m + u[d === "y" ? "top" : "left"], m, m - u[g]);
                }
                if (i) {
                  _g2 = f === "y" ? "bottom" : "right";
                  h = qo(h + u[f === "y" ? "top" : "left"], h, h - u[_g2]);
                }
                v = s.fn(_objectSpread(_objectSpread({}, t), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, d, m), _defineProperty(_objectSpread3, f, h), _objectSpread3)));
                return _context7.abrupt("return", _objectSpread(_objectSpread({}, v), {}, {
                  data: {
                    x: v.x - n,
                    y: v.y - r
                  }
                }));
              case 22:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }))();
      }
    };
  },
  wm = function wm(e) {
    return e === void 0 && (e = {}), {
      options: e,
      fn: function fn(t) {
        var _ref65;
        var n = t.x,
          r = t.y,
          o = t.placement,
          a = t.rects,
          i = t.middlewareData,
          _St4 = St(e, t),
          _St4$offset = _St4.offset,
          s = _St4$offset === void 0 ? 0 : _St4$offset,
          _St4$mainAxis = _St4.mainAxis,
          c = _St4$mainAxis === void 0 ? !0 : _St4$mainAxis,
          _St4$crossAxis = _St4.crossAxis,
          l = _St4$crossAxis === void 0 ? !0 : _St4$crossAxis,
          u = {
            x: n,
            y: r
          },
          d = en(o),
          f = Ml(d);
        var m = u[d],
          h = u[f];
        var v = St(s, t),
          g = typeof v == "number" ? {
            mainAxis: v,
            crossAxis: 0
          } : _objectSpread({
            mainAxis: 0,
            crossAxis: 0
          }, v);
        if (c) {
          var w = d === "y" ? "height" : "width",
            I = a.reference[d] - a.floating[w] + g.mainAxis,
            P = a.reference[d] + a.reference[w] - g.mainAxis;
          m < I ? m = I : m > P && (m = P);
        }
        if (l) {
          var b, y;
          var _w2 = d === "y" ? "width" : "height",
            _I = ["top", "left"].includes(Tt(o)),
            _P = a.reference[f] - a.floating[_w2] + (_I && ((b = i.offset) == null ? void 0 : b[f]) || 0) + (_I ? 0 : g.crossAxis),
            D = a.reference[f] + a.reference[_w2] + (_I ? 0 : ((y = i.offset) == null ? void 0 : y[f]) || 0) - (_I ? g.crossAxis : 0);
          h < _P ? h = _P : h > D && (h = D);
        }
        return _ref65 = {}, _defineProperty(_ref65, d, m), _defineProperty(_ref65, f, h), _ref65;
      }
    };
  },
  xm = function xm(e) {
    return e === void 0 && (e = {}), {
      name: "size",
      options: e,
      fn: function fn(t) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var n, r, o, a, _St5, _St5$apply, i, s, c, l, u, d, _r$floating, f, m, h, v, g, b, y, w, I, D, _D, _D2, E, _, O, P;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                n = t.placement;
                r = t.rects;
                o = t.platform;
                a = t.elements;
                _St5 = St(e, t);
                _St5$apply = _St5.apply;
                i = _St5$apply === void 0 ? function () {} : _St5$apply;
                s = _objectWithoutProperties(_St5, _excluded66);
                _context8.next = 10;
                return Rn(t, s);
              case 10:
                c = _context8.sent;
                l = Tt(n);
                u = wn(n);
                d = en(n) === "x";
                _r$floating = r.floating;
                f = _r$floating.width;
                m = _r$floating.height;
                if (!(l === "top" || l === "bottom")) {
                  _context8.next = 36;
                  break;
                }
                h = l;
                _context8.t0 = u;
                _context8.next = 22;
                return o.isRTL == null ? void 0 : o.isRTL(a.floating);
              case 22:
                if (!_context8.sent) {
                  _context8.next = 26;
                  break;
                }
                _context8.t1 = "start";
                _context8.next = 27;
                break;
              case 26:
                _context8.t1 = "end";
              case 27:
                _context8.t2 = _context8.t1;
                if (!(_context8.t0 === _context8.t2)) {
                  _context8.next = 32;
                  break;
                }
                _context8.t3 = "left";
                _context8.next = 33;
                break;
              case 32:
                _context8.t3 = "right";
              case 33:
                v = _context8.t3;
                _context8.next = 37;
                break;
              case 36:
                v = l, h = u === "end" ? "top" : "bottom";
              case 37:
                g = m - c[h], b = f - c[v], y = !t.middlewareData.shift;
                w = g, I = b;
                if (d) {
                  D = f - c.left - c.right;
                  I = u || y ? An(b, D) : D;
                } else {
                  _D = m - c.top - c.bottom;
                  w = u || y ? An(g, _D) : _D;
                }
                if (y && !u) {
                  _D2 = Kt(c.left, 0), E = Kt(c.right, 0), _ = Kt(c.top, 0), O = Kt(c.bottom, 0);
                  d ? I = f - 2 * (_D2 !== 0 || E !== 0 ? _D2 + E : Kt(c.left, c.right)) : w = m - 2 * (_ !== 0 || O !== 0 ? _ + O : Kt(c.top, c.bottom));
                }
                _context8.next = 43;
                return i(_objectSpread(_objectSpread({}, t), {}, {
                  availableWidth: I,
                  availableHeight: w
                }));
              case 43:
                _context8.next = 45;
                return o.getDimensions(a.floating);
              case 45:
                P = _context8.sent;
                return _context8.abrupt("return", f !== P.width || m !== P.height ? {
                  reset: {
                    rects: !0
                  }
                } : {});
              case 47:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }))();
      }
    };
  };
function nt(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function st(e) {
  return nt(e).getComputedStyle(e);
}
function Nl(e) {
  return e instanceof nt(e).Node;
}
function Ft(e) {
  return Nl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ct(e) {
  return e instanceof nt(e).HTMLElement;
}
function _t(e) {
  return e instanceof nt(e).Element;
}
function ys(e) {
  return typeof ShadowRoot < "u" && (e instanceof nt(e).ShadowRoot || e instanceof ShadowRoot);
}
function Ln(e) {
  var _st = st(e),
    t = _st.overflow,
    n = _st.overflowX,
    r = _st.overflowY,
    o = _st.display;
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function $m(e) {
  return ["table", "td", "th"].includes(Ft(e));
}
function Xo(e) {
  var t = Ya(),
    n = st(e);
  return n.transform !== "none" || n.perspective !== "none" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some(function (r) {
    return (n.willChange || "").includes(r);
  }) || ["paint", "layout", "strict", "content"].some(function (r) {
    return (n.contain || "").includes(r);
  });
}
function Ya() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function Xr(e) {
  return ["html", "body", "#document"].includes(Ft(e));
}
var Qo = Math.min,
  un = Math.max,
  Or = Math.round,
  yr = Math.floor,
  Xt = function Xt(e) {
    return {
      x: e,
      y: e
    };
  };
function kl(e) {
  var t = st(e);
  var n = parseFloat(t.width) || 0,
    r = parseFloat(t.height) || 0;
  var o = ct(e),
    a = o ? e.offsetWidth : n,
    i = o ? e.offsetHeight : r,
    s = Or(n) !== a || Or(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Ka(e) {
  return _t(e) ? e : e.contextElement;
}
function dn(e) {
  var t = Ka(e);
  if (!ct(t)) return Xt(1);
  var n = t.getBoundingClientRect(),
    _kl = kl(t),
    r = _kl.width,
    o = _kl.height,
    a = _kl.$;
  var i = (a ? Or(n.width) : n.width) / r,
    s = (a ? Or(n.height) : n.height) / o;
  return i && Number.isFinite(i) || (i = 1), s && Number.isFinite(s) || (s = 1), {
    x: i,
    y: s
  };
}
var ws = Xt(0);
function Rl(e, t, n) {
  var r, o;
  if (t === void 0 && (t = !0), !Ya()) return ws;
  var a = e ? nt(e) : window;
  return !n || t && n !== a ? ws : {
    x: ((r = a.visualViewport) == null ? void 0 : r.offsetLeft) || 0,
    y: ((o = a.visualViewport) == null ? void 0 : o.offsetTop) || 0
  };
}
function Qt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(),
    a = Ka(e);
  var i = Xt(1);
  t && (r ? _t(r) && (i = dn(r)) : i = dn(e));
  var s = Rl(a, n, r);
  var c = (o.left + s.x) / i.x,
    l = (o.top + s.y) / i.y,
    u = o.width / i.x,
    d = o.height / i.y;
  if (a) {
    var f = nt(a),
      m = r && _t(r) ? nt(r) : r;
    var h = f.frameElement;
    for (; h && r && m !== f;) {
      var v = dn(h),
        g = h.getBoundingClientRect(),
        b = getComputedStyle(h),
        y = g.left + (h.clientLeft + parseFloat(b.paddingLeft)) * v.x,
        w = g.top + (h.clientTop + parseFloat(b.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, d *= v.y, c += y, l += w, h = nt(h).frameElement;
    }
  }
  return Sr({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function It(e) {
  return ((Nl(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Qr(e) {
  return _t(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Al(e) {
  return Qt(It(e)).left + Qr(e).scrollLeft;
}
function pn(e) {
  if (Ft(e) === "html") return e;
  var t = e.assignedSlot || e.parentNode || ys(e) && e.host || It(e);
  return ys(t) ? t.host : t;
}
function Ll(e) {
  var t = pn(e);
  return Xr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ct(t) && Ln(t) ? t : Ll(t);
}
function Mr(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Ll(e),
    o = r === ((n = e.ownerDocument) == null ? void 0 : n.body),
    a = nt(r);
  return o ? t.concat(a, a.visualViewport || [], Ln(r) ? r : []) : t.concat(r, Mr(r));
}
function xs(e, t, n) {
  var r;
  if (t === "viewport") r = function (o, a) {
    var i = nt(o),
      s = It(o),
      c = i.visualViewport;
    var l = s.clientWidth,
      u = s.clientHeight,
      d = 0,
      f = 0;
    if (c) {
      l = c.width, u = c.height;
      var m = Ya();
      (!m || m && a === "fixed") && (d = c.offsetLeft, f = c.offsetTop);
    }
    return {
      width: l,
      height: u,
      x: d,
      y: f
    };
  }(e, n);else if (t === "document") r = function (o) {
    var a = It(o),
      i = Qr(o),
      s = o.ownerDocument.body,
      c = un(a.scrollWidth, a.clientWidth, s.scrollWidth, s.clientWidth),
      l = un(a.scrollHeight, a.clientHeight, s.scrollHeight, s.clientHeight);
    var u = -i.scrollLeft + Al(o);
    var d = -i.scrollTop;
    return st(s).direction === "rtl" && (u += un(a.clientWidth, s.clientWidth) - c), {
      width: c,
      height: l,
      x: u,
      y: d
    };
  }(It(e));else if (_t(t)) r = function (o, a) {
    var i = Qt(o, !0, a === "fixed"),
      s = i.top + o.clientTop,
      c = i.left + o.clientLeft,
      l = ct(o) ? dn(o) : Xt(1);
    return {
      width: o.clientWidth * l.x,
      height: o.clientHeight * l.y,
      x: c * l.x,
      y: s * l.y
    };
  }(t, n);else {
    var o = Rl(e);
    r = _objectSpread(_objectSpread({}, t), {}, {
      x: t.x - o.x,
      y: t.y - o.y
    });
  }
  return Sr(r);
}
function jl(e, t) {
  var n = pn(e);
  return !(n === t || !_t(n) || Xr(n)) && (st(n).position === "fixed" || jl(n, t));
}
function $s(e, t) {
  return ct(e) && st(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function Cs(e, t) {
  var n = nt(e);
  if (!ct(e)) return n;
  var r = $s(e, t);
  for (; r && $m(r) && st(r).position === "static";) r = $s(r, t);
  return r && (Ft(r) === "html" || Ft(r) === "body" && st(r).position === "static" && !Xo(r)) ? n : r || function (o) {
    var a = pn(o);
    for (; ct(a) && !Xr(a);) {
      if (Xo(a)) return a;
      a = pn(a);
    }
    return null;
  }(e) || n;
}
function Cm(e, t, n) {
  var r = ct(t),
    o = It(t),
    a = n === "fixed",
    i = Qt(e, !0, a, t);
  var s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var c = Xt(0);
  if (r || !r && !a) if ((Ft(t) !== "body" || Ln(o)) && (s = Qr(t)), ct(t)) {
    var l = Qt(t, !0, a, t);
    c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
  } else o && (c.x = Al(o));
  return {
    x: i.left + s.scrollLeft - c.x,
    y: i.top + s.scrollTop - c.y,
    width: i.width,
    height: i.height
  };
}
var Tm = {
  getClippingRect: function getClippingRect(e) {
    var t = e.element,
      n = e.boundary,
      r = e.rootBoundary,
      o = e.strategy;
    var a = n === "clippingAncestors" ? function (l, u) {
        var d = u.get(l);
        if (d) return d;
        var f = Mr(l).filter(function (g) {
            return _t(g) && Ft(g) !== "body";
          }),
          m = null;
        var h = st(l).position === "fixed";
        var v = h ? pn(l) : l;
        for (; _t(v) && !Xr(v);) {
          var g = st(v),
            b = Xo(v);
          b || g.position !== "fixed" || (m = null), (h ? !b && !m : !b && g.position === "static" && m && ["absolute", "fixed"].includes(m.position) || Ln(v) && !b && jl(l, v)) ? f = f.filter(function (y) {
            return y !== v;
          }) : m = g, v = pn(v);
        }
        return u.set(l, f), f;
      }(t, this._c) : [].concat(n),
      i = [].concat(_toConsumableArray(a), [r]),
      s = i[0],
      c = i.reduce(function (l, u) {
        var d = xs(t, u, o);
        return l.top = un(d.top, l.top), l.right = Qo(d.right, l.right), l.bottom = Qo(d.bottom, l.bottom), l.left = un(d.left, l.left), l;
      }, xs(t, s, o));
    return {
      width: c.right - c.left,
      height: c.bottom - c.top,
      x: c.left,
      y: c.top
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: function convertOffsetParentRelativeRectToViewportRelativeRect(e) {
    var t = e.rect,
      n = e.offsetParent,
      r = e.strategy;
    var o = ct(n),
      a = It(n);
    if (n === a) return t;
    var i = {
        scrollLeft: 0,
        scrollTop: 0
      },
      s = Xt(1);
    var c = Xt(0);
    if ((o || !o && r !== "fixed") && ((Ft(n) !== "body" || Ln(a)) && (i = Qr(n)), ct(n))) {
      var l = Qt(n);
      s = dn(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
    }
    return {
      width: t.width * s.x,
      height: t.height * s.y,
      x: t.x * s.x - i.scrollLeft * s.x + c.x,
      y: t.y * s.y - i.scrollTop * s.y + c.y
    };
  },
  isElement: _t,
  getDimensions: function getDimensions(e) {
    return kl(e);
  },
  getOffsetParent: Cs,
  getDocumentElement: It,
  getScale: dn,
  getElementRects: function getElementRects(e) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var t, n, r, o, a;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            t = e.reference, n = e.floating, r = e.strategy;
            o = _this.getOffsetParent || Cs, a = _this.getDimensions;
            _context9.t0 = Cm;
            _context9.t1 = t;
            _context9.next = 6;
            return o(n);
          case 6:
            _context9.t2 = _context9.sent;
            _context9.t3 = r;
            _context9.t4 = (0, _context9.t0)(_context9.t1, _context9.t2, _context9.t3);
            _context9.t5 = _objectSpread;
            _context9.t6 = {
              x: 0,
              y: 0
            };
            _context9.next = 13;
            return a(n);
          case 13:
            _context9.t7 = _context9.sent;
            _context9.t8 = (0, _context9.t5)(_context9.t6, _context9.t7);
            return _context9.abrupt("return", {
              reference: _context9.t4,
              floating: _context9.t8
            });
          case 16:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  getClientRects: function getClientRects(e) {
    return Array.from(e.getClientRects());
  },
  isRTL: function isRTL(e) {
    return st(e).direction === "rtl";
  }
};
function _m(e, t, n, r) {
  r === void 0 && (r = {});
  var _r4 = r,
    _r4$ancestorScroll = _r4.ancestorScroll,
    o = _r4$ancestorScroll === void 0 ? !0 : _r4$ancestorScroll,
    _r4$ancestorResize = _r4.ancestorResize,
    a = _r4$ancestorResize === void 0 ? !0 : _r4$ancestorResize,
    _r4$elementResize = _r4.elementResize,
    i = _r4$elementResize === void 0 ? !0 : _r4$elementResize,
    _r4$layoutShift = _r4.layoutShift,
    s = _r4$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _r4$layoutShift,
    _r4$animationFrame = _r4.animationFrame,
    c = _r4$animationFrame === void 0 ? !1 : _r4$animationFrame,
    l = Ka(e),
    u = o || a ? [].concat(_toConsumableArray(l ? Mr(l) : []), _toConsumableArray(Mr(t))) : [];
  u.forEach(function (v) {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  var d = l && s ? function (v, g) {
    var b,
      y = null;
    var w = It(v);
    function I() {
      clearTimeout(b), y && y.disconnect(), y = null;
    }
    return function P(D, E) {
      D === void 0 && (D = !1), E === void 0 && (E = 1), I();
      var _v$getBoundingClientR = v.getBoundingClientRect(),
        _ = _v$getBoundingClientR.left,
        O = _v$getBoundingClientR.top,
        A = _v$getBoundingClientR.width,
        M = _v$getBoundingClientR.height;
      if (D || g(), !A || !M) return;
      var B = yr(O),
        G = yr(w.clientWidth - (_ + A)),
        N = yr(w.clientHeight - (O + M)),
        j = yr(_);
      var U = !0;
      y = new IntersectionObserver(function (L) {
        var R = L[0].intersectionRatio;
        if (R !== E) {
          if (!U) return P();
          R ? P(!1, R) : b = setTimeout(function () {
            P(!1, 1e-7);
          }, 100);
        }
        U = !1;
      }, {
        rootMargin: -B + "px " + -G + "px " + -N + "px " + -j + "px",
        threshold: un(0, Qo(1, E)) || 1
      }), y.observe(v);
    }(!0), I;
  }(l, n) : null;
  var f,
    m = null;
  i && (m = new ResizeObserver(n), l && !c && m.observe(l), m.observe(t));
  var h = c ? Qt(e) : null;
  return c && function v() {
    var g = Qt(e);
    !h || g.x === h.x && g.y === h.y && g.width === h.width && g.height === h.height || n(), h = g, f = requestAnimationFrame(v);
  }(), n(), function () {
    u.forEach(function (v) {
      o && v.removeEventListener("scroll", n), a && v.removeEventListener("resize", n);
    }), d && d(), m && m.disconnect(), m = null, c && cancelAnimationFrame(f);
  };
}
var Im = function Im(e, t, n) {
    var r = /* @__PURE__ */new Map(),
      o = _objectSpread({
        platform: Tm
      }, n),
      a = _objectSpread(_objectSpread({}, o.platform), {}, {
        _c: r
      });
    return fm(e, t, _objectSpread(_objectSpread({}, o), {}, {
      platform: a
    }));
  },
  Pm = function Pm(e) {
    function t(n) {
      return {}.hasOwnProperty.call(n, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn: function fn(n) {
        var _ref66 = typeof e == "function" ? e(n) : e,
          r = _ref66.element,
          o = _ref66.padding;
        return r && t(r) ? r.current != null ? hs({
          element: r.current,
          padding: o
        }).fn(n) : {} : r ? hs({
          element: r,
          padding: o
        }).fn(n) : {};
      }
    };
  };
var Ir = typeof document < "u" ? pa : V;
function Nr(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  var n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0;) if (!Nr(e[r], t[r])) return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length) return !1;
    for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, o[r])) return !1;
    for (r = n; r-- !== 0;) {
      var a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !Nr(e[a], t[a])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Fl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ts(e, t) {
  var n = Fl(e);
  return Math.round(t * n) / n;
}
function _s(e) {
  var t = ee.useRef(e);
  return Ir(function () {
    t.current = e;
  }), t;
}
function Dm(e) {
  e === void 0 && (e = {});
  var _e2 = e,
    _e2$placement = _e2.placement,
    t = _e2$placement === void 0 ? "bottom" : _e2$placement,
    _e2$strategy = _e2.strategy,
    n = _e2$strategy === void 0 ? "absolute" : _e2$strategy,
    _e2$middleware = _e2.middleware,
    r = _e2$middleware === void 0 ? [] : _e2$middleware,
    o = _e2.platform,
    _e2$elements = _e2.elements,
    _e2$elements2 = _e2$elements === void 0 ? {} : _e2$elements,
    a = _e2$elements2.reference,
    i = _e2$elements2.floating,
    _e2$transform = _e2.transform,
    s = _e2$transform === void 0 ? !0 : _e2$transform,
    c = _e2.whileElementsMounted,
    l = _e2.open,
    _ee$useState3 = ee.useState({
      x: 0,
      y: 0,
      strategy: n,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }),
    _ee$useState4 = _slicedToArray(_ee$useState3, 2),
    u = _ee$useState4[0],
    d = _ee$useState4[1],
    _ee$useState5 = ee.useState(r),
    _ee$useState6 = _slicedToArray(_ee$useState5, 2),
    f = _ee$useState6[0],
    m = _ee$useState6[1];
  Nr(f, r) || m(r);
  var _ee$useState7 = ee.useState(null),
    _ee$useState8 = _slicedToArray(_ee$useState7, 2),
    h = _ee$useState8[0],
    v = _ee$useState8[1],
    _ee$useState9 = ee.useState(null),
    _ee$useState10 = _slicedToArray(_ee$useState9, 2),
    g = _ee$useState10[0],
    b = _ee$useState10[1],
    y = ee.useCallback(function (U) {
      U != D.current && (D.current = U, v(U));
    }, [v]),
    w = ee.useCallback(function (U) {
      U !== E.current && (E.current = U, b(U));
    }, [b]),
    I = a || h,
    P = i || g,
    D = ee.useRef(null),
    E = ee.useRef(null),
    _ = ee.useRef(u),
    O = _s(c),
    A = _s(o),
    M = ee.useCallback(function () {
      if (!D.current || !E.current) return;
      var U = {
        placement: t,
        strategy: n,
        middleware: f
      };
      A.current && (U.platform = A.current), Im(D.current, E.current, U).then(function (L) {
        var R = _objectSpread(_objectSpread({}, L), {}, {
          isPositioned: !0
        });
        B.current && !Nr(_.current, R) && (_.current = R, lf.flushSync(function () {
          d(R);
        }));
      });
    }, [f, t, n, A]);
  Ir(function () {
    l === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d(function (U) {
      return _objectSpread(_objectSpread({}, U), {}, {
        isPositioned: !1
      });
    }));
  }, [l]);
  var B = ee.useRef(!1);
  Ir(function () {
    return B.current = !0, function () {
      B.current = !1;
    };
  }, []), Ir(function () {
    if (I && (D.current = I), P && (E.current = P), I && P) {
      if (O.current) return O.current(I, P, M);
      M();
    }
  }, [I, P, M, O]);
  var G = ee.useMemo(function () {
      return {
        reference: D,
        floating: E,
        setReference: y,
        setFloating: w
      };
    }, [y, w]),
    N = ee.useMemo(function () {
      return {
        reference: I,
        floating: P
      };
    }, [I, P]),
    j = ee.useMemo(function () {
      var U = {
        position: n,
        left: 0,
        top: 0
      };
      if (!N.floating) return U;
      var L = Ts(N.floating, u.x),
        R = Ts(N.floating, u.y);
      return s ? _objectSpread(_objectSpread({}, U), {}, {
        transform: "translate(" + L + "px, " + R + "px)"
      }, Fl(N.floating) >= 1.5 && {
        willChange: "transform"
      }) : {
        position: n,
        left: L,
        top: R
      };
    }, [n, s, N.floating, u.x, u.y]);
  return ee.useMemo(function () {
    return _objectSpread(_objectSpread({}, u), {}, {
      update: M,
      refs: G,
      elements: N,
      floatingStyles: j
    });
  }, [u, M, G, N, j]);
}
var Sm = /* @__PURE__ */x(function (e, t) {
    var n = e.children,
      _e$width = e.width,
      r = _e$width === void 0 ? 10 : _e$width,
      _e$height = e.height,
      o = _e$height === void 0 ? 5 : _e$height,
      a = _objectWithoutProperties(e, _excluded67);
    return /* @__PURE__ */C(ie.svg, S({}, a, {
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none"
    }), e.asChild ? n : /* @__PURE__ */C("polygon", {
      points: "0,0 30,0 15,10"
    }));
  }),
  Em = Sm;
function Wl(e) {
  var _te29 = te(void 0),
    _te30 = _slicedToArray(_te29, 2),
    t = _te30[0],
    n = _te30[1];
  return jt(function () {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      var r = new ResizeObserver(function (o) {
        if (!Array.isArray(o) || !o.length) return;
        var a = o[0];
        var i, s;
        if ("borderBoxSize" in a) {
          var c = a.borderBoxSize,
            l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else i = e.offsetWidth, s = e.offsetHeight;
        n({
          width: i,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), function () {
        return r.unobserve(e);
      };
    } else n(void 0);
  }, [e]), t;
}
var Hl = "Popper",
  _Ke9 = Ke(Hl),
  _Ke10 = _slicedToArray(_Ke9, 2),
  Bl = _Ke10[0],
  xn = _Ke10[1],
  _Bl = Bl(Hl),
  _Bl2 = _slicedToArray(_Bl, 2),
  Om = _Bl2[0],
  Vl = _Bl2[1],
  Ul = function Ul(e) {
    var t = e.__scopePopper,
      n = e.children,
      _te31 = te(null),
      _te32 = _slicedToArray(_te31, 2),
      r = _te32[0],
      o = _te32[1];
    return /* @__PURE__ */C(Om, {
      scope: t,
      anchor: r,
      onAnchorChange: o
    }, n);
  },
  Mm = "PopperAnchor",
  Zr = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopper,
      r = e.virtualRef,
      o = _objectWithoutProperties(e, _excluded68),
      a = Vl(Mm, n),
      i = k(null),
      s = Ce(t, i);
    return V(function () {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */C(ie.div, S({}, o, {
      ref: s
    }));
  }),
  Yl = "PopperContent",
  _Bl3 = Bl(Yl),
  _Bl4 = _slicedToArray(_Bl3, 2),
  Nm = _Bl4[0],
  km = _Bl4[1],
  Kl = /* @__PURE__ */x(function (e, t) {
    var n, r, o, a, i, s, c, l;
    var u = e.__scopePopper,
      _e$side = e.side,
      d = _e$side === void 0 ? "bottom" : _e$side,
      _e$sideOffset = e.sideOffset,
      f = _e$sideOffset === void 0 ? 0 : _e$sideOffset,
      _e$align = e.align,
      m = _e$align === void 0 ? "center" : _e$align,
      _e$alignOffset = e.alignOffset,
      h = _e$alignOffset === void 0 ? 0 : _e$alignOffset,
      _e$arrowPadding = e.arrowPadding,
      v = _e$arrowPadding === void 0 ? 0 : _e$arrowPadding,
      _e$avoidCollisions = e.avoidCollisions,
      g = _e$avoidCollisions === void 0 ? !0 : _e$avoidCollisions,
      _e$collisionBoundary = e.collisionBoundary,
      b = _e$collisionBoundary === void 0 ? [] : _e$collisionBoundary,
      _e$collisionPadding = e.collisionPadding,
      y = _e$collisionPadding === void 0 ? 0 : _e$collisionPadding,
      _e$sticky = e.sticky,
      w = _e$sticky === void 0 ? "partial" : _e$sticky,
      _e$hideWhenDetached = e.hideWhenDetached,
      I = _e$hideWhenDetached === void 0 ? !1 : _e$hideWhenDetached,
      _e$updatePositionStra = e.updatePositionStrategy,
      P = _e$updatePositionStra === void 0 ? "optimized" : _e$updatePositionStra,
      D = e.onPlaced,
      E = _objectWithoutProperties(e, _excluded69),
      _ = Vl(Yl, u),
      _te33 = te(null),
      _te34 = _slicedToArray(_te33, 2),
      O = _te34[0],
      A = _te34[1],
      M = Ce(t, function (ke) {
        return A(ke);
      }),
      _te35 = te(null),
      _te36 = _slicedToArray(_te35, 2),
      B = _te36[0],
      G = _te36[1],
      N = Wl(B),
      j = (n = N == null ? void 0 : N.width) !== null && n !== void 0 ? n : 0,
      U = (r = N == null ? void 0 : N.height) !== null && r !== void 0 ? r : 0,
      L = d + (m !== "center" ? "-" + m : ""),
      R = typeof y == "number" ? y : _objectSpread({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, y),
      Y = Array.isArray(b) ? b : [b],
      re = Y.length > 0,
      ae = {
        padding: R,
        boundary: Y.filter(jm),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: re
      },
      _Dm = Dm({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: L,
        whileElementsMounted: function whileElementsMounted() {
          for (var _len9 = arguments.length, ke = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            ke[_key9] = arguments[_key9];
          }
          return _m.apply(void 0, ke.concat([{
            animationFrame: P === "always"
          }]));
        },
        elements: {
          reference: _.anchor
        },
        middleware: [bm({
          mainAxis: f + U,
          alignmentAxis: h
        }), g && ym(_objectSpread({
          mainAxis: !0,
          crossAxis: !1,
          limiter: w === "partial" ? wm() : void 0
        }, ae)), g && hm(_objectSpread({}, ae)), xm(_objectSpread(_objectSpread({}, ae), {}, {
          apply: function apply(_ref67) {
            var ke = _ref67.elements,
              ze = _ref67.rects,
              ye = _ref67.availableWidth,
              Ot = _ref67.availableHeight;
            var _ze$reference = ze.reference,
              vt = _ze$reference.width,
              In = _ze$reference.height,
              Be = ke.floating.style;
            Be.setProperty("--radix-popper-available-width", "".concat(ye, "px")), Be.setProperty("--radix-popper-available-height", "".concat(Ot, "px")), Be.setProperty("--radix-popper-anchor-width", "".concat(vt, "px")), Be.setProperty("--radix-popper-anchor-height", "".concat(In, "px"));
          }
        })), B && Pm({
          element: B,
          padding: v
        }), Fm({
          arrowWidth: j,
          arrowHeight: U
        }), I && gm(_objectSpread({
          strategy: "referenceHidden"
        }, ae))]
      }),
      se = _Dm.refs,
      le = _Dm.floatingStyles,
      fe = _Dm.placement,
      xe = _Dm.isPositioned,
      be = _Dm.middlewareData,
      _Gl = Gl(fe),
      _Gl2 = _slicedToArray(_Gl, 2),
      q = _Gl2[0],
      W = _Gl2[1],
      F = Xe(D);
    jt(function () {
      xe && (F == null || F());
    }, [xe, F]);
    var J = (o = be.arrow) === null || o === void 0 ? void 0 : o.x,
      Se = (a = be.arrow) === null || a === void 0 ? void 0 : a.y,
      Pe = ((i = be.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0,
      _te37 = te(),
      _te38 = _slicedToArray(_te37, 2),
      Ae = _te38[0],
      Le = _te38[1];
    return jt(function () {
      O && Le(window.getComputedStyle(O).zIndex);
    }, [O]), /* @__PURE__ */C("div", {
      ref: se.setFloating,
      "data-radix-popper-content-wrapper": "",
      style: _objectSpread(_objectSpread({}, le), {}, {
        transform: xe ? le.transform : "translate(0, -200%)",
        // keep off the page when measuring
        minWidth: "max-content",
        zIndex: Ae,
        "--radix-popper-transform-origin": [(s = be.transformOrigin) === null || s === void 0 ? void 0 : s.x, (c = be.transformOrigin) === null || c === void 0 ? void 0 : c.y].join(" ")
      }),
      dir: e.dir
    }, /* @__PURE__ */C(Nm, {
      scope: u,
      placedSide: q,
      onArrowChange: G,
      arrowX: J,
      arrowY: Se,
      shouldHideArrow: Pe
    }, /* @__PURE__ */C(ie.div, S({
      "data-side": q,
      "data-align": W
    }, E, {
      ref: M,
      style: _objectSpread(_objectSpread({}, E.style), {}, {
        // if the PopperContent hasn't been placed yet (not all measurements done)
        // we prevent animations so that users's animation don't kick in too early referring wrong sides
        animation: xe ? void 0 : "none",
        // hide the content if using the hide middleware and should be hidden
        opacity: (l = be.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
      })
    }))));
  }),
  Rm = "PopperArrow",
  Am = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  },
  Lm = /* @__PURE__ */x(function (t, n) {
    var _style;
    var r = t.__scopePopper,
      o = _objectWithoutProperties(t, _excluded70),
      a = km(Rm, r),
      i = Am[a.placedSide];
    return (
      // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
      // doesn't report size as we'd expect on SVG elements.
      // it reports their bounding box which is effectively the largest path inside the SVG.
      /* @__PURE__ */
      C("span", {
        ref: a.onArrowChange,
        style: (_style = {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY
        }, _defineProperty(_style, i, 0), _defineProperty(_style, "transformOrigin", {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[a.placedSide]), _defineProperty(_style, "transform", {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[a.placedSide]), _defineProperty(_style, "visibility", a.shouldHideArrow ? "hidden" : void 0), _style)
      }, /* @__PURE__ */C(Em, S({}, o, {
        ref: n,
        style: _objectSpread(_objectSpread({}, o.style), {}, {
          // ensures the element can be measured correctly (mostly for if SVG)
          display: "block"
        })
      })))
    );
  });
function jm(e) {
  return e !== null;
}
var Fm = function Fm(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn: function fn(t) {
      var n, r, o, a, i;
      var s = t.placement,
        c = t.rects,
        l = t.middlewareData,
        d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0,
        f = d ? 0 : e.arrowWidth,
        m = d ? 0 : e.arrowHeight,
        _Gl3 = Gl(s),
        _Gl4 = _slicedToArray(_Gl3, 2),
        h = _Gl4[0],
        v = _Gl4[1],
        g = {
          start: "0%",
          center: "50%",
          end: "100%"
        }[v],
        b = ((r = (o = l.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2,
        y = ((a = (i = l.arrow) === null || i === void 0 ? void 0 : i.y) !== null && a !== void 0 ? a : 0) + m / 2;
      var w = "",
        I = "";
      return h === "bottom" ? (w = d ? g : "".concat(b, "px"), I = "".concat(-m, "px")) : h === "top" ? (w = d ? g : "".concat(b, "px"), I = "".concat(c.floating.height + m, "px")) : h === "right" ? (w = "".concat(-m, "px"), I = d ? g : "".concat(y, "px")) : h === "left" && (w = "".concat(c.floating.width + m, "px"), I = d ? g : "".concat(y, "px")), {
        data: {
          x: w,
          y: I
        }
      };
    }
  };
};
function Gl(e) {
  var _e$split = e.split("-"),
    _e$split2 = _slicedToArray(_e$split, 2),
    t = _e$split2[0],
    _e$split2$ = _e$split2[1],
    n = _e$split2$ === void 0 ? "center" : _e$split2$;
  return [t, n];
}
var Ga = Ul,
  Jr = Zr,
  za = Kl,
  zl = Lm,
  ql = "Popover",
  _Ke11 = Ke(ql, [xn]),
  _Ke12 = _slicedToArray(_Ke11, 2),
  Xl = _Ke12[0],
  GT = _Ke12[1],
  Gn = xn(),
  _Xl = Xl(ql),
  _Xl2 = _slicedToArray(_Xl, 2),
  Wm = _Xl2[0],
  Bt = _Xl2[1],
  Ql = function Ql(e) {
    var t = e.__scopePopover,
      n = e.children,
      r = e.open,
      o = e.defaultOpen,
      a = e.onOpenChange,
      _e$modal2 = e.modal,
      i = _e$modal2 === void 0 ? !1 : _e$modal2,
      s = Gn(t),
      c = k(null),
      _te39 = te(!1),
      _te40 = _slicedToArray(_te39, 2),
      l = _te40[0],
      u = _te40[1],
      _Ze11 = Ze({
        prop: r,
        defaultProp: o,
        onChange: a
      }),
      _Ze12 = _slicedToArray(_Ze11, 2),
      _Ze12$ = _Ze12[0],
      d = _Ze12$ === void 0 ? !1 : _Ze12$,
      f = _Ze12[1];
    return /* @__PURE__ */C(Ga, s, /* @__PURE__ */C(Wm, {
      scope: t,
      contentId: it(),
      triggerRef: c,
      open: d,
      onOpenChange: f,
      onOpenToggle: X(function () {
        return f(function (m) {
          return !m;
        });
      }, [f]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: X(function () {
        return u(!0);
      }, []),
      onCustomAnchorRemove: X(function () {
        return u(!1);
      }, []),
      modal: i
    }, n));
  },
  Hm = "PopoverAnchor",
  Bm = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopover,
      r = _objectWithoutProperties(e, _excluded71),
      o = Bt(Hm, n),
      a = Gn(n),
      i = o.onCustomAnchorAdd,
      s = o.onCustomAnchorRemove;
    return V(function () {
      return i(), function () {
        return s();
      };
    }, [i, s]), /* @__PURE__ */C(Jr, S({}, a, r, {
      ref: t
    }));
  }),
  Vm = "PopoverTrigger",
  Um = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopover,
      r = _objectWithoutProperties(e, _excluded72),
      o = Bt(Vm, n),
      a = Gn(n),
      i = Ce(t, o.triggerRef),
      s = /* @__PURE__ */C(ie.button, S({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ru(o.open)
      }, r, {
        ref: i,
        onClick: Z(e.onClick, o.onOpenToggle)
      }));
    return o.hasCustomAnchor ? s : /* @__PURE__ */C(Jr, S({
      asChild: !0
    }, a), s);
  }),
  Zl = "PopoverPortal",
  _Xl3 = Xl(Zl, {
    forceMount: void 0
  }),
  _Xl4 = _slicedToArray(_Xl3, 2),
  Ym = _Xl4[0],
  Km = _Xl4[1],
  Jl = function Jl(e) {
    var t = e.__scopePopover,
      n = e.forceMount,
      r = e.children,
      o = e.container,
      a = Bt(Zl, t);
    return /* @__PURE__ */C(Ym, {
      scope: t,
      forceMount: n
    }, /* @__PURE__ */C(et, {
      present: n || a.open
    }, /* @__PURE__ */C(Yn, {
      asChild: !0,
      container: o
    }, r)));
  },
  jn = "PopoverContent",
  eu = /* @__PURE__ */x(function (e, t) {
    var n = Km(jn, e.__scopePopover),
      _e$forceMount3 = e.forceMount,
      r = _e$forceMount3 === void 0 ? n.forceMount : _e$forceMount3,
      o = _objectWithoutProperties(e, _excluded73),
      a = Bt(jn, e.__scopePopover);
    return /* @__PURE__ */C(et, {
      present: r || a.open
    }, a.modal ? /* @__PURE__ */C(Gm, S({}, o, {
      ref: t
    })) : /* @__PURE__ */C(zm, S({}, o, {
      ref: t
    })));
  }),
  Gm = /* @__PURE__ */x(function (e, t) {
    var n = Bt(jn, e.__scopePopover),
      r = k(null),
      o = Ce(t, r),
      a = k(!1);
    return V(function () {
      var i = r.current;
      if (i) return La(i);
    }, []), /* @__PURE__ */C(Aa, {
      as: qt,
      allowPinchZoom: !0
    }, /* @__PURE__ */C(tu, S({}, e, {
      ref: o,
      trapFocus: n.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: Z(e.onCloseAutoFocus, function (i) {
        var s;
        i.preventDefault(), a.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
      }),
      onPointerDownOutside: Z(e.onPointerDownOutside, function (i) {
        var s = i.detail.originalEvent,
          c = s.button === 0 && s.ctrlKey === !0,
          l = s.button === 2 || c;
        a.current = l;
      }, {
        checkForDefaultPrevented: !1
      }),
      onFocusOutside: Z(e.onFocusOutside, function (i) {
        return i.preventDefault();
      }, {
        checkForDefaultPrevented: !1
      })
    })));
  }),
  zm = /* @__PURE__ */x(function (e, t) {
    var n = Bt(jn, e.__scopePopover),
      r = k(!1),
      o = k(!1);
    return /* @__PURE__ */C(tu, S({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: function onCloseAutoFocus(a) {
        var i;
        if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
          var s;
          r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
        }
        r.current = !1, o.current = !1;
      },
      onInteractOutside: function onInteractOutside(a) {
        var i, s;
        (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
        var c = a.target;
        ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
      }
    }));
  }),
  tu = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopover,
      r = e.trapFocus,
      o = e.onOpenAutoFocus,
      a = e.onCloseAutoFocus,
      i = e.disableOutsidePointerEvents,
      s = e.onEscapeKeyDown,
      c = e.onPointerDownOutside,
      l = e.onFocusOutside,
      u = e.onInteractOutside,
      d = _objectWithoutProperties(e, _excluded74),
      f = Bt(jn, n),
      m = Gn(n);
    return Ra(), /* @__PURE__ */C(ka, {
      asChild: !0,
      loop: !0,
      trapped: r,
      onMountAutoFocus: o,
      onUnmountAutoFocus: a
    }, /* @__PURE__ */C(Un, {
      asChild: !0,
      disableOutsidePointerEvents: i,
      onInteractOutside: u,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onDismiss: function onDismiss() {
        return f.onOpenChange(!1);
      }
    }, /* @__PURE__ */C(za, S({
      "data-state": ru(f.open),
      role: "dialog",
      id: f.contentId
    }, m, d, {
      ref: t,
      style: _objectSpread(_objectSpread({}, d.style), {}, {
        "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
        "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
        "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
      })
    }))));
  }),
  qm = "PopoverClose",
  nu = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopover,
      r = _objectWithoutProperties(e, _excluded75),
      o = Bt(qm, n);
    return /* @__PURE__ */C(ie.button, S({
      type: "button"
    }, r, {
      ref: t,
      onClick: Z(e.onClick, function () {
        return o.onOpenChange(!1);
      })
    }));
  }),
  Xm = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopePopover,
      r = _objectWithoutProperties(e, _excluded76),
      o = Gn(n);
    return /* @__PURE__ */C(zl, S({}, o, r, {
      ref: t
    }));
  });
function ru(e) {
  return e ? "open" : "closed";
}
function lt(e) {
  "@babel/helpers - typeof";

  return lt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lt(e);
}
function Te(e) {
  if (e === null || e === !0 || e === !1) return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Q(e, t) {
  if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ne(e) {
  Q(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || lt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */new Date(NaN));
}
function Ve(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = Te(t);
  return isNaN(r) ? /* @__PURE__ */new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Ye(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = Te(t);
  if (isNaN(r)) return /* @__PURE__ */new Date(NaN);
  if (!r) return n;
  var o = n.getDate(),
    a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var i = a.getDate();
  return o >= i ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), o), n);
}
function Qm(e, t) {
  Q(2, arguments);
  var n = ne(e).getTime(),
    r = Te(t);
  return new Date(n + r);
}
var Zm = {};
function bt() {
  return Zm;
}
function ht(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = bt(),
    d = Te((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ne(e),
    m = f.getDay(),
    h = (m < d ? 7 : 0) + m - d;
  return f.setDate(f.getDate() - h), f.setHours(0, 0, 0, 0), f;
}
function Zt(e) {
  return Q(1, arguments), ht(e, {
    weekStartsOn: 1
  });
}
function Jm(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getFullYear(),
    r = /* @__PURE__ */new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var o = Zt(r),
    a = /* @__PURE__ */new Date(0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  var i = Zt(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function eh(e) {
  Q(1, arguments);
  var t = Jm(e),
    n = /* @__PURE__ */new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Zt(n);
  return r;
}
function mn(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function hn(e) {
  Q(1, arguments);
  var t = ne(e);
  return t.setHours(0, 0, 0, 0), t;
}
var th = 864e5;
function Ct(e, t) {
  Q(2, arguments);
  var n = hn(e),
    r = hn(t),
    o = n.getTime() - mn(n),
    a = r.getTime() - mn(r);
  return Math.round((o - a) / th);
}
function Zo(e, t) {
  Q(2, arguments);
  var n = Te(t),
    r = n * 7;
  return Ve(e, r);
}
function nh(e, t) {
  Q(2, arguments);
  var n = Te(t);
  return Ye(e, n * 12);
}
function rh(e) {
  Q(1, arguments);
  var t;
  if (e && typeof e.forEach == "function") t = e;else if (lt(e) === "object" && e !== null) t = Array.prototype.slice.call(e);else return /* @__PURE__ */new Date(NaN);
  var n;
  return t.forEach(function (r) {
    var o = ne(r);
    (n === void 0 || n < o || isNaN(Number(o))) && (n = o);
  }), n || /* @__PURE__ */new Date(NaN);
}
function oh(e) {
  Q(1, arguments);
  var t;
  if (e && typeof e.forEach == "function") t = e;else if (lt(e) === "object" && e !== null) t = Array.prototype.slice.call(e);else return /* @__PURE__ */new Date(NaN);
  var n;
  return t.forEach(function (r) {
    var o = ne(r);
    (n === void 0 || n > o || isNaN(o.getDate())) && (n = o);
  }), n || /* @__PURE__ */new Date(NaN);
}
var ah = 6e4,
  ih = 36e5,
  sh = 1e3;
function We(e, t) {
  Q(2, arguments);
  var n = hn(e),
    r = hn(t);
  return n.getTime() === r.getTime();
}
function qa(e) {
  return Q(1, arguments), e instanceof Date || lt(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function eo(e) {
  if (Q(1, arguments), !qa(e) && typeof e != "number") return !1;
  var t = ne(e);
  return !isNaN(Number(t));
}
function Fn(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = ne(t),
    o = n.getFullYear() - r.getFullYear(),
    a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
var ch = 6048e5;
function lh(e, t, n) {
  Q(2, arguments);
  var r = ht(e, n),
    o = ht(t, n),
    a = r.getTime() - mn(r),
    i = o.getTime() - mn(o);
  return Math.round((a - i) / ch);
}
function uh(e) {
  Q(1, arguments);
  var t = ne(e);
  return t.setHours(23, 59, 59, 999), t;
}
function zn(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function dh(e) {
  Q(1, arguments);
  var t = ne(e);
  return uh(t).getTime() === zn(t).getTime();
}
function Ee(e) {
  Q(1, arguments);
  var t = ne(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function fh(e) {
  Q(1, arguments);
  var t = ne(e),
    n = /* @__PURE__ */new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Xa(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = bt(),
    d = Te((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ne(e),
    m = f.getDay(),
    h = (m < d ? -7 : 0) + 6 - (m - d);
  return f.setDate(f.getDate() + h), f.setHours(23, 59, 59, 999), f;
}
function ou(e) {
  return Q(1, arguments), Xa(e, {
    weekStartsOn: 1
  });
}
function au(e, t) {
  Q(2, arguments);
  var n = Te(t);
  return Qm(e, -n);
}
var vh = 864e5;
function ph(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(),
    o = n - r;
  return Math.floor(o / vh) + 1;
}
function gn(e) {
  Q(1, arguments);
  var t = 1,
    n = ne(e),
    r = n.getUTCDay(),
    o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function iu(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getUTCFullYear(),
    r = /* @__PURE__ */new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = gn(r),
    a = /* @__PURE__ */new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = gn(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function mh(e) {
  Q(1, arguments);
  var t = iu(e),
    n = /* @__PURE__ */new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = gn(n);
  return r;
}
var hh = 6048e5;
function su(e) {
  Q(1, arguments);
  var t = ne(e),
    n = gn(t).getTime() - mh(t).getTime();
  return Math.round(n / hh) + 1;
}
function Jt(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = bt(),
    d = Te((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ne(e),
    m = f.getUTCDay(),
    h = (m < d ? 7 : 0) + m - d;
  return f.setUTCDate(f.getUTCDate() - h), f.setUTCHours(0, 0, 0, 0), f;
}
function Qa(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = ne(e),
    d = u.getUTCFullYear(),
    f = bt(),
    m = Te((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = f.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */new Date(0);
  h.setUTCFullYear(d + 1, 0, m), h.setUTCHours(0, 0, 0, 0);
  var v = Jt(h, t),
    g = /* @__PURE__ */new Date(0);
  g.setUTCFullYear(d, 0, m), g.setUTCHours(0, 0, 0, 0);
  var b = Jt(g, t);
  return u.getTime() >= v.getTime() ? d + 1 : u.getTime() >= b.getTime() ? d : d - 1;
}
function gh(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = bt(),
    d = Te((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1),
    f = Qa(e, t),
    m = /* @__PURE__ */new Date(0);
  m.setUTCFullYear(f, 0, d), m.setUTCHours(0, 0, 0, 0);
  var h = Jt(m, t);
  return h;
}
var bh = 6048e5;
function cu(e, t) {
  Q(1, arguments);
  var n = ne(e),
    r = Jt(n, t).getTime() - gh(n, t).getTime();
  return Math.round(r / bh) + 1;
}
function we(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
  return n + r;
}
var yh = {
  // Year
  y: function y(t, n) {
    var r = t.getUTCFullYear(),
      o = r > 0 ? r : 1 - r;
    return we(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function M(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : we(r + 1, 2);
  },
  // Day of the month
  d: function d(t, n) {
    return we(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function a(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h(t, n) {
    return we(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function H(t, n) {
    return we(t.getUTCHours(), n.length);
  },
  // Minute
  m: function m(t, n) {
    return we(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function s(t, n) {
    return we(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function S(t, n) {
    var r = n.length,
      o = t.getUTCMilliseconds(),
      a = Math.floor(o * Math.pow(10, r - 3));
    return we(a, n.length);
  }
};
var Rt = yh;
var an = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wh = {
    // Era
    G: function G(t, n, r) {
      var o = t.getUTCFullYear() > 0 ? 1 : 0;
      switch (n) {
        case "G":
        case "GG":
        case "GGG":
          return r.era(o, {
            width: "abbreviated"
          });
        case "GGGGG":
          return r.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return r.era(o, {
            width: "wide"
          });
      }
    },
    // Year
    y: function y(t, n, r) {
      if (n === "yo") {
        var o = t.getUTCFullYear(),
          a = o > 0 ? o : 1 - o;
        return r.ordinalNumber(a, {
          unit: "year"
        });
      }
      return Rt.y(t, n);
    },
    // Local week-numbering year
    Y: function Y(t, n, r, o) {
      var a = Qa(t, o),
        i = a > 0 ? a : 1 - a;
      if (n === "YY") {
        var s = i % 100;
        return we(s, 2);
      }
      return n === "Yo" ? r.ordinalNumber(i, {
        unit: "year"
      }) : we(i, n.length);
    },
    // ISO week-numbering year
    R: function R(t, n) {
      var r = iu(t);
      return we(r, n.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(t, n) {
      var r = t.getUTCFullYear();
      return we(r, n.length);
    },
    // Quarter
    Q: function Q(t, n, r) {
      var o = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (n) {
        case "Q":
          return String(o);
        case "QQ":
          return we(o, 2);
        case "Qo":
          return r.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return r.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return r.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return r.quarter(o, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function q(t, n, r) {
      var o = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (n) {
        case "q":
          return String(o);
        case "qq":
          return we(o, 2);
        case "qo":
          return r.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return r.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return r.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return r.quarter(o, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function M(t, n, r) {
      var o = t.getUTCMonth();
      switch (n) {
        case "M":
        case "MM":
          return Rt.M(t, n);
        case "Mo":
          return r.ordinalNumber(o + 1, {
            unit: "month"
          });
        case "MMM":
          return r.month(o, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return r.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return r.month(o, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function L(t, n, r) {
      var o = t.getUTCMonth();
      switch (n) {
        case "L":
          return String(o + 1);
        case "LL":
          return we(o + 1, 2);
        case "Lo":
          return r.ordinalNumber(o + 1, {
            unit: "month"
          });
        case "LLL":
          return r.month(o, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return r.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return r.month(o, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function w(t, n, r, o) {
      var a = cu(t, o);
      return n === "wo" ? r.ordinalNumber(a, {
        unit: "week"
      }) : we(a, n.length);
    },
    // ISO week of year
    I: function I(t, n, r) {
      var o = su(t);
      return n === "Io" ? r.ordinalNumber(o, {
        unit: "week"
      }) : we(o, n.length);
    },
    // Day of the month
    d: function d(t, n, r) {
      return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
        unit: "date"
      }) : Rt.d(t, n);
    },
    // Day of year
    D: function D(t, n, r) {
      var o = ph(t);
      return n === "Do" ? r.ordinalNumber(o, {
        unit: "dayOfYear"
      }) : we(o, n.length);
    },
    // Day of week
    E: function E(t, n, r) {
      var o = t.getUTCDay();
      switch (n) {
        case "E":
        case "EE":
        case "EEE":
          return r.day(o, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return r.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return r.day(o, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return r.day(o, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function e(t, n, r, o) {
      var a = t.getUTCDay(),
        i = (a - o.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "e":
          return String(i);
        case "ee":
          return we(i, 2);
        case "eo":
          return r.ordinalNumber(i, {
            unit: "day"
          });
        case "eee":
          return r.day(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return r.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return r.day(a, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return r.day(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function c(t, n, r, o) {
      var a = t.getUTCDay(),
        i = (a - o.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "c":
          return String(i);
        case "cc":
          return we(i, n.length);
        case "co":
          return r.ordinalNumber(i, {
            unit: "day"
          });
        case "ccc":
          return r.day(a, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return r.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return r.day(a, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return r.day(a, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function i(t, n, r) {
      var o = t.getUTCDay(),
        a = o === 0 ? 7 : o;
      switch (n) {
        case "i":
          return String(a);
        case "ii":
          return we(a, n.length);
        case "io":
          return r.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return r.day(o, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return r.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return r.day(o, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return r.day(o, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function a(t, n, r) {
      var o = t.getUTCHours(),
        a = o / 12 >= 1 ? "pm" : "am";
      switch (n) {
        case "a":
        case "aa":
          return r.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return r.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return r.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(t, n, r) {
      var o = t.getUTCHours(),
        a;
      switch (o === 12 ? a = an.noon : o === 0 ? a = an.midnight : a = o / 12 >= 1 ? "pm" : "am", n) {
        case "b":
        case "bb":
          return r.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return r.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return r.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(t, n, r) {
      var o = t.getUTCHours(),
        a;
      switch (o >= 17 ? a = an.evening : o >= 12 ? a = an.afternoon : o >= 4 ? a = an.morning : a = an.night, n) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function h(t, n, r) {
      if (n === "ho") {
        var o = t.getUTCHours() % 12;
        return o === 0 && (o = 12), r.ordinalNumber(o, {
          unit: "hour"
        });
      }
      return Rt.h(t, n);
    },
    // Hour [0-23]
    H: function H(t, n, r) {
      return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
        unit: "hour"
      }) : Rt.H(t, n);
    },
    // Hour [0-11]
    K: function K(t, n, r) {
      var o = t.getUTCHours() % 12;
      return n === "Ko" ? r.ordinalNumber(o, {
        unit: "hour"
      }) : we(o, n.length);
    },
    // Hour [1-24]
    k: function k(t, n, r) {
      var o = t.getUTCHours();
      return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
        unit: "hour"
      }) : we(o, n.length);
    },
    // Minute
    m: function m(t, n, r) {
      return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
        unit: "minute"
      }) : Rt.m(t, n);
    },
    // Second
    s: function s(t, n, r) {
      return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
        unit: "second"
      }) : Rt.s(t, n);
    },
    // Fraction of second
    S: function S(t, n) {
      return Rt.S(t, n);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(t, n, r, o) {
      var a = o._originalDate || t,
        i = a.getTimezoneOffset();
      if (i === 0) return "Z";
      switch (n) {
        case "X":
          return Ps(i);
        case "XXXX":
        case "XX":
          return Gt(i);
        case "XXXXX":
        case "XXX":
        default:
          return Gt(i, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(t, n, r, o) {
      var a = o._originalDate || t,
        i = a.getTimezoneOffset();
      switch (n) {
        case "x":
          return Ps(i);
        case "xxxx":
        case "xx":
          return Gt(i);
        case "xxxxx":
        case "xxx":
        default:
          return Gt(i, ":");
      }
    },
    // Timezone (GMT)
    O: function O(t, n, r, o) {
      var a = o._originalDate || t,
        i = a.getTimezoneOffset();
      switch (n) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + Is(i, ":");
        case "OOOO":
        default:
          return "GMT" + Gt(i, ":");
      }
    },
    // Timezone (specific non-location)
    z: function z(t, n, r, o) {
      var a = o._originalDate || t,
        i = a.getTimezoneOffset();
      switch (n) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + Is(i, ":");
        case "zzzz":
        default:
          return "GMT" + Gt(i, ":");
      }
    },
    // Seconds timestamp
    t: function t(_t2, n, r, o) {
      var a = o._originalDate || _t2,
        i = Math.floor(a.getTime() / 1e3);
      return we(i, n.length);
    },
    // Milliseconds timestamp
    T: function T(t, n, r, o) {
      var a = o._originalDate || t,
        i = a.getTime();
      return we(i, n.length);
    }
  };
function Is(e, t) {
  var n = e > 0 ? "-" : "+",
    r = Math.abs(e),
    o = Math.floor(r / 60),
    a = r % 60;
  if (a === 0) return n + String(o);
  var i = t || "";
  return n + String(o) + i + we(a, 2);
}
function Ps(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + we(Math.abs(e) / 60, 2);
  }
  return Gt(e, t);
}
function Gt(e, t) {
  var n = t || "",
    r = e > 0 ? "-" : "+",
    o = Math.abs(e),
    a = we(Math.floor(o / 60), 2),
    i = we(o % 60, 2);
  return r + a + n + i;
}
var xh = wh;
var Ds = function Ds(t, n) {
    switch (t) {
      case "P":
        return n.date({
          width: "short"
        });
      case "PP":
        return n.date({
          width: "medium"
        });
      case "PPP":
        return n.date({
          width: "long"
        });
      case "PPPP":
      default:
        return n.date({
          width: "full"
        });
    }
  },
  lu = function lu(t, n) {
    switch (t) {
      case "p":
        return n.time({
          width: "short"
        });
      case "pp":
        return n.time({
          width: "medium"
        });
      case "ppp":
        return n.time({
          width: "long"
        });
      case "pppp":
      default:
        return n.time({
          width: "full"
        });
    }
  },
  $h = function $h(t, n) {
    var r = t.match(/(P+)(p+)?/) || [],
      o = r[1],
      a = r[2];
    if (!a) return Ds(t, n);
    var i;
    switch (o) {
      case "P":
        i = n.dateTime({
          width: "short"
        });
        break;
      case "PP":
        i = n.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        i = n.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        i = n.dateTime({
          width: "full"
        });
        break;
    }
    return i.replace("{{date}}", Ds(o, n)).replace("{{time}}", lu(a, n));
  },
  Ch = {
    p: lu,
    P: $h
  };
var Jo = Ch;
var Th = ["D", "DD"],
  _h = ["YY", "YYYY"];
function uu(e) {
  return Th.indexOf(e) !== -1;
}
function du(e) {
  return _h.indexOf(e) !== -1;
}
function kr(e, t, n) {
  if (e === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Ih = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  },
  Ph = function Ph(t, n, r) {
    var o,
      a = Ih[t];
    return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
  };
var Dh = Ph;
function To(e) {
  return function () {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      n = t.width ? String(t.width) : e.defaultWidth,
      r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var Sh = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  },
  Eh = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  },
  Oh = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  Mh = {
    date: To({
      formats: Sh,
      defaultWidth: "full"
    }),
    time: To({
      formats: Eh,
      defaultWidth: "full"
    }),
    dateTime: To({
      formats: Oh,
      defaultWidth: "full"
    })
  };
var Nh = Mh;
var kh = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  },
  Rh = function Rh(t, n, r, o) {
    return kh[t];
  };
var Ah = Rh;
function Dn(e) {
  return function (t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone",
      o;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth,
        i = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth,
        c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
var Lh = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  },
  jh = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  },
  Fh = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  Wh = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  Hh = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  },
  Bh = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  },
  Vh = function Vh(t, n) {
    var r = Number(t),
      o = r % 100;
    if (o > 20 || o < 10) switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
    return r + "th";
  },
  Uh = {
    ordinalNumber: Vh,
    era: Dn({
      values: Lh,
      defaultWidth: "wide"
    }),
    quarter: Dn({
      values: jh,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Dn({
      values: Fh,
      defaultWidth: "wide"
    }),
    day: Dn({
      values: Wh,
      defaultWidth: "wide"
    }),
    dayPeriod: Dn({
      values: Hh,
      defaultWidth: "wide",
      formattingValues: Bh,
      defaultFormattingWidth: "wide"
    })
  };
var Yh = Uh;
function Sn(e) {
  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      r = n.width,
      o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth],
      a = t.match(o);
    if (!a) return null;
    var i = a[0],
      s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth],
      c = Array.isArray(s) ? Gh(s, function (d) {
        return d.test(i);
      }) : Kh(s, function (d) {
        return d.test(i);
      }),
      l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var u = t.slice(i.length);
    return {
      value: l,
      rest: u
    };
  };
}
function Kh(e, t) {
  for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function Gh(e, t) {
  for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
}
function zh(e) {
  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      r = t.match(e.matchPattern);
    if (!r) return null;
    var o = r[0],
      a = t.match(e.parsePattern);
    if (!a) return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var s = t.slice(o.length);
    return {
      value: i,
      rest: s
    };
  };
}
var qh = /^(\d+)(th|st|nd|rd)?/i,
  Xh = /\d+/i,
  Qh = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  },
  Zh = {
    any: [/^b/i, /^(a|c)/i]
  },
  Jh = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  },
  eg = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  tg = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  },
  ng = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  rg = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  },
  og = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  },
  ag = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  },
  ig = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  },
  sg = {
    ordinalNumber: zh({
      matchPattern: qh,
      parsePattern: Xh,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }),
    era: Sn({
      matchPatterns: Qh,
      defaultMatchWidth: "wide",
      parsePatterns: Zh,
      defaultParseWidth: "any"
    }),
    quarter: Sn({
      matchPatterns: Jh,
      defaultMatchWidth: "wide",
      parsePatterns: eg,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Sn({
      matchPatterns: tg,
      defaultMatchWidth: "wide",
      parsePatterns: ng,
      defaultParseWidth: "any"
    }),
    day: Sn({
      matchPatterns: rg,
      defaultMatchWidth: "wide",
      parsePatterns: og,
      defaultParseWidth: "any"
    }),
    dayPeriod: Sn({
      matchPatterns: ag,
      defaultMatchWidth: "any",
      parsePatterns: ig,
      defaultParseWidth: "any"
    })
  };
var cg = sg;
var lg = {
  code: "en-US",
  formatDistance: Dh,
  formatLong: Nh,
  formatRelative: Ah,
  localize: Yh,
  match: cg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var Za = lg;
var ug = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  dg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  fg = /^'([^]*?)'?$/,
  vg = /''/g,
  pg = /[a-zA-Z]/;
function ve(e, t, n) {
  var r, o, a, i, s, c, l, u, d, f, m, h, v, g, b, y, w, I;
  Q(2, arguments);
  var P = String(t),
    D = bt(),
    E = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : D.locale) !== null && r !== void 0 ? r : Za,
    _ = Te((a = (i = (s = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : D.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = D.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(_ >= 1 && _ <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = Te((m = (h = (v = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (b = n.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && v !== void 0 ? v : D.weekStartsOn) !== null && h !== void 0 ? h : (w = D.locale) === null || w === void 0 || (I = w.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(O >= 0 && O <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!E.localize) throw new RangeError("locale must contain localize property");
  if (!E.formatLong) throw new RangeError("locale must contain formatLong property");
  var A = ne(e);
  if (!eo(A)) throw new RangeError("Invalid time value");
  var M = mn(A),
    B = au(A, M),
    G = {
      firstWeekContainsDate: _,
      weekStartsOn: O,
      locale: E,
      _originalDate: A
    },
    N = P.match(dg).map(function (j) {
      var U = j[0];
      if (U === "p" || U === "P") {
        var L = Jo[U];
        return L(j, E.formatLong);
      }
      return j;
    }).join("").match(ug).map(function (j) {
      if (j === "''") return "'";
      var U = j[0];
      if (U === "'") return mg(j);
      var L = xh[U];
      if (L) return !(n != null && n.useAdditionalWeekYearTokens) && du(j) && kr(j, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && uu(j) && kr(j, t, String(e)), L(B, j, E.localize, G);
      if (U.match(pg)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
      return j;
    }).join("");
  return N;
}
function mg(e) {
  var t = e.match(fg);
  return t ? t[1].replace(vg, "'") : e;
}
function hg(e, t) {
  if (e == null) throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function gg(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getFullYear(),
    r = t.getMonth(),
    o = /* @__PURE__ */new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
var bg = 6048e5;
function yg(e) {
  Q(1, arguments);
  var t = ne(e),
    n = Zt(t).getTime() - eh(t).getTime();
  return Math.round(n / bg) + 1;
}
function wg(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getTime();
  return n;
}
function xg(e) {
  return Q(1, arguments), Math.floor(wg(e) / 1e3);
}
function $g(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = ne(e),
    d = u.getFullYear(),
    f = bt(),
    m = Te((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = f.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */new Date(0);
  h.setFullYear(d + 1, 0, m), h.setHours(0, 0, 0, 0);
  var v = ht(h, t),
    g = /* @__PURE__ */new Date(0);
  g.setFullYear(d, 0, m), g.setHours(0, 0, 0, 0);
  var b = ht(g, t);
  return u.getTime() >= v.getTime() ? d + 1 : u.getTime() >= b.getTime() ? d : d - 1;
}
function Cg(e, t) {
  var n, r, o, a, i, s, c, l;
  Q(1, arguments);
  var u = bt(),
    d = Te((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1),
    f = $g(e, t),
    m = /* @__PURE__ */new Date(0);
  m.setFullYear(f, 0, d), m.setHours(0, 0, 0, 0);
  var h = ht(m, t);
  return h;
}
var Tg = 6048e5;
function _g(e, t) {
  Q(1, arguments);
  var n = ne(e),
    r = ht(n, t).getTime() - Cg(n, t).getTime();
  return Math.round(r / Tg) + 1;
}
function Ig(e) {
  Q(1, arguments);
  var t = ne(e),
    n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Pg(e, t) {
  return Q(1, arguments), lh(Ig(e), Ee(e), t) + 1;
}
function bn(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = ne(t);
  return n.getTime() > r.getTime();
}
function fn(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = ne(t);
  return n.getTime() < r.getTime();
}
function Dg(e) {
  return Q(1, arguments), ne(e).getDate() === 1;
}
function Ss(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Sg(e, t) {
  if (e) {
    if (typeof e == "string") return Ss(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ss(e, t);
  }
}
function Es(e, t) {
  var _n6 = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!_n6) {
    if (Array.isArray(e) || (_n6 = Sg(e)) || t && e && typeof e.length == "number") {
      _n6 && (e = _n6);
      var r = 0,
        o = function o() {};
      return {
        s: o,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a = !0,
    i = !1,
    s;
  return {
    s: function s() {
      _n6 = _n6.call(e);
    },
    n: function n() {
      var l = _n6.next();
      return a = l.done, l;
    },
    e: function e(l) {
      i = !0, s = l;
    },
    f: function f() {
      try {
        !a && _n6.return != null && _n6.return();
      } finally {
        if (i) throw s;
      }
    }
  };
}
function z(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ea(e, t) {
  return ea = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (r, o) {
    return r.__proto__ = o, r;
  }, ea(e, t);
}
function pe(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ea(e, t);
}
function Rr(e) {
  return Rr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Rr(e);
}
function Eg() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused3) {
    return !1;
  }
}
function Og(e, t) {
  if (t && (lt(t) === "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return z(e);
}
function me(e) {
  var t = Eg();
  return function () {
    var r = Rr(e),
      o;
    if (t) {
      var a = Rr(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else o = r.apply(this, arguments);
    return Og(this, o);
  };
}
function ue(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Mg(e, t) {
  if (lt(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (lt(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fu(e) {
  var t = Mg(e, "string");
  return lt(t) === "symbol" ? t : String(t);
}
function Os(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fu(r.key), r);
  }
}
function de(e, t, n) {
  return t && Os(e.prototype, t), n && Os(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function K(e, t, n) {
  return t = fu(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ng = 10,
  vu = /* @__PURE__ */function () {
    function e() {
      ue(this, e), K(this, "priority", void 0), K(this, "subPriority", 0);
    }
    return de(e, [{
      key: "validate",
      value: function value(n, r) {
        return !0;
      }
    }]), e;
  }(),
  kg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n(r, o, a, i, s) {
      var c;
      return ue(this, n), c = t.call(this), c.value = r, c.validateValue = o, c.setValue = a, c.priority = i, s && (c.subPriority = s), c;
    }
    return de(n, [{
      key: "validate",
      value: function value(o, a) {
        return this.validateValue(o, this.value, a);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return this.setValue(o, a, this.value, i);
      }
    }]), n;
  }(vu),
  Rg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", Ng), K(z(r), "subPriority", -1), r;
    }
    return de(n, [{
      key: "set",
      value: function value(o, a) {
        if (a.timestampIsSet) return o;
        var i = /* @__PURE__ */new Date(0);
        return i.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), i.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), i;
      }
    }]), n;
  }(vu),
  ge = /* @__PURE__ */function () {
    function e() {
      ue(this, e), K(this, "incompatibleTokens", void 0), K(this, "priority", void 0), K(this, "subPriority", void 0);
    }
    return de(e, [{
      key: "run",
      value: function value(n, r, o, a) {
        var i = this.parse(n, r, o, a);
        return i ? {
          setter: new kg(i.value, this.validate, this.set, this.priority, this.subPriority),
          rest: i.rest
        } : null;
      }
    }, {
      key: "validate",
      value: function value(n, r, o) {
        return !0;
      }
    }]), e;
  }(),
  Ag = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 140), K(z(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "G":
          case "GG":
          case "GGG":
            return i.era(o, {
              width: "abbreviated"
            }) || i.era(o, {
              width: "narrow"
            });
          case "GGGGG":
            return i.era(o, {
              width: "narrow"
            });
          case "GGGG":
          default:
            return i.era(o, {
              width: "wide"
            }) || i.era(o, {
              width: "abbreviated"
            }) || i.era(o, {
              width: "narrow"
            });
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return a.era = i, o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Oe = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
    // 0 to 9999, -0 to -9999
  },
  pt = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };
function Me(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ie(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function mt(e, t) {
  var n = t.match(e);
  if (!n) return null;
  if (n[0] === "Z") return {
    value: 0,
    rest: t.slice(1)
  };
  var r = n[1] === "+" ? 1 : -1,
    o = n[2] ? parseInt(n[2], 10) : 0,
    a = n[3] ? parseInt(n[3], 10) : 0,
    i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * ih + a * ah + i * sh),
    rest: t.slice(n[0].length)
  };
}
function pu(e) {
  return Ie(Oe.anyDigitsSigned, e);
}
function De(e, t) {
  switch (e) {
    case 1:
      return Ie(Oe.singleDigit, t);
    case 2:
      return Ie(Oe.twoDigits, t);
    case 3:
      return Ie(Oe.threeDigits, t);
    case 4:
      return Ie(Oe.fourDigits, t);
    default:
      return Ie(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Ar(e, t) {
  switch (e) {
    case 1:
      return Ie(Oe.singleDigitSigned, t);
    case 2:
      return Ie(Oe.twoDigitsSigned, t);
    case 3:
      return Ie(Oe.threeDigitsSigned, t);
    case 4:
      return Ie(Oe.fourDigitsSigned, t);
    default:
      return Ie(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Ja(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function mu(e, t) {
  var n = t > 0,
    r = n ? t : 1 - t,
    o;
  if (r <= 50) o = e || 100;else {
    var a = r + 50,
      i = Math.floor(a / 100) * 100,
      s = e >= a % 100;
    o = e + i - (s ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function hu(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Lg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 130), K(z(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        var s = function s(l) {
          return {
            year: l,
            isTwoDigitYear: a === "yy"
          };
        };
        switch (a) {
          case "y":
            return Me(De(4, o), s);
          case "yo":
            return Me(i.ordinalNumber(o, {
              unit: "year"
            }), s);
          default:
            return Me(De(a.length, o), s);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a.isTwoDigitYear || a.year > 0;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        var s = o.getUTCFullYear();
        if (i.isTwoDigitYear) {
          var c = mu(i.year, s);
          return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
        }
        var l = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  jg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 130), K(z(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        var s = function s(l) {
          return {
            year: l,
            isTwoDigitYear: a === "YY"
          };
        };
        switch (a) {
          case "Y":
            return Me(De(4, o), s);
          case "Yo":
            return Me(i.ordinalNumber(o, {
              unit: "year"
            }), s);
          default:
            return Me(De(a.length, o), s);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a.isTwoDigitYear || a.year > 0;
      }
    }, {
      key: "set",
      value: function value(o, a, i, s) {
        var c = Qa(o, s);
        if (i.isTwoDigitYear) {
          var l = mu(i.year, c);
          return o.setUTCFullYear(l, 0, s.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), Jt(o, s);
        }
        var u = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
        return o.setUTCFullYear(u, 0, s.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), Jt(o, s);
      }
    }]), n;
  }(ge),
  Fg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 130), K(z(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a) {
        return Ar(a === "R" ? 4 : a.length, o);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        var s = /* @__PURE__ */new Date(0);
        return s.setUTCFullYear(i, 0, 4), s.setUTCHours(0, 0, 0, 0), gn(s);
      }
    }]), n;
  }(ge),
  Wg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 130), K(z(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a) {
        return Ar(a === "u" ? 4 : a.length, o);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Hg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 120), K(z(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "Q":
          case "QQ":
            return De(a.length, o);
          case "Qo":
            return i.ordinalNumber(o, {
              unit: "quarter"
            });
          case "QQQ":
            return i.quarter(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.quarter(o, {
              width: "narrow",
              context: "formatting"
            });
          case "QQQQQ":
            return i.quarter(o, {
              width: "narrow",
              context: "formatting"
            });
          case "QQQQ":
          default:
            return i.quarter(o, {
              width: "wide",
              context: "formatting"
            }) || i.quarter(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.quarter(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 4;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Bg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 120), K(z(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "q":
          case "qq":
            return De(a.length, o);
          case "qo":
            return i.ordinalNumber(o, {
              unit: "quarter"
            });
          case "qqq":
            return i.quarter(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.quarter(o, {
              width: "narrow",
              context: "standalone"
            });
          case "qqqqq":
            return i.quarter(o, {
              width: "narrow",
              context: "standalone"
            });
          case "qqqq":
          default:
            return i.quarter(o, {
              width: "wide",
              context: "standalone"
            }) || i.quarter(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.quarter(o, {
              width: "narrow",
              context: "standalone"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 4;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Vg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), K(z(r), "priority", 110), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        var s = function s(l) {
          return l - 1;
        };
        switch (a) {
          case "M":
            return Me(Ie(Oe.month, o), s);
          case "MM":
            return Me(De(2, o), s);
          case "Mo":
            return Me(i.ordinalNumber(o, {
              unit: "month"
            }), s);
          case "MMM":
            return i.month(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.month(o, {
              width: "narrow",
              context: "formatting"
            });
          case "MMMMM":
            return i.month(o, {
              width: "narrow",
              context: "formatting"
            });
          case "MMMM":
          default:
            return i.month(o, {
              width: "wide",
              context: "formatting"
            }) || i.month(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.month(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 11;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Ug = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 110), K(z(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        var s = function s(l) {
          return l - 1;
        };
        switch (a) {
          case "L":
            return Me(Ie(Oe.month, o), s);
          case "LL":
            return Me(De(2, o), s);
          case "Lo":
            return Me(i.ordinalNumber(o, {
              unit: "month"
            }), s);
          case "LLL":
            return i.month(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.month(o, {
              width: "narrow",
              context: "standalone"
            });
          case "LLLLL":
            return i.month(o, {
              width: "narrow",
              context: "standalone"
            });
          case "LLLL":
          default:
            return i.month(o, {
              width: "wide",
              context: "standalone"
            }) || i.month(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.month(o, {
              width: "narrow",
              context: "standalone"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 11;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge);
function Yg(e, t, n) {
  Q(2, arguments);
  var r = ne(e),
    o = Te(t),
    a = cu(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var Kg = /* @__PURE__ */function (e) {
  pe(n, e);
  var t = me(n);
  function n() {
    var r;
    ue(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 100), K(z(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return de(n, [{
    key: "parse",
    value: function value(o, a, i) {
      switch (a) {
        case "w":
          return Ie(Oe.week, o);
        case "wo":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return De(a.length, o);
      }
    }
  }, {
    key: "validate",
    value: function value(o, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function value(o, a, i, s) {
      return Jt(Yg(o, i, s), s);
    }
  }]), n;
}(ge);
function Gg(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = Te(t),
    o = su(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var zg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 100), K(z(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "I":
            return Ie(Oe.week, o);
          case "Io":
            return i.ordinalNumber(o, {
              unit: "week"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 53;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return gn(Gg(o, i));
      }
    }]), n;
  }(ge),
  qg = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  Xg = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  Qg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "subPriority", 1), K(z(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "d":
            return Ie(Oe.date, o);
          case "do":
            return i.ordinalNumber(o, {
              unit: "date"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        var i = o.getUTCFullYear(),
          s = hu(i),
          c = o.getUTCMonth();
        return s ? a >= 1 && a <= Xg[c] : a >= 1 && a <= qg[c];
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCDate(i), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  Zg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "subpriority", 1), K(z(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "D":
          case "DD":
            return Ie(Oe.dayOfYear, o);
          case "Do":
            return i.ordinalNumber(o, {
              unit: "date"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        var i = o.getUTCFullYear(),
          s = hu(i);
        return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMonth(0, i), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge);
function ei(e, t, n) {
  var r, o, a, i, s, c, l, u;
  Q(2, arguments);
  var d = bt(),
    f = Te((r = (o = (a = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (s = n.locale) === null || s === void 0 || (c = s.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && a !== void 0 ? a : d.weekStartsOn) !== null && o !== void 0 ? o : (l = d.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = ne(e),
    h = Te(t),
    v = m.getUTCDay(),
    g = h % 7,
    b = (g + 7) % 7,
    y = (b < f ? 7 : 0) + h - v;
  return m.setUTCDate(m.getUTCDate() + y), m;
}
var Jg = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "E":
          case "EE":
          case "EEE":
            return i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "EEEEE":
            return i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "EEEEEE":
            return i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "EEEE":
          default:
            return i.day(o, {
              width: "wide",
              context: "formatting"
            }) || i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 6;
      }
    }, {
      key: "set",
      value: function value(o, a, i, s) {
        return o = ei(o, i, s), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  eb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i, s) {
        var c = function c(u) {
          var d = Math.floor((u - 1) / 7) * 7;
          return (u + s.weekStartsOn + 6) % 7 + d;
        };
        switch (a) {
          case "e":
          case "ee":
            return Me(De(a.length, o), c);
          case "eo":
            return Me(i.ordinalNumber(o, {
              unit: "day"
            }), c);
          case "eee":
            return i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "eeeee":
            return i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "eeeeee":
            return i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
          case "eeee":
          default:
            return i.day(o, {
              width: "wide",
              context: "formatting"
            }) || i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 6;
      }
    }, {
      key: "set",
      value: function value(o, a, i, s) {
        return o = ei(o, i, s), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  tb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i, s) {
        var c = function c(u) {
          var d = Math.floor((u - 1) / 7) * 7;
          return (u + s.weekStartsOn + 6) % 7 + d;
        };
        switch (a) {
          case "c":
          case "cc":
            return Me(De(a.length, o), c);
          case "co":
            return Me(i.ordinalNumber(o, {
              unit: "day"
            }), c);
          case "ccc":
            return i.day(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.day(o, {
              width: "short",
              context: "standalone"
            }) || i.day(o, {
              width: "narrow",
              context: "standalone"
            });
          case "ccccc":
            return i.day(o, {
              width: "narrow",
              context: "standalone"
            });
          case "cccccc":
            return i.day(o, {
              width: "short",
              context: "standalone"
            }) || i.day(o, {
              width: "narrow",
              context: "standalone"
            });
          case "cccc":
          default:
            return i.day(o, {
              width: "wide",
              context: "standalone"
            }) || i.day(o, {
              width: "abbreviated",
              context: "standalone"
            }) || i.day(o, {
              width: "short",
              context: "standalone"
            }) || i.day(o, {
              width: "narrow",
              context: "standalone"
            });
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 6;
      }
    }, {
      key: "set",
      value: function value(o, a, i, s) {
        return o = ei(o, i, s), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge);
function nb(e, t) {
  Q(2, arguments);
  var n = Te(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1,
    o = ne(e),
    a = o.getUTCDay(),
    i = n % 7,
    s = (i + 7) % 7,
    c = (s < r ? 7 : 0) + n - a;
  return o.setUTCDate(o.getUTCDate() + c), o;
}
var rb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 90), K(z(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        var s = function s(l) {
          return l === 0 ? 7 : l;
        };
        switch (a) {
          case "i":
          case "ii":
            return De(a.length, o);
          case "io":
            return i.ordinalNumber(o, {
              unit: "day"
            });
          case "iii":
            return Me(i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            }), s);
          case "iiiii":
            return Me(i.day(o, {
              width: "narrow",
              context: "formatting"
            }), s);
          case "iiiiii":
            return Me(i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            }), s);
          case "iiii":
          default:
            return Me(i.day(o, {
              width: "wide",
              context: "formatting"
            }) || i.day(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(o, {
              width: "short",
              context: "formatting"
            }) || i.day(o, {
              width: "narrow",
              context: "formatting"
            }), s);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 7;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o = nb(o, i), o.setUTCHours(0, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  ob = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 80), K(z(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "a":
          case "aa":
          case "aaa":
            return i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaaa":
            return i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return i.dayPeriod(o, {
              width: "wide",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCHours(Ja(i), 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  ab = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 80), K(z(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "b":
          case "bb":
          case "bbb":
            return i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbbb":
            return i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return i.dayPeriod(o, {
              width: "wide",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCHours(Ja(i), 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  ib = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 80), K(z(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "B":
          case "BB":
          case "BBB":
            return i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBBB":
            return i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return i.dayPeriod(o, {
              width: "wide",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "abbreviated",
              context: "formatting"
            }) || i.dayPeriod(o, {
              width: "narrow",
              context: "formatting"
            });
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCHours(Ja(i), 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  sb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 70), K(z(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "h":
            return Ie(Oe.hour12h, o);
          case "ho":
            return i.ordinalNumber(o, {
              unit: "hour"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 12;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        var s = o.getUTCHours() >= 12;
        return s && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : !s && i === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  cb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 70), K(z(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "H":
            return Ie(Oe.hour23h, o);
          case "Ho":
            return i.ordinalNumber(o, {
              unit: "hour"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 23;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCHours(i, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  lb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 70), K(z(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "K":
            return Ie(Oe.hour11h, o);
          case "Ko":
            return i.ordinalNumber(o, {
              unit: "hour"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 11;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        var s = o.getUTCHours() >= 12;
        return s && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  ub = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 70), K(z(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "k":
            return Ie(Oe.hour24h, o);
          case "ko":
            return i.ordinalNumber(o, {
              unit: "hour"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 1 && a <= 24;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        var s = i <= 24 ? i % 24 : i;
        return o.setUTCHours(s, 0, 0, 0), o;
      }
    }]), n;
  }(ge),
  db = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 60), K(z(r), "incompatibleTokens", ["t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "m":
            return Ie(Oe.minute, o);
          case "mo":
            return i.ordinalNumber(o, {
              unit: "minute"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 59;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMinutes(i, 0, 0), o;
      }
    }]), n;
  }(ge),
  fb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 50), K(z(r), "incompatibleTokens", ["t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a, i) {
        switch (a) {
          case "s":
            return Ie(Oe.second, o);
          case "so":
            return i.ordinalNumber(o, {
              unit: "second"
            });
          default:
            return De(a.length, o);
        }
      }
    }, {
      key: "validate",
      value: function value(o, a) {
        return a >= 0 && a <= 59;
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCSeconds(i, 0), o;
      }
    }]), n;
  }(ge),
  vb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 30), K(z(r), "incompatibleTokens", ["t", "T"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a) {
        var i = function i(c) {
          return Math.floor(c * Math.pow(10, -a.length + 3));
        };
        return Me(De(a.length, o), i);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return o.setUTCMilliseconds(i), o;
      }
    }]), n;
  }(ge),
  pb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 10), K(z(r), "incompatibleTokens", ["t", "T", "x"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a) {
        switch (a) {
          case "X":
            return mt(pt.basicOptionalMinutes, o);
          case "XX":
            return mt(pt.basic, o);
          case "XXXX":
            return mt(pt.basicOptionalSeconds, o);
          case "XXXXX":
            return mt(pt.extendedOptionalSeconds, o);
          case "XXX":
          default:
            return mt(pt.extended, o);
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return a.timestampIsSet ? o : new Date(o.getTime() - i);
      }
    }]), n;
  }(ge),
  mb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 10), K(z(r), "incompatibleTokens", ["t", "T", "X"]), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o, a) {
        switch (a) {
          case "x":
            return mt(pt.basicOptionalMinutes, o);
          case "xx":
            return mt(pt.basic, o);
          case "xxxx":
            return mt(pt.basicOptionalSeconds, o);
          case "xxxxx":
            return mt(pt.extendedOptionalSeconds, o);
          case "xxx":
          default:
            return mt(pt.extended, o);
        }
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return a.timestampIsSet ? o : new Date(o.getTime() - i);
      }
    }]), n;
  }(ge),
  hb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 40), K(z(r), "incompatibleTokens", "*"), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o) {
        return pu(o);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return [new Date(i * 1e3), {
          timestampIsSet: !0
        }];
      }
    }]), n;
  }(ge),
  gb = /* @__PURE__ */function (e) {
    pe(n, e);
    var t = me(n);
    function n() {
      var r;
      ue(this, n);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) a[i] = arguments[i];
      return r = t.call.apply(t, [this].concat(a)), K(z(r), "priority", 20), K(z(r), "incompatibleTokens", "*"), r;
    }
    return de(n, [{
      key: "parse",
      value: function value(o) {
        return pu(o);
      }
    }, {
      key: "set",
      value: function value(o, a, i) {
        return [new Date(i), {
          timestampIsSet: !0
        }];
      }
    }]), n;
  }(ge),
  bb = {
    G: new Ag(),
    y: new Lg(),
    Y: new jg(),
    R: new Fg(),
    u: new Wg(),
    Q: new Hg(),
    q: new Bg(),
    M: new Vg(),
    L: new Ug(),
    w: new Kg(),
    I: new zg(),
    d: new Qg(),
    D: new Zg(),
    E: new Jg(),
    e: new eb(),
    c: new tb(),
    i: new rb(),
    a: new ob(),
    b: new ab(),
    B: new ib(),
    h: new sb(),
    H: new cb(),
    K: new lb(),
    k: new ub(),
    m: new db(),
    s: new fb(),
    S: new vb(),
    X: new pb(),
    x: new mb(),
    t: new hb(),
    T: new gb()
  },
  yb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  wb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  xb = /^'([^]*?)'?$/,
  $b = /''/g,
  Cb = /\S/,
  Tb = /[a-zA-Z]/;
function ti(e, t, n, r) {
  var o, a, i, s, c, l, u, d, f, m, h, v, g, b, y, w, I, P;
  Q(3, arguments);
  var D = String(e),
    E = String(t),
    _ = bt(),
    O = (o = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : _.locale) !== null && o !== void 0 ? o : Za;
  if (!O.match) throw new RangeError("locale must contain match property");
  var A = Te((i = (s = (c = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && c !== void 0 ? c : _.firstWeekContainsDate) !== null && s !== void 0 ? s : (f = _.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(A >= 1 && A <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = Te((h = (v = (g = (b = r == null ? void 0 : r.weekStartsOn) !== null && b !== void 0 ? b : r == null || (y = r.locale) === null || y === void 0 || (w = y.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && g !== void 0 ? g : _.weekStartsOn) !== null && v !== void 0 ? v : (I = _.locale) === null || I === void 0 || (P = I.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(M >= 0 && M <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (E === "") return D === "" ? ne(n) : /* @__PURE__ */new Date(NaN);
  var B = {
      firstWeekContainsDate: A,
      weekStartsOn: M,
      locale: O
    },
    G = [new Rg()],
    N = E.match(wb).map(function (W) {
      var F = W[0];
      if (F in Jo) {
        var J = Jo[F];
        return J(W, O.formatLong);
      }
      return W;
    }).join("").match(yb),
    j = [],
    U = Es(N),
    L;
  try {
    var R = function R() {
      var F = L.value;
      !(r != null && r.useAdditionalWeekYearTokens) && du(F) && kr(F, E, e), !(r != null && r.useAdditionalDayOfYearTokens) && uu(F) && kr(F, E, e);
      var J = F[0],
        Se = bb[J];
      if (Se) {
        var Pe = Se.incompatibleTokens;
        if (Array.isArray(Pe)) {
          var Ae = j.find(function (ke) {
            return Pe.includes(ke.token) || ke.token === J;
          });
          if (Ae) throw new RangeError("The format string mustn't contain `".concat(Ae.fullToken, "` and `").concat(F, "` at the same time"));
        } else if (Se.incompatibleTokens === "*" && j.length > 0) throw new RangeError("The format string mustn't contain `".concat(F, "` and any other token at the same time"));
        j.push({
          token: J,
          fullToken: F
        });
        var Le = Se.run(D, F, O.match, B);
        if (!Le) return {
          v: /* @__PURE__ */new Date(NaN)
        };
        G.push(Le.setter), D = Le.rest;
      } else {
        if (J.match(Tb)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + J + "`");
        if (F === "''" ? F = "'" : J === "'" && (F = _b(F)), D.indexOf(F) === 0) D = D.slice(F.length);else return {
          v: /* @__PURE__ */new Date(NaN)
        };
      }
    };
    for (U.s(); !(L = U.n()).done;) {
      var Y = R();
      if (lt(Y) === "object") return Y.v;
    }
  } catch (W) {
    U.e(W);
  } finally {
    U.f();
  }
  if (D.length > 0 && Cb.test(D)) return /* @__PURE__ */new Date(NaN);
  var re = G.map(function (W) {
      return W.priority;
    }).sort(function (W, F) {
      return F - W;
    }).filter(function (W, F, J) {
      return J.indexOf(W) === F;
    }).map(function (W) {
      return G.filter(function (F) {
        return F.priority === W;
      }).sort(function (F, J) {
        return J.subPriority - F.subPriority;
      });
    }).map(function (W) {
      return W[0];
    }),
    ae = ne(n);
  if (isNaN(ae.getTime())) return /* @__PURE__ */new Date(NaN);
  var se = au(ae, mn(ae)),
    le = {},
    fe = Es(re),
    xe;
  try {
    for (fe.s(); !(xe = fe.n()).done;) {
      var be = xe.value;
      if (!be.validate(se, B)) return /* @__PURE__ */new Date(NaN);
      var q = be.set(se, le, B);
      Array.isArray(q) ? (se = q[0], hg(le, q[1])) : se = q;
    }
  } catch (W) {
    fe.e(W);
  } finally {
    fe.f();
  }
  return se;
}
function _b(e) {
  return e.match(xb)[1].replace($b, "'");
}
function Pt(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = ne(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function Ib(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = ne(t);
  return n.getFullYear() === r.getFullYear();
}
function Ms(e, t) {
  Q(2, arguments);
  var n = ne(e).getTime(),
    r = ne(t.start).getTime(),
    o = ne(t.end).getTime();
  if (!(r <= o)) throw new RangeError("Invalid interval");
  return n >= r && n <= o;
}
function _o(e, t) {
  Q(2, arguments);
  var n = Te(t);
  return Ve(e, -n);
}
function Io(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = Te(t),
    o = n.getFullYear(),
    a = n.getDate(),
    i = /* @__PURE__ */new Date(0);
  i.setFullYear(o, r, 15), i.setHours(0, 0, 0, 0);
  var s = gg(i);
  return n.setMonth(r, Math.min(a, s)), n;
}
function Ns(e, t) {
  Q(2, arguments);
  var n = ne(e),
    r = Te(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */new Date(NaN) : (n.setFullYear(r), n);
}
var _oe = function oe() {
  return _oe = Object.assign || function (t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _oe.apply(this, arguments);
};
function Pb(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function gu(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++) (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function qn(e) {
  return e.mode === "multiple";
}
function Xn(e) {
  return e.mode === "range";
}
function to(e) {
  return e.mode === "single";
}
var Db = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Sb(e, t) {
  return ve(e, "LLLL y", t);
}
function Eb(e, t) {
  return ve(e, "d", t);
}
function Ob(e, t) {
  return ve(e, "LLLL", t);
}
function Mb(e) {
  return "".concat(e);
}
function Nb(e, t) {
  return ve(e, "cccccc", t);
}
function kb(e, t) {
  return ve(e, "yyyy", t);
}
var Rb = /* @__PURE__ */Object.freeze({
    __proto__: null,
    formatCaption: Sb,
    formatDay: Eb,
    formatMonthCaption: Ob,
    formatWeekNumber: Mb,
    formatWeekdayName: Nb,
    formatYearCaption: kb
  }),
  Ab = function Ab(e, t, n) {
    return ve(e, "do MMMM (EEEE)", n);
  },
  Lb = function Lb() {
    return "Month: ";
  },
  jb = function jb() {
    return "Go to next month";
  },
  Fb = function Fb() {
    return "Go to previous month";
  },
  Wb = function Wb(e, t) {
    return ve(e, "cccc", t);
  },
  Hb = function Hb(e) {
    return "Week n. ".concat(e);
  },
  Bb = function Bb() {
    return "Year: ";
  },
  Vb = /* @__PURE__ */Object.freeze({
    __proto__: null,
    labelDay: Ab,
    labelMonthDropdown: Lb,
    labelNext: jb,
    labelPrevious: Fb,
    labelWeekNumber: Hb,
    labelWeekday: Wb,
    labelYearDropdown: Bb
  });
function Ub() {
  var e = "buttons",
    t = Db,
    n = Za,
    r = {},
    o = {},
    a = 1,
    i = {},
    s = /* @__PURE__ */new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: Rb,
    labels: Vb,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function Yb(e) {
  var t = e.fromYear,
    n = e.toYear,
    r = e.fromMonth,
    o = e.toMonth,
    a = e.fromDate,
    i = e.toDate;
  return r ? a = Ee(r) : t && (a = new Date(t, 0, 1)), o ? i = zn(o) : n && (i = new Date(n, 11, 31)), {
    fromDate: a ? hn(a) : void 0,
    toDate: i ? hn(i) : void 0
  };
}
var bu = he(void 0);
function Kb(e) {
  var t,
    n = e.initialProps,
    r = Ub(),
    o = Yb(n),
    a = o.fromDate,
    i = o.toDate,
    s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var c;
  (to(n) || qn(n) || Xn(n)) && (c = n.onSelect);
  var l = _oe(_oe(_oe({}, r), n), {
    captionLayout: s,
    classNames: _oe(_oe({}, r.classNames), n.classNames),
    components: _oe({}, n.components),
    formatters: _oe(_oe({}, r.formatters), n.formatters),
    fromDate: a,
    labels: _oe(_oe({}, r.labels), n.labels),
    mode: n.mode || r.mode,
    modifiers: _oe(_oe({}, r.modifiers), n.modifiers),
    modifiersClassNames: _oe(_oe({}, r.modifiersClassNames), n.modifiersClassNames),
    onSelect: c,
    styles: _oe(_oe({}, r.styles), n.styles),
    toDate: i
  });
  return $.createElement(bu.Provider, {
    value: l
  }, e.children);
}
function _e() {
  var e = ce(bu);
  if (!e) throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function yu(e) {
  var t = _e(),
    n = t.locale,
    r = t.classNames,
    o = t.styles,
    a = t.formatters.formatCaption;
  return $.createElement("div", {
    className: r.caption_label,
    style: o.caption_label,
    "aria-live": "polite",
    role: "presentation",
    id: e.id
  }, a(e.displayMonth, {
    locale: n
  }));
}
function Gb(e) {
  return $.createElement("svg", _oe({
    width: "8px",
    height: "8px",
    viewBox: "0 0 120 120",
    "data-testid": "iconDropdown"
  }, e), $.createElement("path", {
    d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
}
function wu(e) {
  var t,
    n,
    r = e.onChange,
    o = e.value,
    a = e.children,
    i = e.caption,
    s = e.className,
    c = e.style,
    l = _e(),
    u = (n = (t = l.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : Gb;
  return $.createElement("div", {
    className: s,
    style: c
  }, $.createElement("span", {
    className: l.classNames.vhidden
  }, e["aria-label"]), $.createElement("select", {
    name: e.name,
    "aria-label": e["aria-label"],
    className: l.classNames.dropdown,
    style: l.styles.dropdown,
    value: o,
    onChange: r
  }, a), $.createElement("div", {
    className: l.classNames.caption_label,
    style: l.styles.caption_label,
    "aria-hidden": "true"
  }, i, $.createElement(u, {
    className: l.classNames.dropdown_icon,
    style: l.styles.dropdown_icon
  })));
}
function zb(e) {
  var t,
    n = _e(),
    r = n.fromDate,
    o = n.toDate,
    a = n.styles,
    i = n.locale,
    s = n.formatters.formatMonthCaption,
    c = n.classNames,
    l = n.components,
    u = n.labels.labelMonthDropdown;
  if (!r) return $.createElement($.Fragment, null);
  if (!o) return $.createElement($.Fragment, null);
  var d = [];
  if (Ib(r, o)) for (var f = Ee(r), m = r.getMonth(); m <= o.getMonth(); m++) d.push(Io(f, m));else for (var f = Ee( /* @__PURE__ */new Date()), m = 0; m <= 11; m++) d.push(Io(f, m));
  var h = function h(g) {
      var b = Number(g.target.value),
        y = Io(Ee(e.displayMonth), b);
      e.onChange(y);
    },
    v = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : wu;
  return $.createElement(v, {
    name: "months",
    "aria-label": u(),
    className: c.dropdown_month,
    style: a.dropdown_month,
    onChange: h,
    value: e.displayMonth.getMonth(),
    caption: s(e.displayMonth, {
      locale: i
    })
  }, d.map(function (g) {
    return $.createElement("option", {
      key: g.getMonth(),
      value: g.getMonth()
    }, s(g, {
      locale: i
    }));
  }));
}
function qb(e) {
  var t,
    n = e.displayMonth,
    r = _e(),
    o = r.fromDate,
    a = r.toDate,
    i = r.locale,
    s = r.styles,
    c = r.classNames,
    l = r.components,
    u = r.formatters.formatYearCaption,
    d = r.labels.labelYearDropdown,
    f = [];
  if (!o) return $.createElement($.Fragment, null);
  if (!a) return $.createElement($.Fragment, null);
  for (var m = o.getFullYear(), h = a.getFullYear(), v = m; v <= h; v++) f.push(Ns(fh( /* @__PURE__ */new Date()), v));
  var g = function g(y) {
      var w = Ns(Ee(n), Number(y.target.value));
      e.onChange(w);
    },
    b = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : wu;
  return $.createElement(b, {
    name: "years",
    "aria-label": d(),
    className: c.dropdown_year,
    style: s.dropdown_year,
    onChange: g,
    value: n.getFullYear(),
    caption: u(n, {
      locale: i
    })
  }, f.map(function (y) {
    return $.createElement("option", {
      key: y.getFullYear(),
      value: y.getFullYear()
    }, u(y, {
      locale: i
    }));
  }));
}
function Xb(e, t) {
  var n = te(e),
    r = n[0],
    o = n[1],
    a = t === void 0 ? r : t;
  return [a, o];
}
function Qb(e) {
  var t = e.month,
    n = e.defaultMonth,
    r = e.today,
    o = t || n || r || /* @__PURE__ */new Date(),
    a = e.toDate,
    i = e.fromDate,
    s = e.numberOfMonths,
    c = s === void 0 ? 1 : s;
  if (a && Fn(a, o) < 0) {
    var l = -1 * (c - 1);
    o = Ye(a, l);
  }
  return i && Fn(o, i) < 0 && (o = i), Ee(o);
}
function Zb() {
  var e = _e(),
    t = Qb(e),
    n = Xb(t, e.month),
    r = n[0],
    o = n[1],
    a = function a(i) {
      var s;
      if (!e.disableNavigation) {
        var c = Ee(i);
        o(c), (s = e.onMonthChange) === null || s === void 0 || s.call(e, c);
      }
    };
  return [r, a];
}
function Jb(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = Ee(e), a = Ee(Ye(o, r)), i = Fn(a, o), s = [], c = 0; c < i; c++) {
    var l = Ye(o, c);
    s.push(l);
  }
  return n && (s = s.reverse()), s;
}
function e0(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate,
      r = t.pagedNavigation,
      o = t.numberOfMonths,
      a = o === void 0 ? 1 : o,
      i = r ? a : 1,
      s = Ee(e);
    if (!n) return Ye(s, i);
    var c = Fn(n, e);
    if (!(c < a)) return Ye(s, i);
  }
}
function t0(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate,
      r = t.pagedNavigation,
      o = t.numberOfMonths,
      a = o === void 0 ? 1 : o,
      i = r ? a : 1,
      s = Ee(e);
    if (!n) return Ye(s, -i);
    var c = Fn(s, n);
    if (!(c <= 0)) return Ye(s, -i);
  }
}
var xu = he(void 0);
function n0(e) {
  var t = _e(),
    n = Zb(),
    r = n[0],
    o = n[1],
    a = Jb(r, t),
    i = e0(r, t),
    s = t0(r, t),
    c = function c(d) {
      return a.some(function (f) {
        return Pt(d, f);
      });
    },
    l = function l(d, f) {
      c(d) || (f && fn(d, f) ? o(Ye(d, 1 + t.numberOfMonths * -1)) : o(d));
    },
    u = {
      currentMonth: r,
      displayMonths: a,
      goToMonth: o,
      goToDate: l,
      previousMonth: s,
      nextMonth: i,
      isDateDisplayed: c
    };
  return $.createElement(xu.Provider, {
    value: u
  }, e.children);
}
function $n() {
  var e = ce(xu);
  if (!e) throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function ks(e) {
  var t,
    n = _e(),
    r = n.classNames,
    o = n.styles,
    a = n.components,
    i = $n().goToMonth,
    s = function s(u) {
      i(Ye(u, e.displayIndex ? -e.displayIndex : 0));
    },
    c = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : yu,
    l = $.createElement(c, {
      id: e.id,
      displayMonth: e.displayMonth
    });
  return $.createElement("div", {
    className: r.caption_dropdowns,
    style: o.caption_dropdowns
  }, $.createElement("div", {
    className: r.vhidden
  }, l), $.createElement(zb, {
    onChange: s,
    displayMonth: e.displayMonth
  }), $.createElement(qb, {
    onChange: s,
    displayMonth: e.displayMonth
  }));
}
function r0(e) {
  return $.createElement("svg", _oe({
    width: "16px",
    height: "16px",
    viewBox: "0 0 120 120"
  }, e), $.createElement("path", {
    d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
}
function o0(e) {
  return $.createElement("svg", _oe({
    width: "16px",
    height: "16px",
    viewBox: "0 0 120 120"
  }, e), $.createElement("path", {
    d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
    fill: "currentColor"
  }));
}
var Lr = x(function (e, t) {
  var n = _e(),
    r = n.classNames,
    o = n.styles,
    a = [r.button_reset, r.button];
  e.className && a.push(e.className);
  var i = a.join(" "),
    s = _oe(_oe({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), $.createElement("button", _oe({}, e, {
    ref: t,
    type: "button",
    className: i,
    style: s
  }));
});
function a0(e) {
  var t,
    n,
    r = _e(),
    o = r.dir,
    a = r.locale,
    i = r.classNames,
    s = r.styles,
    c = r.labels,
    l = c.labelPrevious,
    u = c.labelNext,
    d = r.components;
  if (!e.nextMonth && !e.previousMonth) return $.createElement($.Fragment, null);
  var f = l(e.previousMonth, {
      locale: a
    }),
    m = [i.nav_button, i.nav_button_previous].join(" "),
    h = u(e.nextMonth, {
      locale: a
    }),
    v = [i.nav_button, i.nav_button_next].join(" "),
    g = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : o0,
    b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : r0;
  return $.createElement("div", {
    className: i.nav,
    style: s.nav
  }, !e.hidePrevious && $.createElement(Lr, {
    name: "previous-month",
    "aria-label": f,
    className: m,
    style: s.nav_button_previous,
    disabled: !e.previousMonth,
    onClick: e.onPreviousClick
  }, o === "rtl" ? $.createElement(g, {
    className: i.nav_icon,
    style: s.nav_icon
  }) : $.createElement(b, {
    className: i.nav_icon,
    style: s.nav_icon
  })), !e.hideNext && $.createElement(Lr, {
    name: "next-month",
    "aria-label": h,
    className: v,
    style: s.nav_button_next,
    disabled: !e.nextMonth,
    onClick: e.onNextClick
  }, o === "rtl" ? $.createElement(b, {
    className: i.nav_icon,
    style: s.nav_icon
  }) : $.createElement(g, {
    className: i.nav_icon,
    style: s.nav_icon
  })));
}
function Rs(e) {
  var t = _e().numberOfMonths,
    n = $n(),
    r = n.previousMonth,
    o = n.nextMonth,
    a = n.goToMonth,
    i = n.displayMonths,
    s = i.findIndex(function (h) {
      return Pt(e.displayMonth, h);
    }),
    c = s === 0,
    l = s === i.length - 1,
    u = t > 1 && (c || !l),
    d = t > 1 && (l || !c),
    f = function f() {
      r && a(r);
    },
    m = function m() {
      o && a(o);
    };
  return $.createElement(a0, {
    displayMonth: e.displayMonth,
    hideNext: u,
    hidePrevious: d,
    nextMonth: o,
    previousMonth: r,
    onPreviousClick: f,
    onNextClick: m
  });
}
function i0(e) {
  var t,
    n = _e(),
    r = n.classNames,
    o = n.disableNavigation,
    a = n.styles,
    i = n.captionLayout,
    s = n.components,
    c = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : yu,
    l;
  return o ? l = $.createElement(c, {
    id: e.id,
    displayMonth: e.displayMonth
  }) : i === "dropdown" ? l = $.createElement(ks, {
    displayMonth: e.displayMonth,
    id: e.id
  }) : i === "dropdown-buttons" ? l = $.createElement($.Fragment, null, $.createElement(ks, {
    displayMonth: e.displayMonth,
    displayIndex: e.displayIndex,
    id: e.id
  }), $.createElement(Rs, {
    displayMonth: e.displayMonth,
    displayIndex: e.displayIndex,
    id: e.id
  })) : l = $.createElement($.Fragment, null, $.createElement(c, {
    id: e.id,
    displayMonth: e.displayMonth,
    displayIndex: e.displayIndex
  }), $.createElement(Rs, {
    displayMonth: e.displayMonth,
    id: e.id
  })), $.createElement("div", {
    className: r.caption,
    style: a.caption
  }, l);
}
function s0(e) {
  var t = _e(),
    n = t.footer,
    r = t.styles,
    o = t.classNames.tfoot;
  return n ? $.createElement("tfoot", {
    className: o,
    style: r.tfoot
  }, $.createElement("tr", null, $.createElement("td", {
    colSpan: 8
  }, n))) : $.createElement($.Fragment, null);
}
function c0(e, t, n) {
  for (var r = n ? Zt( /* @__PURE__ */new Date()) : ht( /* @__PURE__ */new Date(), {
      locale: e,
      weekStartsOn: t
    }), o = [], a = 0; a < 7; a++) {
    var i = Ve(r, a);
    o.push(i);
  }
  return o;
}
function l0() {
  var e = _e(),
    t = e.classNames,
    n = e.styles,
    r = e.showWeekNumber,
    o = e.locale,
    a = e.weekStartsOn,
    i = e.ISOWeek,
    s = e.formatters.formatWeekdayName,
    c = e.labels.labelWeekday,
    l = c0(o, a, i);
  return $.createElement("tr", {
    style: n.head_row,
    className: t.head_row
  }, r && $.createElement("td", {
    style: n.head_cell,
    className: t.head_cell
  }), l.map(function (u, d) {
    return $.createElement("th", {
      key: d,
      scope: "col",
      className: t.head_cell,
      style: n.head_cell,
      "aria-label": c(u, {
        locale: o
      })
    }, s(u, {
      locale: o
    }));
  }));
}
function u0() {
  var e,
    t = _e(),
    n = t.classNames,
    r = t.styles,
    o = t.components,
    a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : l0;
  return $.createElement("thead", {
    style: r.head,
    className: n.head
  }, $.createElement(a, null));
}
function d0(e) {
  var t = _e(),
    n = t.locale,
    r = t.formatters.formatDay;
  return $.createElement($.Fragment, null, r(e.date, {
    locale: n
  }));
}
var ni = he(void 0);
function f0(e) {
  if (!qn(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return $.createElement(ni.Provider, {
      value: t
    }, e.children);
  }
  return $.createElement(v0, {
    initialProps: e.initialProps,
    children: e.children
  });
}
function v0(e) {
  var t = e.initialProps,
    n = e.children,
    r = t.selected,
    o = t.min,
    a = t.max,
    i = function i(l, u, d) {
      var f, m;
      (f = t.onDayClick) === null || f === void 0 || f.call(t, l, u, d);
      var h = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
      if (!h) {
        var v = !!(!u.selected && a && (r == null ? void 0 : r.length) === a);
        if (!v) {
          var g = r ? gu([], r, !0) : [];
          if (u.selected) {
            var b = g.findIndex(function (y) {
              return We(l, y);
            });
            g.splice(b, 1);
          } else g.push(l);
          (m = t.onSelect) === null || m === void 0 || m.call(t, g, l, u, d);
        }
      }
    },
    s = {
      disabled: []
    };
  r && s.disabled.push(function (l) {
    var u = a && r.length > a - 1,
      d = r.some(function (f) {
        return We(f, l);
      });
    return !!(u && !d);
  });
  var c = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return $.createElement(ni.Provider, {
    value: c
  }, n);
}
function ri() {
  var e = ce(ni);
  if (!e) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function p0(e, t) {
  var n = t || {},
    r = n.from,
    o = n.to;
  return r && o ? We(o, e) && We(r, e) ? void 0 : We(o, e) ? {
    from: o,
    to: void 0
  } : We(r, e) ? void 0 : bn(r, e) ? {
    from: e,
    to: o
  } : {
    from: r,
    to: e
  } : o ? bn(e, o) ? {
    from: o,
    to: e
  } : {
    from: e,
    to: o
  } : r ? fn(e, r) ? {
    from: e,
    to: r
  } : {
    from: r,
    to: e
  } : {
    from: e,
    to: void 0
  };
}
var oi = he(void 0);
function m0(e) {
  if (!Xn(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return $.createElement(oi.Provider, {
      value: t
    }, e.children);
  }
  return $.createElement(h0, {
    initialProps: e.initialProps,
    children: e.children
  });
}
function h0(e) {
  var t = e.initialProps,
    n = e.children,
    r = t.selected,
    o = r || {},
    a = o.from,
    i = o.to,
    s = t.min,
    c = t.max,
    l = function l(m, h, v) {
      var g, b;
      (g = t.onDayClick) === null || g === void 0 || g.call(t, m, h, v);
      var y = p0(m, r);
      (b = t.onSelect) === null || b === void 0 || b.call(t, y, m, h, v);
    },
    u = {
      range_start: [],
      range_end: [],
      range_middle: [],
      disabled: []
    };
  if (a ? (u.range_start = [a], i ? (u.range_end = [i], We(a, i) || (u.range_middle = [{
    after: a,
    before: i
  }])) : u.range_end = [a]) : i && (u.range_start = [i], u.range_end = [i]), s && (a && !i && u.disabled.push({
    after: _o(a, s - 1),
    before: Ve(a, s - 1)
  }), a && i && u.disabled.push({
    after: a,
    before: Ve(a, s - 1)
  }), !a && i && u.disabled.push({
    after: _o(i, s - 1),
    before: Ve(i, s - 1)
  })), c) {
    if (a && !i && (u.disabled.push({
      before: Ve(a, -c + 1)
    }), u.disabled.push({
      after: Ve(a, c - 1)
    })), a && i) {
      var d = Ct(i, a) + 1,
        f = c - d;
      u.disabled.push({
        before: _o(a, f)
      }), u.disabled.push({
        after: Ve(i, f)
      });
    }
    !a && i && (u.disabled.push({
      before: Ve(i, -c + 1)
    }), u.disabled.push({
      after: Ve(i, c - 1)
    }));
  }
  return $.createElement(oi.Provider, {
    value: {
      selected: r,
      onDayClick: l,
      modifiers: u
    }
  }, n);
}
function ai() {
  var e = ce(oi);
  if (!e) throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Pr(e) {
  return Array.isArray(e) ? gu([], e, !0) : e !== void 0 ? [e] : [];
}
function g0(e) {
  var t = {};
  return Object.entries(e).forEach(function (n) {
    var r = n[0],
      o = n[1];
    t[r] = Pr(o);
  }), t;
}
var ut;
(function (e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ut || (ut = {}));
var b0 = ut.Selected,
  xt = ut.Disabled,
  y0 = ut.Hidden,
  w0 = ut.Today,
  Po = ut.RangeEnd,
  Do = ut.RangeMiddle,
  So = ut.RangeStart,
  x0 = ut.Outside;
function $0(e, t, n) {
  var r,
    o = (r = {}, r[b0] = Pr(e.selected), r[xt] = Pr(e.disabled), r[y0] = Pr(e.hidden), r[w0] = [e.today], r[Po] = [], r[Do] = [], r[So] = [], r[x0] = [], r);
  return e.fromDate && o[xt].push({
    before: e.fromDate
  }), e.toDate && o[xt].push({
    after: e.toDate
  }), qn(e) ? o[xt] = o[xt].concat(t.modifiers[xt]) : Xn(e) && (o[xt] = o[xt].concat(n.modifiers[xt]), o[So] = n.modifiers[So], o[Do] = n.modifiers[Do], o[Po] = n.modifiers[Po]), o;
}
var $u = he(void 0);
function C0(e) {
  var t = _e(),
    n = ri(),
    r = ai(),
    o = $0(t, n, r),
    a = g0(t.modifiers),
    i = _oe(_oe({}, o), a);
  return $.createElement($u.Provider, {
    value: i
  }, e.children);
}
function Cu() {
  var e = ce($u);
  if (!e) throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function T0(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function _0(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function I0(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function P0(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function D0(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function S0(e, t) {
  var n,
    r = t.from,
    o = t.to;
  if (r && o) {
    var a = Ct(o, r) < 0;
    a && (n = [o, r], r = n[0], o = n[1]);
    var i = Ct(e, r) >= 0 && Ct(o, e) >= 0;
    return i;
  }
  return o ? We(o, e) : r ? We(r, e) : !1;
}
function E0(e) {
  return qa(e);
}
function O0(e) {
  return Array.isArray(e) && e.every(qa);
}
function M0(e, t) {
  return t.some(function (n) {
    if (typeof n == "boolean") return n;
    if (E0(n)) return We(e, n);
    if (O0(n)) return n.includes(e);
    if (_0(n)) return S0(e, n);
    if (D0(n)) return n.dayOfWeek.includes(e.getDay());
    if (T0(n)) {
      var r = Ct(n.before, e),
        o = Ct(n.after, e),
        a = r > 0,
        i = o < 0,
        s = bn(n.before, n.after);
      return s ? i && a : a || i;
    }
    return I0(n) ? Ct(e, n.after) > 0 : P0(n) ? Ct(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function ii(e, t, n) {
  var r = Object.keys(t).reduce(function (a, i) {
      var s = t[i];
      return M0(e, s) && a.push(i), a;
    }, []),
    o = {};
  return r.forEach(function (a) {
    return o[a] = !0;
  }), n && !Pt(e, n) && (o.outside = !0), o;
}
function N0(e, t) {
  for (var n = Ee(e[0]), r = zn(e[e.length - 1]), o, a, i = n; i <= r;) {
    var s = ii(i, t),
      c = !s.disabled && !s.hidden;
    if (!c) {
      i = Ve(i, 1);
      continue;
    }
    if (s.selected) return i;
    s.today && !a && (a = i), o || (o = i), i = Ve(i, 1);
  }
  return a || o;
}
var k0 = 365;
function Tu(e, t) {
  var n = t.moveBy,
    r = t.direction,
    o = t.context,
    a = t.modifiers,
    i = t.retry,
    s = i === void 0 ? {
      count: 0,
      lastFocused: e
    } : i,
    c = o.weekStartsOn,
    l = o.fromDate,
    u = o.toDate,
    d = o.locale,
    f = {
      day: Ve,
      week: Zo,
      month: Ye,
      year: nh,
      startOfWeek: function startOfWeek(g) {
        return o.ISOWeek ? Zt(g) : ht(g, {
          locale: d,
          weekStartsOn: c
        });
      },
      endOfWeek: function endOfWeek(g) {
        return o.ISOWeek ? ou(g) : Xa(g, {
          locale: d,
          weekStartsOn: c
        });
      }
    },
    m = f[n](e, r === "after" ? 1 : -1);
  r === "before" && l ? m = rh([l, m]) : r === "after" && u && (m = oh([u, m]));
  var h = !0;
  if (a) {
    var v = ii(m, a);
    h = !v.disabled && !v.hidden;
  }
  return h ? m : s.count > k0 ? s.lastFocused : Tu(m, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: a,
    retry: _oe(_oe({}, s), {
      count: s.count + 1
    })
  });
}
var _u = he(void 0);
function R0(e) {
  var t = $n(),
    n = Cu(),
    r = te(),
    o = r[0],
    a = r[1],
    i = te(),
    s = i[0],
    c = i[1],
    l = N0(t.displayMonths, n),
    u = (o !== null && o !== void 0 ? o : s && t.isDateDisplayed(s)) ? s : l,
    d = function d() {
      c(o), a(void 0);
    },
    f = function f(g) {
      a(g);
    },
    m = _e(),
    h = function h(g, b) {
      if (o) {
        var y = Tu(o, {
          moveBy: g,
          direction: b,
          context: m,
          modifiers: n
        });
        We(o, y) || (t.goToDate(y, o), f(y));
      }
    },
    v = {
      focusedDay: o,
      focusTarget: u,
      blur: d,
      focus: f,
      focusDayAfter: function focusDayAfter() {
        return h("day", "after");
      },
      focusDayBefore: function focusDayBefore() {
        return h("day", "before");
      },
      focusWeekAfter: function focusWeekAfter() {
        return h("week", "after");
      },
      focusWeekBefore: function focusWeekBefore() {
        return h("week", "before");
      },
      focusMonthBefore: function focusMonthBefore() {
        return h("month", "before");
      },
      focusMonthAfter: function focusMonthAfter() {
        return h("month", "after");
      },
      focusYearBefore: function focusYearBefore() {
        return h("year", "before");
      },
      focusYearAfter: function focusYearAfter() {
        return h("year", "after");
      },
      focusStartOfWeek: function focusStartOfWeek() {
        return h("startOfWeek", "before");
      },
      focusEndOfWeek: function focusEndOfWeek() {
        return h("endOfWeek", "after");
      }
    };
  return $.createElement(_u.Provider, {
    value: v
  }, e.children);
}
function si() {
  var e = ce(_u);
  if (!e) throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function A0(e, t) {
  var n = Cu(),
    r = ii(e, n, t);
  return r;
}
var ci = he(void 0);
function L0(e) {
  if (!to(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return $.createElement(ci.Provider, {
      value: t
    }, e.children);
  }
  return $.createElement(j0, {
    initialProps: e.initialProps,
    children: e.children
  });
}
function j0(e) {
  var t = e.initialProps,
    n = e.children,
    r = function r(a, i, s) {
      var c, l, u;
      if ((c = t.onDayClick) === null || c === void 0 || c.call(t, a, i, s), i.selected && !t.required) {
        (l = t.onSelect) === null || l === void 0 || l.call(t, void 0, a, i, s);
        return;
      }
      (u = t.onSelect) === null || u === void 0 || u.call(t, a, a, i, s);
    },
    o = {
      selected: t.selected,
      onDayClick: r
    };
  return $.createElement(ci.Provider, {
    value: o
  }, n);
}
function Iu() {
  var e = ce(ci);
  if (!e) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function F0(e, t) {
  var n = _e(),
    r = Iu(),
    o = ri(),
    a = ai(),
    i = si(),
    s = i.focusDayAfter,
    c = i.focusDayBefore,
    l = i.focusWeekAfter,
    u = i.focusWeekBefore,
    d = i.blur,
    f = i.focus,
    m = i.focusMonthBefore,
    h = i.focusMonthAfter,
    v = i.focusYearBefore,
    g = i.focusYearAfter,
    b = i.focusStartOfWeek,
    y = i.focusEndOfWeek,
    w = function w(L) {
      var R, Y, re, ae;
      to(n) ? (R = r.onDayClick) === null || R === void 0 || R.call(r, e, t, L) : qn(n) ? (Y = o.onDayClick) === null || Y === void 0 || Y.call(o, e, t, L) : Xn(n) ? (re = a.onDayClick) === null || re === void 0 || re.call(a, e, t, L) : (ae = n.onDayClick) === null || ae === void 0 || ae.call(n, e, t, L);
    },
    I = function I(L) {
      var R;
      f(e), (R = n.onDayFocus) === null || R === void 0 || R.call(n, e, t, L);
    },
    P = function P(L) {
      var R;
      d(), (R = n.onDayBlur) === null || R === void 0 || R.call(n, e, t, L);
    },
    D = function D(L) {
      var R;
      (R = n.onDayMouseEnter) === null || R === void 0 || R.call(n, e, t, L);
    },
    E = function E(L) {
      var R;
      (R = n.onDayMouseLeave) === null || R === void 0 || R.call(n, e, t, L);
    },
    _ = function _(L) {
      var R;
      (R = n.onDayPointerEnter) === null || R === void 0 || R.call(n, e, t, L);
    },
    O = function O(L) {
      var R;
      (R = n.onDayPointerLeave) === null || R === void 0 || R.call(n, e, t, L);
    },
    A = function A(L) {
      var R;
      (R = n.onDayTouchCancel) === null || R === void 0 || R.call(n, e, t, L);
    },
    M = function M(L) {
      var R;
      (R = n.onDayTouchEnd) === null || R === void 0 || R.call(n, e, t, L);
    },
    B = function B(L) {
      var R;
      (R = n.onDayTouchMove) === null || R === void 0 || R.call(n, e, t, L);
    },
    G = function G(L) {
      var R;
      (R = n.onDayTouchStart) === null || R === void 0 || R.call(n, e, t, L);
    },
    N = function N(L) {
      var R;
      (R = n.onDayKeyUp) === null || R === void 0 || R.call(n, e, t, L);
    },
    j = function j(L) {
      var R;
      switch (L.key) {
        case "ArrowLeft":
          L.preventDefault(), L.stopPropagation(), n.dir === "rtl" ? s() : c();
          break;
        case "ArrowRight":
          L.preventDefault(), L.stopPropagation(), n.dir === "rtl" ? c() : s();
          break;
        case "ArrowDown":
          L.preventDefault(), L.stopPropagation(), l();
          break;
        case "ArrowUp":
          L.preventDefault(), L.stopPropagation(), u();
          break;
        case "PageUp":
          L.preventDefault(), L.stopPropagation(), L.shiftKey ? v() : m();
          break;
        case "PageDown":
          L.preventDefault(), L.stopPropagation(), L.shiftKey ? g() : h();
          break;
        case "Home":
          L.preventDefault(), L.stopPropagation(), b();
          break;
        case "End":
          L.preventDefault(), L.stopPropagation(), y();
          break;
      }
      (R = n.onDayKeyDown) === null || R === void 0 || R.call(n, e, t, L);
    },
    U = {
      onClick: w,
      onFocus: I,
      onBlur: P,
      onKeyDown: j,
      onKeyUp: N,
      onMouseEnter: D,
      onMouseLeave: E,
      onPointerEnter: _,
      onPointerLeave: O,
      onTouchCancel: A,
      onTouchEnd: M,
      onTouchMove: B,
      onTouchStart: G
    };
  return U;
}
function W0() {
  var e = _e(),
    t = Iu(),
    n = ri(),
    r = ai(),
    o = to(e) ? t.selected : qn(e) ? n.selected : Xn(e) ? r.selected : void 0;
  return o;
}
function H0(e) {
  return Object.values(ut).includes(e);
}
function B0(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function (r) {
    var o = e.modifiersClassNames[r];
    if (o) n.push(o);else if (H0(r)) {
      var a = e.classNames["day_".concat(r)];
      a && n.push(a);
    }
  }), n;
}
function V0(e, t) {
  var n = _oe({}, e.styles.day);
  return Object.keys(t).forEach(function (r) {
    var o;
    n = _oe(_oe({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function Pu(e, t, n) {
  var r,
    o,
    a,
    i = _e(),
    s = si(),
    c = A0(e, t),
    l = F0(e, c),
    u = W0(),
    d = !!(i.onDayClick || i.mode !== "default");
  V(function () {
    var D;
    c.outside || s.focusedDay && d && We(s.focusedDay, e) && ((D = n.current) === null || D === void 0 || D.focus());
  }, [s.focusedDay, e, n, d, c.outside]);
  var f = B0(i, c).join(" "),
    m = V0(i, c),
    h = !!(c.outside && !i.showOutsideDays || c.hidden),
    v = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : d0,
    g = $.createElement(v, {
      date: e,
      displayMonth: t,
      activeModifiers: c
    }),
    b = {
      style: m,
      className: f,
      children: g,
      role: "gridcell"
    },
    y = s.focusTarget && We(s.focusTarget, e) && !c.outside,
    w = s.focusedDay && We(s.focusedDay, e),
    I = _oe(_oe(_oe({}, b), (r = {
      disabled: c.disabled,
      role: "gridcell"
    }, r["aria-selected"] = c.selected, r.tabIndex = w || y ? 0 : -1, r)), l),
    P = {
      isButton: d,
      isHidden: h,
      activeModifiers: c,
      selectedDays: u,
      buttonProps: I,
      divProps: b
    };
  return P;
}
function U0(e) {
  var t = k(null),
    n = Pu(e.date, e.displayMonth, t);
  return n.isHidden ? $.createElement("div", {
    role: "gridcell"
  }) : n.isButton ? $.createElement(Lr, _oe({
    name: "day",
    ref: t
  }, n.buttonProps)) : $.createElement("div", _oe({}, n.divProps));
}
function Y0(e) {
  var t = e.number,
    n = e.dates,
    r = _e(),
    o = r.onWeekNumberClick,
    a = r.styles,
    i = r.classNames,
    s = r.locale,
    c = r.labels.labelWeekNumber,
    l = r.formatters.formatWeekNumber,
    u = l(Number(t), {
      locale: s
    });
  if (!o) return $.createElement("span", {
    className: i.weeknumber,
    style: a.weeknumber
  }, u);
  var d = c(Number(t), {
      locale: s
    }),
    f = function f(m) {
      o(t, n, m);
    };
  return $.createElement(Lr, {
    name: "week-number",
    "aria-label": d,
    className: i.weeknumber,
    style: a.weeknumber,
    onClick: f
  }, u);
}
function K0(e) {
  var t,
    n,
    r = _e(),
    o = r.styles,
    a = r.classNames,
    i = r.showWeekNumber,
    s = r.components,
    c = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : U0,
    l = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : Y0,
    u;
  return i && (u = $.createElement("td", {
    className: a.cell,
    style: o.cell
  }, $.createElement(l, {
    number: e.weekNumber,
    dates: e.dates
  }))), $.createElement("tr", {
    className: a.row,
    style: o.row
  }, u, e.dates.map(function (d) {
    return $.createElement("td", {
      className: a.cell,
      style: o.cell,
      key: xg(d),
      role: "presentation"
    }, $.createElement(c, {
      displayMonth: e.displayMonth,
      date: d
    }));
  }));
}
function As(e, t, n) {
  for (var r = n != null && n.ISOWeek ? ou(t) : Xa(t, n), o = n != null && n.ISOWeek ? Zt(e) : ht(e, n), a = Ct(r, o), i = [], s = 0; s <= a; s++) i.push(Ve(o, s));
  var c = i.reduce(function (l, u) {
    var d = n != null && n.ISOWeek ? yg(u) : _g(u, n),
      f = l.find(function (m) {
        return m.weekNumber === d;
      });
    return f ? (f.dates.push(u), l) : (l.push({
      weekNumber: d,
      dates: [u]
    }), l);
  }, []);
  return c;
}
function G0(e, t) {
  var n = As(Ee(e), zn(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = Pg(e, t);
    if (r < 6) {
      var o = n[n.length - 1],
        a = o.dates[o.dates.length - 1],
        i = Zo(a, 6 - r),
        s = As(Zo(a, 1), i, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function z0(e) {
  var t,
    n,
    r,
    o = _e(),
    a = o.locale,
    i = o.classNames,
    s = o.styles,
    c = o.hideHead,
    l = o.fixedWeeks,
    u = o.components,
    d = o.weekStartsOn,
    f = o.firstWeekContainsDate,
    m = o.ISOWeek,
    h = G0(e.displayMonth, {
      useFixedWeeks: !!l,
      ISOWeek: m,
      locale: a,
      weekStartsOn: d,
      firstWeekContainsDate: f
    }),
    v = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : u0,
    g = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : K0,
    b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : s0;
  return $.createElement("table", {
    id: e.id,
    className: i.table,
    style: s.table,
    role: "grid",
    "aria-labelledby": e["aria-labelledby"]
  }, !c && $.createElement(v, null), $.createElement("tbody", {
    className: i.tbody,
    style: s.tbody
  }, h.map(function (y) {
    return $.createElement(g, {
      displayMonth: e.displayMonth,
      key: y.weekNumber,
      dates: y.dates,
      weekNumber: y.weekNumber
    });
  })), $.createElement(b, {
    displayMonth: e.displayMonth
  }));
}
function q0() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var X0 = q0() ? ee.useLayoutEffect : ee.useEffect,
  Eo = !1,
  Q0 = 0;
function Ls() {
  return "react-day-picker-".concat(++Q0);
}
function Z0(e) {
  var t,
    n = e !== null && e !== void 0 ? e : Eo ? Ls() : null,
    r = ee.useState(n),
    o = r[0],
    a = r[1];
  return X0(function () {
    o === null && a(Ls());
  }, []), ee.useEffect(function () {
    Eo === !1 && (Eo = !0);
  }, []), (t = e !== null && e !== void 0 ? e : o) !== null && t !== void 0 ? t : void 0;
}
function J0(e) {
  var t,
    n,
    r = _e(),
    o = r.dir,
    a = r.classNames,
    i = r.styles,
    s = r.components,
    c = $n().displayMonths,
    l = Z0(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0),
    u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0,
    d = [a.month],
    f = i.month,
    m = e.displayIndex === 0,
    h = e.displayIndex === c.length - 1,
    v = !m && !h;
  o === "rtl" && (t = [m, h], h = t[0], m = t[1]), m && (d.push(a.caption_start), f = _oe(_oe({}, f), i.caption_start)), h && (d.push(a.caption_end), f = _oe(_oe({}, f), i.caption_end)), v && (d.push(a.caption_between), f = _oe(_oe({}, f), i.caption_between));
  var g = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : i0;
  return $.createElement("div", {
    key: e.displayIndex,
    className: d.join(" "),
    style: f
  }, $.createElement(g, {
    id: l,
    displayMonth: e.displayMonth,
    displayIndex: e.displayIndex
  }), $.createElement(z0, {
    id: u,
    "aria-labelledby": l,
    displayMonth: e.displayMonth
  }));
}
function ey(e) {
  var t = e.initialProps,
    n = _e(),
    r = si(),
    o = $n(),
    a = te(!1),
    i = a[0],
    s = a[1];
  V(function () {
    n.initialFocus && r.focusTarget && (i || (r.focus(r.focusTarget), s(!0)));
  }, [n.initialFocus, i, r.focus, r.focusTarget, r]);
  var c = [n.classNames.root, n.className];
  n.numberOfMonths > 1 && c.push(n.classNames.multiple_months), n.showWeekNumber && c.push(n.classNames.with_weeknumber);
  var l = _oe(_oe({}, n.styles.root), n.style),
    u = Object.keys(t).filter(function (d) {
      return d.startsWith("data-");
    }).reduce(function (d, f) {
      var m;
      return _oe(_oe({}, d), (m = {}, m[f] = t[f], m));
    }, {});
  return $.createElement("div", _oe({
    className: c.join(" "),
    style: l,
    dir: n.dir,
    id: n.id
  }, u), $.createElement("div", {
    className: n.classNames.months,
    style: n.styles.months
  }, o.displayMonths.map(function (d, f) {
    return $.createElement(J0, {
      key: f,
      displayIndex: f,
      displayMonth: d
    });
  })));
}
function ty(e) {
  var t = e.children,
    n = Pb(e, ["children"]);
  return $.createElement(Kb, {
    initialProps: n
  }, $.createElement(n0, null, $.createElement(L0, {
    initialProps: n
  }, $.createElement(f0, {
    initialProps: n
  }, $.createElement(m0, {
    initialProps: n
  }, $.createElement(C0, null, $.createElement(R0, null, t)))))));
}
function js(e) {
  return $.createElement(ty, _oe({}, e), $.createElement(ey, {
    initialProps: e
  }));
}
var ny = x(function (_ref68, i) {
    var t = _ref68.children,
      n = _ref68.className,
      r = _ref68.endAligned,
      _ref68$size = _ref68.size,
      o = _ref68$size === void 0 ? "medium" : _ref68$size,
      a = _objectWithoutProperties(_ref68, _excluded77);
    var s = dt();
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, a), {}, {
      className: T("goat-Input", "goat-Input_".concat(o), {
        "goat-Input_suffixed": r
      }, {
        "goat-disabled": s.disabled
      }, {
        "goat-invalid": s.touched && s.validity.valid === !1
      }, n),
      ref: i,
      children: t
    }));
  }),
  ry = x(function (_ref69, a) {
    var t = _ref69.className,
      n = _ref69.disabled,
      r = _ref69.id,
      o = _objectWithoutProperties(_ref69, _excluded78);
    var i = dt({
      disabled: n,
      id: r
    });
    return /* @__PURE__ */p.jsx("input", _objectSpread(_objectSpread({}, o), {}, {
      "aria-describedby": i.describedBy(o),
      className: T("goat-Input__Text", t),
      disabled: i.disabled,
      id: i.id,
      ref: a
    }));
  }),
  oy = x(function (_ref70, s) {
    var _ref70$resize = _ref70.resize,
      t = _ref70$resize === void 0 ? "both" : _ref70$resize,
      n = _ref70.size,
      r = _ref70.className,
      o = _ref70.disabled,
      a = _ref70.id,
      i = _objectWithoutProperties(_ref70, _excluded79);
    var c = dt({
      disabled: o,
      id: a
    });
    return /* @__PURE__ */p.jsx("textarea", _objectSpread(_objectSpread({}, i), {}, {
      "aria-describedby": c.describedBy(i),
      className: T("goat-Input", "goat-Input__Area", "goat-Input_".concat(n), {
        "goat-disabled": c.disabled
      }, {
        "goat-invalid": c.touched && c.validity.valid === !1
      }, r),
      style: {
        "--goat-Input__Area-resize": t
      },
      disabled: c.disabled,
      id: c.id,
      ref: s
    }));
  }),
  jr = {
    Root: ny,
    Text: ry,
    Area: oy
  };
var Ge = x(function (_ref71, s) {
    var _ref71$as = _ref71.as,
      t = _ref71$as === void 0 ? "span" : _ref71$as,
      _ref71$color = _ref71.color,
      n = _ref71$color === void 0 ? "gray-900" : _ref71$color,
      _ref71$type = _ref71.type,
      r = _ref71$type === void 0 ? "body-medium" : _ref71$type,
      o = _ref71.className,
      a = _ref71.style,
      i = _objectWithoutProperties(_ref71, _excluded80);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, i), {}, {
      ref: s,
      style: _objectSpread(_objectSpread({}, a), {}, {
        "--goat-color": yn(n)
      }),
      className: T("goat-Typography", "goat-Typography--".concat(r), "goat-Typography--".concat(n), o)
    }));
  }),
  zT = x(function (_ref72, r) {
    var _ref72$type = _ref72.type,
      t = _ref72$type === void 0 ? "header-large" : _ref72$type,
      n = _objectWithoutProperties(_ref72, _excluded81);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "h1"
    }));
  }),
  ay = x(function (_ref73, r) {
    var _ref73$type = _ref73.type,
      t = _ref73$type === void 0 ? "header-medium" : _ref73$type,
      n = _objectWithoutProperties(_ref73, _excluded82);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "h2"
    }));
  }),
  qT = x(function (_ref74, r) {
    var _ref74$type = _ref74.type,
      t = _ref74$type === void 0 ? "header-small" : _ref74$type,
      n = _objectWithoutProperties(_ref74, _excluded83);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "h3"
    }));
  }),
  XT = x(function (_ref75, r) {
    var _ref75$type = _ref75.type,
      t = _ref75$type === void 0 ? "body-large" : _ref75$type,
      n = _objectWithoutProperties(_ref75, _excluded84);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "h4"
    }));
  }),
  QT = x(function (_ref76, r) {
    var _ref76$type = _ref76.type,
      t = _ref76$type === void 0 ? "body-medium" : _ref76$type,
      n = _objectWithoutProperties(_ref76, _excluded85);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "h5"
    }));
  }),
  ZT = x(function (_ref77, r) {
    var _ref77$type = _ref77.type,
      t = _ref77$type === void 0 ? "body-medium" : _ref77$type,
      n = _objectWithoutProperties(_ref77, _excluded86);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "p"
    }));
  }),
  JT = x(function (_ref78, r) {
    var _ref78$type = _ref78.type,
      t = _ref78$type === void 0 ? "body-medium" : _ref78$type,
      n = _objectWithoutProperties(_ref78, _excluded87);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({
      type: t
    }, n), {}, {
      ref: r,
      as: "span"
    }));
  });
function iy(_ref79) {
  var e = _ref79.displayMonth;
  var _$n = $n(),
    t = _$n.goToMonth,
    n = _$n.nextMonth,
    r = _$n.previousMonth,
    o = _$n.displayMonths;
  return /* @__PURE__ */p.jsxs(ay, {
    type: "body-medium",
    className: T("goat-DatePicker__Caption", {
      "goat-DatePicker__Caption_multiple": o.length > 1
    }),
    children: [/* @__PURE__ */p.jsx(Qe, {
      className: T("goat-DatePicker__CaptionPrev"),
      icon: xc,
      disabled: !r,
      onClick: function onClick() {
        return r && t(r);
      }
    }), ve(e, "MMMM yyy"), /* @__PURE__ */p.jsx(Qe, {
      className: T("goat-DatePicker__CaptionNext"),
      icon: ha,
      disabled: !n,
      onClick: function onClick() {
        return n && t(n);
      }
    })]
  });
}
function sy(e) {
  var t = k(null),
    n = Pu(e.date, e.displayMonth, t);
  if (n.isHidden) return null;
  if (!n.isButton) return /* @__PURE__ */p.jsx("div", _objectSpread({}, n.divProps));
  var _n$activeModifiers = n.activeModifiers,
    r = _n$activeModifiers.range_start,
    o = _n$activeModifiers.range_middle,
    a = _n$activeModifiers.range_end,
    i = _n$activeModifiers.selected,
    s = _n$activeModifiers.disabled,
    c = _n$activeModifiers.today,
    l = dh(e.date),
    u = Dg(e.date),
    d = r && a && n.selectedDays && "from" in n.selectedDays && n.selectedDays.to ? "startend" : r ? "start" : o ? "middle" : a ? "end" : "none";
  return /* @__PURE__ */p.jsx("button", _objectSpread(_objectSpread({}, n.buttonProps), {}, {
    type: "button",
    className: T("goat-Button", "goat-DatePicker__DayButton", "goat-DatePicker__DayButton_".concat(d), {
      "goat-Button_disabled": s,
      "goat-DatePicker__DayButton_disabled": s,
      "goat-DatePicker__DayButton_selected": i,
      "goat-DatePicker__DayButton_today": c,
      "goat-DatePicker__DayButton_firstDay": u,
      "goat-DatePicker__DayButton_lastDay": l
    }),
    ref: t
  }));
}
var cy = function cy(_ref80) {
    var e = _ref80.presets,
      t = _ref80.onRangeClick;
    return /* @__PURE__ */p.jsx("div", {
      className: T("goat-DatePicker__RangePresets"),
      children: e.map(function (_ref81) {
        var n = _ref81.label,
          r = _ref81.range;
        return /* @__PURE__ */p.jsx(Fe, {
          variant: "subtle",
          size: "small",
          onClick: function onClick() {
            return t(r());
          },
          children: n
        }, n);
      })
    });
  },
  Re = function Re(e, t) {
    if (!e) return;
    var n = ti(e, t, /* @__PURE__ */new Date());
    return eo(n) ? n : void 0;
  },
  Qn = function Qn(e, t, n) {
    var r = e && n && !e.includes("T") ? "".concat(e, "T00:00:00") : e,
      o = t && n && !t.includes("T") ? "".concat(t, "T23:59:59") : t;
    return {
      minDate: Re(r, n ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd"),
      maxDate: Re(o, n ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd")
    };
  },
  Du = {
    h12: "hh",
    h23: "HH",
    h11: "kk",
    h24: "KK"
  },
  ly = function ly(e, t) {
    var n = {
      hours: null,
      minutes: null,
      timePeriod: "AM"
    };
    if (!e) return n;
    var r = ti(e, "HH:mm", /* @__PURE__ */new Date());
    if (!eo(r)) return n;
    var o = "".concat(Du[t], " mm a"),
      _ve$split = ve(r, o).split(" "),
      _ve$split2 = _slicedToArray(_ve$split, 3),
      a = _ve$split2[0],
      i = _ve$split2[1],
      s = _ve$split2[2];
    return {
      hours: +a,
      minutes: +i,
      timePeriod: s
    };
  },
  Oo = function Oo(e, t, n) {
    if (!e) return "";
    var r = ["h12", "h11"].includes(n),
      o = "".concat(Du[n], ":mm").concat(r ? " a" : ""),
      a = ti("".concat(e).concat(r ? " " + t : ""), o, /* @__PURE__ */new Date());
    return eo(a) ? ve(a, "HH:mm") : "";
  },
  uy = function uy(_ref82) {
    var _ref83;
    var e = _ref82.from,
      t = _ref82.to,
      n = _ref82.max,
      r = _ref82.min,
      o = _ref82.singleMonth,
      a = _ref82.time;
    var _Qn = Qn(r, n, a),
      i = _Qn.minDate,
      s = _Qn.maxDate;
    var c = (_ref83 = t !== null && t !== void 0 ? t : e) !== null && _ref83 !== void 0 ? _ref83 : /* @__PURE__ */new Date();
    return i && fn(c, i) && (c = i), s && bn(c, s) && (c = s), (s && !o && Pt(c, s) || e && t && !Pt(e, t) && Pt(t, c)) && (c = Ye(c, -1)), Ee(c);
  },
  Su = function Su(_ref84) {
    var e = _ref84.fromValue,
      t = _ref84.inputFormat,
      n = _ref84.max,
      r = _ref84.min,
      o = _ref84.time,
      a = _ref84.toValue;
    var i = Re(e, t),
      s = Re(a, t),
      _Qn2 = Qn(r, n, o),
      c = _Qn2.minDate,
      l = _Qn2.maxDate;
    return e && !i || a && !s || c && (i && fn(i, c) || s && fn(s, c)) || l && (i && bn(i, l) || s && bn(s, l)) || s && i && fn(s, i) ? "Invalid date" : "";
  },
  dy = function dy(_ref85) {
    var e = _ref85.currentMonth,
      t = _ref85.fromValue,
      n = _ref85.inputFormat,
      r = _ref85.max,
      o = _ref85.min,
      a = _ref85.singleMonth,
      i = _ref85.target,
      s = _ref85.time,
      c = _ref85.toValue;
    var l = Re(t, n),
      u = Re(c, n),
      _Qn3 = Qn(o, r, s),
      d = _Qn3.minDate,
      f = _Qn3.maxDate,
      m = !Su({
        fromValue: t,
        inputFormat: n,
        max: r,
        min: o,
        time: s,
        toValue: c
      }),
      h = {
        start: e,
        end: zn(a ? e : Ye(e, 1))
      };
    return m ? i === "from" ? !l || Ms(l, h) ? e : a ? Ee(l) : f && Pt(l, f) ? Ee(Ye(l, -1)) : Ee(l) : !u || Ms(u, h) ? e : a || d && Pt(u, d) ? Ee(u) : Ee(Ye(u, -1)) : e;
  },
  fy = function fy(_ref86) {
    var e = _ref86.fromValue,
      t = _ref86.inputFormat,
      n = _ref86.outputFormat,
      r = _ref86.range,
      o = _ref86.toValue;
    var a = Re(e, t),
      i = Re(o, t);
    return i == null || i.setSeconds(59), !r && a ? ve(a, n) : r && a && i ? "".concat(ve(a, n), ",").concat(ve(i, n)) : "";
  },
  vy = function vy(_ref87) {
    var e = _ref87.fromValue,
      t = _ref87.toValue,
      n = _ref87.inputFormat,
      r = _ref87.outputFormat,
      o = _ref87.range,
      a = _ref87.min,
      i = _ref87.max,
      s = _ref87.time;
    var c = Su({
      fromValue: e,
      inputFormat: n,
      max: i,
      min: a,
      time: s,
      toValue: t
    });
    return {
      selectedDate: !c && e ? Re(e, n) : void 0,
      selectedRange: !c && e ? {
        from: Re(e, n),
        to: Re(t, n)
      } : void 0,
      customValidity: c,
      value: c ? "" : fy({
        fromValue: e,
        inputFormat: n,
        outputFormat: r,
        range: o,
        toValue: t
      })
    };
  },
  py = function py(_ref88) {
    var _ref89;
    var e = _ref88.min,
      t = _ref88.max,
      n = _ref88.range,
      r = _ref88.defaultValue,
      o = _ref88.value,
      a = _ref88.outputFormat,
      i = _ref88.inputFormat,
      s = _ref88.time;
    var c = k(null),
      l = al(),
      u = (_ref89 = r !== null && r !== void 0 ? r : o) !== null && _ref89 !== void 0 ? _ref89 : "",
      d = Ne(function () {
        if (n) {
          var _Qn4 = Qn(e, t, s),
            _ = _Qn4.minDate,
            O = _Qn4.maxDate;
          return !!_ && !!O && Pt(_, O);
        }
        return !0;
      }, [t, e, s, n]),
      _te41 = te(function () {
        var _ref92;
        var _ref90 = (_ref92 = u == null ? void 0 : u.split(",").map(function (A) {
            return Re(A, a);
          })) !== null && _ref92 !== void 0 ? _ref92 : [],
          _ref91 = _slicedToArray(_ref90, 2),
          _ = _ref91[0],
          O = _ref91[1];
        return {
          fromValue: _ ? ve(_, i) : "",
          toValue: O ? ve(O, i) : "",
          fromTime: ve(_ !== null && _ !== void 0 ? _ : new Date(0, 0, 1, 0, 0), "HH:mm"),
          toTime: ve(O !== null && O !== void 0 ? O : new Date(0, 0, 1, 23, 59), "HH:mm"),
          internalUpdate: !1,
          month: uy({
            from: _,
            to: O,
            max: t,
            min: e,
            singleMonth: d,
            time: s
          })
        };
      }),
      _te42 = _slicedToArray(_te41, 2),
      _te42$ = _te42[0],
      f = _te42$.fromValue,
      m = _te42$.toValue,
      h = _te42$.fromTime,
      v = _te42$.toTime,
      g = _te42$.internalUpdate,
      b = _te42$.month,
      y = _te42[1],
      w = function w(_, O) {
        return y(function (A) {
          var _$fromValue, _$toValue;
          return _objectSpread(_objectSpread(_objectSpread({}, A), _), {}, {
            month: dy({
              currentMonth: A.month,
              fromValue: (_$fromValue = _.fromValue) !== null && _$fromValue !== void 0 ? _$fromValue : A.fromValue,
              inputFormat: i,
              max: t,
              min: e,
              singleMonth: d,
              target: O,
              time: s,
              toValue: (_$toValue = _.toValue) !== null && _$toValue !== void 0 ? _$toValue : A.toValue
            })
          });
        });
      },
      _Ne = Ne(function () {
        return vy({
          fromValue: f,
          toValue: m,
          inputFormat: i,
          outputFormat: a,
          range: n,
          time: s,
          min: e,
          max: t
        });
      }, [f, i, t, e, a, s, n, m]),
      I = _Ne.value,
      P = _Ne.customValidity,
      D = _Ne.selectedDate,
      E = _Ne.selectedRange;
    return V(function () {
      var O, A;
      if (!c.current) return;
      var _ = c.current.value;
      c.current.value = I, (O = c.current._valueTracker) == null || O.setValue(_), c.current.setCustomValidity(P), (A = c.current) == null || A.checkValidity(), c.current.dispatchEvent(new InputEvent("change", {
        bubbles: !0
      })), On(l, {
        target: c.current
      });
    }, [P, I]), V(function () {
      if (typeof o == "string" && !g) {
        var _o$split = o.split(","),
          _o$split2 = _slicedToArray(_o$split, 2),
          _o$split2$ = _o$split2[0],
          _ = _o$split2$ === void 0 ? "" : _o$split2$,
          _o$split2$2 = _o$split2[1],
          O = _o$split2$2 === void 0 ? "" : _o$split2$2,
          A = Re(_, a),
          M = Re(O, a);
        w({
          fromValue: A ? ve(A, i) : void 0,
          toValue: M ? ve(M, i) : void 0,
          fromTime: A ? ve(A, "HH:mm") : h,
          toTime: M ? ve(M, "HH:mm") : v
        }, n ? "to" : "from");
      }
      return function () {
        y(function (_) {
          return _objectSpread(_objectSpread({}, _), {}, {
            internalUpdate: !1
          });
        });
      };
    }, [o]), {
      fromTime: h,
      toTime: v,
      fromValue: f,
      inputRef: c,
      month: b,
      singleMonth: d,
      toValue: m,
      selectedRange: E,
      selectedDate: D,
      handleBlur: function handleBlur() {
        On(l, {
          target: c.current
        }, {
          touched: !0
        });
      },
      handleDayPickerSelectRange: function handleDayPickerSelectRange(_) {
        var O = Re(f, i),
          A = Re(m, i);
        if (_ != null && _.from && h) {
          var _h$split$map = h.split(":").map(Number),
            _h$split$map2 = _slicedToArray(_h$split$map, 2),
            G = _h$split$map2[0],
            N = _h$split$map2[1];
          _.from.setHours(O && We(O, _.from) ? G : 0), _.from.setMinutes(A && We(A, _.from) ? N : 0);
        }
        if (_ != null && _.to && v) {
          var _v$split$map = v.split(":").map(Number),
            _v$split$map2 = _slicedToArray(_v$split$map, 2),
            _G = _v$split$map2[0],
            _N = _v$split$map2[1];
          _.to.setHours(A && We(A, _.to) ? _G : 23), _.to.setMinutes(A && We(A, _.to) ? _N : 59);
        }
        var M = _ != null && _.from ? ve(_.from, i) : "",
          B = _ != null && _.to ? ve(_.to, i) : "";
        w({
          fromValue: M,
          toValue: B,
          fromTime: _ != null && _.from ? ve(_.from, "HH:mm") : "00:00",
          toTime: _ != null && _.to ? ve(_.to, "HH:mm") : "23:59",
          internalUpdate: !0
        }, B !== m ? "to" : "from");
      },
      handleDayPickerSelectSingle: function handleDayPickerSelectSingle(_) {
        if (_ && h) {
          var _h$split$map3 = h.split(":").map(Number),
            _h$split$map4 = _slicedToArray(_h$split$map3, 2),
            A = _h$split$map4[0],
            M = _h$split$map4[1];
          _.setHours(A), _.setMinutes(M);
        }
        var O = _ ? ve(_, i) : "";
        w({
          fromValue: O,
          internalUpdate: !0
        }, "from");
      },
      handleFromTimeChange: function handleFromTimeChange(_) {
        var O = Re(f, i),
          _$split$map = _.split(":").map(Number),
          _$split$map2 = _slicedToArray(_$split$map, 2),
          A = _$split$map2[0],
          M = _$split$map2[1];
        O && _ && (O.setHours(A), O.setMinutes(M)), w({
          fromTime: _,
          fromValue: O ? ve(O, i) : void 0,
          internalUpdate: !0
        }, "from");
      },
      handleToTimeChange: function handleToTimeChange(_) {
        var O = Re(m, i),
          _$split$map3 = _.split(":").map(Number),
          _$split$map4 = _slicedToArray(_$split$map3, 2),
          A = _$split$map4[0],
          M = _$split$map4[1];
        O && _ && (O.setHours(A), O.setMinutes(M)), w({
          toTime: _,
          toValue: O ? ve(O, i) : void 0,
          internalUpdate: !0
        }, "to");
      },
      handlFromValueChange: function handlFromValueChange(_) {
        var O = Re(_.target.value, i);
        w({
          fromValue: _.target.value,
          fromTime: O ? ve(O, "HH:mm") : h,
          internalUpdate: !0
        }, "from");
      },
      handlToValueChange: function handlToValueChange(_) {
        var O = Re(_.target.value, i);
        w({
          toValue: _.target.value,
          toTime: O ? ve(O, "HH:mm") : v,
          internalUpdate: !0
        }, "to");
      },
      setMonth: function setMonth(_) {
        y(function (O) {
          return _objectSpread(_objectSpread({}, O), {}, {
            month: _
          });
        });
      }
    };
  },
  my = function my(_ref93) {
    var e = _ref93.onClear,
      t = _ref93.onDone,
      n = _ref93.translations;
    return /* @__PURE__ */p.jsxs("div", {
      className: T("goat-DatePicker__Actions"),
      children: [/* @__PURE__ */p.jsx(Fe, {
        variant: "ghost",
        onClick: e,
        children: n.clear
      }), /* @__PURE__ */p.jsx(Fe, {
        onClick: t,
        children: n.done
      })]
    });
  },
  hy = function hy(_ref94) {
    var e = _ref94.translations;
    return /* @__PURE__ */p.jsx("div", {
      className: T("goat-DatePicker__Timezone"),
      children: /* @__PURE__ */p.jsxs(vn, {
        children: [/* @__PURE__ */p.jsx(vn.Icon, {
          as: ff
        }), e.timezone]
      })
    });
  },
  gy = {
    calendarButtonAriaLabelSingle: function calendarButtonAriaLabelSingle(e, t) {
      return e ? "Change Date, ".concat(ve(e, t ? "PPPp" : "PPP")) : "Choose Date";
    },
    calendarButtonAriaLabelRange: function calendarButtonAriaLabelRange(e, t) {
      return e != null && e.from && e != null && e.to ? "Change Date Range, from ".concat(ve(e.from, t ? "PPPp" : "PPP"), " to ").concat(ve(e.to, t ? "PPPp" : "PPP")) : "Choose Date Range";
    },
    clear: "Clear",
    done: "Done",
    empty: "Empty",
    timezone: "UTC ".concat(ve( /* @__PURE__ */new Date(), "xxx")),
    timeAriaLabel: "Time",
    timeFromAriaLabel: "Time from",
    timeToAriaLabel: "Time to",
    hoursAriaLabel: "hours",
    minutesAriaLabel: "minutes",
    timePeriodAriaLabel: "am/pm",
    am: "AM",
    pm: "PM"
  },
  Fs = x(function (_ref95, d) {
    var t = _ref95.value,
      n = _ref95.setValue,
      r = _ref95.min,
      o = _ref95.max,
      a = _ref95.placeholder,
      i = _ref95.className,
      s = _ref95.onFinish,
      c = _ref95.onFocus,
      l = _ref95.translations,
      u = _objectWithoutProperties(_ref95, _excluded88);
    var _te43 = te(t),
      _te44 = _slicedToArray(_te43, 2),
      f = _te44[0],
      m = _te44[1],
      h = Pa(d),
      v = k(0),
      g = function g(b) {
        m(b), b != null && n(b);
      };
    return V(function () {
      m(t);
    }, [t]), V(function () {
      var _ref96;
      h.current && (h.current.innerText = (_ref96 = f !== null ? f.toString().padStart(2, "0") : a) !== null && _ref96 !== void 0 ? _ref96 : "");
    }, [a, f, h]), /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, u), {}, {
      ref: h,
      className: T(i, "goat-InputTime_Segment", {
        "goat-InputTime_Segment__empty": f === null
      }),
      style: {
        "--max-digits": o.toString().length
      },
      onKeyDown: function onKeyDown(b) {
        if (b.key === "Tab") return;
        if (b.preventDefault(), b.key === "Backspace") {
          v.current = v.current > 0 ? v.current - 1 : 0, g(f && f > 10 ? Math.floor(f / 10) : null);
          return;
        }
        if (b.key === "ArrowUp") {
          g((f !== null && f !== void 0 ? f : -1) + 1 > o ? r : (f !== null && f !== void 0 ? f : -1) + 1);
          return;
        }
        if (b.key === "ArrowDown") {
          g((f !== null && f !== void 0 ? f : 0) - 1 < r ? o : (f !== null && f !== void 0 ? f : 0) - 1);
          return;
        }
        var y = +b.key;
        if (isNaN(y)) return;
        v.current++;
        var w = v.current == 1 ? y : (f !== null && f !== void 0 ? f : 0) * 10 + y;
        if (w > o) if (y <= o) w = y;else return;
        (v.current === 2 || w * 10 >= o) && (s == null || s()), g(w);
      },
      onFocus: function onFocus(b) {
        v.current = 0, c == null || c(b);
      },
      contentEditable: "true",
      spellCheck: "false",
      autoCapitalize: "off",
      autoCorrect: "off",
      inputMode: "numeric",
      tabIndex: 0,
      "aria-valuemin": r,
      "aria-valuemax": o,
      "aria-valuenow": f !== null && f !== void 0 ? f : void 0,
      "aria-valuetext": f != null ? f.toString().padStart(2, "0") : l.empty
    }));
  });
var Mo = "rovingFocusGroup.onEntryFocus",
  by = {
    bubbles: !1,
    cancelable: !0
  },
  li = "RovingFocusGroup",
  _Vr3 = Vr(li),
  _Vr4 = _slicedToArray(_Vr3, 3),
  ta = _Vr4[0],
  Eu = _Vr4[1],
  yy = _Vr4[2],
  _Ke13 = Ke(li, [yy]),
  _Ke14 = _slicedToArray(_Ke13, 2),
  wy = _Ke14[0],
  Cn = _Ke14[1],
  _wy = wy(li),
  _wy2 = _slicedToArray(_wy, 2),
  xy = _wy2[0],
  $y = _wy2[1],
  Cy = /* @__PURE__ */x(function (e, t) {
    return /* @__PURE__ */C(ta.Provider, {
      scope: e.__scopeRovingFocusGroup
    }, /* @__PURE__ */C(ta.Slot, {
      scope: e.__scopeRovingFocusGroup
    }, /* @__PURE__ */C(Ty, S({}, e, {
      ref: t
    }))));
  }),
  Ty = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
      r = e.orientation,
      _e$loop2 = e.loop,
      o = _e$loop2 === void 0 ? !1 : _e$loop2,
      a = e.dir,
      i = e.currentTabStopId,
      s = e.defaultCurrentTabStopId,
      c = e.onCurrentTabStopIdChange,
      l = e.onEntryFocus,
      u = _objectWithoutProperties(e, _excluded89),
      d = k(null),
      f = Ce(t, d),
      m = Vn(a),
      _Ze13 = Ze({
        prop: i,
        defaultProp: s,
        onChange: c
      }),
      _Ze14 = _slicedToArray(_Ze13, 2),
      _Ze14$ = _Ze14[0],
      h = _Ze14$ === void 0 ? null : _Ze14$,
      v = _Ze14[1],
      _te45 = te(!1),
      _te46 = _slicedToArray(_te45, 2),
      g = _te46[0],
      b = _te46[1],
      y = Xe(l),
      w = Eu(n),
      I = k(!1),
      _te47 = te(0),
      _te48 = _slicedToArray(_te47, 2),
      P = _te48[0],
      D = _te48[1];
    return V(function () {
      var E = d.current;
      if (E) return E.addEventListener(Mo, y), function () {
        return E.removeEventListener(Mo, y);
      };
    }, [y]), /* @__PURE__ */C(xy, {
      scope: n,
      orientation: r,
      dir: m,
      loop: o,
      currentTabStopId: h,
      onItemFocus: X(function (E) {
        return v(E);
      }, [v]),
      onItemShiftTab: X(function () {
        return b(!0);
      }, []),
      onFocusableItemAdd: X(function () {
        return D(function (E) {
          return E + 1;
        });
      }, []),
      onFocusableItemRemove: X(function () {
        return D(function (E) {
          return E - 1;
        });
      }, [])
    }, /* @__PURE__ */C(ie.div, S({
      tabIndex: g || P === 0 ? -1 : 0,
      "data-orientation": r
    }, u, {
      ref: f,
      style: _objectSpread({
        outline: "none"
      }, e.style),
      onMouseDown: Z(e.onMouseDown, function () {
        I.current = !0;
      }),
      onFocus: Z(e.onFocus, function (E) {
        var _ = !I.current;
        if (E.target === E.currentTarget && _ && !g) {
          var O = new CustomEvent(Mo, by);
          if (E.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
            var A = w().filter(function (j) {
                return j.focusable;
              }),
              M = A.find(function (j) {
                return j.active;
              }),
              B = A.find(function (j) {
                return j.id === h;
              }),
              N = [M, B].concat(_toConsumableArray(A)).filter(Boolean).map(function (j) {
                return j.ref.current;
              });
            Ou(N);
          }
        }
        I.current = !1;
      }),
      onBlur: Z(e.onBlur, function () {
        return b(!1);
      })
    })));
  }),
  _y = "RovingFocusGroupItem",
  Iy = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
      _e$focusable = e.focusable,
      r = _e$focusable === void 0 ? !0 : _e$focusable,
      _e$active = e.active,
      o = _e$active === void 0 ? !1 : _e$active,
      a = e.tabStopId,
      i = _objectWithoutProperties(e, _excluded90),
      s = it(),
      c = a || s,
      l = $y(_y, n),
      u = l.currentTabStopId === c,
      d = Eu(n),
      f = l.onFocusableItemAdd,
      m = l.onFocusableItemRemove;
    return V(function () {
      if (r) return f(), function () {
        return m();
      };
    }, [r, f, m]), /* @__PURE__ */C(ta.ItemSlot, {
      scope: n,
      id: c,
      focusable: r,
      active: o
    }, /* @__PURE__ */C(ie.span, S({
      tabIndex: u ? 0 : -1,
      "data-orientation": l.orientation
    }, i, {
      ref: t,
      onMouseDown: Z(e.onMouseDown, function (h) {
        r ? l.onItemFocus(c) : h.preventDefault();
      }),
      onFocus: Z(e.onFocus, function () {
        return l.onItemFocus(c);
      }),
      onKeyDown: Z(e.onKeyDown, function (h) {
        if (h.key === "Tab" && h.shiftKey) {
          l.onItemShiftTab();
          return;
        }
        if (h.target !== h.currentTarget) return;
        var v = Sy(h, l.orientation, l.dir);
        if (v !== void 0) {
          h.preventDefault();
          var b = d().filter(function (y) {
            return y.focusable;
          }).map(function (y) {
            return y.ref.current;
          });
          if (v === "last") b.reverse();else if (v === "prev" || v === "next") {
            v === "prev" && b.reverse();
            var y = b.indexOf(h.currentTarget);
            b = l.loop ? Ey(b, y + 1) : b.slice(y + 1);
          }
          setTimeout(function () {
            return Ou(b);
          });
        }
      })
    })));
  }),
  Py = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
function Dy(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Sy(e, t, n) {
  var r = Dy(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return Py[r];
}
function Ou(e) {
  var t = document.activeElement;
  var _iterator5 = _createForOfIteratorHelper(e),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var n = _step5.value;
      if (n === t || (n.focus(), document.activeElement !== t)) return;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
function Ey(e, t) {
  return e.map(function (n, r) {
    return e[(t + r) % e.length];
  });
}
var ui = Cy,
  di = Iy,
  no = "ToggleGroup",
  _Ke15 = Ke(no, [Cn]),
  _Ke16 = _slicedToArray(_Ke15, 2),
  Mu = _Ke16[0],
  e_ = _Ke16[1],
  Nu = Cn(),
  Oy = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.type,
      r = _objectWithoutProperties(e, _excluded91);
    if (n === "single") {
      var o = r;
      return /* @__PURE__ */$.createElement(My, S({}, o, {
        ref: t
      }));
    }
    if (n === "multiple") {
      var _o2 = r;
      return /* @__PURE__ */$.createElement(Ny, S({}, _o2, {
        ref: t
      }));
    }
    throw new Error("Missing prop `type` expected on `".concat(no, "`"));
  }),
  _Mu = Mu(no),
  _Mu2 = _slicedToArray(_Mu, 2),
  ku = _Mu2[0],
  Ru = _Mu2[1],
  My = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.value,
      r = e.defaultValue,
      _e$onValueChange3 = e.onValueChange,
      o = _e$onValueChange3 === void 0 ? function () {} : _e$onValueChange3,
      a = _objectWithoutProperties(e, _excluded92),
      _Ze15 = Ze({
        prop: n,
        defaultProp: r,
        onChange: o
      }),
      _Ze16 = _slicedToArray(_Ze15, 2),
      i = _Ze16[0],
      s = _Ze16[1];
    return /* @__PURE__ */$.createElement(ku, {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: i ? [i] : [],
      onItemActivate: s,
      onItemDeactivate: $.useCallback(function () {
        return s("");
      }, [s])
    }, /* @__PURE__ */$.createElement(Au, S({}, a, {
      ref: t
    })));
  }),
  Ny = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.value,
      r = e.defaultValue,
      _e$onValueChange4 = e.onValueChange,
      o = _e$onValueChange4 === void 0 ? function () {} : _e$onValueChange4,
      a = _objectWithoutProperties(e, _excluded93),
      _Ze17 = Ze({
        prop: n,
        defaultProp: r,
        onChange: o
      }),
      _Ze18 = _slicedToArray(_Ze17, 2),
      _Ze18$ = _Ze18[0],
      i = _Ze18$ === void 0 ? [] : _Ze18$,
      s = _Ze18[1],
      c = $.useCallback(function (u) {
        return s(function () {
          var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return [].concat(_toConsumableArray(d), [u]);
        });
      }, [s]),
      l = $.useCallback(function (u) {
        return s(function () {
          var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return d.filter(function (f) {
            return f !== u;
          });
        });
      }, [s]);
    return /* @__PURE__ */$.createElement(ku, {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: c,
      onItemDeactivate: l
    }, /* @__PURE__ */$.createElement(Au, S({}, a, {
      ref: t
    })));
  }),
  _Mu3 = Mu(no),
  _Mu4 = _slicedToArray(_Mu3, 2),
  ky = _Mu4[0],
  Ry = _Mu4[1],
  Au = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeToggleGroup,
      _e$disabled = e.disabled,
      r = _e$disabled === void 0 ? !1 : _e$disabled,
      _e$rovingFocus = e.rovingFocus,
      o = _e$rovingFocus === void 0 ? !0 : _e$rovingFocus,
      a = e.orientation,
      i = e.dir,
      _e$loop3 = e.loop,
      s = _e$loop3 === void 0 ? !0 : _e$loop3,
      c = _objectWithoutProperties(e, _excluded94),
      l = Nu(n),
      u = Vn(i),
      d = _objectSpread({
        role: "group",
        dir: u
      }, c);
    return /* @__PURE__ */$.createElement(ky, {
      scope: n,
      rovingFocus: o,
      disabled: r
    }, o ? /* @__PURE__ */$.createElement(ui, S({
      asChild: !0
    }, l, {
      orientation: a,
      dir: u,
      loop: s
    }), /* @__PURE__ */$.createElement(ie.div, S({}, d, {
      ref: t
    }))) : /* @__PURE__ */$.createElement(ie.div, S({}, d, {
      ref: t
    })));
  }),
  na = "ToggleGroupItem",
  Ay = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = Ru(na, e.__scopeToggleGroup),
      r = Ry(na, e.__scopeToggleGroup),
      o = Nu(e.__scopeToggleGroup),
      a = n.value.includes(e.value),
      i = r.disabled || e.disabled,
      s = _objectSpread(_objectSpread({}, e), {}, {
        pressed: a,
        disabled: i
      }),
      c = $.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */$.createElement(di, S({
      asChild: !0
    }, o, {
      focusable: !i,
      active: a,
      ref: c
    }), /* @__PURE__ */$.createElement(Ws, S({}, s, {
      ref: t
    }))) : /* @__PURE__ */$.createElement(Ws, S({}, s, {
      ref: t
    }));
  }),
  Ws = /* @__PURE__ */$.forwardRef(function (e, t) {
    var n = e.__scopeToggleGroup,
      r = e.value,
      o = _objectWithoutProperties(e, _excluded95),
      a = Ru(na, n),
      i = {
        role: "radio",
        "aria-checked": e.pressed,
        "aria-pressed": void 0
      },
      s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */$.createElement(cl, S({}, s, o, {
      ref: t,
      onPressedChange: function onPressedChange(c) {
        c ? a.onItemActivate(r) : a.onItemDeactivate(r);
      }
    }));
  }),
  Ly = Oy,
  jy = Ay;
var Lu = x(function (_ref97, o) {
  var e = _ref97.children,
    _ref97$as = _ref97.as,
    t = _ref97$as === void 0 ? Fe : _ref97$as,
    n = _ref97.className,
    r = _objectWithoutProperties(_ref97, _excluded96);
  return /* @__PURE__ */p.jsx(jy, _objectSpread(_objectSpread({}, r), {}, {
    className: T(n, "goat-ToggleButton"),
    ref: o,
    asChild: !0,
    children: /* @__PURE__ */p.jsx(t, {
      children: e
    })
  }));
});
Lu.displayName = "ToggleGroupButton";
var Fy = function Fy(_ref98) {
    var e = _ref98.children,
      t = _ref98.onValueChange,
      n = _ref98.value,
      r = _ref98.defaultValue,
      o = _ref98.size,
      a = _objectWithoutProperties(_ref98, _excluded97);
    var _te49 = te(n !== null && n !== void 0 ? n : r),
      _te50 = _slicedToArray(_te49, 2),
      i = _te50[0],
      s = _te50[1];
    return V(function () {
      n !== void 0 && s(n);
    }, [n]), /* @__PURE__ */p.jsx(Ly, _objectSpread(_objectSpread({}, a), {}, {
      value: i,
      onValueChange: function onValueChange(c) {
        c && (t == null || t(c), s(c));
      },
      orientation: "horizontal",
      type: "single",
      asChild: !0,
      children: /* @__PURE__ */p.jsx(el, {
        size: o,
        children: e
      })
    }));
  },
  No = {
    Root: Fy,
    Button: Lu
  },
  ko = function ko(e, t) {
    return e === null || t === null ? "" : "".concat(e.toString().padStart(2, "0"), ":").concat(t.toString().padStart(2, "0"));
  },
  Wy = function Wy(e) {
    return {
      h12: {
        min: 1,
        max: 12
      },
      h23: {
        min: 0,
        max: 23
      },
      h11: {
        min: 0,
        max: 11
      },
      h24: {
        min: 1,
        max: 24
      }
    }[e];
  },
  Hs = function Hs(_ref99) {
    var e = _ref99.className,
      t = _ref99.value,
      n = _ref99.onChange,
      r = _ref99.hourCycle,
      o = _ref99.translations,
      a = _objectWithoutProperties(_ref99, _excluded98);
    var i = k(null),
      _Ne2 = Ne(function () {
        return ly(t, r);
      }, [t, r]),
      s = _Ne2.hours,
      c = _Ne2.minutes,
      l = _Ne2.timePeriod,
      u = ["h11", "h12"].includes(r);
    return /* @__PURE__ */p.jsxs(p.Fragment, {
      children: [/* @__PURE__ */p.jsxs(jr.Root, _objectSpread(_objectSpread({
        role: "group",
        className: T(e, "goat-InputTime"),
        size: "small"
      }, a), {}, {
        children: [/* @__PURE__ */p.jsx(Fs, _objectSpread(_objectSpread({
          placeholder: "hh"
        }, Wy(r)), {}, {
          value: s,
          setValue: function setValue(d) {
            n(Oo(ko(d, c), l, r));
          },
          onFinish: function onFinish() {
            var d;
            (d = i.current) == null || d.focus();
          },
          translations: o,
          "aria-label": o.hoursAriaLabel
        })), ":", /* @__PURE__ */p.jsx(Fs, {
          ref: i,
          placeholder: "mm",
          min: 0,
          max: 59,
          value: c,
          setValue: function setValue(d) {
            n(Oo(ko(s, d), l, r));
          },
          translations: o,
          "aria-label": o.minutesAriaLabel
        })]
      })), u && /* @__PURE__ */p.jsxs(No.Root, {
        size: "small",
        value: l,
        onValueChange: function onValueChange(d) {
          n(Oo(ko(s, c), d, r));
        },
        "aria-label": o.timePeriodAriaLabel,
        children: [/* @__PURE__ */p.jsx(No.Button, {
          value: "AM",
          children: o.am
        }), /* @__PURE__ */p.jsx(No.Button, {
          value: "PM",
          children: o.pm
        })]
      })]
    });
  },
  t_ = x(function (_ref100, _) {
    var _ref101, _ref102;
    var t = _ref100.className,
      n = _ref100.style,
      r = _ref100.dayPickerProps,
      o = _ref100.defaultValue,
      a = _ref100.disabled,
      i = _ref100.inputFormat,
      s = _ref100.max,
      c = _ref100.min,
      l = _ref100.onBlur,
      u = _ref100.onChange,
      d = _ref100.onFocus,
      f = _ref100.outputFormat,
      m = _ref100.placeholder,
      h = _ref100.popoverClassName,
      _ref100$range = _ref100.range,
      v = _ref100$range === void 0 ? !1 : _ref100$range,
      g = _ref100.rangePresets,
      _ref100$size = _ref100.size,
      b = _ref100$size === void 0 ? "medium" : _ref100$size,
      y = _ref100.translations,
      _ref100$time = _ref100.time,
      w = _ref100$time === void 0 ? !1 : _ref100$time,
      I = _ref100.timezone,
      P = _ref100.value,
      _ref100$hourCycle = _ref100.hourCycle,
      D = _ref100$hourCycle === void 0 ? "h23" : _ref100$hourCycle,
      E = _objectWithoutProperties(_ref100, _excluded99);
    var O = i !== null && i !== void 0 ? i : w ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy",
      A = f !== null && f !== void 0 ? f : w ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd",
      M = _objectSpread(_objectSpread({}, gy), y),
      _py = py({
        defaultValue: o,
        inputFormat: O,
        max: s,
        min: c,
        outputFormat: A,
        range: v,
        time: w,
        value: P
      }),
      B = _py.fromTime,
      G = _py.toTime,
      N = _py.handleFromTimeChange,
      j = _py.handleToTimeChange,
      U = _py.fromValue,
      L = _py.handleBlur,
      R = _py.handleDayPickerSelectRange,
      Y = _py.handleDayPickerSelectSingle,
      re = _py.inputRef,
      ae = _py.month,
      se = _py.selectedDate,
      le = _py.selectedRange,
      fe = _py.handlFromValueChange,
      xe = _py.setMonth,
      be = _py.handlToValueChange,
      q = _py.singleMonth,
      W = _py.toValue,
      _te51 = te(!1),
      _te52 = _slicedToArray(_te51, 2),
      F = _te52[0],
      J = _te52[1],
      _te53 = te(!1),
      _te54 = _slicedToArray(_te53, 2),
      Se = _te54[0],
      Pe = _te54[1],
      Ae = k(null);
    sf(_, function () {
      return re.current;
    });
    var _Qn5 = Qn(c, s, w),
      Le = _Qn5.minDate,
      ke = _Qn5.maxDate,
      ze = _objectSpread(_objectSpread({
        initialFocus: Se,
        month: ae,
        onMonthChange: function onMonthChange(ye) {
          return xe(ye);
        },
        numberOfMonths: q ? 1 : 2,
        fromDate: Le,
        toDate: ke,
        weekStartsOn: 1
      }, r !== null && r !== void 0 ? r : {}), {}, {
        classNames: _objectSpread({
          caption_between: T("goat-DatePicker__Month_between"),
          caption_end: T("goat-DatePicker__Month_last"),
          caption_start: T("goat-DatePicker__Month_first"),
          cell: T("goat-DatePicker__Cell"),
          head_cell: T("goat-DatePicker__HeadCell"),
          month: T("goat-DatePicker__Month"),
          months: T("goat-DatePicker__Months"),
          row: T("goat-DatePicker__Row"),
          table: T("goat-DatePicker__Table")
        }, (_ref101 = r == null ? void 0 : r.classNames) !== null && _ref101 !== void 0 ? _ref101 : {}),
        components: _objectSpread({
          Caption: iy,
          Day: sy
        }, (_ref102 = r == null ? void 0 : r.components) !== null && _ref102 !== void 0 ? _ref102 : {})
      });
    return /* @__PURE__ */p.jsxs(Ql, {
      open: Se || F,
      children: [/* @__PURE__ */p.jsx(Bm, {
        asChild: !0,
        children: /* @__PURE__ */p.jsxs(jr.Root, {
          size: b,
          style: n,
          className: T("goat-DatePicker", "goat-DatePicker_".concat(v ? "range" : "single"), t),
          children: [/* @__PURE__ */p.jsx("input", _objectSpread(_objectSpread({}, E), {}, {
            ref: re,
            className: T("goat-DatePicker__HiddenInput"),
            onChange: function onChange(ye) {
              u == null || u(ye);
            }
          })), /* @__PURE__ */p.jsxs("div", {
            className: T("goat-DatePicker__InputWrapper"),
            onFocus: function onFocus(ye) {
              J(!0), d == null || d(ye);
            },
            onBlur: function onBlur(ye) {
              var Ot;
              ye.stopPropagation(), ye.currentTarget.contains(ye.relatedTarget) || (L(), ye.relatedTarget && (Ot = Ae.current) != null && Ot.contains(ye.relatedTarget) && Pe(!0), J(!1), l == null || l(ye));
            },
            onChange: function onChange(ye) {
              return ye.stopPropagation();
            },
            onInvalid: function onInvalid(ye) {
              return ye.stopPropagation();
            },
            children: [/* @__PURE__ */p.jsx("input", {
              className: T("goat-Input__Text", "goat-DatePicker__Input"),
              value: U !== null && U !== void 0 ? U : "",
              onChange: fe,
              placeholder: m
            }), v && /* @__PURE__ */p.jsxs(p.Fragment, {
              children: ["-", /* @__PURE__ */p.jsx("input", {
                className: T("goat-Input__Text", "goat-DatePicker__Input"),
                value: W !== null && W !== void 0 ? W : "",
                onChange: be,
                placeholder: m
              })]
            })]
          }), /* @__PURE__ */p.jsx(Qe, {
            "aria-label": v ? M.calendarButtonAriaLabelRange(le, w) : M.calendarButtonAriaLabelSingle(se, w),
            icon: vf,
            disabled: a,
            onClick: function onClick() {
              return Pe(!0);
            }
          })]
        })
      }), /* @__PURE__ */p.jsx(Jl, {
        children: /* @__PURE__ */p.jsxs(eu, {
          ref: Ae,
          className: T("goat-DatePicker__Popover", {
            "goat-DatePicker__Popover_twomonths": !q
          }, h),
          align: "start",
          sideOffset: 8,
          onOpenAutoFocus: function onOpenAutoFocus(ye) {
            return ye.preventDefault();
          },
          onInteractOutside: function onInteractOutside() {
            return Pe(!1);
          },
          onEscapeKeyDown: function onEscapeKeyDown() {
            return Pe(!1);
          },
          children: [v && g && /* @__PURE__ */p.jsxs(p.Fragment, {
            children: [/* @__PURE__ */p.jsx(cy, {
              presets: g,
              onRangeClick: R
            }), /* @__PURE__ */p.jsx(Bs, {})]
          }), v ? /* @__PURE__ */p.jsx(js, _objectSpread({
            mode: "range",
            selected: le,
            onSelect: R
          }, ze)) : /* @__PURE__ */p.jsx(js, _objectSpread({
            mode: "single",
            selected: se,
            onSelect: Y
          }, ze)), /* @__PURE__ */p.jsxs("div", {
            className: T("goat-DatePicker__Time"),
            children: [I && /* @__PURE__ */p.jsx(hy, {
              translations: M
            }), w && /* @__PURE__ */p.jsxs("div", {
              className: T("goat-DatePicker__TimeInputsWrapper"),
              children: [/* @__PURE__ */p.jsx(Hs, {
                value: B,
                onChange: N,
                hourCycle: D,
                translations: M,
                "aria-label": v ? M.timeFromAriaLabel : M.timeAriaLabel
              }), v && /* @__PURE__ */p.jsxs(p.Fragment, {
                children: [/* @__PURE__ */p.jsx(je, {
                  as: pf
                }), /* @__PURE__ */p.jsx(Hs, {
                  value: G,
                  onChange: j,
                  hourCycle: D,
                  translations: M,
                  "aria-label": M.timeToAriaLabel
                })]
              })]
            })]
          }), /* @__PURE__ */p.jsx(Bs, {}), /* @__PURE__ */p.jsx(my, {
            onClear: function onClear() {
              return v ? R(void 0) : Y(void 0);
            },
            onDone: function onDone() {
              return Pe(!1);
            },
            translations: M
          })]
        })
      })]
    });
  }),
  Bs = function Bs() {
    return /* @__PURE__ */p.jsx("hr", {
      className: T("goat-DatePicker__Popover__HR")
    });
  },
  Hy = x(function (_ref103, a) {
    var _ref103$as = _ref103.as,
      t = _ref103$as === void 0 ? "div" : _ref103$as,
      n = _ref103.children,
      r = _ref103.className,
      o = _objectWithoutProperties(_ref103, _excluded100);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Dialog__Body", r),
      ref: a,
      children: n
    }));
  }),
  By = x(function (_ref104, f) {
    var t = _ref104.accentColor,
      _ref104$as = _ref104.as,
      n = _ref104$as === void 0 ? Kv : _ref104$as,
      r = _ref104.children,
      o = _ref104.className,
      a = _ref104.closeLabel,
      _ref104$size = _ref104.size,
      i = _ref104$size === void 0 ? "medium" : _ref104$size,
      s = _ref104.style,
      c = _ref104.minHeight,
      l = _ref104.hideCloseIcon,
      u = _ref104.radixProps,
      d = _objectWithoutProperties(_ref104, _excluded101);
    return /* @__PURE__ */p.jsxs(Il, {
      children: [/* @__PURE__ */p.jsx(Pl, {
        className: "goat-Dialog__Backdrop"
      }), /* @__PURE__ */p.jsx(Fa, _objectSpread(_objectSpread({
        asChild: !0
      }, u), {}, {
        children: /* @__PURE__ */p.jsxs(n, _objectSpread(_objectSpread({}, d), {}, {
          className: T("goat-Dialog", "goat-Dialog_".concat(i), o),
          style: _objectSpread(_objectSpread({}, s), {}, {
            "--goat-dialog-accent-color": t,
            "--goat-dialog-min-height": c
          }),
          ref: f,
          children: [r, !l && /* @__PURE__ */p.jsx(Ha, {
            asChild: !0,
            children: /* @__PURE__ */p.jsx(Qe, {
              "aria-label": a,
              className: "goat-Dialog__Close",
              icon: Dt
            })
          })]
        }))
      }))]
    });
  }),
  Vy = x(function (_ref105, a) {
    var _ref105$as = _ref105.as,
      t = _ref105$as === void 0 ? "div" : _ref105$as,
      n = _ref105.children,
      r = _ref105.className,
      o = _objectWithoutProperties(_ref105, _excluded102);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Dialog__Footer", r),
      ref: a,
      children: n
    }));
  }),
  Uy = x(function (_ref106, a) {
    var _ref106$as = _ref106.as,
      t = _ref106$as === void 0 ? "h2" : _ref106$as,
      n = _ref106.children,
      r = _ref106.className,
      o = _objectWithoutProperties(_ref106, _excluded103);
    return /* @__PURE__ */p.jsx(Wa, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
        className: T("goat-Dialog__Header", r),
        ref: a,
        children: n
      }))
    });
  }),
  Yy = ja;
var n_ = {
    Body: Hy,
    Content: By,
    Footer: Vy,
    Header: Uy,
    Root: Yy,
    Trigger: Va
  },
  Ky = x(function (_ref107, o) {
    var _ref107$as = _ref107.as,
      t = _ref107$as === void 0 ? "div" : _ref107$as,
      n = _ref107.className,
      r = _ref107.children;
    var a = T("goat-Drawer__Body", n);
    return /* @__PURE__ */p.jsx(t, {
      ref: o,
      className: a,
      children: r
    });
  }),
  Gy = function Gy(_ref108) {
    var e = _ref108.children,
      t = _ref108.className,
      n = _objectWithoutProperties(_ref108, _excluded104);
    return /* @__PURE__ */p.jsxs(Il, {
      children: [/* @__PURE__ */p.jsx(Pl, {
        className: "goat-Drawer__Overlay"
      }), /* @__PURE__ */p.jsx(Fa, _objectSpread(_objectSpread({}, n), {}, {
        className: T("goat-Drawer__Content", t),
        children: e
      }))]
    });
  },
  zy = x(function (_ref109, a) {
    var _ref109$as = _ref109.as,
      t = _ref109$as === void 0 ? "div" : _ref109$as,
      n = _ref109.className,
      r = _ref109.children,
      o = _objectWithoutProperties(_ref109, _excluded105);
    var i = T("goat-Drawer__Footer", n);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: i,
      children: r
    }));
  }),
  qy = x(function (_ref110, c) {
    var _ref110$as = _ref110.as,
      t = _ref110$as === void 0 ? "div" : _ref110$as,
      _ref110$variant = _ref110.variant,
      n = _ref110$variant === void 0 ? "application" : _ref110$variant,
      r = _ref110.style,
      _ref110$color = _ref110.color,
      o = _ref110$color === void 0 ? "coral-500" : _ref110$color,
      a = _ref110.className,
      i = _ref110.children,
      s = _objectWithoutProperties(_ref110, _excluded106);
    var l = T("goat-Drawer__Header", "goat-Drawer__Header_".concat(n), a);
    return /* @__PURE__ */p.jsxs(t, _objectSpread(_objectSpread({}, s), {}, {
      ref: c,
      style: _objectSpread(_objectSpread({}, r), {}, {
        "--goat-panel-header-color": yn(o)
      }),
      className: l,
      children: [i, /* @__PURE__ */p.jsx(Ha, {
        asChild: !0,
        children: /* @__PURE__ */p.jsx(Qe, {
          className: "goat-Drawer__CloseAction",
          variant: "ghost",
          icon: Dt
        })
      })]
    }));
  }),
  Xy = x(function (_ref111, a) {
    var _ref111$as = _ref111.as,
      t = _ref111$as === void 0 ? "p" : _ref111$as,
      n = _ref111.className,
      r = _ref111.children,
      o = _objectWithoutProperties(_ref111, _excluded107);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: n,
      as: t,
      type: "body-small",
      color: "gray-600",
      children: r
    }));
  }),
  Qy = x(function (_ref112, o) {
    var _ref112$as = _ref112.as,
      t = _ref112$as === void 0 ? "div" : _ref112$as,
      n = _ref112.className,
      r = _ref112.children;
    var a = T("goat-Drawer__Text", n);
    return /* @__PURE__ */p.jsx(Wa, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, {
        ref: o,
        className: a,
        children: r
      })
    });
  }),
  Zy = x(function (_ref113, a) {
    var _ref113$as = _ref113.as,
      t = _ref113$as === void 0 ? "p" : _ref113$as,
      n = _ref113.className,
      r = _ref113.children,
      o = _objectWithoutProperties(_ref113, _excluded108);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: n,
      as: t,
      type: "header-small",
      color: "gray-900",
      children: r
    }));
  });
var Vt = function Vt(_ref114) {
  var e = _ref114.children,
    t = _objectWithoutProperties(_ref114, _excluded109);
  return /* @__PURE__ */p.jsx(ja, _objectSpread(_objectSpread({}, t), {}, {
    children: e
  }));
};
Vt.Header = qy;
Vt.Body = Ky;
Vt.Footer = zy;
Vt.Title = Zy;
Vt.Subtitle = Xy;
Vt.Trigger = Va;
Vt.Content = Gy;
Vt.Text = Qy;
var r_ = x(function (_ref115, o) {
  var t = _ref115.row,
    n = _ref115.className,
    r = _objectWithoutProperties(_ref115, _excluded110);
  return /* @__PURE__ */p.jsx(il, _objectSpread(_objectSpread({}, r), {}, {
    as: "fieldset",
    className: T("goat-Fieldset", {
      "goat-Fieldset__row": t
    }, n),
    ref: o
  }));
});
function Vs(e) {
  var t = Jy(Array.from(e.elements), function (n) {
    return n.name || "";
  });
  return Object.fromEntries(Object.entries(t).filter(function (_ref116) {
    var _ref117 = _slicedToArray(_ref116, 1),
      n = _ref117[0];
    return n;
  }).map(function (_ref118) {
    var _ref119 = _slicedToArray(_ref118, 2),
      n = _ref119[0],
      r = _ref119[1];
    return [n, ew(r)];
  }));
}
var Jy = function Jy(e, t) {
  return e.reduce(function (n, r, o) {
    var _n$a;
    var a = t(r, o);
    return ((_n$a = n[a]) !== null && _n$a !== void 0 ? _n$a : n[a] = []).push(r), n;
  }, {});
};
function ew(e) {
  var _t$options;
  if (e.some(ju)) return Ro(e.find(function (n) {
    return n.checked;
  }));
  if (e.length > 1) return e.map(Ro).filter(Boolean);
  var _e3 = _slicedToArray(e, 1),
    t = _e3[0];
  return rw(t) ? Array.from((_t$options = t.options) !== null && _t$options !== void 0 ? _t$options : []).filter(function (n) {
    return n.selected;
  }).map(function (n) {
    return n.value;
  }) : Ro(t);
}
function Ro(e) {
  var t;
  return e ? tw(e) ? e.hasAttribute("value") ? e.checked ? e.value : null : e.checked : ju(e) ? e.value || "" : nw(e) ? (t = e.value) != null && t.length ? ow(e.value) : null : e.value : null;
}
var tw = function tw(e) {
    return e.type === "checkbox";
  },
  nw = function nw(e) {
    return e.type === "number";
  },
  ju = function ju(e) {
    return e.type === "radio";
  },
  rw = function rw(e) {
    return e.multiple;
  },
  ow = function ow(e) {
    return isNaN(+e) ? 0 : +e;
  },
  o_ = x(function (_ref120, l) {
    var t = _ref120.children,
      n = _ref120.className,
      r = _ref120.disabled,
      o = _ref120.onChange,
      a = _ref120.onInvalid,
      i = _ref120.onReset,
      s = _ref120.onSubmit,
      c = _objectWithoutProperties(_ref120, _excluded111);
    var _te55 = te(!1),
      _te56 = _slicedToArray(_te55, 2),
      u = _te56[0],
      d = _te56[1],
      _te57 = te({}),
      _te58 = _slicedToArray(_te57, 2),
      f = _te58[0],
      m = _te58[1];
    return /* @__PURE__ */p.jsx(Gv, {
      value: {
        disabled: r,
        touched: u,
        resetToken: f
      },
      children: /* @__PURE__ */p.jsx("form", _objectSpread(_objectSpread({}, c), {}, {
        className: T("goat-Form", n),
        onChange: function onChange(h) {
          o == null || o(h, Vs(h.currentTarget));
        },
        onInvalid: function onInvalid(h) {
          h.preventDefault(), d(!0), a == null || a(h);
        },
        onReset: function onReset(h) {
          d(!1), m({}), i == null || i(h);
        },
        onSubmit: function onSubmit(h) {
          if (h.preventDefault(), d(!0), r) return;
          var v = h.nativeEvent.submitter;
          v != null && v.disabled || s == null || s(h, Vs(h.currentTarget));
        },
        ref: l,
        children: t
      }))
    });
  }),
  a_ = function a_(_ref121) {
    var e = _ref121.areas,
      _ref121$center = _ref121.center,
      t = _ref121$center === void 0 ? !1 : _ref121$center,
      n = _ref121.children,
      r = _ref121.cols,
      o = _ref121.gap,
      a = _ref121.grid,
      i = _ref121.placeContent,
      s = _ref121.placeItems,
      c = _ref121.rows,
      l = _ref121.style,
      u = _ref121.width,
      d = _objectWithoutProperties(_ref121, _excluded112);
    return /* @__PURE__ */p.jsx(Sa, _objectSpread(_objectSpread({}, d), {}, {
      width: u,
      style: Ta(_objectSpread(_objectSpread(_objectSpread({}, l), {}, {
        display: "grid",
        grid: a,
        // prevent grid blowout needed for columns only, see https://css-tricks.com/preventing-a-grid-blowout/
        gridTemplateColumns: typeof r == "number" ? "repeat(".concat(r, ", minmax(0, 1fr))") : r,
        gridTemplateRows: typeof c == "number" ? "repeat(".concat(c, ", 1fr)") : c,
        gridTemplateAreas: Array.isArray(e) ? e.map(function (f) {
          return "\"".concat(f, "\"");
        }).join("\n") : e,
        placeContent: t ? "center" : i,
        placeItems: t ? "center" : s
      }, Array.isArray(o) ? {
        rowGap: o[0],
        columnGap: o[1]
      } : {
        gap: o
      }), {}, {
        width: u
      })),
      children: n
    }));
  };
var Fu = {
  exports: {}
};
var aw = /* @__PURE__ */$f(Tv);
(function (e) {
  var t = $,
    n = aw;
  function r(i, s, c, l) {
    Object.defineProperty(i, s, {
      get: c,
      set: l,
      enumerable: !0,
      configurable: !0
    });
  }
  r(e.exports, "useControllableState", function () {
    return o;
  });
  function o(_ref122) {
    var i = _ref122.prop,
      s = _ref122.defaultProp,
      _ref122$onChange = _ref122.onChange,
      c = _ref122$onChange === void 0 ? function () {} : _ref122$onChange;
    var _a3 = a({
        defaultProp: s,
        onChange: c
      }),
      _a4 = _slicedToArray(_a3, 2),
      l = _a4[0],
      u = _a4[1],
      d = i !== void 0,
      f = d ? i : l,
      m = n.useCallbackRef(c),
      h = t.useCallback(function (v) {
        if (d) {
          var b = typeof v == "function" ? v(i) : v;
          b !== i && m(b);
        } else u(v);
      }, [d, i, u, m]);
    return [f, h];
  }
  function a(_ref123) {
    var i = _ref123.defaultProp,
      s = _ref123.onChange;
    var c = t.useState(i),
      _c2 = _slicedToArray(c, 1),
      l = _c2[0],
      u = t.useRef(l),
      d = n.useCallbackRef(s);
    return t.useEffect(function () {
      u.current !== l && (d(l), u.current = l);
    }, [l, u, d]), c;
  }
})(Fu);
var Us = Fu.exports;
var Wu = he(null),
  iw = function iw(_ref124) {
    var e = _ref124.children,
      t = _ref124.onChange,
      n = _ref124.value,
      r = _ref124.onInputChange,
      o = _ref124.inputValue,
      a = _ref124.defaultValue,
      i = _ref124.disabled,
      s = _ref124.className,
      c = _objectWithoutProperties(_ref124, _excluded113);
    var l = dt(),
      _Us$useControllableSt = Us.useControllableState({
        defaultProp: "",
        onChange: r,
        prop: o
      }),
      _Us$useControllableSt2 = _slicedToArray(_Us$useControllableSt, 2),
      u = _Us$useControllableSt2[0],
      d = _Us$useControllableSt2[1],
      _Us$useControllableSt3 = Us.useControllableState({
        defaultProp: a !== null && a !== void 0 ? a : [],
        prop: n,
        onChange: t
      }),
      _Us$useControllableSt4 = _slicedToArray(_Us$useControllableSt3, 2),
      f = _Us$useControllableSt4[0],
      m = _Us$useControllableSt4[1],
      h = f && f.length > 0,
      v = function v(b) {
        m(f == null ? void 0 : f.filter(function (y) {
          return y !== b;
        }));
      },
      g = function g(b) {
        f != null && f.includes(b) || m([].concat(_toConsumableArray(f !== null && f !== void 0 ? f : []), [b]));
      };
    return /* @__PURE__ */p.jsx(Wu.Provider, {
      value: {
        removeSelectedItem: v,
        addSelectedItem: g,
        disabled: i,
        inputValue: u,
        selectedItems: f !== null && f !== void 0 ? f : [],
        onInputChange: d
      },
      children: /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, c), {}, {
        className: T("goat-Input", "goat-InputWithTags", {
          "goat-InputWithTags_WithTagsInside": h,
          "goat-invalid": l.touched && l.validity.valid === !1,
          "goat-disabled": i
        }, s),
        children: e
      }))
    });
  };
function Hu() {
  var e = ce(Wu);
  if (!e) throw new Error("InputWithTags compound components cannot be rendered outside the InputWithTags component");
  return e;
}
var sw = x(function (t, n) {
    var r = k(null),
      o = Kr(n, r),
      a = Hu(),
      i = a.selectedItems.toString(),
      s = Hc(i);
    return V(function () {
      var c = r.current,
        l = window.HTMLSelectElement.prototype,
        d = Object.getOwnPropertyDescriptor(l, "value").set;
      if (s !== i && d) {
        var f = new Event("change", {
          bubbles: !0
        });
        c == null || c.dispatchEvent(f);
      }
    }, [s, i]), /* @__PURE__ */p.jsxs("select", _objectSpread(_objectSpread({}, t), {}, {
      multiple: !0,
      value: a.selectedItems,
      onChange: function onChange() {
        return null;
      },
      hidden: !0,
      ref: o,
      "aria-hidden": !0,
      children: [a.selectedItems.length ? null : /* @__PURE__ */p.jsx("option", {
        value: ""
      }), a.selectedItems.map(function (c) {
        return /* @__PURE__ */p.jsx("option", {
          value: c
        }, c);
      })]
    }));
  }),
  cw = x(function (_ref125, o) {
    var _r$htmlFor;
    var t = _ref125.children,
      n = _ref125.className,
      r = _objectWithoutProperties(_ref125, _excluded114);
    var a = Na();
    return /* @__PURE__ */p.jsx(Ma, {
      value: a,
      children: /* @__PURE__ */p.jsx("label", _objectSpread(_objectSpread({}, r), {}, {
        className: T("goat-InputWithTags_Label", n),
        ref: o,
        htmlFor: (_r$htmlFor = r.htmlFor) !== null && _r$htmlFor !== void 0 ? _r$htmlFor : a.id,
        children: t
      }))
    });
  }),
  lw = function lw(_ref126) {
    var e = _ref126.placeholder,
      t = _ref126.renderTag,
      n = _objectWithoutProperties(_ref126, _excluded115);
    var r = Hu(),
      o = dt(),
      a = k(null),
      i = k(null);
    return /* @__PURE__ */p.jsxs("div", _objectSpread(_objectSpread({}, n), {}, {
      className: "goat-InputWithTags_List",
      children: [r.selectedItems.map(function (c, l) {
        var u = function u() {
          return {
            "data-goat-tag-index": l,
            disabled: !!r.disabled,
            onKeyDown: function onKeyDown(d) {
              var f;
              d.key === "Backspace" && (d.preventDefault(), d.stopPropagation(), r.removeSelectedItem(c), (f = a.current) == null || f.focus());
            }
          };
        };
        return /* @__PURE__ */p.jsx(Wt, {
          children: t(function (d) {
            d.stopPropagation(), r.removeSelectedItem(c);
          }, c, u)
        }, "selected-item-".concat(l));
      }), /* @__PURE__ */p.jsx("input", {
        ref: a,
        className: "goat-InputWithTags_Input",
        placeholder: e,
        id: o.id,
        autoComplete: "off",
        disabled: r.disabled,
        onBlur: function onBlur(s) {
          s.currentTarget.value.length > 0 && (r.addSelectedItem(s.currentTarget.value), a.current && Uo(a.current, ""));
        },
        onKeyDown: function onKeyDown(s) {
          var c;
          if (s.key === "Enter" && (s.preventDefault(), s.stopPropagation(), r.addSelectedItem(s.currentTarget.value), a.current && Uo(a.current, "")), s.key === "Backspace" && !s.currentTarget.value) {
            s.preventDefault(), s.stopPropagation();
            var l = (c = i.current) == null ? void 0 : c.querySelectorAll("[data-goat-tag-index]"),
              u = l == null ? void 0 : l[l.length - 1];
            u == null || u.focus();
          }
        }
      })]
    }));
  };
var i_ = {
  Root: iw,
  List: lw,
  Label: cw,
  Input: sw
};
var fi = function fi(_ref127) {
  var e = _ref127.children,
    t = _ref127.className,
    n = _ref127.htmlFor,
    r = _objectWithoutProperties(_ref127, _excluded116);
  var o = Na();
  return /* @__PURE__ */p.jsx(Ma, {
    value: o,
    children: /* @__PURE__ */p.jsx("label", _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-Label", {
        "goat-Label_coupled": o.inline
      }, {
        "goat-disabled": o.disabled
      }, t),
      htmlFor: n !== null && n !== void 0 ? n : o.id,
      children: e
    }))
  });
};
var s_ = x(function (_ref128, o) {
  var t = _ref128.children,
    n = _ref128.className,
    r = _objectWithoutProperties(_ref128, _excluded117);
  return /* @__PURE__ */p.jsx("legend", _objectSpread(_objectSpread({}, r), {}, {
    className: T("goat-Legend", n),
    ref: o,
    children: t
  }));
});
var uw = x(function (_ref129, u) {
  var _ref129$as = _ref129.as,
    t = _ref129$as === void 0 ? "a" : _ref129$as,
    n = _ref129.children,
    r = _ref129.className,
    o = _ref129.disabled,
    a = _ref129.href,
    _ref129$color = _ref129.color,
    i = _ref129$color === void 0 ? "default" : _ref129$color,
    _ref129$size = _ref129.size,
    s = _ref129$size === void 0 ? "medium" : _ref129$size,
    _ref129$variant = _ref129.variant,
    c = _ref129$variant === void 0 ? "standalone" : _ref129$variant,
    l = _objectWithoutProperties(_ref129, _excluded118);
  return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, l), {}, {
    className: T("goat-Link", "goat-Link_".concat(i), "goat-Link_".concat(c), "goat-Link_".concat(s), {
      "goat-disabled": o
    }, r),
    href: o ? void 0 : a,
    ref: u,
    children: /* @__PURE__ */p.jsx(Yc, {
      value: {
        size: "small"
      },
      children: n
    })
  }));
});
var dw = function dw(_ref130) {
    var e = _ref130.className,
      t = _objectWithoutProperties(_ref130, _excluded119);
    return /* @__PURE__ */p.jsx(je, _objectSpread(_objectSpread({}, t), {}, {
      className: T("goat-ListItem__AfterIcon", e)
    }));
  },
  fw = x(function (_ref131, i) {
    var _ref131$as = _ref131.as,
      t = _ref131$as === void 0 ? "div" : _ref131$as,
      n = _ref131.className,
      r = _ref131.children,
      _ref131$direction = _ref131.direction,
      o = _ref131$direction === void 0 ? "row" : _ref131$direction,
      a = _objectWithoutProperties(_ref131, _excluded120);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, a), {}, {
      className: T("goat-ListItem__Content", "goat-ListItem__Content_".concat(o), n),
      ref: i,
      children: r
    }));
  }),
  vw = x(function (_ref132, a) {
    var _ref132$as = _ref132.as,
      t = _ref132$as === void 0 ? "p" : _ref132$as,
      n = _ref132.children,
      r = _ref132.className,
      o = _objectWithoutProperties(_ref132, _excluded121);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-ListItem__Secondary", r),
      ref: a,
      children: n
    }));
  }),
  Tn = x(function (_ref133, i) {
    var _ref133$as = _ref133.as,
      t = _ref133$as === void 0 ? "label" : _ref133$as,
      n = _ref133.children,
      r = _ref133.className,
      o = _ref133.disabled,
      a = _objectWithoutProperties(_ref133, _excluded122);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, a), {}, {
      className: T("goat-ListItem", {
        "goat-disabled": o
      }, r),
      ref: i,
      children: n
    }));
  });
Tn.AfterIcon = dw;
Tn.Content = fw;
Tn.Secondary = vw;
var pw = ["Enter", " "],
  mw = ["ArrowDown", "PageUp", "Home"],
  Bu = ["ArrowUp", "PageDown", "End"],
  hw = [].concat(mw, Bu),
  ro = "Menu",
  _Vr5 = Vr(ro),
  _Vr6 = _slicedToArray(_Vr5, 3),
  ra = _Vr6[0],
  gw = _Vr6[1],
  bw = _Vr6[2],
  _Ke17 = Ke(ro, [bw, xn, Cn]),
  _Ke18 = _slicedToArray(_Ke17, 2),
  tn = _Ke18[0],
  Vu = _Ke18[1],
  vi = xn(),
  Uu = Cn(),
  _tn = tn(ro),
  _tn2 = _slicedToArray(_tn, 2),
  yw = _tn2[0],
  Zn = _tn2[1],
  _tn3 = tn(ro),
  _tn4 = _slicedToArray(_tn3, 2),
  ww = _tn4[0],
  pi = _tn4[1],
  xw = function xw(e) {
    var t = e.__scopeMenu,
      _e$open = e.open,
      n = _e$open === void 0 ? !1 : _e$open,
      r = e.children,
      o = e.dir,
      a = e.onOpenChange,
      _e$modal3 = e.modal,
      i = _e$modal3 === void 0 ? !0 : _e$modal3,
      s = vi(t),
      _te59 = te(null),
      _te60 = _slicedToArray(_te59, 2),
      c = _te60[0],
      l = _te60[1],
      u = k(!1),
      d = Xe(a),
      f = Vn(o);
    return V(function () {
      var m = function m() {
          u.current = !0, document.addEventListener("pointerdown", h, {
            capture: !0,
            once: !0
          }), document.addEventListener("pointermove", h, {
            capture: !0,
            once: !0
          });
        },
        h = function h() {
          return u.current = !1;
        };
      return document.addEventListener("keydown", m, {
        capture: !0
      }), function () {
        document.removeEventListener("keydown", m, {
          capture: !0
        }), document.removeEventListener("pointerdown", h, {
          capture: !0
        }), document.removeEventListener("pointermove", h, {
          capture: !0
        });
      };
    }, []), /* @__PURE__ */C(Ga, s, /* @__PURE__ */C(yw, {
      scope: t,
      open: n,
      onOpenChange: d,
      content: c,
      onContentChange: l
    }, /* @__PURE__ */C(ww, {
      scope: t,
      onClose: X(function () {
        return d(!1);
      }, [d]),
      isUsingKeyboardRef: u,
      dir: f,
      modal: i
    }, r)));
  },
  $w = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeMenu,
      r = _objectWithoutProperties(e, _excluded123),
      o = vi(n);
    return /* @__PURE__ */C(Jr, S({}, o, r, {
      ref: t
    }));
  }),
  Yu = "MenuPortal",
  _tn5 = tn(Yu, {
    forceMount: void 0
  }),
  _tn6 = _slicedToArray(_tn5, 2),
  Cw = _tn6[0],
  Tw = _tn6[1],
  _w = function _w(e) {
    var t = e.__scopeMenu,
      n = e.forceMount,
      r = e.children,
      o = e.container,
      a = Zn(Yu, t);
    return /* @__PURE__ */C(Cw, {
      scope: t,
      forceMount: n
    }, /* @__PURE__ */C(et, {
      present: n || a.open
    }, /* @__PURE__ */C(Yn, {
      asChild: !0,
      container: o
    }, r)));
  },
  Lt = "MenuContent",
  _tn7 = tn(Lt),
  _tn8 = _slicedToArray(_tn7, 2),
  Iw = _tn8[0],
  Ku = _tn8[1],
  Pw = /* @__PURE__ */x(function (e, t) {
    var n = Tw(Lt, e.__scopeMenu),
      _e$forceMount4 = e.forceMount,
      r = _e$forceMount4 === void 0 ? n.forceMount : _e$forceMount4,
      o = _objectWithoutProperties(e, _excluded124),
      a = Zn(Lt, e.__scopeMenu),
      i = pi(Lt, e.__scopeMenu);
    return /* @__PURE__ */C(ra.Provider, {
      scope: e.__scopeMenu
    }, /* @__PURE__ */C(et, {
      present: r || a.open
    }, /* @__PURE__ */C(ra.Slot, {
      scope: e.__scopeMenu
    }, i.modal ? /* @__PURE__ */C(Dw, S({}, o, {
      ref: t
    })) : /* @__PURE__ */C(Sw, S({}, o, {
      ref: t
    })))));
  }),
  Dw = /* @__PURE__ */x(function (e, t) {
    var n = Zn(Lt, e.__scopeMenu),
      r = k(null),
      o = Ce(t, r);
    return V(function () {
      var a = r.current;
      if (a) return La(a);
    }, []), /* @__PURE__ */C(Gu, S({}, e, {
      ref: o,
      trapFocus: n.open,
      disableOutsidePointerEvents: n.open,
      disableOutsideScroll: !0,
      onFocusOutside: Z(e.onFocusOutside, function (a) {
        return a.preventDefault();
      }, {
        checkForDefaultPrevented: !1
      }),
      onDismiss: function onDismiss() {
        return n.onOpenChange(!1);
      }
    }));
  }),
  Sw = /* @__PURE__ */x(function (e, t) {
    var n = Zn(Lt, e.__scopeMenu);
    return /* @__PURE__ */C(Gu, S({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: function onDismiss() {
        return n.onOpenChange(!1);
      }
    }));
  }),
  Gu = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeMenu,
      _e$loop4 = e.loop,
      r = _e$loop4 === void 0 ? !1 : _e$loop4,
      o = e.trapFocus,
      a = e.onOpenAutoFocus,
      i = e.onCloseAutoFocus,
      s = e.disableOutsidePointerEvents,
      c = e.onEntryFocus,
      l = e.onEscapeKeyDown,
      u = e.onPointerDownOutside,
      d = e.onFocusOutside,
      f = e.onInteractOutside,
      m = e.onDismiss,
      h = e.disableOutsideScroll,
      v = _objectWithoutProperties(e, _excluded125),
      g = Zn(Lt, n),
      b = pi(Lt, n),
      y = vi(n),
      w = Uu(n),
      I = gw(n),
      _te61 = te(null),
      _te62 = _slicedToArray(_te61, 2),
      P = _te62[0],
      D = _te62[1],
      E = k(null),
      _ = Ce(t, E, g.onContentChange),
      O = k(0),
      A = k(""),
      M = k(0),
      B = k(null),
      G = k("right"),
      N = k(0),
      j = h ? Aa : Wt,
      U = h ? {
        as: qt,
        allowPinchZoom: !0
      } : void 0,
      L = function L(Y) {
        var re, ae;
        var se = A.current + Y,
          le = I().filter(function (F) {
            return !F.disabled;
          }),
          fe = document.activeElement,
          xe = (re = le.find(function (F) {
            return F.ref.current === fe;
          })) === null || re === void 0 ? void 0 : re.textValue,
          be = le.map(function (F) {
            return F.textValue;
          }),
          q = jw(be, se, xe),
          W = (ae = le.find(function (F) {
            return F.textValue === q;
          })) === null || ae === void 0 ? void 0 : ae.ref.current;
        (function F(J) {
          A.current = J, window.clearTimeout(O.current), J !== "" && (O.current = window.setTimeout(function () {
            return F("");
          }, 1e3));
        })(se), W && setTimeout(function () {
          return W.focus();
        });
      };
    V(function () {
      return function () {
        return window.clearTimeout(O.current);
      };
    }, []), Ra();
    var R = X(function (Y) {
      var re, ae;
      return G.current === ((re = B.current) === null || re === void 0 ? void 0 : re.side) && Ww(Y, (ae = B.current) === null || ae === void 0 ? void 0 : ae.area);
    }, []);
    return /* @__PURE__ */C(Iw, {
      scope: n,
      searchRef: A,
      onItemEnter: X(function (Y) {
        R(Y) && Y.preventDefault();
      }, [R]),
      onItemLeave: X(function (Y) {
        var re;
        R(Y) || ((re = E.current) === null || re === void 0 || re.focus(), D(null));
      }, [R]),
      onTriggerLeave: X(function (Y) {
        R(Y) && Y.preventDefault();
      }, [R]),
      pointerGraceTimerRef: M,
      onPointerGraceIntentChange: X(function (Y) {
        B.current = Y;
      }, [])
    }, /* @__PURE__ */C(j, U, /* @__PURE__ */C(ka, {
      asChild: !0,
      trapped: o,
      onMountAutoFocus: Z(a, function (Y) {
        var re;
        Y.preventDefault(), (re = E.current) === null || re === void 0 || re.focus();
      }),
      onUnmountAutoFocus: i
    }, /* @__PURE__ */C(Un, {
      asChild: !0,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: m
    }, /* @__PURE__ */C(ui, S({
      asChild: !0
    }, w, {
      dir: b.dir,
      orientation: "vertical",
      loop: r,
      currentTabStopId: P,
      onCurrentTabStopIdChange: D,
      onEntryFocus: Z(c, function (Y) {
        b.isUsingKeyboardRef.current || Y.preventDefault();
      })
    }), /* @__PURE__ */C(za, S({
      role: "menu",
      "aria-orientation": "vertical",
      "data-state": Rw(g.open),
      "data-radix-menu-content": "",
      dir: b.dir
    }, y, v, {
      ref: _,
      style: _objectSpread({
        outline: "none"
      }, v.style),
      onKeyDown: Z(v.onKeyDown, function (Y) {
        var ae = Y.target.closest("[data-radix-menu-content]") === Y.currentTarget,
          se = Y.ctrlKey || Y.altKey || Y.metaKey,
          le = Y.key.length === 1;
        ae && (Y.key === "Tab" && Y.preventDefault(), !se && le && L(Y.key));
        var fe = E.current;
        if (Y.target !== fe || !hw.includes(Y.key)) return;
        Y.preventDefault();
        var be = I().filter(function (q) {
          return !q.disabled;
        }).map(function (q) {
          return q.ref.current;
        });
        Bu.includes(Y.key) && be.reverse(), Aw(be);
      }),
      onBlur: Z(e.onBlur, function (Y) {
        Y.currentTarget.contains(Y.target) || (window.clearTimeout(O.current), A.current = "");
      }),
      onPointerMove: Z(e.onPointerMove, aa(function (Y) {
        var re = Y.target,
          ae = N.current !== Y.clientX;
        if (Y.currentTarget.contains(re) && ae) {
          var se = Y.clientX > N.current ? "right" : "left";
          G.current = se, N.current = Y.clientX;
        }
      }))
    })))))));
  }),
  oa = "MenuItem",
  Ys = "menu.itemSelect",
  Ew = /* @__PURE__ */x(function (e, t) {
    var _e$disabled2 = e.disabled,
      n = _e$disabled2 === void 0 ? !1 : _e$disabled2,
      r = e.onSelect,
      o = _objectWithoutProperties(e, _excluded126),
      a = k(null),
      i = pi(oa, e.__scopeMenu),
      s = Ku(oa, e.__scopeMenu),
      c = Ce(t, a),
      l = k(!1),
      u = function u() {
        var d = a.current;
        if (!n && d) {
          var f = new CustomEvent(Ys, {
            bubbles: !0,
            cancelable: !0
          });
          d.addEventListener(Ys, function (m) {
            return r == null ? void 0 : r(m);
          }, {
            once: !0
          }), ba(d, f), f.defaultPrevented ? l.current = !1 : i.onClose();
        }
      };
    return /* @__PURE__ */C(Ow, S({}, o, {
      ref: c,
      disabled: n,
      onClick: Z(e.onClick, u),
      onPointerDown: function onPointerDown(d) {
        var f;
        (f = e.onPointerDown) === null || f === void 0 || f.call(e, d), l.current = !0;
      },
      onPointerUp: Z(e.onPointerUp, function (d) {
        var f;
        l.current || (f = d.currentTarget) === null || f === void 0 || f.click();
      }),
      onKeyDown: Z(e.onKeyDown, function (d) {
        var f = s.searchRef.current !== "";
        n || f && d.key === " " || pw.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
      })
    }));
  }),
  Ow = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeMenu,
      _e$disabled3 = e.disabled,
      r = _e$disabled3 === void 0 ? !1 : _e$disabled3,
      o = e.textValue,
      a = _objectWithoutProperties(e, _excluded127),
      i = Ku(oa, n),
      s = Uu(n),
      c = k(null),
      l = Ce(t, c),
      _te63 = te(!1),
      _te64 = _slicedToArray(_te63, 2),
      u = _te64[0],
      d = _te64[1],
      _te65 = te(""),
      _te66 = _slicedToArray(_te65, 2),
      f = _te66[0],
      m = _te66[1];
    return V(function () {
      var h = c.current;
      if (h) {
        var v;
        m(((v = h.textContent) !== null && v !== void 0 ? v : "").trim());
      }
    }, [a.children]), /* @__PURE__ */C(ra.ItemSlot, {
      scope: n,
      disabled: r,
      textValue: o !== null && o !== void 0 ? o : f
    }, /* @__PURE__ */C(di, S({
      asChild: !0
    }, s, {
      focusable: !r
    }), /* @__PURE__ */C(ie.div, S({
      role: "menuitem",
      "data-highlighted": u ? "" : void 0,
      "aria-disabled": r || void 0,
      "data-disabled": r ? "" : void 0
    }, a, {
      ref: l,
      onPointerMove: Z(e.onPointerMove, aa(function (h) {
        r ? i.onItemLeave(h) : (i.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus());
      })),
      onPointerLeave: Z(e.onPointerLeave, aa(function (h) {
        return i.onItemLeave(h);
      })),
      onFocus: Z(e.onFocus, function () {
        return d(!0);
      }),
      onBlur: Z(e.onBlur, function () {
        return d(!1);
      })
    }))));
  }),
  Mw = "MenuRadioGroup";
tn(Mw, {
  value: void 0,
  onValueChange: function onValueChange() {}
});
var Nw = "MenuItemIndicator";
tn(Nw, {
  checked: !1
});
var kw = "MenuSub";
tn(kw);
function Rw(e) {
  return e ? "open" : "closed";
}
function Aw(e) {
  var t = document.activeElement;
  var _iterator6 = _createForOfIteratorHelper(e),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var n = _step6.value;
      if (n === t || (n.focus(), document.activeElement !== t)) return;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
}
function Lw(e, t) {
  return e.map(function (n, r) {
    return e[(t + r) % e.length];
  });
}
function jw(e, t, n) {
  var o = t.length > 1 && Array.from(t).every(function (l) {
      return l === t[0];
    }) ? t[0] : t,
    a = n ? e.indexOf(n) : -1;
  var i = Lw(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter(function (l) {
    return l !== n;
  }));
  var c = i.find(function (l) {
    return l.toLowerCase().startsWith(o.toLowerCase());
  });
  return c !== n ? c : void 0;
}
function Fw(e, t) {
  var n = e.x,
    r = e.y;
  var o = !1;
  for (var a = 0, i = t.length - 1; a < t.length; i = a++) {
    var s = t[a].x,
      c = t[a].y,
      l = t[i].x,
      u = t[i].y;
    c > r != u > r && n < (l - s) * (r - c) / (u - c) + s && (o = !o);
  }
  return o;
}
function Ww(e, t) {
  if (!t) return !1;
  var n = {
    x: e.clientX,
    y: e.clientY
  };
  return Fw(n, t);
}
function aa(e) {
  return function (t) {
    return t.pointerType === "mouse" ? e(t) : void 0;
  };
}
var Hw = xw,
  Bw = $w,
  Vw = _w,
  Uw = Pw,
  Yw = Ew,
  zu = "DropdownMenu",
  _Ke19 = Ke(zu, [Vu]),
  _Ke20 = _slicedToArray(_Ke19, 2),
  Kw = _Ke20[0],
  c_ = _Ke20[1],
  Jn = Vu(),
  _Kw = Kw(zu),
  _Kw2 = _slicedToArray(_Kw, 2),
  Gw = _Kw2[0],
  qu = _Kw2[1],
  zw = function zw(e) {
    var t = e.__scopeDropdownMenu,
      n = e.children,
      r = e.dir,
      o = e.open,
      a = e.defaultOpen,
      i = e.onOpenChange,
      _e$modal4 = e.modal,
      s = _e$modal4 === void 0 ? !0 : _e$modal4,
      c = Jn(t),
      l = k(null),
      _Ze19 = Ze({
        prop: o,
        defaultProp: a,
        onChange: i
      }),
      _Ze20 = _slicedToArray(_Ze19, 2),
      _Ze20$ = _Ze20[0],
      u = _Ze20$ === void 0 ? !1 : _Ze20$,
      d = _Ze20[1];
    return /* @__PURE__ */C(Gw, {
      scope: t,
      triggerId: it(),
      triggerRef: l,
      contentId: it(),
      open: u,
      onOpenChange: d,
      onOpenToggle: X(function () {
        return d(function (f) {
          return !f;
        });
      }, [d]),
      modal: s
    }, /* @__PURE__ */C(Hw, S({}, c, {
      open: u,
      onOpenChange: d,
      dir: r,
      modal: s
    }), n));
  },
  qw = "DropdownMenuTrigger",
  Xw = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDropdownMenu,
      _e$disabled4 = e.disabled,
      r = _e$disabled4 === void 0 ? !1 : _e$disabled4,
      o = _objectWithoutProperties(e, _excluded128),
      a = qu(qw, n),
      i = Jn(n);
    return /* @__PURE__ */C(Bw, S({
      asChild: !0
    }, i), /* @__PURE__ */C(ie.button, S({
      type: "button",
      id: a.triggerId,
      "aria-haspopup": "menu",
      "aria-expanded": a.open,
      "aria-controls": a.open ? a.contentId : void 0,
      "data-state": a.open ? "open" : "closed",
      "data-disabled": r ? "" : void 0,
      disabled: r
    }, o, {
      ref: ga(t, a.triggerRef),
      onPointerDown: Z(e.onPointerDown, function (s) {
        !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
      }),
      onKeyDown: Z(e.onKeyDown, function (s) {
        r || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
      })
    })));
  }),
  Qw = function Qw(e) {
    var t = e.__scopeDropdownMenu,
      n = _objectWithoutProperties(e, _excluded129),
      r = Jn(t);
    return /* @__PURE__ */C(Vw, S({}, r, n));
  },
  Zw = "DropdownMenuContent",
  Jw = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDropdownMenu,
      r = _objectWithoutProperties(e, _excluded130),
      o = qu(Zw, n),
      a = Jn(n),
      i = k(!1);
    return /* @__PURE__ */C(Uw, S({
      id: o.contentId,
      "aria-labelledby": o.triggerId
    }, a, r, {
      ref: t,
      onCloseAutoFocus: Z(e.onCloseAutoFocus, function (s) {
        var c;
        i.current || (c = o.triggerRef.current) === null || c === void 0 || c.focus(), i.current = !1, s.preventDefault();
      }),
      onInteractOutside: Z(e.onInteractOutside, function (s) {
        var c = s.detail.originalEvent,
          l = c.button === 0 && c.ctrlKey === !0,
          u = c.button === 2 || l;
        (!o.modal || u) && (i.current = !0);
      }),
      style: _objectSpread(_objectSpread({}, e.style), {}, {
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      })
    }));
  }),
  e1 = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeDropdownMenu,
      r = _objectWithoutProperties(e, _excluded131),
      o = Jn(n);
    return /* @__PURE__ */C(Yw, S({}, o, r, {
      ref: t
    }));
  }),
  t1 = zw,
  n1 = Xw,
  r1 = Jw,
  o1 = e1,
  a1 = 4,
  Ks = function Ks(e) {
    return e * a1;
  },
  i1 = function i1(_ref134) {
    var _ref134$align = _ref134.align,
      e = _ref134$align === void 0 ? "start" : _ref134$align,
      t = _ref134.children,
      n = _ref134.className,
      r = _ref134.alignOffset,
      _ref134$sideOffset = _ref134.sideOffset,
      o = _ref134$sideOffset === void 0 ? 2 : _ref134$sideOffset,
      _ref134$collisionPadd = _ref134.collisionPadding,
      a = _ref134$collisionPadd === void 0 ? 20 : _ref134$collisionPadd,
      i = _objectWithoutProperties(_ref134, _excluded132);
    return /* @__PURE__ */p.jsx(Qw, {
      children: /* @__PURE__ */p.jsx(r1, _objectSpread(_objectSpread({}, i), {}, {
        className: T("goat-Menu", n),
        align: e,
        alignOffset: r && Ks(r),
        loop: !0,
        collisionPadding: a,
        sideOffset: Ks(o),
        children: t
      }))
    });
  },
  s1 = x(function (_ref135, s) {
    var t = _ref135.children,
      n = _ref135.className,
      r = _ref135.onSelect,
      o = _ref135.textValue,
      a = _ref135.disabled,
      i = _objectWithoutProperties(_ref135, _excluded133);
    return /* @__PURE__ */p.jsx(o1, _objectSpread(_objectSpread({
      asChild: !0,
      ref: s,
      onSelect: r,
      textValue: o,
      disabled: a
    }, i), {}, {
      children: /* @__PURE__ */p.jsx(Tn, {
        className: T(n),
        disabled: a,
        children: t
      })
    }));
  }),
  c1 = x(function (_ref136, a) {
    var _ref136$as = _ref136.as,
      t = _ref136$as === void 0 ? Fe : _ref136$as,
      n = _ref136.children,
      r = _ref136.className,
      o = _objectWithoutProperties(_ref136, _excluded134);
    return /* @__PURE__ */p.jsx(n1, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
        ref: a,
        className: T(r),
        children: n
      }))
    });
  });
var mi = function mi(_ref137) {
  var e = _ref137.children,
    t = _objectWithoutProperties(_ref137, _excluded135);
  return /* @__PURE__ */p.jsx(t1, _objectSpread(_objectSpread({}, t), {}, {
    modal: !1,
    children: e
  }));
};
mi.Content = i1;
mi.Item = s1;
mi.Trigger = c1;
var l1 = function l1(_ref138) {
    var e = _ref138.children,
      t = _ref138.className,
      _ref138$flow = _ref138.flow,
      n = _ref138$flow === void 0 ? "row" : _ref138$flow,
      r = _objectWithoutProperties(_ref138, _excluded136);
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-Notification__Content", "goat-Notification__Content_".concat(n), t),
      children: e
    }));
  },
  Xu = he({}),
  u1 = function u1() {
    return ce(Xu);
  },
  d1 = Xu.Provider,
  f1 = {
    attentive: {
      color: "yellow-500",
      as: Ho
    },
    informative: {
      color: "blue-500",
      as: $c
    },
    negative: {
      color: "red-500",
      as: Ho
    },
    positive: {
      color: "green-500",
      as: Cc
    }
  },
  v1 = function v1(e) {
    var _u2 = u1(),
      t = _u2.sentiment,
      n = _u2.size;
    return t === "neutral" ? null : /* @__PURE__ */p.jsx(je, _objectSpread(_objectSpread(_objectSpread({}, e), f1[t]), {}, {
      className: "goat-Notification__Icon",
      size: n
    }));
  },
  p1 = function p1(_ref139) {
    var e = _ref139.children,
      t = _ref139.className,
      n = _ref139.onDismiss,
      _ref139$sentiment = _ref139.sentiment,
      r = _ref139$sentiment === void 0 ? "neutral" : _ref139$sentiment,
      _ref139$size = _ref139.size,
      o = _ref139$size === void 0 ? "medium" : _ref139$size,
      a = _objectWithoutProperties(_ref139, _excluded137);
    return /* @__PURE__ */p.jsx(d1, {
      value: {
        sentiment: r,
        size: o
      },
      children: /* @__PURE__ */p.jsxs("div", _objectSpread(_objectSpread({}, a), {}, {
        className: T("goat-Notification", "goat-Notification_".concat(r), "goat-Notification_".concat(o), t),
        children: [e, n && /* @__PURE__ */p.jsx(Qe, {
          icon: Dt,
          size: o,
          onClick: n
        })]
      }))
    });
  };
var l_ = {
    Content: l1,
    Icon: v1,
    Root: p1
  },
  $t = {
    page: "page",
    next: "next",
    previous: "previous",
    startEllipsis: "start-ellipsis",
    endEllipsis: "end-ellipsis"
  },
  m1 = x(function (_ref140, s) {
    var t = _ref140.className,
      n = _ref140.type,
      r = _ref140.page,
      o = _ref140.selected,
      a = _ref140.as,
      i = _objectWithoutProperties(_ref140, _excluded138);
    return n === $t.startEllipsis || n === $t.endEllipsis ? /* @__PURE__ */p.jsx(Ge, {
      type: "body-medium",
      children: "..."
    }) : n === "page" ? /* @__PURE__ */p.jsx(Fe, _objectSpread(_objectSpread({}, i), {}, {
      as: a,
      size: "small",
      variant: o ? "outlined" : "ghost",
      className: T("goat-PaginationElement", {
        "goat-active": o
      }, t),
      ref: s,
      children: r
    })) : /* @__PURE__ */p.jsx(Fe, _objectSpread(_objectSpread({}, i), {}, {
      as: a,
      className: T("goat-PaginationElement", t),
      ref: s,
      size: "small",
      variant: "subtle",
      children: n === $t.next ? /* @__PURE__ */p.jsx(Fe.Icon, {
        as: ha
      }) : /* @__PURE__ */p.jsx(Fe.Icon, {
        as: xc
      })
    }));
  }),
  h1 = function h1(_ref141) {
    var e = _ref141.className,
      t = _ref141.children,
      n = _objectWithoutProperties(_ref141, _excluded139);
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, n), {}, {
      className: T("goat-PaginationItems", e),
      children: t
    }));
  },
  g1 = function g1(_ref142) {
    var e = _ref142.className,
      t = _ref142.children;
    return /* @__PURE__ */p.jsx("ul", {
      className: T("goat-PaginationList", e),
      children: at.map(t, function (n) {
        return /* @__PURE__ */p.jsx("li", {
          className: T("goat-PaginationElementWrapper"),
          children: n
        });
      })
    });
  };
var hi = function hi(_ref143) {
  var e = _ref143.children,
    t = _ref143.className,
    n = _ref143.centered,
    r = _objectWithoutProperties(_ref143, _excluded140);
  return /* @__PURE__ */p.jsx("nav", _objectSpread(_objectSpread({}, r), {}, {
    className: T("goat-Pagination", {
      "goat-Pagination_centered": n
    }, t),
    children: e
  }));
};
hi.Element = m1;
hi.List = g1;
hi.Items = h1;
var qe = 1,
  Ao = function Ao(e, t) {
    var n = t - e + 1;
    return Array.from({
      length: n
    }, function (r, o) {
      return e + o;
    });
  };
function u_(_ref144) {
  var _ref144$count = _ref144.count,
    e = _ref144$count === void 0 ? 1 : _ref144$count,
    _ref144$disabled = _ref144.disabled,
    t = _ref144$disabled === void 0 ? !1 : _ref144$disabled,
    n = _ref144.onChange,
    r = _ref144.page,
    _ref144$siblingCount = _ref144.siblingCount,
    o = _ref144$siblingCount === void 0 ? 1 : _ref144$siblingCount;
  var a = function a(m, h) {
      n == null || n(m, h);
    },
    i = Ao(1, Math.min(qe, e)),
    s = Ao(Math.max(e - qe + 1, qe + 1), e),
    c = Math.max(Math.min(
    // Natural start
    r - o,
    // Lower boundary when page is high
    e - qe - o * 2 - 1),
    // Greater than startPages
    qe + 2),
    l = Math.min(Math.max(
    // Natural end
    r + o,
    // Upper boundary when page is low
    qe + o * 2 + 2),
    // Less than endPages
    s.length > 0 ? s[0] - 2 : e - 1),
    u = [$t.previous].concat(_toConsumableArray(i), _toConsumableArray(c > qe + 2 ? [$t.startEllipsis] : qe + 1 < e - qe ? [qe + 1] : []), _toConsumableArray(Ao(c, l)), _toConsumableArray(l < e - qe - 1 ? [$t.endEllipsis] : e - qe > qe ? [e - qe] : []), _toConsumableArray(s), [$t.next]),
    d = function d(m) {
      switch (m) {
        case "previous":
          return r - 1;
        case "next":
          return r + 1;
      }
    };
  return {
    items: u.map(function (m) {
      return m === $t.startEllipsis || m === $t.endEllipsis ? {
        type: m
      } : typeof m == "number" ? {
        onClick: function onClick(h) {
          a(h, m);
        },
        type: "page",
        page: m,
        selected: m === r,
        disabled: t,
        "aria-current": m === r ? "true" : void 0
      } : {
        onClick: function onClick(h) {
          a(h, d(m));
        },
        type: m,
        page: d(m),
        selected: !1,
        disabled: t || m.indexOf("ellipsis") === -1 && (m === "next" ? r >= e : r <= 1)
      };
    })
  };
}
var b1 = x(function (_ref145, s) {
  var _ref145$as = _ref145.as,
    t = _ref145$as === void 0 ? "div" : _ref145$as,
    n = _ref145.className,
    r = _ref145.children,
    o = _ref145.containerClassName,
    _ref145$containerFlex = _ref145.containerFlexDirection,
    a = _ref145$containerFlex === void 0 ? "row" : _ref145$containerFlex,
    i = _objectWithoutProperties(_ref145, _excluded141);
  return /* @__PURE__ */p.jsx("div", {
    className: T("goat-PanelLayout__PageContainer", "goat-PanelLayout__PageContainer_".concat(a), o),
    children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, i), {}, {
      ref: s,
      className: T("goat-PanelLayout__Page", n),
      children: r
    }))
  });
});
var y1 = x(function (_ref146, o) {
  var t = _ref146.className,
    n = _ref146.children,
    r = _objectWithoutProperties(_ref146, _excluded142);
  return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, r), {}, {
    ref: o,
    className: T("goat-PanelLayout", t),
    children: n
  }));
});
y1.Page = b1;
var w1 = x(function (_ref147, o) {
    var _ref147$as = _ref147.as,
      t = _ref147$as === void 0 ? "div" : _ref147$as,
      n = _ref147.className,
      r = _ref147.children;
    var a = T("goat-Panel__Body", n);
    return /* @__PURE__ */p.jsx(t, {
      ref: o,
      className: a,
      children: r
    });
  }),
  Qu = x(function (_ref148, c) {
    var t = _ref148.children,
      n = _ref148.className,
      r = _ref148.persistent,
      _ref148$autoClose = _ref148.autoClose,
      o = _ref148$autoClose === void 0 ? !1 : _ref148$autoClose,
      _ref148$as = _ref148.as,
      a = _ref148$as === void 0 ? "div" : _ref148$as,
      i = _ref148.border,
      s = _objectWithoutProperties(_ref148, _excluded143);
    var l = o ? {} : {
        onPointerDownOutside: function onPointerDownOutside(d) {
          var f;
          d.preventDefault(), (f = s.onPointerDownOutside) == null || f.call(s, d);
        },
        onInteractOutside: function onInteractOutside(d) {
          var f;
          d.preventDefault(), (f = s.onInteractOutside) == null || f.call(s, d);
        },
        onEscapeKeyDown: function onEscapeKeyDown(d) {
          var f;
          d.preventDefault(), (f = s.onEscapeKeyDown) == null || f.call(s, d);
        }
      },
      u = i || (r ? "right" : "left");
    return /* @__PURE__ */p.jsx(Fa, _objectSpread(_objectSpread(_objectSpread({}, s), l), {}, {
      forceMount: !0,
      className: T("goat-Panel__Content", {
        "goat-Panel__Content_persistent": r
      }, _defineProperty({}, "goat-Panel__Content_border_".concat(u), u !== "none"), n),
      asChild: !0,
      ref: c,
      children: /* @__PURE__ */p.jsx(a, {
        children: t
      })
    }));
  }),
  x1 = x(function (_ref149, a) {
    var _ref149$as = _ref149.as,
      t = _ref149$as === void 0 ? "div" : _ref149$as,
      n = _ref149.className,
      r = _ref149.children,
      o = _objectWithoutProperties(_ref149, _excluded144);
    var i = T("goat-Panel__Footer", n);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: i,
      children: r
    }));
  }),
  $1 = x(function (_ref150, l) {
    var _ref150$as = _ref150.as,
      t = _ref150$as === void 0 ? "div" : _ref150$as,
      _ref150$variant = _ref150.variant,
      n = _ref150$variant === void 0 ? "application" : _ref150$variant,
      r = _ref150.style,
      _ref150$color = _ref150.color,
      o = _ref150$color === void 0 ? "coral-500" : _ref150$color,
      a = _ref150.className,
      i = _ref150.children,
      s = _ref150.disableClose,
      c = _objectWithoutProperties(_ref150, _excluded145);
    var u = T("goat-Panel__Header", "goat-Panel__Header_".concat(n), a);
    return /* @__PURE__ */p.jsxs(t, _objectSpread(_objectSpread({}, c), {}, {
      ref: l,
      style: _objectSpread(_objectSpread({}, r), {}, {
        "--goat-panel-header-color": yn(o)
      }),
      className: u,
      children: [i, !s && /* @__PURE__ */p.jsx(Ha, {
        asChild: !0,
        children: /* @__PURE__ */p.jsx(Qe, {
          className: "goat-Panel__CloseAction",
          icon: Dt
        })
      })]
    }));
  }),
  C1 = x(function (_ref151, a) {
    var _ref151$as = _ref151.as,
      t = _ref151$as === void 0 ? "p" : _ref151$as,
      n = _ref151.className,
      r = _ref151.children,
      o = _objectWithoutProperties(_ref151, _excluded146);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: n,
      as: t,
      type: "body-small",
      color: "gray-600",
      children: r
    }));
  }),
  T1 = x(function (_ref152, o) {
    var _ref152$as = _ref152.as,
      t = _ref152$as === void 0 ? "div" : _ref152$as,
      n = _ref152.className,
      r = _ref152.children;
    var a = T("goat-Panel__Text", n);
    return /* @__PURE__ */p.jsx(Wa, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, {
        ref: o,
        className: a,
        children: r
      })
    });
  }),
  _1 = x(function (_ref153, a) {
    var _ref153$as = _ref153.as,
      t = _ref153$as === void 0 ? "p" : _ref153$as,
      n = _ref153.className,
      r = _ref153.children,
      o = _objectWithoutProperties(_ref153, _excluded147);
    return /* @__PURE__ */p.jsx(Ge, _objectSpread(_objectSpread({}, o), {}, {
      ref: a,
      className: n,
      as: t,
      type: "title-medium",
      color: "gray-900",
      children: r
    }));
  }),
  I1 = x(function (_ref154, o) {
    var _ref154$as = _ref154.as,
      t = _ref154$as === void 0 ? Fe : _ref154$as,
      n = _ref154.className,
      r = _objectWithoutProperties(_ref154, _excluded148);
    return /* @__PURE__ */p.jsx("div", {
      className: "goat-Panel__Toggle",
      children: /* @__PURE__ */p.jsx(lm, _objectSpread(_objectSpread({}, r), {}, {
        className: T("goat-Panel__ToggleButton", n),
        ref: o,
        asChild: !0,
        children: /* @__PURE__ */p.jsxs(t, {
          variant: "ghost",
          size: "small",
          children: [/* @__PURE__ */p.jsx(Fe.Icon, {
            as: mf,
            className: "goat-Panel__ToggleIcon goat-Panel__ToggleIcon_opened"
          }), /* @__PURE__ */p.jsx(Fe.Icon, {
            as: hf,
            className: "goat-Panel__ToggleIcon goat-Panel__ToggleIcon_closed"
          })]
        })
      }))
    });
  });
var yt = function yt(_ref155) {
  var e = _ref155.children,
    t = _objectWithoutProperties(_ref155, _excluded149);
  return /* @__PURE__ */p.jsx(ja, _objectSpread(_objectSpread({}, t), {}, {
    modal: !1,
    children: e
  }));
};
yt.Content = Qu;
yt.Header = $1;
yt.Body = w1;
yt.Footer = x1;
yt.Title = _1;
yt.Subtitle = C1;
yt.Trigger = Va;
yt.Content = Qu;
yt.Text = T1;
yt.Toggle = I1;
var d_ = x(function (_ref156, o) {
  var _ref156$as = _ref156.as,
    t = _ref156$as === void 0 ? Fe : _ref156$as,
    n = _ref156.children,
    r = _objectWithoutProperties(_ref156, _excluded150);
  return /* @__PURE__ */p.jsx(nu, _objectSpread(_objectSpread({}, r), {}, {
    ref: o,
    asChild: !0,
    children: /* @__PURE__ */p.jsx(t, {
      children: n
    })
  }));
});
var f_ = function f_(_ref157) {
    var e = _ref157.children,
      t = _ref157.className,
      _ref157$portal = _ref157.portal,
      n = _ref157$portal === void 0 ? {} : _ref157$portal,
      r = _ref157.showArrow,
      o = _ref157.sideOffset,
      _ref157$size = _ref157.size,
      a = _ref157$size === void 0 ? "medium" : _ref157$size,
      i = _objectWithoutProperties(_ref157, _excluded151);
    return /* @__PURE__ */p.jsx(Jl, _objectSpread(_objectSpread({}, n), {}, {
      children: /* @__PURE__ */p.jsxs(eu, _objectSpread(_objectSpread({}, i), {}, {
        className: T("goat-PopoverContent", "goat-PopoverContent_".concat(a), t),
        sideOffset: o !== null && o !== void 0 ? o : r ? 8 : 16,
        children: [r && /* @__PURE__ */p.jsx(Xm, {
          className: "goat-PopoverArrow"
        }), e]
      }))
    }));
  },
  v_ = function v_(_ref158) {
    var t = _ref158.className,
      n = _ref158.children,
      r = _objectWithoutProperties(_ref158, _excluded152);
    return /* @__PURE__ */p.jsx("footer", _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-PopoverFooter", t),
      children: n
    }));
  },
  p_ = function p_(_ref159) {
    var e = _ref159.className,
      t = _ref159.children,
      n = _ref159.close,
      r = _objectWithoutProperties(_ref159, _excluded153);
    return /* @__PURE__ */p.jsxs("header", _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-PopoverHeader", e),
      children: [t, /* @__PURE__ */p.jsx(nu, _objectSpread(_objectSpread({}, n), {}, {
        asChild: !0,
        children: /* @__PURE__ */p.jsx(Qe, {
          className: "goat-PopoverClose",
          icon: Dt
        })
      }))]
    }));
  },
  m_ = Ql,
  h_ = x(function (_ref160, a) {
    var _ref160$as = _ref160.as,
      t = _ref160$as === void 0 ? Fe : _ref160$as,
      n = _ref160.className,
      r = _ref160.children,
      o = _objectWithoutProperties(_ref160, _excluded154);
    return /* @__PURE__ */p.jsx(Um, _objectSpread(_objectSpread({}, o), {}, {
      asChild: !0,
      className: T("goat-PopoverTrigger", n),
      ref: a,
      children: /* @__PURE__ */p.jsx(t, {
        children: r
      })
    }));
  }),
  Zu = "Progress",
  oo = 100,
  _Ke21 = Ke(Zu),
  _Ke22 = _slicedToArray(_Ke21, 2),
  P1 = _Ke22[0],
  g_ = _Ke22[1],
  _P2 = P1(Zu),
  _P3 = _slicedToArray(_P2, 2),
  D1 = _P3[0],
  S1 = _P3[1],
  Ju = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeProgress,
      r = e.value,
      o = e.max,
      _e$getValueLabel = e.getValueLabel,
      a = _e$getValueLabel === void 0 ? M1 : _e$getValueLabel,
      i = _objectWithoutProperties(e, _excluded155),
      s = ia(o) ? o : oo,
      c = td(r, s) ? r : null,
      l = Fr(c) ? a(c, s) : void 0;
    return /* @__PURE__ */C(D1, {
      scope: n,
      value: c,
      max: s
    }, /* @__PURE__ */C(ie.div, S({
      "aria-valuemax": s,
      "aria-valuemin": 0,
      "aria-valuenow": Fr(c) ? c : void 0,
      "aria-valuetext": l,
      role: "progressbar",
      "data-state": ed(c, s),
      "data-value": c !== null && c !== void 0 ? c : void 0,
      "data-max": s
    }, i, {
      ref: t
    })));
  });
Ju.propTypes = {
  max: function max(e, t, n) {
    var r = e[t],
      o = String(r);
    return r && !ia(r) ? new Error(N1(o, n)) : null;
  },
  value: function value(e, t, n) {
    var r = e[t],
      o = String(r),
      a = ia(e.max) ? e.max : oo;
    return r != null && !td(r, a) ? new Error(k1(o, n)) : null;
  }
};
var E1 = "ProgressIndicator",
  O1 = /* @__PURE__ */x(function (e, t) {
    var n;
    var r = e.__scopeProgress,
      o = _objectWithoutProperties(e, _excluded156),
      a = S1(E1, r);
    return /* @__PURE__ */C(ie.div, S({
      "data-state": ed(a.value, a.max),
      "data-value": (n = a.value) !== null && n !== void 0 ? n : void 0,
      "data-max": a.max
    }, o, {
      ref: t
    }));
  });
function M1(e, t) {
  return "".concat(Math.round(e / t * 100), "%");
}
function ed(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Fr(e) {
  return typeof e == "number";
}
function ia(e) {
  return Fr(e) && !isNaN(e) && e > 0;
}
function td(e, t) {
  return Fr(e) && !isNaN(e) && e <= t && e >= 0;
}
function N1(e, t) {
  return "Invalid prop `max` of value `".concat(e, "` supplied to `").concat(t, "`. Only numbers greater than 0 are valid max values. Defaulting to `").concat(oo, "`.");
}
function k1(e, t) {
  return "Invalid prop `value` of value `".concat(e, "` supplied to `").concat(t, "`. The `value` prop must be:\n  - a positive number\n  - less than the value passed to `max` (or ").concat(oo, " if no `max` prop is set)\n  - `null` if the progress is indeterminate.\n\nDefaulting to `null`.");
}
var b_ = x(function (_ref161, s) {
  var t = _ref161.className,
    n = _ref161.value,
    r = _ref161.max,
    _ref161$indicatorColo = _ref161.indicatorColor,
    o = _ref161$indicatorColo === void 0 ? "green-500" : _ref161$indicatorColo,
    a = _ref161.style,
    i = _objectWithoutProperties(_ref161, _excluded157);
  return /* @__PURE__ */p.jsx(Ju, _objectSpread(_objectSpread({}, i), {}, {
    value: n,
    max: r,
    className: T("goat-ProgressBar", t),
    ref: s,
    children: /* @__PURE__ */p.jsx(O1, {
      className: "goat-ProgressBarIndicator",
      style: _objectSpread(_objectSpread({}, a), {}, {
        "--goat-progressbar-indicator-color": yn(o),
        transform: "translateX(-".concat(100 - n / r * 100, "%)")
      })
    })
  }));
});
var y_ = x(function (_ref162, a) {
  var t = _ref162.className,
    n = _ref162.disabled,
    r = _ref162.id,
    o = _objectWithoutProperties(_ref162, _excluded158);
  var i = dt({
    disabled: n,
    id: r,
    inline: !0
  });
  return /* @__PURE__ */p.jsx("input", _objectSpread(_objectSpread({}, o), {}, {
    "aria-describedby": i.describedBy(o),
    className: T("goat-Radio", {
      "goat-touched": i.touched
    }, t),
    disabled: i.disabled,
    id: i.id,
    ref: a,
    type: "radio"
  }));
});
function w_(_ref163) {
  var e = _ref163.children,
    t = _objectWithoutProperties(_ref163, _excluded159);
  return /* @__PURE__ */p.jsx(Sl, _objectSpread(_objectSpread({}, t), {}, {
    direction: "row",
    children: e
  }));
}
var R1 = x(function (_ref164, i) {
    var t = _ref164.className,
      _ref164$size = _ref164.size,
      n = _ref164$size === void 0 ? "medium" : _ref164$size,
      _ref164$variant = _ref164.variant,
      r = _ref164$variant === void 0 ? "default" : _ref164$variant,
      _ref164$clearProps = _ref164.clearProps,
      o = _ref164$clearProps === void 0 ? {} : _ref164$clearProps,
      a = _objectWithoutProperties(_ref164, _excluded160);
    var s = Pa(i);
    return /* @__PURE__ */p.jsxs(jr.Root, {
      className: T("goat-Search", "goat-Search_".concat(n), "goat-Search_".concat(r), t),
      size: n,
      children: [/* @__PURE__ */p.jsx(je, {
        as: gf,
        size: n
      }), /* @__PURE__ */p.jsx(jr.Text, _objectSpread(_objectSpread({}, a), {}, {
        ref: s
      })), /* @__PURE__ */p.jsx(Qe, _objectSpread(_objectSpread({}, o), {}, {
        disabled: a.disabled,
        icon: Dt,
        onClick: function onClick(c) {
          var l;
          s.current && Uo(s.current, ""), (l = o.onClick) == null || l.call(o, c);
        },
        size: n
      }))]
    });
  }),
  nd = he(null),
  rd = he(null),
  od = he(null);
function Et() {
  var e = ce(nd);
  if (!e) throw new Error("Select compound components cannot be rendered outside the Select component");
  return e;
}
function ao() {
  var e = ce(rd);
  if (!e) throw new Error("Select compound components cannot be rendered outside the Select component");
  return e;
}
function ad() {
  return ce(od);
}
function A1(_ref165) {
  var e = _ref165.className,
    t = _ref165.children,
    _ref165$collisionPadd = _ref165.collisionPadding,
    n = _ref165$collisionPadd === void 0 ? 20 : _ref165$collisionPadd,
    r = _ref165.lockWidthToAnchor,
    o = _objectWithoutProperties(_ref165, _excluded161);
  var a = Et();
  return /* @__PURE__ */p.jsx(Kl, _objectSpread(_objectSpread(_objectSpread({
    collisionPadding: n,
    sideOffset: 8
  }, o), a.getMenuProps()), {}, {
    className: T("goat-SelectContent", {
      "goat-SelectContent__lockWidthToAnchor": r
    }, e),
    children: t
  }));
}
var L1 = x(function (_ref166, c) {
    var _ref166$as = _ref166.as,
      t = _ref166$as === void 0 ? Fe : _ref166$as,
      n = _ref166.children,
      r = _ref166.className,
      o = _ref166.context,
      a = _ref166.options,
      _ref166$type = _ref166.type,
      i = _ref166$type === void 0 ? "button" : _ref166$type,
      s = _objectWithoutProperties(_ref166, _excluded162);
    var l = dt();
    return /* @__PURE__ */p.jsx(Zr, _objectSpread(_objectSpread(_objectSpread({}, s), {}, {
      type: i,
      asChild: !0,
      className: T({
        "goat-active": o.isOpen,
        "goat-invalid": l.touched && l.validity.valid === !1
      }, r)
    }, o.getToggleButtonProps(_objectSpread({
      ref: c
    }, a))), {}, {
      children: /* @__PURE__ */p.jsx(t, {
        children: n
      })
    }));
  }),
  j1 = x(function (_ref167, n) {
    var _r$selectedItems;
    var t = Object.assign({}, (_objectDestructuringEmpty(_ref167), _ref167));
    var r = Et(),
      o = (_r$selectedItems = r.selectedItems) !== null && _r$selectedItems !== void 0 ? _r$selectedItems : [],
      a = k(null),
      i = Kr(n, a),
      s = r.multiple ? o.map(function (u) {
        return r.itemToString(u);
      }) : r.itemToString(r.selectedItem),
      c = Array.isArray(s) ? s.toString() : s,
      l = Hc(c);
    return V(function () {
      var u = a.current;
      if (l !== c) {
        var d = new Event("change", {
          bubbles: !0
        });
        u == null || u.dispatchEvent(d);
      }
    }, [l, c]), /* @__PURE__ */p.jsxs("select", _objectSpread(_objectSpread({}, t), {}, {
      multiple: r.multiple,
      value: s,
      onChange: function onChange() {
        return null;
      },
      hidden: !0,
      ref: i,
      "aria-hidden": !0,
      children: [s ? null : /* @__PURE__ */p.jsx("option", {
        value: ""
      }), r.items.map(function (u) {
        return /* @__PURE__ */p.jsx("option", {
          value: r.itemToString(u)
        }, r.itemToString(u));
      })]
    }));
  }),
  F1 = function F1(_ref168) {
    var e = _ref168.children,
      t = _ref168.className,
      n = _objectWithoutProperties(_ref168, _excluded163);
    var _ao = ao(),
      r = _ao.inputRef,
      _Et = Et(),
      o = _Et.getLabelProps,
      a = _Et.disabled,
      i = _Et.openMenu,
      s = function s(c) {
        var l;
        a || (i(), r == null || r.focus(), (l = n.onClick) == null || l.call(n, c));
      };
    return /* @__PURE__ */p.jsx("label", _objectSpread(_objectSpread(_objectSpread({}, n), o()), {}, {
      onClick: s,
      className: T("goat-SelectLabel", t),
      children: e
    }));
  },
  W1 = function W1(_ref169) {
    var e = _ref169.children,
      t = _ref169.className,
      n = _objectWithoutProperties(_ref169, _excluded164);
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({
      className: T("goat-SelectLayout", t)
    }, n), {}, {
      children: e
    }));
  },
  H1 = function H1(_ref170) {
    var _ref170$maxHeight = _ref170.maxHeight,
      e = _ref170$maxHeight === void 0 ? "".concat(5 * 40 + 20, "px") : _ref170$maxHeight,
      _ref170$maxWidth = _ref170.maxWidth,
      t = _ref170$maxWidth === void 0 ? "100%" : _ref170$maxWidth,
      n = _ref170.className,
      r = _ref170.itemClassName,
      o = _objectWithoutProperties(_ref170, _excluded165);
    var s;
    var a = Et(),
      i = new Set((s = a.selectedItems) == null ? void 0 : s.map(a.itemToString));
    return a.isOpen ? /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-SelectContentOverflowWrapper", n),
      style: {
        "--goat-Select-max-height": e,
        "--goat-Select-max-width": t
      },
      children: a.filteredItems.map(function (c, l) {
        var u = a.itemToString(c),
          d = a.selectedItem && a.itemToString(a.selectedItem),
          f = a.multiple ? i.has(u) : d === u,
          m = a.labelToNode(c);
        return /* @__PURE__ */p.jsx(Tn, _objectSpread(_objectSpread({
          as: "div"
        }, a.getItemProps(_objectSpread({
          item: c,
          index: l
        }, a.multiple ? {
          "aria-selected": f
        } : {}))), {}, {
          className: T(r, "goat-SelectItem", {
            "goat-selected": a.multiple ? !1 : f,
            "goat-active": a.highlightedIndex === l
          }),
          children: a.multiple ? /* @__PURE__ */p.jsxs(p.Fragment, {
            children: [/* @__PURE__ */p.jsx(sl, {
              checked: f,
              onChange: function onChange() {
                return null;
              }
            }), /* @__PURE__ */p.jsx("span", {
              className: "goat-SelectItem__text",
              children: m
            })]
          }) : /* @__PURE__ */p.jsxs(p.Fragment, {
            children: [/* @__PURE__ */p.jsx("span", {
              className: "goat-SelectItem__text",
              children: m
            }), /* @__PURE__ */p.jsx(je, {
              as: wc,
              size: "small",
              className: T("goat-SelectIcon", {
                "goat-SelectIcon_visible": f
              })
            })]
          })
        }), u);
      })
    })) : null;
  };
function B1(e) {
  return e;
}
var V1 = function V1(_ref171) {
  var _ref172;
  var e = _ref171.className,
    t = _objectWithoutProperties(_ref171, _excluded166);
  var n = Et(),
    r = ad(),
    _ao2 = ao(),
    o = _ao2.setInputRef,
    a = (_ref172 = r == null ? void 0 : r.getDropdownProps) !== null && _ref172 !== void 0 ? _ref172 : B1;
  return /* @__PURE__ */p.jsx(fi, _objectSpread(_objectSpread({}, t), {}, {
    className: T("goat-SelectWithSearch", e, {
      "goat-SelectWithSearch__closed": !n.isOpen,
      "goat-SelectWithSearch__hidden": !n.isSearchable
    }),
    children: /* @__PURE__ */p.jsx(R1, _objectSpread(_objectSpread({}, n.getInputProps(a(_objectSpread({
      onChange: function onChange(i) {
        i.stopPropagation();
      },
      tabIndex: n.isOpen ? 0 : -1,
      disabled: n.disabled,
      ref: o
    }, r ? {
      preventKeyAction: n.isOpen
    } : {})))), {}, {
      variant: "select"
    }))
  }));
};
function zt(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    o,
    a;
  for (a = 0; a < r.length; a++) o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var id = {
    exports: {}
  },
  U1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  Y1 = U1,
  K1 = Y1;
function sd() {}
function cd() {}
cd.resetWarningCache = sd;
var G1 = function G1() {
  function e(r, o, a, i, s, c) {
    if (c !== K1) {
      var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw l.name = "Invariant Violation", l;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: cd,
    resetWarningCache: sd
  };
  return n.PropTypes = n, n;
};
id.exports = G1();
var z1 = id.exports;
var H = /* @__PURE__ */xf(z1);
var $e = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var io = 60103,
  so = 60106,
  er = 60107,
  tr = 60108,
  nr = 60114,
  rr = 60109,
  or = 60110,
  ar = 60112,
  ir = 60113,
  gi = 60120,
  sr = 60115,
  cr = 60116,
  ld = 60121,
  ud = 60122,
  dd = 60117,
  fd = 60129,
  vd = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var He = Symbol.for;
  io = He("react.element"), so = He("react.portal"), er = He("react.fragment"), tr = He("react.strict_mode"), nr = He("react.profiler"), rr = He("react.provider"), or = He("react.context"), ar = He("react.forward_ref"), ir = He("react.suspense"), gi = He("react.suspense_list"), sr = He("react.memo"), cr = He("react.lazy"), ld = He("react.block"), ud = He("react.server.block"), dd = He("react.fundamental"), fd = He("react.debug_trace_mode"), vd = He("react.legacy_hidden");
}
function ft(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case io:
        switch (e = e.type, e) {
          case er:
          case nr:
          case tr:
          case ir:
          case gi:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case or:
              case ar:
              case cr:
              case sr:
              case rr:
                return e;
              default:
                return t;
            }
        }
      case so:
        return t;
    }
  }
}
var q1 = rr,
  X1 = io,
  Q1 = ar,
  Z1 = er,
  J1 = cr,
  ex = sr,
  tx = so,
  nx = nr,
  rx = tr,
  ox = ir;
$e.ContextConsumer = or;
$e.ContextProvider = q1;
$e.Element = X1;
$e.ForwardRef = Q1;
$e.Fragment = Z1;
$e.Lazy = J1;
$e.Memo = ex;
$e.Portal = tx;
$e.Profiler = nx;
$e.StrictMode = rx;
$e.Suspense = ox;
$e.isAsyncMode = function () {
  return !1;
};
$e.isConcurrentMode = function () {
  return !1;
};
$e.isContextConsumer = function (e) {
  return ft(e) === or;
};
$e.isContextProvider = function (e) {
  return ft(e) === rr;
};
$e.isElement = function (e) {
  return typeof e == "object" && e !== null && e.$$typeof === io;
};
$e.isForwardRef = function (e) {
  return ft(e) === ar;
};
$e.isFragment = function (e) {
  return ft(e) === er;
};
$e.isLazy = function (e) {
  return ft(e) === cr;
};
$e.isMemo = function (e) {
  return ft(e) === sr;
};
$e.isPortal = function (e) {
  return ft(e) === so;
};
$e.isProfiler = function (e) {
  return ft(e) === nr;
};
$e.isStrictMode = function (e) {
  return ft(e) === tr;
};
$e.isSuspense = function (e) {
  return ft(e) === ir;
};
$e.isValidElementType = function (e) {
  return typeof e == "string" || typeof e == "function" || e === er || e === nr || e === fd || e === tr || e === ir || e === gi || e === vd || typeof e == "object" && e !== null && (e.$$typeof === cr || e.$$typeof === sr || e.$$typeof === rr || e.$$typeof === or || e.$$typeof === ar || e.$$typeof === dd || e.$$typeof === ld || e[0] === ud);
};
$e.typeOf = ft;
var Gs = function Gs(e) {
    return typeof e == "object" && e != null && e.nodeType === 1;
  },
  zs = function zs(e, t) {
    return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
  },
  Lo = function Lo(e, t) {
    if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
      var n = getComputedStyle(e, null);
      return zs(n.overflowY, t) || zs(n.overflowX, t) || function (r) {
        var o = function (a) {
          if (!a.ownerDocument || !a.ownerDocument.defaultView) return null;
          try {
            return a.ownerDocument.defaultView.frameElement;
          } catch (_unused4) {
            return null;
          }
        }(r);
        return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
      }(e);
    }
    return !1;
  },
  wr = function wr(e, t, n, r, o, a, i, s) {
    return a < e && i > t || a > e && i < t ? 0 : a <= e && s <= n || i >= t && s >= n ? a - e - r : i > t && s < n || a < e && s > n ? i - t + o : 0;
  },
  ax = function ax(e) {
    var t = e.parentElement;
    return t !== null && t !== void 0 ? t : e.getRootNode().host || null;
  };
var ix = function ix(e, t) {
    var n, r, o, a, i, s;
    if (typeof document > "u") return [];
    var c = t.scrollMode,
      l = t.block,
      u = t.inline,
      d = t.boundary,
      f = t.skipOverflowHiddenElements,
      m = typeof d == "function" ? d : function (N) {
        return N !== d;
      };
    if (!Gs(e)) throw new TypeError("Invalid target");
    var h = document.scrollingElement || document.documentElement,
      v = [],
      g = e;
    for (; Gs(g) && m(g);) {
      if (g = ax(g), g === h) {
        v.push(g);
        break;
      }
      g != null && g === document.body && Lo(g) && !Lo(document.documentElement) || g != null && Lo(g, f) && v.push(g);
    }
    var b = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth,
      y = (a = (o = window.visualViewport) == null ? void 0 : o.height) != null ? a : innerHeight,
      w = (i = window.scrollX) != null ? i : pageXOffset,
      I = (s = window.scrollY) != null ? s : pageYOffset,
      _e$getBoundingClientR = e.getBoundingClientRect(),
      P = _e$getBoundingClientR.height,
      D = _e$getBoundingClientR.width,
      E = _e$getBoundingClientR.top,
      _ = _e$getBoundingClientR.right,
      O = _e$getBoundingClientR.bottom,
      A = _e$getBoundingClientR.left,
      M = l === "start" || l === "nearest" ? E : l === "end" ? O : E + P / 2,
      B = u === "center" ? A + D / 2 : u === "end" ? _ : A,
      G = [];
    for (var N = 0; N < v.length; N++) {
      var j = v[N],
        _j$getBoundingClientR = j.getBoundingClientRect(),
        U = _j$getBoundingClientR.height,
        L = _j$getBoundingClientR.width,
        R = _j$getBoundingClientR.top,
        Y = _j$getBoundingClientR.right,
        re = _j$getBoundingClientR.bottom,
        ae = _j$getBoundingClientR.left;
      if (c === "if-needed" && E >= 0 && A >= 0 && O <= y && _ <= b && E >= R && O <= re && A >= ae && _ <= Y) return G;
      var se = getComputedStyle(j),
        le = parseInt(se.borderLeftWidth, 10),
        fe = parseInt(se.borderTopWidth, 10),
        xe = parseInt(se.borderRightWidth, 10),
        be = parseInt(se.borderBottomWidth, 10),
        q = 0,
        W = 0,
        F = "offsetWidth" in j ? j.offsetWidth - j.clientWidth - le - xe : 0,
        J = "offsetHeight" in j ? j.offsetHeight - j.clientHeight - fe - be : 0,
        Se = "offsetWidth" in j ? j.offsetWidth === 0 ? 0 : L / j.offsetWidth : 0,
        Pe = "offsetHeight" in j ? j.offsetHeight === 0 ? 0 : U / j.offsetHeight : 0;
      if (h === j) q = l === "start" ? M : l === "end" ? M - y : l === "nearest" ? wr(I, I + y, y, fe, be, I + M, I + M + P, P) : M - y / 2, W = u === "start" ? B : u === "center" ? B - b / 2 : u === "end" ? B - b : wr(w, w + b, b, le, xe, w + B, w + B + D, D), q = Math.max(0, q + I), W = Math.max(0, W + w);else {
        q = l === "start" ? M - R - fe : l === "end" ? M - re + be + J : l === "nearest" ? wr(R, re, U, fe, be + J, M, M + P, P) : M - (R + U / 2) + J / 2, W = u === "start" ? B - ae - le : u === "center" ? B - (ae + L / 2) + F / 2 : u === "end" ? B - Y + xe + F : wr(ae, Y, L, le, xe + F, B, B + D, D);
        var Ae = j.scrollLeft,
          Le = j.scrollTop;
        q = Math.max(0, Math.min(Le + q / Pe, j.scrollHeight - U / Pe + J)), W = Math.max(0, Math.min(Ae + W / Se, j.scrollWidth - L / Se + F)), M += Le - q, B += Ae - W;
      }
      G.push({
        el: j,
        top: q,
        left: W
      });
    }
    return G;
  },
  sx = 0;
function bi() {}
function cx(e, t) {
  if (e) {
    var n = ix(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function (r) {
      var o = r.el,
        a = r.top,
        i = r.left;
      o.scrollTop = a, o.scrollLeft = i;
    });
  }
}
function qs(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function pd(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++) i[s] = arguments[s];
    r(), n = setTimeout(function () {
      n = null, e.apply(void 0, i);
    }, t);
  }
  return o.cancel = r, o;
}
function Je() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return function (r) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++) a[i - 1] = arguments[i];
    return t.some(function (s) {
      return s && s.apply(void 0, [r].concat(a)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function ln() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return function (r) {
    t.forEach(function (o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function lx() {
  return String(sx++);
}
function ux(e) {
  var t = e.isOpen,
    n = e.resultCount,
    r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Wr(e, t) {
  return Object.keys(e).reduce(function (n, r) {
    return n[r] = md(t, r) ? t[r] : e[r], n;
  }, {});
}
function md(e, t) {
  return e[t] !== void 0;
}
function sa(e) {
  var t = e.key,
    n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function xr(e, t, n, r, o) {
  if (o === void 0 && (o = !0), n === 0) return -1;
  var a = n - 1;
  (typeof t != "number" || t < 0 || t >= n) && (t = e > 0 ? -1 : a + 1);
  var i = t + e;
  i < 0 ? i = o ? a : 0 : i > a && (i = o ? 0 : a);
  var s = Wn(e, i, n, r, o);
  return s === -1 ? t >= n ? -1 : t : s;
}
function Wn(e, t, n, r, o) {
  var a = r(t);
  if (!a || !a.hasAttribute("disabled")) return t;
  if (e > 0) {
    for (var i = t + 1; i < n; i++) if (!r(i).hasAttribute("disabled")) return i;
  } else for (var s = t - 1; s >= 0; s--) if (!r(s).hasAttribute("disabled")) return s;
  return o ? e > 0 ? Wn(1, 0, n, r, !1) : Wn(-1, n - 1, n, r, !1) : -1;
}
function Xs(e, t, n, r) {
  return r === void 0 && (r = !0), t.some(function (o) {
    return o && (qs(o, e, n) || r && qs(o, n.document.activeElement, n));
  });
}
var dx = pd(function (e) {
  gd(e).textContent = "";
}, 500);
function hd(e, t) {
  var n = gd(t);
  e && (n.textContent = e, dx(t));
}
function gd(e) {
  e === void 0 && (e = document);
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
var fx = ["isInitialMount", "highlightedIndex", "items", "environment"],
  bd = {
    highlightedIndex: -1,
    isOpen: !1,
    selectedItem: null,
    inputValue: ""
  };
function vx(e, t, n) {
  var r = e.props,
    o = e.type,
    a = {};
  Object.keys(t).forEach(function (i) {
    px(i, e, t, n), n[i] !== t[i] && (a[i] = n[i]);
  }), r.onStateChange && Object.keys(a).length && r.onStateChange(S({
    type: o
  }, a));
}
function px(e, t, n, r) {
  var o = t.props,
    a = t.type,
    i = "on" + yi(e) + "Change";
  o[i] && r[e] !== void 0 && r[e] !== n[e] && o[i](S({
    type: a
  }, r));
}
function mx(e, t) {
  return t.changes;
}
function hx(e) {
  var t = e.selectedItem,
    n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var gx = pd(function (e, t) {
    hd(e(), t);
  }, 200),
  bx = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? pa : V;
function yx(e) {
  var t = e.id,
    n = t === void 0 ? "downshift-" + lx() : t,
    r = e.labelId,
    o = e.menuId,
    a = e.getItemId,
    i = e.toggleButtonId,
    s = e.inputId,
    c = k({
      labelId: r || n + "-label",
      menuId: o || n + "-menu",
      getItemId: a || function (l) {
        return n + "-item-" + l;
      },
      toggleButtonId: i || n + "-toggle-button",
      inputId: s || n + "-input"
    });
  return c.current;
}
function yd(e, t, n, r) {
  var o, a;
  if (e === void 0) {
    if (t === void 0) throw new Error(r);
    o = n[t], a = t;
  } else a = t === void 0 ? n.indexOf(e) : t, o = e;
  return [o, a];
}
function wx(e) {
  return e ? String(e) : "";
}
function yi(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function wi(e) {
  var t = k(e);
  return t.current = e, t;
}
function wd(e, t, n) {
  var r = k(),
    o = k(),
    a = X(function (f, m) {
      o.current = m, f = Wr(f, m.props);
      var h = e(f, m),
        v = m.props.stateReducer(f, S({}, m, {
          changes: h
        }));
      return v;
    }, [e]),
    i = ma(a, t),
    s = i[0],
    c = i[1],
    l = wi(n),
    u = X(function (f) {
      return c(S({
        props: l.current
      }, f));
    }, [l]),
    d = o.current;
  return V(function () {
    d && r.current && r.current !== s && vx(d, Wr(r.current, d.props), s), r.current = s;
  }, [s, n, d]), [s, u];
}
function xx(e, t, n) {
  var r = wd(e, t, n),
    o = r[0],
    a = r[1];
  return [Wr(o, n), a];
}
var Mn = {
  itemToString: wx,
  stateReducer: mx,
  getA11ySelectionMessage: hx,
  scrollIntoView: cx,
  environment: /* istanbul ignore next (ssr) */
  typeof window > "u" ? {} : window
};
function ot(e, t, n) {
  n === void 0 && (n = bd);
  var r = e["default" + yi(t)];
  return r !== void 0 ? r : n[t];
}
function En(e, t, n) {
  n === void 0 && (n = bd);
  var r = e[t];
  if (r !== void 0) return r;
  var o = e["initial" + yi(t)];
  return o !== void 0 ? o : ot(e, t, n);
}
function $x(e) {
  var t = En(e, "selectedItem"),
    n = En(e, "isOpen"),
    r = En(e, "highlightedIndex"),
    o = En(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: o
  };
}
function Nn(e, t, n) {
  var r = e.items,
    o = e.initialHighlightedIndex,
    a = e.defaultHighlightedIndex,
    i = t.selectedItem,
    s = t.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && s === o ? o : a !== void 0 ? a : i ? r.indexOf(i) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function Cx(e, t, n, r) {
  var o = k({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return V(function () {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var a = function a() {
          o.current.isMouseDown = !0;
        },
        i = function i(d) {
          o.current.isMouseDown = !1, e && !Xs(d.target, t.map(function (f) {
            return f.current;
          }), n) && r();
        },
        s = function s() {
          o.current.isTouchMove = !1;
        },
        c = function c() {
          o.current.isTouchMove = !0;
        },
        l = function l(d) {
          e && !o.current.isTouchMove && !Xs(d.target, t.map(function (f) {
            return f.current;
          }), n, !1) && r();
        };
      return n.addEventListener("mousedown", a), n.addEventListener("mouseup", i), n.addEventListener("touchstart", s), n.addEventListener("touchmove", c), n.addEventListener("touchend", l), function () {
        n.removeEventListener("mousedown", a), n.removeEventListener("mouseup", i), n.removeEventListener("touchstart", s), n.removeEventListener("touchmove", c), n.removeEventListener("touchend", l);
      };
    }
  }, [e, n]), o;
}
var xd = function xd() {
  return bi;
};
function Qs(e, t, n) {
  var r = n.isInitialMount,
    o = n.highlightedIndex,
    a = n.items,
    i = n.environment,
    s = zt(n, fx);
  V(function () {
    r || gx(function () {
      return e(S({
        highlightedIndex: o,
        highlightedItem: a[o],
        resultCount: a.length
      }, s));
    }, i.document);
  }, t);
}
function Tx(e) {
  var t = e.highlightedIndex,
    n = e.isOpen,
    r = e.itemRefs,
    o = e.getItemNodeFromIndex,
    a = e.menuElement,
    i = e.scrollIntoView,
    s = k(!0);
  return bx(function () {
    t < 0 || !n || !Object.keys(r.current).length || (s.current === !1 ? s.current = !0 : i(o(t), a));
  }, [t]), s;
}
var $d = bi;
function Zs(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return S({
    isOpen: !1,
    highlightedIndex: -1
  }, o && S({
    selectedItem: e.items[t],
    isOpen: ot(e, "isOpen"),
    highlightedIndex: ot(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function _x(e, t, n) {
  var r = t.type,
    o = t.props,
    a;
  switch (r) {
    case n.ItemMouseMove:
      a = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      a = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      a = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Nn(o, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      a = {
        isOpen: !0,
        highlightedIndex: Nn(o, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      a = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      a = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      a = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      a = {
        highlightedIndex: ot(o, "highlightedIndex"),
        isOpen: ot(o, "isOpen"),
        selectedItem: ot(o, "selectedItem"),
        inputValue: ot(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return S({}, e, a);
}
H.array.isRequired, H.func, H.func, H.func, H.number, H.number, H.number, H.bool, H.bool, H.bool, H.any, H.any, H.any, H.string, H.string, H.string, H.func, H.string, H.func, H.func, H.func, H.func, H.func, H.shape({
  addEventListener: H.func,
  removeEventListener: H.func,
  document: H.shape({
    getElementById: H.func,
    activeElement: H.any,
    body: H.any
  })
});
function Ix(e) {
  var t = e.isOpen,
    n = e.resultCount,
    r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
_tt(_tt({}, Mn), {
  getA11yStatusMessage: Ix
});
var xi = 0,
  $i = 1,
  Ci = 2,
  Ti = 3,
  _i = 4,
  Ii = 5,
  Pi = 6,
  Di = 7,
  Si = 8,
  Hr = 9,
  Ei = 10,
  Cd = 11,
  Td = 12,
  Oi = 13,
  _d = 14,
  Id = 15,
  Pd = 16,
  Dd = 17,
  Sd = 18,
  Mi = 19,
  Ed = 20,
  Od = 21,
  Ni = 22,
  Md = /* @__PURE__ */Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: xi,
    InputKeyDownArrowUp: $i,
    InputKeyDownEscape: Ci,
    InputKeyDownHome: Ti,
    InputKeyDownEnd: _i,
    InputKeyDownPageUp: Ii,
    InputKeyDownPageDown: Pi,
    InputKeyDownEnter: Di,
    InputChange: Si,
    InputBlur: Hr,
    InputFocus: Ei,
    MenuMouseLeave: Cd,
    ItemMouseMove: Td,
    ItemClick: Oi,
    ToggleButtonClick: _d,
    FunctionToggleMenu: Id,
    FunctionOpenMenu: Pd,
    FunctionCloseMenu: Dd,
    FunctionSetHighlightedIndex: Sd,
    FunctionSelectItem: Mi,
    FunctionSetInputValue: Ed,
    FunctionReset: Od,
    ControlledPropUpdatedSelectedItem: Ni
  });
function Px(e) {
  var t = $x(e),
    n = t.selectedItem,
    r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), S({}, t, {
    inputValue: r
  });
}
H.array.isRequired, H.func, H.func, H.func, H.func, H.number, H.number, H.number, H.bool, H.bool, H.bool, H.any, H.any, H.any, H.string, H.string, H.string, H.string, H.string, H.string, H.func, H.string, H.string, H.func, H.func, H.func, H.func, H.func, H.func, H.shape({
  addEventListener: H.func,
  removeEventListener: H.func,
  document: H.shape({
    getElementById: H.func,
    activeElement: H.any,
    body: H.any
  })
});
function Dx(e, t, n) {
  var r = k(),
    o = wd(e, t, n),
    a = o[0],
    i = o[1];
  return V(function () {
    md(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && i({
      type: Ni,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = a.selectedItem === r.current ? n.selectedItem : a.selectedItem);
  }, [a.selectedItem, n.selectedItem]), [Wr(a, n), i];
}
var Sx = S({}, Mn, {
  selectedItemChanged: function selectedItemChanged(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: ux
});
function Ex(e, t) {
  var n,
    r = t.type,
    o = t.props,
    a = t.altKey,
    i;
  switch (r) {
    case Oi:
      i = {
        isOpen: ot(o, "isOpen"),
        highlightedIndex: ot(o, "highlightedIndex"),
        selectedItem: o.items[t.index],
        inputValue: o.itemToString(o.items[t.index])
      };
      break;
    case xi:
      e.isOpen ? i = {
        highlightedIndex: xr(1, e.highlightedIndex, o.items.length, t.getItemNodeFromIndex, !0)
      } : i = {
        highlightedIndex: a && e.selectedItem == null ? -1 : Nn(o, e, 1, t.getItemNodeFromIndex),
        isOpen: o.items.length >= 0
      };
      break;
    case $i:
      e.isOpen ? a ? i = Zs(o, e.highlightedIndex) : i = {
        highlightedIndex: xr(-1, e.highlightedIndex, o.items.length, t.getItemNodeFromIndex, !0)
      } : i = {
        highlightedIndex: Nn(o, e, -1, t.getItemNodeFromIndex),
        isOpen: o.items.length >= 0
      };
      break;
    case Di:
      i = Zs(o, e.highlightedIndex);
      break;
    case Ci:
      i = S({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Ii:
      i = {
        highlightedIndex: xr(-10, e.highlightedIndex, o.items.length, t.getItemNodeFromIndex, !1)
      };
      break;
    case Pi:
      i = {
        highlightedIndex: xr(10, e.highlightedIndex, o.items.length, t.getItemNodeFromIndex, !1)
      };
      break;
    case Ti:
      i = {
        highlightedIndex: Wn(1, 0, o.items.length, t.getItemNodeFromIndex, !1)
      };
      break;
    case _i:
      i = {
        highlightedIndex: Wn(-1, o.items.length - 1, o.items.length, t.getItemNodeFromIndex, !1)
      };
      break;
    case Hr:
      i = S({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case Si:
      i = {
        isOpen: !0,
        highlightedIndex: ot(o, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case Ei:
      i = {
        isOpen: !0,
        highlightedIndex: Nn(o, e, 0)
      };
      break;
    case Mi:
      i = {
        selectedItem: t.selectedItem,
        inputValue: o.itemToString(t.selectedItem)
      };
      break;
    case Ni:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return _x(e, t, Md);
  }
  return S({}, e, i);
}
var Ox = ["onMouseLeave", "refKey", "ref"],
  Mx = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  Nx = ["onClick", "onPress", "refKey", "ref"],
  kx = ["onKeyDown", "onChange", "onInput", "onFocus", "onBlur", "onChangeText", "refKey", "ref"];
Ue.stateChangeTypes = Md;
function Ue(e) {
  e === void 0 && (e = {});
  var t = S({}, Sx, e),
    n = t.initialIsOpen,
    r = t.defaultIsOpen,
    o = t.items,
    a = t.scrollIntoView,
    i = t.environment,
    s = t.getA11yStatusMessage,
    c = t.getA11ySelectionMessage,
    l = t.itemToString,
    u = Px(t),
    d = Dx(Ex, u, t),
    f = d[0],
    m = d[1],
    h = f.isOpen,
    v = f.highlightedIndex,
    g = f.selectedItem,
    b = f.inputValue,
    y = k(null),
    w = k({}),
    I = k(null),
    P = k(null),
    D = k(!0),
    E = yx(t),
    _ = k(),
    O = wi({
      state: f,
      props: t
    }),
    A = X(function (q) {
      return w.current[E.getItemId(q)];
    }, [E]);
  Qs(s, [h, v, b, o], S({
    isInitialMount: D.current,
    previousResultCount: _.current,
    items: o,
    environment: i,
    itemToString: l
  }, f)), Qs(c, [g], S({
    isInitialMount: D.current,
    previousResultCount: _.current,
    items: o,
    environment: i,
    itemToString: l
  }, f));
  var M = Tx({
    menuElement: y.current,
    highlightedIndex: v,
    isOpen: h,
    itemRefs: w,
    scrollIntoView: a,
    getItemNodeFromIndex: A
  });
  $d({
    isInitialMount: D.current,
    props: t,
    state: f
  }), V(function () {
    var q = n || r || h;
    q && I.current && I.current.focus();
  }, []), V(function () {
    D.current || (_.current = o.length);
  });
  var B = Cx(h, [I, y, P], i, function () {
      m({
        type: Hr,
        selectItem: !1
      });
    }),
    G = xd();
  V(function () {
    return D.current = !1, function () {
      D.current = !0;
    };
  }, []), V(function () {
    var q;
    if (!h) w.current = {};else if (((q = i.document) == null ? void 0 : q.activeElement) !== I.current) {
      var W;
      I == null || (W = I.current) == null || W.focus();
    }
  }, [h, i]);
  var N = Ne(function () {
      return {
        ArrowDown: function ArrowDown(W) {
          W.preventDefault(), m({
            type: xi,
            altKey: W.altKey,
            getItemNodeFromIndex: A
          });
        },
        ArrowUp: function ArrowUp(W) {
          W.preventDefault(), m({
            type: $i,
            altKey: W.altKey,
            getItemNodeFromIndex: A
          });
        },
        Home: function Home(W) {
          O.current.state.isOpen && (W.preventDefault(), m({
            type: Ti,
            getItemNodeFromIndex: A
          }));
        },
        End: function End(W) {
          O.current.state.isOpen && (W.preventDefault(), m({
            type: _i,
            getItemNodeFromIndex: A
          }));
        },
        Escape: function Escape(W) {
          var F = O.current.state;
          (F.isOpen || F.inputValue || F.selectedItem || F.highlightedIndex > -1) && (W.preventDefault(), m({
            type: Ci
          }));
        },
        Enter: function Enter(W) {
          var F = O.current.state;
          !F.isOpen || W.which === 229 || (W.preventDefault(), m({
            type: Di,
            getItemNodeFromIndex: A
          }));
        },
        PageUp: function PageUp(W) {
          O.current.state.isOpen && (W.preventDefault(), m({
            type: Ii,
            getItemNodeFromIndex: A
          }));
        },
        PageDown: function PageDown(W) {
          O.current.state.isOpen && (W.preventDefault(), m({
            type: Pi,
            getItemNodeFromIndex: A
          }));
        }
      };
    }, [m, O, A]),
    j = X(function (q) {
      return S({
        id: E.labelId,
        htmlFor: E.inputId
      }, q);
    }, [E]),
    U = X(function (q, W) {
      var F,
        J = q === void 0 ? {} : q,
        Se = J.onMouseLeave,
        Pe = J.refKey,
        Ae = Pe === void 0 ? "ref" : Pe,
        Le = J.ref,
        ke = zt(J, Ox),
        ze = W === void 0 ? {} : W;
      return ze.suppressRefError, S((F = {}, F[Ae] = ln(Le, function (ye) {
        y.current = ye;
      }), F.id = E.menuId, F.role = "listbox", F["aria-labelledby"] = ke && ke["aria-label"] ? void 0 : "" + E.labelId, F.onMouseLeave = Je(Se, function () {
        m({
          type: Cd
        });
      }), F), ke);
    }, [m, G, E]),
    L = X(function (q) {
      var W,
        F,
        J = q === void 0 ? {} : q,
        Se = J.item,
        Pe = J.index,
        Ae = J.refKey,
        Le = Ae === void 0 ? "ref" : Ae,
        ke = J.ref,
        ze = J.onMouseMove,
        ye = J.onMouseDown,
        Ot = J.onClick;
      J.onPress;
      var vt = J.disabled,
        In = zt(J, Mx),
        Be = O.current,
        vo = Be.props,
        fr = Be.state,
        po = yd(Se, Pe, vo.items, "Pass either item or index to getItemProps!"),
        Mt = po[1],
        mo = "onClick",
        vr = Ot,
        Nt = function Nt() {
          Mt !== fr.highlightedIndex && (M.current = !1, m({
            type: Td,
            index: Mt,
            disabled: vt
          }));
        },
        Yt = function Yt() {
          m({
            type: Oi,
            index: Mt
          });
        },
        kt = function kt(af) {
          return af.preventDefault();
        };
      return S((W = {}, W[Le] = ln(ke, function (wt) {
        wt && (w.current[E.getItemId(Mt)] = wt);
      }), W.disabled = vt, W.role = "option", W["aria-selected"] = "" + (Mt === fr.highlightedIndex), W.id = E.getItemId(Mt), W), !vt && (F = {}, F[mo] = Je(vr, Yt), F), {
        onMouseMove: Je(ze, Nt),
        onMouseDown: Je(ye, kt)
      }, In);
    }, [m, O, M, E]),
    R = X(function (q) {
      var W,
        F = q === void 0 ? {} : q,
        J = F.onClick;
      F.onPress;
      var Se = F.refKey,
        Pe = Se === void 0 ? "ref" : Se,
        Ae = F.ref,
        Le = zt(F, Nx),
        ke = O.current.state,
        ze = function ze() {
          m({
            type: _d
          });
        };
      return S((W = {}, W[Pe] = ln(Ae, function (ye) {
        P.current = ye;
      }), W["aria-controls"] = E.menuId, W["aria-expanded"] = ke.isOpen, W.id = E.toggleButtonId, W.tabIndex = -1, W), !Le.disabled && S({}, {
        onClick: Je(J, ze)
      }), Le);
    }, [m, O, E]),
    Y = X(function (q, W) {
      var F,
        J = q === void 0 ? {} : q,
        Se = J.onKeyDown,
        Pe = J.onChange,
        Ae = J.onInput,
        Le = J.onFocus,
        ke = J.onBlur;
      J.onChangeText;
      var ze = J.refKey,
        ye = ze === void 0 ? "ref" : ze,
        Ot = J.ref,
        vt = zt(J, kx),
        In = W === void 0 ? {} : W;
      In.suppressRefError;
      var Be = O.current.state,
        vo = function vo(kt) {
          var wt = sa(kt);
          wt && N[wt] && N[wt](kt);
        },
        fr = function fr(kt) {
          m({
            type: Si,
            inputValue: kt.target.value
          });
        },
        po = function po(kt) {
          Be.isOpen && !B.current.isMouseDown && m({
            type: Hr,
            selectItem: kt.relatedTarget !== null
          });
        },
        Mt = function Mt() {
          Be.isOpen || m({
            type: Ei
          });
        },
        mo = "onChange",
        vr = {};
      if (!vt.disabled) {
        var Nt;
        vr = (Nt = {}, Nt[mo] = Je(Pe, Ae, fr), Nt.onKeyDown = Je(Se, vo), Nt.onBlur = Je(ke, po), Nt.onFocus = Je(Le, Mt), Nt);
      }
      return S((F = {}, F[ye] = ln(Ot, function (Yt) {
        I.current = Yt;
      }), F["aria-activedescendant"] = Be.isOpen && Be.highlightedIndex > -1 ? E.getItemId(Be.highlightedIndex) : "", F["aria-autocomplete"] = "list", F["aria-controls"] = E.menuId, F["aria-expanded"] = Be.isOpen, F["aria-labelledby"] = vt && vt["aria-label"] ? void 0 : "" + E.labelId, F.autoComplete = "off", F.id = E.inputId, F.role = "combobox", F.value = Be.inputValue, F), vr, vt);
    }, [m, N, O, B, G, E]),
    re = X(function () {
      m({
        type: Id
      });
    }, [m]),
    ae = X(function () {
      m({
        type: Dd
      });
    }, [m]),
    se = X(function () {
      m({
        type: Pd
      });
    }, [m]),
    le = X(function (q) {
      m({
        type: Sd,
        highlightedIndex: q
      });
    }, [m]),
    fe = X(function (q) {
      m({
        type: Mi,
        selectedItem: q
      });
    }, [m]),
    xe = X(function (q) {
      m({
        type: Ed,
        inputValue: q
      });
    }, [m]),
    be = X(function () {
      m({
        type: Od
      });
    }, [m]);
  return {
    // prop getters.
    getItemProps: L,
    getLabelProps: j,
    getMenuProps: U,
    getInputProps: Y,
    getToggleButtonProps: R,
    // actions.
    toggleMenu: re,
    openMenu: se,
    closeMenu: ae,
    setHighlightedIndex: le,
    setInputValue: xe,
    selectItem: fe,
    reset: be,
    // state.
    highlightedIndex: v,
    isOpen: h,
    selectedItem: g,
    inputValue: b
  };
}
var Nd = {
  activeIndex: -1,
  selectedItems: []
};
function Js(e, t) {
  return En(e, t, Nd);
}
function ec(e, t) {
  return ot(e, t, Nd);
}
function Rx(e) {
  var t = Js(e, "activeIndex"),
    n = Js(e, "selectedItems");
  return {
    activeIndex: t,
    selectedItems: n
  };
}
function tc(e) {
  if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) return !1;
  var t = e.target;
  return !(t instanceof HTMLInputElement &&
  // if element is a text input
  t.value !== "" && (
  // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  t.selectionStart !== 0 || t.selectionEnd !== 0));
}
function Ax(e) {
  var t = e.removedSelectedItem,
    n = e.itemToString;
  return n(t) + " has been removed.";
}
H.array, H.array, H.array, H.func, H.func, H.func, H.number, H.number, H.number, H.func, H.func, H.string, H.string, H.shape({
  addEventListener: H.func,
  removeEventListener: H.func,
  document: H.shape({
    getElementById: H.func,
    activeElement: H.any,
    body: H.any
  })
});
var Lx = {
    itemToString: Mn.itemToString,
    stateReducer: Mn.stateReducer,
    environment: Mn.environment,
    getA11yRemovalMessage: Ax,
    keyNavigationNext: "ArrowRight",
    keyNavigationPrevious: "ArrowLeft"
  },
  jx = bi,
  ki = 0,
  Ri = 1,
  Ai = 2,
  Li = 3,
  ji = 4,
  Fi = 5,
  Wi = 6,
  Hi = 7,
  Bi = 8,
  Vi = 9,
  Ui = 10,
  Yi = 11,
  Ki = 12,
  Fx = /* @__PURE__ */Object.freeze({
    __proto__: null,
    SelectedItemClick: ki,
    SelectedItemKeyDownDelete: Ri,
    SelectedItemKeyDownBackspace: Ai,
    SelectedItemKeyDownNavigationNext: Li,
    SelectedItemKeyDownNavigationPrevious: ji,
    DropdownKeyDownNavigationPrevious: Fi,
    DropdownKeyDownBackspace: Wi,
    DropdownClick: Hi,
    FunctionAddSelectedItem: Bi,
    FunctionRemoveSelectedItem: Vi,
    FunctionSetSelectedItems: Ui,
    FunctionSetActiveIndex: Yi,
    FunctionReset: Ki
  });
function Wx(e, t) {
  var n = t.type,
    r = t.index,
    o = t.props,
    a = t.selectedItem,
    i = e.activeIndex,
    s = e.selectedItems,
    c;
  switch (n) {
    case ki:
      c = {
        activeIndex: r
      };
      break;
    case ji:
      c = {
        activeIndex: i - 1 < 0 ? 0 : i - 1
      };
      break;
    case Li:
      c = {
        activeIndex: i + 1 >= s.length ? -1 : i + 1
      };
      break;
    case Ai:
    case Ri:
      {
        if (i < 0) break;
        var l = i;
        s.length === 1 ? l = -1 : i === s.length - 1 && (l = s.length - 2), c = S({
          selectedItems: [].concat(s.slice(0, i), s.slice(i + 1))
        }, {
          activeIndex: l
        });
        break;
      }
    case Fi:
      c = {
        activeIndex: s.length - 1
      };
      break;
    case Wi:
      c = {
        selectedItems: s.slice(0, s.length - 1)
      };
      break;
    case Bi:
      c = {
        selectedItems: [].concat(s, [a])
      };
      break;
    case Hi:
      c = {
        activeIndex: -1
      };
      break;
    case Vi:
      {
        var u = i,
          d = s.indexOf(a);
        if (d < 0) break;
        s.length === 1 ? u = -1 : d === s.length - 1 && (u = s.length - 2), c = {
          selectedItems: [].concat(s.slice(0, d), s.slice(d + 1)),
          activeIndex: u
        };
        break;
      }
    case Ui:
      {
        var f = t.selectedItems;
        c = {
          selectedItems: f
        };
        break;
      }
    case Yi:
      {
        var m = t.activeIndex;
        c = {
          activeIndex: m
        };
        break;
      }
    case Ki:
      c = {
        activeIndex: ec(o, "activeIndex"),
        selectedItems: ec(o, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return S({}, e, c);
}
var Hx = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"],
  Bx = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
cn.stateChangeTypes = Fx;
function cn(e) {
  e === void 0 && (e = {}), jx();
  var t = S({}, Lx, e),
    n = t.getA11yRemovalMessage,
    r = t.itemToString,
    o = t.environment,
    a = t.keyNavigationNext,
    i = t.keyNavigationPrevious,
    s = xx(Wx, Rx(t), t),
    c = s[0],
    l = s[1],
    u = c.activeIndex,
    d = c.selectedItems,
    f = k(!0),
    m = k(null),
    h = k(d),
    v = k();
  v.current = [];
  var g = wi({
    state: c,
    props: t
  });
  V(function () {
    if (!f.current) {
      if (d.length < h.current.length) {
        var M = h.current.find(function (B) {
          return d.indexOf(B) < 0;
        });
        hd(n({
          itemToString: r,
          resultCount: d.length,
          removedSelectedItem: M,
          activeIndex: u,
          activeSelectedItem: d[u]
        }), o.document);
      }
      h.current = d;
    }
  }, [d.length]), V(function () {
    f.current || (u === -1 && m.current ? m.current.focus() : v.current[u] && v.current[u].focus());
  }, [u]), $d({
    isInitialMount: f.current,
    props: t,
    state: c
  });
  var b = xd();
  V(function () {
    return f.current = !1, function () {
      f.current = !0;
    };
  }, []);
  var y = Ne(function () {
      var M;
      return M = {}, M[i] = function () {
        l({
          type: ji
        });
      }, M[a] = function () {
        l({
          type: Li
        });
      }, M.Delete = function () {
        l({
          type: Ri
        });
      }, M.Backspace = function () {
        l({
          type: Ai
        });
      }, M;
    }, [l, a, i]),
    w = Ne(function () {
      var M;
      return M = {}, M[i] = function (B) {
        tc(B) && l({
          type: Fi
        });
      }, M.Backspace = function (G) {
        tc(G) && l({
          type: Wi
        });
      }, M;
    }, [l, i]),
    I = X(function (M) {
      var B,
        G = M === void 0 ? {} : M,
        N = G.refKey,
        j = N === void 0 ? "ref" : N,
        U = G.ref,
        L = G.onClick,
        R = G.onKeyDown,
        Y = G.selectedItem,
        re = G.index,
        ae = zt(G, Hx),
        se = g.current.state,
        le = yd(Y, re, se.selectedItems, "Pass either item or index to getSelectedItemProps!"),
        fe = le[1],
        xe = fe > -1 && fe === se.activeIndex,
        be = function be() {
          l({
            type: ki,
            index: fe
          });
        },
        q = function q(F) {
          var J = sa(F);
          J && y[J] && y[J](F);
        };
      return S((B = {}, B[j] = ln(U, function (W) {
        W && v.current.push(W);
      }), B.tabIndex = xe ? 0 : -1, B.onClick = Je(L, be), B.onKeyDown = Je(R, q), B), ae);
    }, [l, g, y]),
    P = X(function (M, B) {
      var G,
        N = M === void 0 ? {} : M,
        j = N.refKey,
        U = j === void 0 ? "ref" : j,
        L = N.ref,
        R = N.onKeyDown,
        Y = N.onClick,
        re = N.preventKeyAction,
        ae = re === void 0 ? !1 : re,
        se = zt(N, Bx),
        le = B === void 0 ? {} : B;
      le.suppressRefError;
      var fe = function fe(q) {
          var W = sa(q);
          W && w[W] && w[W](q);
        },
        xe = function xe() {
          l({
            type: Hi
          });
        };
      return S((G = {}, G[U] = ln(L, function (be) {
        be && (m.current = be);
      }), G), !ae && {
        onKeyDown: Je(R, fe),
        onClick: Je(Y, xe)
      }, se);
    }, [l, w, b]),
    D = X(function (M) {
      l({
        type: Bi,
        selectedItem: M
      });
    }, [l]),
    E = X(function (M) {
      l({
        type: Vi,
        selectedItem: M
      });
    }, [l]),
    _ = X(function (M) {
      l({
        type: Ui,
        selectedItems: M
      });
    }, [l]),
    O = X(function (M) {
      l({
        type: Yi,
        activeIndex: M
      });
    }, [l]),
    A = X(function () {
      l({
        type: Ki
      });
    }, [l]);
  return {
    getSelectedItemProps: I,
    getDropdownProps: P,
    addSelectedItem: D,
    removeSelectedItem: E,
    setSelectedItems: _,
    setActiveIndex: O,
    reset: A,
    selectedItems: d,
    activeIndex: u
  };
}
function Vx(_ref173) {
  var _t$selectedItems;
  var e = _ref173.children;
  var t = Et(),
    n = (_t$selectedItems = t.selectedItems) !== null && _t$selectedItems !== void 0 ? _t$selectedItems : [],
    _cn = cn({
      selectedItems: n,
      onStateChange: function onStateChange(_ref174) {
        var i = _ref174.selectedItems,
          s = _ref174.type;
        switch (s) {
          case cn.stateChangeTypes.SelectedItemKeyDownBackspace:
          case cn.stateChangeTypes.SelectedItemKeyDownDelete:
          case cn.stateChangeTypes.DropdownKeyDownBackspace:
          case cn.stateChangeTypes.FunctionRemoveSelectedItem:
            t.setSelectedItems(i);
            break;
        }
      }
    }),
    r = _cn.getSelectedItemProps,
    o = _cn.removeSelectedItem,
    a = _cn.getDropdownProps;
  return /* @__PURE__ */p.jsx(od.Provider, {
    value: {
      getSelectedItemProps: r,
      removeSelectedItem: o,
      getDropdownProps: a
    },
    children: e
  });
}
var Ux = [" ", "Enter", "ArrowUp", "ArrowDown"],
  Yx = x(function (_ref175, a) {
    var _i$selectedItems;
    var _ref175$size = _ref175.size,
      t = _ref175$size === void 0 ? "medium" : _ref175$size,
      n = _ref175.className,
      r = _ref175.placeholder,
      o = _objectWithoutProperties(_ref175, _excluded167);
    var i = Et(),
      s = ad(),
      _ao3 = ao(),
      c = _ao3.triggerRef,
      l = _ao3.setTriggerRef,
      u = (_i$selectedItems = i.selectedItems) !== null && _i$selectedItems !== void 0 ? _i$selectedItems : [],
      d = u.length > 0,
      f = dt();
    if (!s) throw new Error("SelectWithTagsTrigger must be used inside SelectTagContext");
    var m = s.getSelectedItemProps,
      h = s.removeSelectedItem;
    return /* @__PURE__ */p.jsxs(Zr, _objectSpread(_objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Select", "goat-SelectWithTags", "goat-Select_".concat(t), {
        "goat-SelectWithTags_WithTagsInside": d,
        "goat-Select_placeholder": !d,
        "goat-active": i.isOpen,
        "goat-invalid": f.touched && f.validity.valid === !1,
        "goat-disabled": i.disabled
      }, n)
    }, i.getToggleButtonProps({
      ref: _a(a, l),
      tabIndex: i.disabled ? -1 : 0,
      disabled: i.disabled,
      onKeyDown: function onKeyDown(v) {
        Ux.includes(v.key) && !i.isOpen && c && c === v.target && (i.openMenu(), v.preventDefault());
      }
    })), {}, {
      children: [d ? /* @__PURE__ */p.jsx("div", {
        className: "goat-SelectWithTags_Tags",
        children: u.map(function (g, b) {
          var y;
          return /* @__PURE__ */p.jsx(Wt, {
            children: (y = i.renderTag) == null ? void 0 : y.call(i, function () {
              return m({
                selectedItem: g,
                index: b,
                disabled: i.disabled,
                tabIndex: i.disabled ? -1 : 0
              });
            }, function (w) {
              w.stopPropagation(), h(g);
            }, g)
          }, "selected-item-".concat(b));
        })
      }) : /* @__PURE__ */p.jsx("span", {
        children: r
      }), /* @__PURE__ */p.jsx(je, {
        as: Br,
        size: t
      })]
    }));
  });
function Kx() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var n = arguments.length > 2 ? arguments[2] : undefined;
  var r = arguments.length > 3 ? arguments[3] : undefined;
  var o = arguments.length > 4 ? arguments[4] : undefined;
  if (t) {
    var s = (r == null ? void 0 : r.length) === 0;
    return {
      labelNode: s ? e : "".concat(o(r[0])).concat(r.length > 1 ? " (+".concat(r.length - 1, ")") : ""),
      isPlaceHolder: s
    };
  }
  var a = n === null;
  return {
    labelNode: a ? e : o(n),
    isPlaceHolder: a
  };
}
var Gx = [" ", "Enter", "ArrowUp", "ArrowDown"],
  zx = x(function (_ref176, i) {
    var _s$selectedItems;
    var t = _ref176.className,
      n = _ref176.placeholder,
      _ref176$size = _ref176.size,
      r = _ref176$size === void 0 ? "medium" : _ref176$size,
      _ref176$type = _ref176.type,
      o = _ref176$type === void 0 ? "button" : _ref176$type,
      a = _objectWithoutProperties(_ref176, _excluded168);
    var s = Et(),
      _ao4 = ao(),
      c = _ao4.setTriggerRef,
      l = (_s$selectedItems = s.selectedItems) !== null && _s$selectedItems !== void 0 ? _s$selectedItems : [],
      _Kx = Kx(n, s.multiple, s.selectedItem, l, s.labelToNode),
      u = _Kx.isPlaceHolder,
      d = _Kx.labelNode,
      f = dt();
    return /* @__PURE__ */p.jsx(Zr, _objectSpread(_objectSpread(_objectSpread({}, a), {}, {
      type: o,
      asChild: !0,
      className: T("goat-Select", "goat-Select_".concat(r), {
        "goat-active": s.isOpen,
        "goat-invalid": f.touched && f.validity.valid === !1,
        "goat-Select_placeholder": u
      }, t)
    }, s.getToggleButtonProps({
      ref: _a(i, c),
      disabled: s.disabled,
      tabIndex: 0,
      onKeyDown: function onKeyDown(m) {
        Gx.includes(m.key) && !s.isOpen && (s.openMenu(), m.preventDefault());
      }
    })), {}, {
      children: /* @__PURE__ */p.jsxs("button", {
        children: [d, /* @__PURE__ */p.jsx(je, {
          as: Br,
          size: r,
          className: "goat-Select_Chevron"
        })]
      })
    }));
  });
function qx(e, t) {
  var n = t.changes,
    r = t.type;
  switch (r) {
    case Ue.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return _objectSpread(_objectSpread({}, n), {}, {
        inputValue: e.inputValue
      });
    case Ue.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, n), {}, {
        inputValue: e.inputValue,
        isOpen: !0
        // keep menu open after selection.
      });

    case Ue.stateChangeTypes.InputKeyDownEnter:
      return _objectSpread(_objectSpread({}, n), {}, {
        isOpen: !0,
        // keep menu open after selection.
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      });
    case Ue.stateChangeTypes.InputBlur:
      return _objectSpread(_objectSpread({}, n), {}, {
        selectedItem: null,
        inputValue: ""
      });
    default:
      return n;
  }
}
function Xx(e, t) {
  var n = t.changes,
    r = t.type;
  switch (r) {
    case Ue.stateChangeTypes.InputBlur:
    case Ue.stateChangeTypes.ControlledPropUpdatedSelectedItem:
    case Ue.stateChangeTypes.InputKeyDownEnter:
    case Ue.stateChangeTypes.InputKeyDownEscape:
    case Ue.stateChangeTypes.ToggleButtonClick:
    case Ue.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, n), {}, {
        inputValue: ""
      });
    default:
      return n;
  }
}
function Qx(e, t) {
  var n = [];
  for (var r = 0; r < e.length; r++) n.push(t(e[r]));
  return n.join(",");
}
function Zx(_ref177, o) {
  var e = _ref177.valueToString,
    t = _ref177.options,
    n = _ref177.searchFilter,
    r = _objectWithoutProperties(_ref177, _excluded169);
  var _rs = rs({
      defaultProp: "",
      onChange: r.onInputChange,
      prop: r.inputValue
    }),
    _rs2 = _slicedToArray(_rs, 2),
    a = _rs2[0],
    i = _rs2[1],
    _rs3 = rs({
      defaultProp: r.defaultValue && Array.isArray(r.defaultValue) ? r.defaultValue : [],
      prop: Array.isArray(r.value) ? r.value : void 0,
      onChange: Array.isArray(r.value) ? r.onChange : void 0
    }),
    _rs4 = _slicedToArray(_rs3, 2),
    s = _rs4[0],
    c = _rs4[1],
    l = Qx(t, e),
    u = Ne(function () {
      return n ? t.filter(function (f) {
        return !a || n(f, a);
      }) : t;
    }, [l, a]);
  return {
    downshift: Ue({
      items: u,
      itemToString: e,
      defaultSelectedItem: r.multiple || Array.isArray(r.defaultValue) ? null : r.defaultValue,
      selectedItem: r.multiple || Array.isArray(r.value) ? null : r.value,
      stateReducer: r.multiple ? qx : Xx,
      onInputValueChange: function onInputValueChange(_ref178) {
        var _ref178$inputValue = _ref178.inputValue,
          f = _ref178$inputValue === void 0 ? "" : _ref178$inputValue;
        i(f);
      },
      onIsOpenChange: function onIsOpenChange(f) {
        !f.isOpen && [Ue.stateChangeTypes.InputKeyDownEnter, Ue.stateChangeTypes.InputKeyDownEscape, Ue.stateChangeTypes.FunctionCloseMenu].includes(f.type) && o && o.focus();
      },
      onSelectedItemChange: function onSelectedItemChange(_ref179) {
        var f = _ref179.selectedItem;
        var m;
        if (r.multiple) {
          if (!f || !s) return;
          var h = s.findIndex(function (g) {
            return e(g) === e(f);
          });
          var v = [];
          h > 0 ? v = [].concat(_toConsumableArray(s.slice(0, h)), _toConsumableArray(s.slice(h + 1))) : h === 0 ? v = s.slice(1) : v = [].concat(_toConsumableArray(s), [f]), c(v);
        } else {
          (m = r.onChange) == null || m.call(r, f);
          return;
        }
      }
    }),
    filteredItems: u,
    selectedItems: s,
    setSelectedItems: c
  };
}
var Jx = function Jx(_ref180) {
  var e = _ref180.className,
    t = _ref180.noHover,
    n = _ref180.children,
    r = _objectWithoutProperties(_ref180, _excluded170);
  return Et().isOpen ? /* @__PURE__ */p.jsx(Tn, _objectSpread(_objectSpread({}, r), {}, {
    as: "div",
    className: T(e, "goat-SelectDummyItem", {
      "goat-SelectDummyItem__noHover": t
    }),
    children: n
  })) : null;
};
function rt(_ref181) {
  var e = _ref181.children,
    t = _ref181.disabled,
    n = _ref181.labelToNode,
    r = _ref181.renderTag,
    o = _objectWithoutProperties(_ref181, _excluded171);
  var _te67 = te(null),
    _te68 = _slicedToArray(_te67, 2),
    a = _te68[0],
    i = _te68[1],
    _te69 = te(null),
    _te70 = _slicedToArray(_te69, 2),
    s = _te70[0],
    c = _te70[1],
    _Zx = Zx(o, s),
    l = _Zx.downshift,
    u = _Zx.filteredItems,
    d = _Zx.selectedItems,
    f = _Zx.setSelectedItems;
  return /* @__PURE__ */p.jsx(Ul, {
    children: /* @__PURE__ */p.jsx(rd.Provider, {
      value: {
        inputRef: a,
        triggerRef: s,
        setTriggerRef: c,
        setInputRef: i
      },
      children: /* @__PURE__ */p.jsx(nd.Provider, {
        value: _objectSpread(_objectSpread({}, l), {}, {
          selectedItems: d,
          setSelectedItems: f,
          isSearchable: !!o.searchFilter,
          renderTag: r,
          itemToString: o.valueToString,
          filteredItems: u,
          items: o.options,
          disabled: !!t,
          multiple: !!o.multiple,
          labelToNode: n
        }),
        children: e
      })
    })
  });
}
rt.displayName = "Select";
rt.Trigger = zx;
rt.Content = A1;
rt.CustomTrigger = L1;
rt.Input = j1;
rt.Label = F1;
rt.List = H1;
rt.Search = V1;
rt.TagContext = Vx;
rt.TagsTrigger = Yx;
rt.Layout = W1;
rt.DummyItem = Jx;
var e$ = x(function (_ref182, a) {
    var _ref182$as = _ref182.as,
      t = _ref182$as === void 0 ? "div" : _ref182$as,
      n = _ref182.children,
      r = _ref182.className,
      o = _objectWithoutProperties(_ref182, _excluded172);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
      className: T("goat-Sidebar__Content", r),
      ref: a,
      children: n
    }));
  }),
  kd = he({
    floating: !1,
    sidebarRef: null
  }),
  Gi = function Gi() {
    var e = ce(kd);
    if (e === void 0) throw new Error("useSidebarContext must be used within a SidebarContext");
    return e;
  },
  Rd = he(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function () {}),
  t$ = function t$() {
    var e = ce(Rd);
    if (e === void 0) throw new Error("useSidebarContextSetFloating must be used within a SidebarContextSetFloating");
    return e;
  },
  Ad = he(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function () {}),
  n$ = function n$() {
    var e = ce(Ad);
    if (e === void 0) throw new Error("useSidebarContextSetOpen must be used within a SidebarContextSetRef");
    return e;
  },
  Ld = he(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function () {}),
  r$ = function r$() {
    var e = ce(Ld);
    if (e === void 0) throw new Error("useSidebarContextFocusWithin must be used within a SidebarContextFocusWithin");
    return e;
  },
  o$ = x(function (_ref183, i) {
    var _ref183$as = _ref183.as,
      t = _ref183$as === void 0 ? "div" : _ref183$as,
      n = _ref183.children,
      r = _ref183.className,
      o = _ref183.label,
      a = _objectWithoutProperties(_ref183, _excluded173);
    return /* @__PURE__ */p.jsxs(t, _objectSpread(_objectSpread({}, a), {}, {
      className: T("goat-Sidebar__Group", r),
      ref: i,
      children: [o && /* @__PURE__ */p.jsx("div", {
        className: "goat-Sidebar__GroupLabel",
        children: o
      }), /* @__PURE__ */p.jsx("div", {
        className: "goat-Sidebar__List",
        children: n
      })]
    }));
  }),
  a$ = x(function (_ref184, o) {
    var _ref184$as = _ref184.as,
      t = _ref184$as === void 0 ? "div" : _ref184$as,
      n = _ref184.className,
      r = _objectWithoutProperties(_ref184, _excluded174);
    return /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-Sidebar__Header", n),
      ref: o
    }));
  }),
  i$ = x(function (_ref185, c) {
    var t = _ref185.active,
      _ref185$as = _ref185.as,
      n = _ref185$as === void 0 ? "a" : _ref185$as,
      r = _ref185.className,
      o = _ref185.children,
      a = _ref185.disabled,
      i = _ref185.href,
      s = _objectWithoutProperties(_ref185, _excluded175);
    return /* @__PURE__ */p.jsx(n, _objectSpread(_objectSpread({}, s), {}, {
      className: T("goat-Sidebar__Item", {
        "goat-active": t
      }, {
        "goat-disabled": a
      }, r),
      href: a ? void 0 : i,
      ref: c,
      children: o
    }));
  }),
  s$ = x(function (_ref186, i) {
    var t = _ref186.className,
      n = _ref186.onClick,
      r = _ref186.ariaLabelFloating,
      o = _ref186.ariaLabelLocked,
      a = _objectWithoutProperties(_ref186, _excluded176);
    var s = Gi(),
      c = t$(),
      l = function l(u) {
        n == null || n(u), c(!s.floating), u.detail && (u.currentTarget.focus(), u.currentTarget.blur());
      };
    return /* @__PURE__ */p.jsx(Qe, _objectSpread(_objectSpread({}, a), {}, {
      "aria-label": s.floating ? r : o,
      className: T("goat-Sidebar__Lock", t),
      icon: bf,
      onClick: l,
      ref: i
    }));
  }),
  c$ = x(function (_ref187, l) {
    var _ref187$as = _ref187.as,
      t = _ref187$as === void 0 ? "button" : _ref187$as,
      n = _ref187.avatar,
      r = _ref187.avatarBgColor,
      o = _ref187.children,
      a = _ref187.className,
      i = _ref187.company,
      s = _ref187.name,
      c = _objectWithoutProperties(_ref187, _excluded177);
    return /* @__PURE__ */p.jsxs(t, _objectSpread(_objectSpread({}, c), {}, {
      className: T("goat-Sidebar__Profile", a),
      ref: l,
      children: [/* @__PURE__ */p.jsxs("div", {
        className: "goat-Sidebar__User",
        children: [/* @__PURE__ */p.jsx("div", {
          className: "goat-Sidebar__Avatar",
          style: {
            backgroundColor: r
          },
          children: n
        }), /* @__PURE__ */p.jsxs("div", {
          className: "goat-Sidebar__UserInfo",
          children: [/* @__PURE__ */p.jsx("div", {
            children: s
          }), /* @__PURE__ */p.jsx("div", {
            children: i
          })]
        })]
      }), /* @__PURE__ */p.jsx("div", {
        className: "goat-Sidebar__ProfileList",
        children: o
      })]
    }));
  }),
  l$ = x(function (_ref188, o) {
    var _ref188$as = _ref188.as,
      t = _ref188$as === void 0 ? "nav" : _ref188$as,
      n = _ref188.className,
      r = _objectWithoutProperties(_ref188, _excluded178);
    var _te71 = te(null),
      _te72 = _slicedToArray(_te71, 2),
      a = _te72[0],
      i = _te72[1],
      s = Gi(),
      c = Kr(i, o),
      l = n$();
    return V(function () {
      l(a);
    }, [a, l]), /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-Sidebar", {
        "goat-Sidebar_floating": s.floating
      }, n),
      tabIndex: -1,
      ref: c
    }));
  }),
  u$ = x(function (_ref189, i) {
    var _ref189$as = _ref189.as,
      t = _ref189$as === void 0 ? Qe : _ref189$as,
      _ref189$icon = _ref189.icon,
      n = _ref189$icon === void 0 ? yf : _ref189$icon,
      r = _ref189.alwaysShow,
      o = _ref189.onClick,
      a = _objectWithoutProperties(_ref189, _excluded179);
    var s = Gi(),
      c = r$(),
      l = function l(u) {
        o == null || o(u), c == null || c();
      };
    return s.floating || r ? /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, a), {}, {
      icon: n,
      onClick: l,
      ref: i
    })) : null;
  });
var Ut = function Ut(_ref190) {
  var e = _ref190.children,
    t = _ref190.floating,
    n = _ref190.onFloatingChange;
  var _te73 = te(!1),
    _te74 = _slicedToArray(_te73, 2),
    r = _te74[0],
    o = _te74[1],
    _te75 = te(null),
    _te76 = _slicedToArray(_te75, 2),
    a = _te76[0],
    i = _te76[1];
  V(function () {
    t !== void 0 && t !== r && o(t);
  }, [r, t]);
  var s = X(function (l) {
      n ? n(l) : o(l);
    }, [n]),
    c = X(function () {
      a && a.focus();
    }, [a]);
  return /* @__PURE__ */p.jsx(Rd.Provider, {
    value: s,
    children: /* @__PURE__ */p.jsx(Ad.Provider, {
      value: i,
      children: /* @__PURE__ */p.jsx(Ld.Provider, {
        value: c,
        children: /* @__PURE__ */p.jsx(kd.Provider, {
          value: {
            sidebarRef: a,
            floating: r
          },
          children: e
        })
      })
    })
  });
};
Ut.Content = e$;
Ut.Group = o$;
Ut.Header = a$;
Ut.Item = i$;
Ut.Lock = s$;
Ut.Profile = c$;
Ut.Root = l$;
Ut.Trigger = u$;
var x_ = x(function (_ref191, s) {
  var t = _ref191.children,
    n = _ref191.size,
    r = _ref191.center,
    o = _ref191.className,
    a = _ref191.style,
    i = _objectWithoutProperties(_ref191, _excluded180);
  var c = T({
    "goat-Square_center": r
  }, o);
  return /* @__PURE__ */p.jsx(Sa, _objectSpread(_objectSpread({
    className: c
  }, i), {}, {
    width: n,
    height: n,
    style: r ? _objectSpread(_objectSpread({}, a), {}, {
      display: "flex"
    }) : a,
    ref: s,
    children: t
  }));
});
var d$ = x(function (_ref192, a) {
  var t = _ref192.children,
    n = _ref192.className,
    _ref192$sentiment = _ref192.sentiment,
    r = _ref192$sentiment === void 0 ? "neutral" : _ref192$sentiment,
    o = _objectWithoutProperties(_ref192, _excluded181);
  return /* @__PURE__ */p.jsxs(vn, _objectSpread(_objectSpread({}, o), {}, {
    color: "gray",
    variant: "contained",
    className: T("goat-StatusTag", "goat-StatusTag_".concat(r), n),
    ref: a,
    children: [/* @__PURE__ */p.jsx(Vc, {
      contrast: r === "neutral" ? "low" : "high",
      sentiment: r
    }), t]
  }));
});
d$.Remove = Ea;
var f$ = function f$(_ref193) {
    var e = _ref193.children,
      t = _ref193.className,
      _ref193$columnSpan = _ref193.columnSpan,
      n = _ref193$columnSpan === void 0 ? "auto" : _ref193$columnSpan,
      r = _objectWithoutProperties(_ref193, _excluded182);
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-SummaryCell", t),
      style: _objectSpread(_objectSpread({}, r.style), {}, {
        "--goat-summary-column-end": typeof n == "number" ? "span ".concat(n) : n
      }),
      children: e
    }));
  },
  v$ = function v$(_ref194) {
    var e = _ref194.children,
      t = _ref194.className,
      n = _objectWithoutProperties(_ref194, _excluded183);
    return /* @__PURE__ */p.jsx("dd", _objectSpread(_objectSpread({}, n), {}, {
      className: T("goat-SummaryValue", t),
      children: e
    }));
  },
  p$ = function p$(_ref195) {
    var e = _ref195.children,
      t = _ref195.className,
      n = _objectWithoutProperties(_ref195, _excluded184);
    return /* @__PURE__ */p.jsx("dt", _objectSpread(_objectSpread({}, n), {}, {
      className: T("goat-SummaryTitle", t),
      children: e
    }));
  };
var zi = x(function (_ref196, u) {
  var t = _ref196.children,
    n = _ref196.className,
    _ref196$gap = _ref196.gap,
    r = _ref196$gap === void 0 ? Wc(6) : _ref196$gap,
    _ref196$columns = _ref196.columns,
    o = _ref196$columns === void 0 ? 8 : _ref196$columns,
    _ref196$minWidth = _ref196.minWidth,
    a = _ref196$minWidth === void 0 ? "80px" : _ref196$minWidth,
    _ref196$vertical = _ref196.vertical,
    i = _ref196$vertical === void 0 ? !1 : _ref196$vertical,
    _ref196$list = _ref196.list,
    s = _ref196$list === void 0 ? !1 : _ref196$list,
    _ref196$noBorder = _ref196.noBorder,
    c = _ref196$noBorder === void 0 ? !1 : _ref196$noBorder,
    l = _objectWithoutProperties(_ref196, _excluded185);
  return /* @__PURE__ */p.jsx("dl", _objectSpread(_objectSpread({}, l), {}, {
    className: T("goat-SummaryCard", {
      "goat-SummaryCard_vertical": i
    }, {
      "goat-SummaryCard_list": s
    }, {
      "goat-SummaryCard_noBorder": c
    }, n),
    style: _objectSpread(_objectSpread({}, l.style), {}, {
      "--goat-summary-layout-gap": r,
      "--goat-summary-column-count": o,
      "--goat-summary-item--min-width": a
    }),
    ref: u,
    children: t
  }));
});
zi.Title = p$;
zi.Cell = f$;
zi.Description = v$;
var m$ = function m$(_ref197) {
    var e = _ref197.children,
      t = _objectWithoutProperties(_ref197, _excluded186);
    return /* @__PURE__ */p.jsx(Kn.Content, _objectSpread(_objectSpread({}, t), {}, {
      children: e
    }));
  },
  h$ = function h$(_ref198) {
    var e = _ref198.children,
      _ref198$triggerProps = _ref198.triggerProps,
      t = _ref198$triggerProps === void 0 ? {} : _ref198$triggerProps;
    return /* @__PURE__ */p.jsxs(p.Fragment, {
      children: [e, /* @__PURE__ */p.jsx("div", {
        className: "goat-SummaryCardCollapsibleToggle",
        children: /* @__PURE__ */p.jsx(Kn.Trigger, _objectSpread(_objectSpread({
          variant: "ghost"
        }, t), {}, {
          children: /* @__PURE__ */p.jsx(je, {
            as: Br
          })
        }))
      })]
    });
  },
  jd = function jd(_ref199) {
    var e = _ref199.children,
      t = _objectWithoutProperties(_ref199, _excluded187);
    return /* @__PURE__ */p.jsx(Kn, _objectSpread(_objectSpread({}, t), {}, {
      children: /* @__PURE__ */p.jsx("div", {
        className: "goat-SummaryCardCollapsible",
        children: e
      })
    }));
  };
jd.Collapsed = m$;
jd.Visible = h$;
function g$(e) {
  var t = k({
    value: e,
    previous: e
  });
  return Ne(function () {
    return t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous;
  }, [e]);
}
var Fd = "Switch",
  _Ke23 = Ke(Fd),
  _Ke24 = _slicedToArray(_Ke23, 2),
  b$ = _Ke24[0],
  $_ = _Ke24[1],
  _b$ = b$(Fd),
  _b$2 = _slicedToArray(_b$, 2),
  y$ = _b$2[0],
  w$ = _b$2[1],
  x$ = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeSwitch,
      r = e.name,
      o = e.checked,
      a = e.defaultChecked,
      i = e.required,
      s = e.disabled,
      _e$value = e.value,
      c = _e$value === void 0 ? "on" : _e$value,
      l = e.onCheckedChange,
      u = _objectWithoutProperties(e, _excluded188),
      _te77 = te(null),
      _te78 = _slicedToArray(_te77, 2),
      d = _te78[0],
      f = _te78[1],
      m = Ce(t, function (y) {
        return f(y);
      }),
      h = k(!1),
      v = d ? !!d.closest("form") : !0,
      _Ze21 = Ze({
        prop: o,
        defaultProp: a,
        onChange: l
      }),
      _Ze22 = _slicedToArray(_Ze21, 2),
      _Ze22$ = _Ze22[0],
      g = _Ze22$ === void 0 ? !1 : _Ze22$,
      b = _Ze22[1];
    return /* @__PURE__ */C(y$, {
      scope: n,
      checked: g,
      disabled: s
    }, /* @__PURE__ */C(ie.button, S({
      type: "button",
      role: "switch",
      "aria-checked": g,
      "aria-required": i,
      "data-state": Wd(g),
      "data-disabled": s ? "" : void 0,
      disabled: s,
      value: c
    }, u, {
      ref: m,
      onClick: Z(e.onClick, function (y) {
        b(function (w) {
          return !w;
        }), v && (h.current = y.isPropagationStopped(), h.current || y.stopPropagation());
      })
    })), v && /* @__PURE__ */C(T$, {
      control: d,
      bubbles: !h.current,
      name: r,
      value: c,
      checked: g,
      required: i,
      disabled: s,
      style: {
        transform: "translateX(-100%)"
      }
    }));
  }),
  $$ = "SwitchThumb",
  C$ = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeSwitch,
      r = _objectWithoutProperties(e, _excluded189),
      o = w$($$, n);
    return /* @__PURE__ */C(ie.span, S({
      "data-state": Wd(o.checked),
      "data-disabled": o.disabled ? "" : void 0
    }, r, {
      ref: t
    }));
  }),
  T$ = function T$(e) {
    var t = e.control,
      n = e.checked,
      _e$bubbles = e.bubbles,
      r = _e$bubbles === void 0 ? !0 : _e$bubbles,
      o = _objectWithoutProperties(e, _excluded190),
      a = k(null),
      i = g$(n),
      s = Wl(t);
    return V(function () {
      var c = a.current,
        l = window.HTMLInputElement.prototype,
        d = Object.getOwnPropertyDescriptor(l, "checked").set;
      if (i !== n && d) {
        var f = new Event("click", {
          bubbles: r
        });
        d.call(c, n), c.dispatchEvent(f);
      }
    }, [i, n, r]), /* @__PURE__ */C("input", S({
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n
    }, o, {
      tabIndex: -1,
      ref: a,
      style: _objectSpread(_objectSpread(_objectSpread({}, e.style), s), {}, {
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      })
    }));
  };
function Wd(e) {
  return e ? "checked" : "unchecked";
}
var _$ = x$,
  I$ = C$;
var P$ = function P$(_ref200) {
    var e = _ref200.checked,
      t = _ref200.className,
      n = _ref200.size,
      r = _objectWithoutProperties(_ref200, _excluded191);
    return /* @__PURE__ */p.jsx(I$, _objectSpread(_objectSpread({}, r), {}, {
      className: T("goat-Switch__Thumb", "goat-Switch__Thumb_".concat(n), {
        "goat-Switch__Thumb_checked": e
      }, t)
    }));
  },
  D$ = function D$(_ref201) {
    var e = _ref201.checked,
      t = _ref201.children,
      n = _ref201.className,
      r = _ref201.disabled,
      o = _ref201.onChange,
      a = _ref201.size,
      i = _objectWithoutProperties(_ref201, _excluded192);
    return /* @__PURE__ */p.jsx(_$, _objectSpread(_objectSpread({}, i), {}, {
      checked: e,
      className: T("goat-Switch", "goat-Switch_".concat(a), {
        "goat-Switch_checked": e
      }, {
        "goat-Switch_disabled": r
      }, n),
      disabled: r,
      onCheckedChange: o,
      children: t
    }));
  },
  S$ = function S$(_ref202) {
    var e = _ref202.children,
      t = _ref202.when;
    return /* @__PURE__ */p.jsx(p.Fragment, {
      children: t ? at.toArray(e).reverse() : e
    });
  },
  C_ = function C_(_ref203) {
    var e = _ref203.children,
      _ref203$labelPlacemen = _ref203.labelPlacement,
      t = _ref203$labelPlacemen === void 0 ? "before" : _ref203$labelPlacemen,
      n = _ref203.onChange,
      _ref203$size = _ref203.size,
      r = _ref203$size === void 0 ? "medium" : _ref203$size,
      o = _objectWithoutProperties(_ref203, _excluded193);
    return /* @__PURE__ */p.jsx(fi, {
      className: t !== "top" ? "goat-Label_coupled" : void 0,
      children: /* @__PURE__ */p.jsxs(S$, {
        when: t === "after",
        children: [/* @__PURE__ */p.jsx(Ge, {
          color: t === "top" ? "gray-600" : void 0,
          type: t === "top" || r === "small" ? "body-small" : "body-medium",
          children: e
        }), /* @__PURE__ */p.jsx(D$, _objectSpread(_objectSpread({}, o), {}, {
          onChange: n,
          size: r,
          children: /* @__PURE__ */p.jsx(P$, _objectSpread(_objectSpread({}, o), {}, {
            size: r
          }))
        }))]
      })
    });
  },
  _n = he({}),
  lr = he({}),
  nc = "tbody",
  E$ = x(function (_ref204, i) {
    var t = _ref204.children,
      n = _ref204.as,
      r = _ref204.className,
      o = _ref204.align,
      a = _objectWithoutProperties(_ref204, _excluded194);
    var s = ce(_n),
      c = T("goat-TableBody", r),
      l = Ne(function () {
        return {
          align: o,
          variant: "body"
        };
      }, [o]),
      u = n !== null && n !== void 0 ? n : s != null && s.interactive ? "div" : nc;
    return /* @__PURE__ */p.jsx(lr.Provider, {
      value: l,
      children: /* @__PURE__ */p.jsx(u, _objectSpread(_objectSpread({}, a), {}, {
        className: c,
        ref: i,
        role: u === nc ? void 0 : "rowgroup",
        children: t
      }))
    });
  }),
  O$ = function O$(_ref205) {
    var e = _ref205.as,
      t = _ref205.interactive,
      n = _ref205.isHeadCell;
    var r = n ? "columnheader" : "cell";
    return e ? {
      Component: e,
      role: r
    } : t ? {
      Component: "div",
      role: r
    } : {
      Component: n ? "th" : "td"
    };
  },
  Hd = x(function (_ref206, l) {
    var _ref207, _ref208;
    var _ref206$width = _ref206.width,
      t = _ref206$width === void 0 ? "auto" : _ref206$width,
      n = _ref206.children,
      r = _ref206.className,
      o = _ref206.align,
      a = _ref206.as,
      i = _ref206.sentiment,
      s = _ref206.style,
      c = _objectWithoutProperties(_ref206, _excluded195);
    var u = ce(lr),
      d = ce(_n),
      f = (u == null ? void 0 : u.variant) === "head",
      m = (u == null ? void 0 : u.variant) === "foot",
      h = (_ref207 = (_ref208 = o !== null && o !== void 0 ? o : u == null ? void 0 : u.align) !== null && _ref208 !== void 0 ? _ref208 : d == null ? void 0 : d.align) !== null && _ref207 !== void 0 ? _ref207 : "left",
      _O$ = O$({
        as: a,
        interactive: d == null ? void 0 : d.interactive,
        isHeadCell: f
      }),
      v = _O$.Component,
      g = _O$.role,
      b = T("goat-TableCell", {
        "goat-TableCellHead": f,
        "goat-TableCellFoot": m
      }, "goat-TableCell_align-".concat(h), {
        "goat-TableCell_sentiment": !!i
      }, _defineProperty({}, "goat-TableCell_".concat(i), !!i), r);
    return /* @__PURE__ */p.jsx(v, _objectSpread(_objectSpread({}, c), {}, {
      style: _objectSpread(_objectSpread({}, s), {}, {
        width: t
      }),
      className: b,
      ref: l,
      role: g,
      children: n
    }));
  }),
  M$ = x(function (_ref209, o) {
    var t = _ref209.className,
      n = _ref209.checkboxProps,
      r = _objectWithoutProperties(_ref209, _excluded196);
    var a = T("goat-TableCellCheckbox", t);
    return /* @__PURE__ */p.jsx(Hd, _objectSpread(_objectSpread({}, r), {}, {
      className: a,
      ref: o,
      children: /* @__PURE__ */p.jsx(fi, {
        className: "goat-TableCheckbox",
        children: /* @__PURE__ */p.jsx(sl, _objectSpread({}, n))
      })
    }));
  }),
  rc = "tfoot",
  N$ = x(function (_ref210, i) {
    var t = _ref210.children,
      n = _ref210.as,
      r = _ref210.className,
      o = _ref210.align,
      a = _objectWithoutProperties(_ref210, _excluded197);
    var s = ce(_n),
      c = T("goat-TableFooter", r),
      l = Ne(function () {
        return {
          align: o,
          variant: "foot"
        };
      }, [o]),
      u = n !== null && n !== void 0 ? n : s != null && s.interactive ? "div" : rc;
    return /* @__PURE__ */p.jsx(lr.Provider, {
      value: l,
      children: /* @__PURE__ */p.jsx(u, _objectSpread(_objectSpread({}, a), {}, {
        className: c,
        ref: i,
        role: u === rc ? void 0 : "rowgroup",
        children: t
      }))
    });
  }),
  oc = "thead",
  k$ = x(function (_ref211, i) {
    var t = _ref211.children,
      n = _ref211.as,
      r = _ref211.align,
      o = _ref211.className,
      a = _objectWithoutProperties(_ref211, _excluded198);
    var s = ce(_n),
      c = T("goat-TableHead", {
        "goat-TableHead_sticky": s == null ? void 0 : s.sticky
      }, o),
      l = Ne(function () {
        return {
          align: r,
          variant: "head"
        };
      }, [r]),
      u = n !== null && n !== void 0 ? n : s != null && s.interactive ? "div" : oc;
    return /* @__PURE__ */p.jsx(lr.Provider, {
      value: l,
      children: /* @__PURE__ */p.jsx(u, _objectSpread(_objectSpread({}, a), {}, {
        className: c,
        ref: i,
        role: u === oc ? void 0 : "rowgroup",
        children: t
      }))
    });
  }),
  R$ = x(function (_ref212, a) {
    var t = _ref212.children,
      n = _ref212.as,
      r = _ref212.className,
      o = _objectWithoutProperties(_ref212, _excluded199);
    var i = T("goat-TableLayout", r),
      s = n !== null && n !== void 0 ? n : "div";
    return /* @__PURE__ */p.jsx(s, _objectSpread(_objectSpread({}, o), {}, {
      className: i,
      ref: a,
      children: t
    }));
  });
var ac = "table",
  A$ = x(function (_ref213, f) {
    var t = _ref213.children,
      n = _ref213.className,
      r = _ref213.align,
      o = _ref213.sticky,
      a = _ref213.noBorder,
      i = _ref213.interactive,
      s = _ref213.as,
      c = _ref213.hover,
      _ref213$tableLayout = _ref213.tableLayout,
      l = _ref213$tableLayout === void 0 ? "auto" : _ref213$tableLayout,
      u = _ref213.style,
      d = _objectWithoutProperties(_ref213, _excluded200);
    var m = T("goat-TableRoot", {
        "goat-TableRoot_noBorder": a
      }, n),
      h = Ne(function () {
        return {
          align: r,
          hover: c,
          interactive: i,
          sticky: o
        };
      }, [r, c, i, o]),
      v = s !== null && s !== void 0 ? s : h != null && h.interactive ? "div" : ac;
    return /* @__PURE__ */p.jsx(_n.Provider, {
      value: h,
      children: /* @__PURE__ */p.jsx(v, _objectSpread(_objectSpread({}, d), {}, {
        style: _objectSpread(_objectSpread({}, u), {}, {
          "--goat-table-layout": l
        }),
        className: m,
        ref: f,
        role: v === ac ? void 0 : "table",
        children: t
      }))
    });
  }),
  ic = "tr",
  L$ = x(function (_ref214, i) {
    var t = _ref214.as,
      n = _ref214.children,
      r = _ref214.className,
      o = _ref214.isSelected,
      a = _objectWithoutProperties(_ref214, _excluded201);
    var s = ce(_n),
      c = ce(lr),
      l = (c == null ? void 0 : c.variant) === "head",
      u = s == null ? void 0 : s.hover,
      d = T("goat-TableRow", {
        "goat-TableRow_hover": !l && u
      }, {
        "goat-TableRow_selected": !l && o
      }, r),
      f = t !== null && t !== void 0 ? t : s != null && s.interactive ? "div" : ic;
    return /* @__PURE__ */p.jsx(f, _objectSpread(_objectSpread({}, a), {}, {
      className: d,
      ref: i,
      role: f === ic ? void 0 : "row",
      children: n
    }));
  }),
  j$ = E$,
  F$ = Hd,
  W$ = k$,
  H$ = L$,
  B$ = R$,
  V$ = A$,
  U$ = N$,
  Y$ = M$,
  $r = {
    Body: j$,
    Cell: F$,
    Head: W$,
    Layout: B$,
    Row: H$,
    Root: V$,
    Checkbox: Y$,
    Footer: U$
  },
  Bd = "Tabs",
  _Ke25 = Ke(Bd, [Cn]),
  _Ke26 = _slicedToArray(_Ke25, 2),
  K$ = _Ke26[0],
  T_ = _Ke26[1],
  Vd = Cn(),
  _K$ = K$(Bd),
  _K$2 = _slicedToArray(_K$, 2),
  G$ = _K$2[0],
  qi = _K$2[1],
  z$ = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      o = e.onValueChange,
      a = e.defaultValue,
      _e$orientation2 = e.orientation,
      i = _e$orientation2 === void 0 ? "horizontal" : _e$orientation2,
      s = e.dir,
      _e$activationMode = e.activationMode,
      c = _e$activationMode === void 0 ? "automatic" : _e$activationMode,
      l = _objectWithoutProperties(e, _excluded202),
      u = Vn(s),
      _Ze23 = Ze({
        prop: r,
        onChange: o,
        defaultProp: a
      }),
      _Ze24 = _slicedToArray(_Ze23, 2),
      d = _Ze24[0],
      f = _Ze24[1];
    return /* @__PURE__ */C(G$, {
      scope: n,
      baseId: it(),
      value: d,
      onValueChange: f,
      orientation: i,
      dir: u,
      activationMode: c
    }, /* @__PURE__ */C(ie.div, S({
      dir: u,
      "data-orientation": i
    }, l, {
      ref: t
    })));
  }),
  q$ = "TabsList",
  X$ = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTabs,
      _e$loop5 = e.loop,
      r = _e$loop5 === void 0 ? !0 : _e$loop5,
      o = _objectWithoutProperties(e, _excluded203),
      a = qi(q$, n),
      i = Vd(n);
    return /* @__PURE__ */C(ui, S({
      asChild: !0
    }, i, {
      orientation: a.orientation,
      dir: a.dir,
      loop: r
    }), /* @__PURE__ */C(ie.div, S({
      role: "tablist",
      "aria-orientation": a.orientation
    }, o, {
      ref: t
    })));
  }),
  Q$ = "TabsTrigger",
  Z$ = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      _e$disabled5 = e.disabled,
      o = _e$disabled5 === void 0 ? !1 : _e$disabled5,
      a = _objectWithoutProperties(e, _excluded204),
      i = qi(Q$, n),
      s = Vd(n),
      c = Ud(i.baseId, r),
      l = Yd(i.baseId, r),
      u = r === i.value;
    return /* @__PURE__ */C(di, S({
      asChild: !0
    }, s, {
      focusable: !o,
      active: u
    }), /* @__PURE__ */C(ie.button, S({
      type: "button",
      role: "tab",
      "aria-selected": u,
      "aria-controls": l,
      "data-state": u ? "active" : "inactive",
      "data-disabled": o ? "" : void 0,
      disabled: o,
      id: c
    }, a, {
      ref: t,
      onMouseDown: Z(e.onMouseDown, function (d) {
        !o && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(r) : d.preventDefault();
      }),
      onKeyDown: Z(e.onKeyDown, function (d) {
        [" ", "Enter"].includes(d.key) && i.onValueChange(r);
      }),
      onFocus: Z(e.onFocus, function () {
        var d = i.activationMode !== "manual";
        !u && !o && d && i.onValueChange(r);
      })
    })));
  }),
  J$ = "TabsContent",
  eC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      o = e.forceMount,
      a = e.children,
      i = _objectWithoutProperties(e, _excluded205),
      s = qi(J$, n),
      c = Ud(s.baseId, r),
      l = Yd(s.baseId, r),
      u = r === s.value,
      d = k(u);
    return V(function () {
      var f = requestAnimationFrame(function () {
        return d.current = !1;
      });
      return function () {
        return cancelAnimationFrame(f);
      };
    }, []), /* @__PURE__ */C(et, {
      present: o || u
    }, function (_ref215) {
      var f = _ref215.present;
      return /* @__PURE__ */C(ie.div, S({
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !f,
        id: l,
        tabIndex: 0
      }, i, {
        ref: t,
        style: _objectSpread(_objectSpread({}, e.style), {}, {
          animationDuration: d.current ? "0s" : void 0
        })
      }), f && a);
    });
  });
function Ud(e, t) {
  return "".concat(e, "-trigger-").concat(t);
}
function Yd(e, t) {
  return "".concat(e, "-content-").concat(t);
}
var tC = x(function (_ref216, o) {
    var _ref216$as = _ref216.as,
      t = _ref216$as === void 0 ? "div" : _ref216$as,
      n = _ref216.value,
      r = _objectWithoutProperties(_ref216, _excluded206);
    return /* @__PURE__ */p.jsx(eC, {
      asChild: !0,
      value: n,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, r), {}, {
        ref: o
      }))
    });
  }),
  nC = x(function (_ref217, a) {
    var _ref217$as = _ref217.as,
      t = _ref217$as === void 0 ? "button" : _ref217$as,
      n = _ref217.className,
      r = _ref217.value,
      o = _objectWithoutProperties(_ref217, _excluded207);
    return /* @__PURE__ */p.jsx(Z$, {
      asChild: !0,
      value: r,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, o), {}, {
        className: T("goat-Tabs__Trigger", n),
        ref: a
      }))
    });
  }),
  Kd = he({}),
  rC = Kd.Provider,
  oC = function oC(e, t) {
    return ce(Kd).set(e, t);
  },
  __ = x(function (_ref218, o) {
    var t = _ref218.children,
      n = _ref218.label,
      r = _objectWithoutProperties(_ref218, _excluded208);
    var a = k(""),
      i = X(function () {
        return /* @__PURE__ */p.jsx(tC, {
          value: a.current,
          children: t
        });
      }, [t]);
    return oC(a, i), /* @__PURE__ */p.jsx(nC, _objectSpread(_objectSpread({}, r), {}, {
      ref: o,
      value: a.current,
      children: n
    }));
  }),
  aC = x(function (_ref219, o) {
    var _ref219$as = _ref219.as,
      t = _ref219$as === void 0 ? "div" : _ref219$as,
      n = _ref219.className,
      r = _objectWithoutProperties(_ref219, _excluded209);
    return /* @__PURE__ */p.jsx(X$, {
      asChild: !0,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, r), {}, {
        className: T("goat-Tabs__List", n),
        ref: o
      }))
    });
  });
var iC = x(function (_ref220, l) {
    var _ref220$as = _ref220.as,
      t = _ref220$as === void 0 ? "div" : _ref220$as,
      n = _ref220.className,
      r = _ref220.defaultValue,
      o = _ref220.onValueChange,
      _ref220$size = _ref220.size,
      a = _ref220$size === void 0 ? "medium" : _ref220$size,
      i = _ref220.value,
      s = _ref220.noGap,
      c = _objectWithoutProperties(_ref220, _excluded210);
    return /* @__PURE__ */p.jsx(z$, {
      asChild: !0,
      defaultValue: r,
      onValueChange: o,
      value: i,
      children: /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, c), {}, {
        className: T("goat-Tabs", "goat-Tabs_".concat(a), {
          "goat-Tabs_noGap": s
        }, n),
        ref: l
      }))
    });
  }),
  sc = "~",
  I_ = x(function (_ref221, o) {
    var t = _ref221.children,
      _ref221$defaultTab = _ref221.defaultTab,
      n = _ref221$defaultTab === void 0 ? 0 : _ref221$defaultTab,
      r = _objectWithoutProperties(_ref221, _excluded211);
    var a = k( /* @__PURE__ */new Map()),
      i = Iv(Bc());
    return /* @__PURE__ */p.jsx(rC, {
      value: {
        set: function set(s, c) {
          s.current || (s.current = a.current.size === n ? sc : String(a.current.size)), c !== a.current.get(s.current) && (a.current.set(s.current, c), i());
        }
      },
      children: /* @__PURE__ */p.jsxs(iC, _objectSpread(_objectSpread({}, r), {}, {
        defaultValue: sc,
        ref: o,
        children: [/* @__PURE__ */p.jsx(aC, {
          children: t
        }), _toConsumableArray(a.current).map(function (_ref222) {
          var _ref223 = _slicedToArray(_ref222, 2),
            s = _ref223[0],
            c = _ref223[1];
          return /* @__PURE__ */p.jsx(Wt, {
            children: c()
          }, s);
        })]
      }))
    });
  }),
  Xi = /* @__PURE__ */x(function (e, t) {
    return /* @__PURE__ */C(ie.span, S({}, e, {
      ref: t,
      style: _objectSpread({
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }, e.style)
    }));
  }),
  sC = Xi,
  Gd = "ToastProvider",
  _Vr7 = Vr("Toast"),
  _Vr8 = _slicedToArray(_Vr7, 3),
  Qi = _Vr8[0],
  cC = _Vr8[1],
  lC = _Vr8[2],
  _Ke27 = Ke("Toast", [lC]),
  _Ke28 = _slicedToArray(_Ke27, 2),
  zd = _Ke28[0],
  P_ = _Ke28[1],
  _zd = zd(Gd),
  _zd2 = _slicedToArray(_zd, 2),
  uC = _zd2[0],
  co = _zd2[1],
  qd = function qd(e) {
    var t = e.__scopeToast,
      _e$label = e.label,
      n = _e$label === void 0 ? "Notification" : _e$label,
      _e$duration = e.duration,
      r = _e$duration === void 0 ? 5e3 : _e$duration,
      _e$swipeDirection = e.swipeDirection,
      o = _e$swipeDirection === void 0 ? "right" : _e$swipeDirection,
      _e$swipeThreshold = e.swipeThreshold,
      a = _e$swipeThreshold === void 0 ? 50 : _e$swipeThreshold,
      i = e.children,
      _te79 = te(null),
      _te80 = _slicedToArray(_te79, 2),
      s = _te80[0],
      c = _te80[1],
      _te81 = te(0),
      _te82 = _slicedToArray(_te81, 2),
      l = _te82[0],
      u = _te82[1],
      d = k(!1),
      f = k(!1);
    return /* @__PURE__ */C(Qi.Provider, {
      scope: t
    }, /* @__PURE__ */C(uC, {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: l,
      viewport: s,
      onViewportChange: c,
      onToastAdd: X(function () {
        return u(function (m) {
          return m + 1;
        });
      }, []),
      onToastRemove: X(function () {
        return u(function (m) {
          return m - 1;
        });
      }, []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: f
    }, i));
  };
qd.propTypes = {
  label: function label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      var t = "Invalid prop `label` supplied to `".concat(Gd, "`. Expected non-empty `string`.");
      return new Error(t);
    }
    return null;
  }
};
var dC = "ToastViewport",
  fC = ["F8"],
  ca = "toast.viewportPause",
  la = "toast.viewportResume",
  vC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      _e$hotkey = e.hotkey,
      r = _e$hotkey === void 0 ? fC : _e$hotkey,
      _e$label2 = e.label,
      o = _e$label2 === void 0 ? "Notifications ({hotkey})" : _e$label2,
      a = _objectWithoutProperties(e, _excluded212),
      i = co(dC, n),
      s = cC(n),
      c = k(null),
      l = k(null),
      u = k(null),
      d = k(null),
      f = Ce(t, d, i.onViewportChange),
      m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
      h = i.toastCount > 0;
    V(function () {
      var g = function g(b) {
        var y;
        r.every(function (I) {
          return b[I] || b.code === I;
        }) && ((y = d.current) === null || y === void 0 || y.focus());
      };
      return document.addEventListener("keydown", g), function () {
        return document.removeEventListener("keydown", g);
      };
    }, [r]), V(function () {
      var g = c.current,
        b = d.current;
      if (h && g && b) {
        var y = function y() {
            if (!i.isClosePausedRef.current) {
              var D = new CustomEvent(ca);
              b.dispatchEvent(D), i.isClosePausedRef.current = !0;
            }
          },
          w = function w() {
            if (i.isClosePausedRef.current) {
              var D = new CustomEvent(la);
              b.dispatchEvent(D), i.isClosePausedRef.current = !1;
            }
          },
          I = function I(D) {
            !g.contains(D.relatedTarget) && w();
          },
          P = function P() {
            g.contains(document.activeElement) || w();
          };
        return g.addEventListener("focusin", y), g.addEventListener("focusout", I), g.addEventListener("pointermove", y), g.addEventListener("pointerleave", P), window.addEventListener("blur", y), window.addEventListener("focus", w), function () {
          g.removeEventListener("focusin", y), g.removeEventListener("focusout", I), g.removeEventListener("pointermove", y), g.removeEventListener("pointerleave", P), window.removeEventListener("blur", y), window.removeEventListener("focus", w);
        };
      }
    }, [h, i.isClosePausedRef]);
    var v = X(function (_ref224) {
      var g = _ref224.tabbingDirection;
      var y = s().map(function (w) {
        var I = w.ref.current,
          P = [I].concat(_toConsumableArray(SC(I)));
        return g === "forwards" ? P : P.reverse();
      });
      return (g === "forwards" ? y.reverse() : y).flat();
    }, [s]);
    return V(function () {
      var g = d.current;
      if (g) {
        var b = function b(y) {
          var w = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !w) {
            var _ = document.activeElement,
              O = y.shiftKey;
            if (y.target === g && O) {
              var P;
              (P = l.current) === null || P === void 0 || P.focus();
              return;
            }
            var B = v({
                tabbingDirection: O ? "backwards" : "forwards"
              }),
              G = B.findIndex(function (N) {
                return N === _;
              });
            if (jo(B.slice(G + 1))) y.preventDefault();else {
              var D, E;
              O ? (D = l.current) === null || D === void 0 || D.focus() : (E = u.current) === null || E === void 0 || E.focus();
            }
          }
        };
        return g.addEventListener("keydown", b), function () {
          return g.removeEventListener("keydown", b);
        };
      }
    }, [s, v]), /* @__PURE__ */C(dp, {
      ref: c,
      role: "region",
      "aria-label": o.replace("{hotkey}", m),
      tabIndex: -1,
      style: {
        pointerEvents: h ? void 0 : "none"
      }
    }, h && /* @__PURE__ */C(cc, {
      ref: l,
      onFocusFromOutsideViewport: function onFocusFromOutsideViewport() {
        var g = v({
          tabbingDirection: "forwards"
        });
        jo(g);
      }
    }), /* @__PURE__ */C(Qi.Slot, {
      scope: n
    }, /* @__PURE__ */C(ie.ol, S({
      tabIndex: -1
    }, a, {
      ref: f
    }))), h && /* @__PURE__ */C(cc, {
      ref: u,
      onFocusFromOutsideViewport: function onFocusFromOutsideViewport() {
        var g = v({
          tabbingDirection: "backwards"
        });
        jo(g);
      }
    }));
  }),
  pC = "ToastFocusProxy",
  cc = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      r = e.onFocusFromOutsideViewport,
      o = _objectWithoutProperties(e, _excluded213),
      a = co(pC, n);
    return /* @__PURE__ */C(Xi, S({
      "aria-hidden": !0,
      tabIndex: 0
    }, o, {
      ref: t,
      style: {
        position: "fixed"
      },
      onFocus: function onFocus(i) {
        var s;
        var c = i.relatedTarget;
        !((s = a.viewport) !== null && s !== void 0 && s.contains(c)) && r();
      }
    }));
  }),
  lo = "Toast",
  mC = "toast.swipeStart",
  hC = "toast.swipeMove",
  gC = "toast.swipeCancel",
  bC = "toast.swipeEnd",
  yC = /* @__PURE__ */x(function (e, t) {
    var n = e.forceMount,
      r = e.open,
      o = e.defaultOpen,
      a = e.onOpenChange,
      i = _objectWithoutProperties(e, _excluded214),
      _Ze25 = Ze({
        prop: r,
        defaultProp: o,
        onChange: a
      }),
      _Ze26 = _slicedToArray(_Ze25, 2),
      _Ze26$ = _Ze26[0],
      s = _Ze26$ === void 0 ? !0 : _Ze26$,
      c = _Ze26[1];
    return /* @__PURE__ */C(et, {
      present: n || s
    }, /* @__PURE__ */C(Xd, S({
      open: s
    }, i, {
      ref: t,
      onClose: function onClose() {
        return c(!1);
      },
      onPause: Xe(e.onPause),
      onResume: Xe(e.onResume),
      onSwipeStart: Z(e.onSwipeStart, function (l) {
        l.currentTarget.setAttribute("data-swipe", "start");
      }),
      onSwipeMove: Z(e.onSwipeMove, function (l) {
        var _l$detail$delta = l.detail.delta,
          u = _l$detail$delta.x,
          d = _l$detail$delta.y;
        l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", "".concat(u, "px")), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", "".concat(d, "px"));
      }),
      onSwipeCancel: Z(e.onSwipeCancel, function (l) {
        l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
      }),
      onSwipeEnd: Z(e.onSwipeEnd, function (l) {
        var _l$detail$delta2 = l.detail.delta,
          u = _l$detail$delta2.x,
          d = _l$detail$delta2.y;
        l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", "".concat(u, "px")), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", "".concat(d, "px")), c(!1);
      })
    })));
  }),
  _zd3 = zd(lo, {
    onClose: function onClose() {}
  }),
  _zd4 = _slicedToArray(_zd3, 2),
  wC = _zd4[0],
  xC = _zd4[1],
  Xd = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      _e$type = e.type,
      r = _e$type === void 0 ? "foreground" : _e$type,
      o = e.duration,
      a = e.open,
      i = e.onClose,
      s = e.onEscapeKeyDown,
      c = e.onPause,
      l = e.onResume,
      u = e.onSwipeStart,
      d = e.onSwipeMove,
      f = e.onSwipeCancel,
      m = e.onSwipeEnd,
      h = _objectWithoutProperties(e, _excluded215),
      v = co(lo, n),
      _te83 = te(null),
      _te84 = _slicedToArray(_te83, 2),
      g = _te84[0],
      b = _te84[1],
      y = Ce(t, function (N) {
        return b(N);
      }),
      w = k(null),
      I = k(null),
      P = o || v.duration,
      D = k(0),
      E = k(P),
      _ = k(0),
      O = v.onToastAdd,
      A = v.onToastRemove,
      M = Xe(function () {
        var N;
        (g == null ? void 0 : g.contains(document.activeElement)) && ((N = v.viewport) === null || N === void 0 || N.focus()), i();
      }),
      B = X(function (N) {
        !N || N === 1 / 0 || (window.clearTimeout(_.current), D.current = /* @__PURE__ */new Date().getTime(), _.current = window.setTimeout(M, N));
      }, [M]);
    V(function () {
      var N = v.viewport;
      if (N) {
        var j = function j() {
            B(E.current), l == null || l();
          },
          U = function U() {
            var L = /* @__PURE__ */new Date().getTime() - D.current;
            E.current = E.current - L, window.clearTimeout(_.current), c == null || c();
          };
        return N.addEventListener(ca, U), N.addEventListener(la, j), function () {
          N.removeEventListener(ca, U), N.removeEventListener(la, j);
        };
      }
    }, [v.viewport, P, c, l, B]), V(function () {
      a && !v.isClosePausedRef.current && B(P);
    }, [a, P, v.isClosePausedRef, B]), V(function () {
      return O(), function () {
        return A();
      };
    }, [O, A]);
    var G = Ne(function () {
      return g ? ef(g) : null;
    }, [g]);
    return v.viewport ? /* @__PURE__ */C(Wt, null, G && /* @__PURE__ */C($C, {
      __scopeToast: n,
      role: "status",
      "aria-live": r === "foreground" ? "assertive" : "polite",
      "aria-atomic": !0
    }, G), /* @__PURE__ */C(wC, {
      scope: n,
      onClose: M
    }, /* @__PURE__ */yc( /* @__PURE__ */C(Qi.ItemSlot, {
      scope: n
    }, /* @__PURE__ */C(up, {
      asChild: !0,
      onEscapeKeyDown: Z(s, function () {
        v.isFocusedToastEscapeKeyDownRef.current || M(), v.isFocusedToastEscapeKeyDownRef.current = !1;
      })
    }, /* @__PURE__ */C(ie.li, S({
      // Ensure toasts are announced as status list or status when focused
      role: "status",
      "aria-live": "off",
      "aria-atomic": !0,
      tabIndex: 0,
      "data-state": a ? "open" : "closed",
      "data-swipe-direction": v.swipeDirection
    }, h, {
      ref: y,
      style: _objectSpread({
        userSelect: "none",
        touchAction: "none"
      }, e.style),
      onKeyDown: Z(e.onKeyDown, function (N) {
        N.key === "Escape" && (s == null || s(N.nativeEvent), N.nativeEvent.defaultPrevented || (v.isFocusedToastEscapeKeyDownRef.current = !0, M()));
      }),
      onPointerDown: Z(e.onPointerDown, function (N) {
        N.button === 0 && (w.current = {
          x: N.clientX,
          y: N.clientY
        });
      }),
      onPointerMove: Z(e.onPointerMove, function (N) {
        if (!w.current) return;
        var j = N.clientX - w.current.x,
          U = N.clientY - w.current.y,
          L = !!I.current,
          R = ["left", "right"].includes(v.swipeDirection),
          Y = ["left", "up"].includes(v.swipeDirection) ? Math.min : Math.max,
          re = R ? Y(0, j) : 0,
          ae = R ? 0 : Y(0, U),
          se = N.pointerType === "touch" ? 10 : 2,
          le = {
            x: re,
            y: ae
          },
          fe = {
            originalEvent: N,
            delta: le
          };
        L ? (I.current = le, Cr(hC, d, fe, {
          discrete: !1
        })) : lc(le, v.swipeDirection, se) ? (I.current = le, Cr(mC, u, fe, {
          discrete: !1
        }), N.target.setPointerCapture(N.pointerId)) : (Math.abs(j) > se || Math.abs(U) > se) && (w.current = null);
      }),
      onPointerUp: Z(e.onPointerUp, function (N) {
        var j = I.current,
          U = N.target;
        if (U.hasPointerCapture(N.pointerId) && U.releasePointerCapture(N.pointerId), I.current = null, w.current = null, j) {
          var L = N.currentTarget,
            R = {
              originalEvent: N,
              delta: j
            };
          lc(j, v.swipeDirection, v.swipeThreshold) ? Cr(bC, m, R, {
            discrete: !0
          }) : Cr(gC, f, R, {
            discrete: !0
          }), L.addEventListener("click", function (Y) {
            return Y.preventDefault();
          }, {
            once: !0
          });
        }
      })
    })))), v.viewport))) : null;
  });
Xd.propTypes = {
  type: function type(e) {
    if (e.type && !["foreground", "background"].includes(e.type)) {
      var t = "Invalid prop `type` supplied to `".concat(lo, "`. Expected `foreground | background`.");
      return new Error(t);
    }
    return null;
  }
};
var $C = function $C(e) {
    var t = e.__scopeToast,
      n = e.children,
      r = _objectWithoutProperties(e, _excluded216),
      o = co(lo, t),
      _te85 = te(!1),
      _te86 = _slicedToArray(_te85, 2),
      a = _te86[0],
      i = _te86[1],
      _te87 = te(!1),
      _te88 = _slicedToArray(_te87, 2),
      s = _te88[0],
      c = _te88[1];
    return PC(function () {
      return i(!0);
    }), V(function () {
      var l = window.setTimeout(function () {
        return c(!0);
      }, 1e3);
      return function () {
        return window.clearTimeout(l);
      };
    }, []), s ? null : /* @__PURE__ */C(Yn, {
      asChild: !0
    }, /* @__PURE__ */C(Xi, r, a && /* @__PURE__ */C(Wt, null, o.label, " ", n)));
  },
  CC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      r = _objectWithoutProperties(e, _excluded217);
    return /* @__PURE__ */C(ie.div, S({}, r, {
      ref: t
    }));
  }),
  TC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      r = _objectWithoutProperties(e, _excluded218);
    return /* @__PURE__ */C(ie.div, S({}, r, {
      ref: t
    }));
  }),
  _C = "ToastAction",
  Qd = /* @__PURE__ */x(function (e, t) {
    var n = e.altText,
      r = _objectWithoutProperties(e, _excluded219);
    return n ? /* @__PURE__ */C(Jd, {
      altText: n,
      asChild: !0
    }, /* @__PURE__ */C(Zd, S({}, r, {
      ref: t
    }))) : null;
  });
Qd.propTypes = {
  altText: function altText(e) {
    return e.altText ? null : new Error("Missing prop `altText` expected on `".concat(_C, "`"));
  }
};
var IC = "ToastClose",
  Zd = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      r = _objectWithoutProperties(e, _excluded220),
      o = xC(IC, n);
    return /* @__PURE__ */C(Jd, {
      asChild: !0
    }, /* @__PURE__ */C(ie.button, S({
      type: "button"
    }, r, {
      ref: t,
      onClick: Z(e.onClick, o.onClose)
    })));
  }),
  Jd = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeToast,
      r = e.altText,
      o = _objectWithoutProperties(e, _excluded221);
    return /* @__PURE__ */C(ie.div, S({
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0
    }, o, {
      ref: t
    }));
  });
function ef(e) {
  var t = [];
  return Array.from(e.childNodes).forEach(function (r) {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), DC(r)) {
      var o = r.ariaHidden || r.hidden || r.style.display === "none",
        a = r.dataset.radixToastAnnounceExclude === "";
      if (!o) if (a) {
        var i = r.dataset.radixToastAnnounceAlt;
        i && t.push(i);
      } else t.push.apply(t, _toConsumableArray(ef(r)));
    }
  }), t;
}
function Cr(e, t, n, _ref225) {
  var r = _ref225.discrete;
  var o = n.originalEvent.currentTarget,
    a = new CustomEvent(e, {
      bubbles: !0,
      cancelable: !0,
      detail: n
    });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? ba(o, a) : o.dispatchEvent(a);
}
var lc = function lc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var r = Math.abs(e.x),
    o = Math.abs(e.y),
    a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function PC() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var t = Xe(e);
  jt(function () {
    var n = 0,
      r = 0;
    return n = window.requestAnimationFrame(function () {
      return r = window.requestAnimationFrame(t);
    }), function () {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function DC(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function SC(e) {
  var t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function acceptNode(r) {
        var o = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function jo(e) {
  var t = document.activeElement;
  return e.some(function (n) {
    return n === t ? !0 : (n.focus(), document.activeElement !== t);
  });
}
var EC = yC;
var OC = function OC(_ref226) {
    var e = _ref226.className,
      t = _objectWithoutProperties(_ref226, _excluded222);
    return /* @__PURE__ */p.jsx(Zd, _objectSpread(_objectSpread({}, t), {}, {
      className: T(e, "goat-ToastClose"),
      asChild: !0,
      children: /* @__PURE__ */p.jsx(Qe, {
        variant: "ghost-inverted",
        icon: Dt
      })
    }));
  },
  MC = function MC(_ref227) {
    var e = _ref227.className,
      t = _ref227.children,
      n = _objectWithoutProperties(_ref227, _excluded223);
    return /* @__PURE__ */p.jsx(TC, _objectSpread(_objectSpread({}, n), {}, {
      className: T(e, "goat-ToastDescription"),
      asChild: !0,
      children: /* @__PURE__ */p.jsx(Ge, {
        as: "div",
        type: "body-medium",
        color: "white",
        children: t
      })
    }));
  },
  NC = function NC(_ref228) {
    var e = _ref228.sentiment;
    return e === "positive" ? /* @__PURE__ */p.jsx(je, {
      className: "goat-ToastIcon",
      as: Cc
    }) : e === "negative" ? /* @__PURE__ */p.jsx(je, {
      className: "goat-ToastIcon",
      as: wf
    }) : e === "informative" ? /* @__PURE__ */p.jsx(je, {
      className: "goat-ToastIcon",
      as: $c
    }) : e === "attentive" ? /* @__PURE__ */p.jsx(je, {
      className: "goat-ToastIcon",
      as: Ho
    }) : null;
  },
  kC = function kC(_ref229) {
    var e = _ref229.className,
      t = _ref229.children,
      n = _objectWithoutProperties(_ref229, _excluded224);
    return /* @__PURE__ */p.jsx(CC, _objectSpread(_objectSpread({}, n), {}, {
      className: T(e, "goat-ToastTitle"),
      asChild: !0,
      children: /* @__PURE__ */p.jsx(Ge, {
        as: "div",
        type: "title-medium",
        color: "white",
        children: t
      })
    }));
  },
  RC = function RC(_ref230) {
    var e = _ref230.className,
      t = _objectWithoutProperties(_ref230, _excluded225);
    return /* @__PURE__ */p.jsx(vC, _objectSpread(_objectSpread({}, t), {}, {
      className: T(e, "goat-ToastViewport")
    }));
  },
  AC = function AC(_ref231) {
    var e = _ref231.className,
      t = _ref231.children,
      n = _objectWithoutProperties(_ref231, _excluded226);
    return /* @__PURE__ */p.jsx(Qd, _objectSpread(_objectSpread({}, n), {}, {
      className: T(e, "goat-ToastAction"),
      asChild: !0,
      children: /* @__PURE__ */p.jsx(uw, {
        as: "button",
        color: "inverted",
        children: t
      })
    }));
  },
  ur = x(function (_ref232, c) {
    var _ref232$as = _ref232.as,
      t = _ref232$as === void 0 ? "li" : _ref232$as,
      n = _ref232.children,
      r = _ref232.className,
      o = _ref232.dismissable,
      a = _ref232.icon,
      _ref232$sentiment = _ref232.sentiment,
      i = _ref232$sentiment === void 0 ? "neutral" : _ref232$sentiment,
      s = _objectWithoutProperties(_ref232, _excluded227);
    return /* @__PURE__ */p.jsx(EC, _objectSpread(_objectSpread({}, s), {}, {
      className: T(r, "goat-Toast", "goat-Toast_".concat(i)),
      ref: c,
      asChild: !0,
      children: /* @__PURE__ */p.jsxs(t, {
        children: [a && /* @__PURE__ */p.jsx(NC, {
          sentiment: i
        }), /* @__PURE__ */p.jsx("div", {
          className: "goat-ToastContent",
          children: n
        }), o && /* @__PURE__ */p.jsx(OC, {})]
      })
    }));
  });
ur.Provider = qd;
ur.Viewport = RC;
ur.Title = kC;
ur.Description = MC;
ur.Action = AC;
var _Ke29 = Ke("Tooltip", [xn]),
  _Ke30 = _slicedToArray(_Ke29, 2),
  uo = _Ke30[0],
  D_ = _Ke30[1],
  fo = xn(),
  LC = "TooltipProvider",
  jC = 700,
  ua = "tooltip.open",
  _uo = uo(LC),
  _uo2 = _slicedToArray(_uo, 2),
  FC = _uo2[0],
  Zi = _uo2[1],
  WC = function WC(e) {
    var t = e.__scopeTooltip,
      _e$delayDuration = e.delayDuration,
      n = _e$delayDuration === void 0 ? jC : _e$delayDuration,
      _e$skipDelayDuration = e.skipDelayDuration,
      r = _e$skipDelayDuration === void 0 ? 300 : _e$skipDelayDuration,
      _e$disableHoverableCo = e.disableHoverableContent,
      o = _e$disableHoverableCo === void 0 ? !1 : _e$disableHoverableCo,
      a = e.children,
      _te89 = te(!0),
      _te90 = _slicedToArray(_te89, 2),
      i = _te90[0],
      s = _te90[1],
      c = k(!1),
      l = k(0);
    return V(function () {
      var u = l.current;
      return function () {
        return window.clearTimeout(u);
      };
    }, []), /* @__PURE__ */C(FC, {
      scope: t,
      isOpenDelayed: i,
      delayDuration: n,
      onOpen: X(function () {
        window.clearTimeout(l.current), s(!1);
      }, []),
      onClose: X(function () {
        window.clearTimeout(l.current), l.current = window.setTimeout(function () {
          return s(!0);
        }, r);
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: X(function (u) {
        c.current = u;
      }, []),
      disableHoverableContent: o
    }, a);
  },
  Ji = "Tooltip",
  _uo3 = uo(Ji),
  _uo4 = _slicedToArray(_uo3, 2),
  HC = _uo4[0],
  dr = _uo4[1],
  BC = function BC(e) {
    var t = e.__scopeTooltip,
      n = e.children,
      r = e.open,
      _e$defaultOpen = e.defaultOpen,
      o = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
      a = e.onOpenChange,
      i = e.disableHoverableContent,
      s = e.delayDuration,
      c = Zi(Ji, e.__scopeTooltip),
      l = fo(t),
      _te91 = te(null),
      _te92 = _slicedToArray(_te91, 2),
      u = _te92[0],
      d = _te92[1],
      f = it(),
      m = k(0),
      h = i !== null && i !== void 0 ? i : c.disableHoverableContent,
      v = s !== null && s !== void 0 ? s : c.delayDuration,
      g = k(!1),
      _Ze27 = Ze({
        prop: r,
        defaultProp: o,
        onChange: function onChange(E) {
          E ? (c.onOpen(), document.dispatchEvent(new CustomEvent(ua))) : c.onClose(), a == null || a(E);
        }
      }),
      _Ze28 = _slicedToArray(_Ze27, 2),
      _Ze28$ = _Ze28[0],
      b = _Ze28$ === void 0 ? !1 : _Ze28$,
      y = _Ze28[1],
      w = Ne(function () {
        return b ? g.current ? "delayed-open" : "instant-open" : "closed";
      }, [b]),
      I = X(function () {
        window.clearTimeout(m.current), g.current = !1, y(!0);
      }, [y]),
      P = X(function () {
        window.clearTimeout(m.current), y(!1);
      }, [y]),
      D = X(function () {
        window.clearTimeout(m.current), m.current = window.setTimeout(function () {
          g.current = !0, y(!0);
        }, v);
      }, [v, y]);
    return V(function () {
      return function () {
        return window.clearTimeout(m.current);
      };
    }, []), /* @__PURE__ */C(Ga, l, /* @__PURE__ */C(HC, {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: w,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: X(function () {
        c.isOpenDelayed ? D() : I();
      }, [c.isOpenDelayed, D, I]),
      onTriggerLeave: X(function () {
        h ? P() : window.clearTimeout(m.current);
      }, [P, h]),
      onOpen: I,
      onClose: P,
      disableHoverableContent: h
    }, n));
  },
  uc = "TooltipTrigger",
  VC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTooltip,
      r = _objectWithoutProperties(e, _excluded228),
      o = dr(uc, n),
      a = Zi(uc, n),
      i = fo(n),
      s = k(null),
      c = Ce(t, s, o.onTriggerChange),
      l = k(!1),
      u = k(!1),
      d = X(function () {
        return l.current = !1;
      }, []);
    return V(function () {
      return function () {
        return document.removeEventListener("pointerup", d);
      };
    }, [d]), /* @__PURE__ */C(Jr, S({
      asChild: !0
    }, i), /* @__PURE__ */C(ie.button, S({
      // We purposefully avoid adding `type=button` here because tooltip triggers are also
      // commonly anchors and the anchor `type` attribute signifies MIME type.
      "aria-describedby": o.open ? o.contentId : void 0,
      "data-state": o.stateAttribute
    }, r, {
      ref: c,
      onPointerMove: Z(e.onPointerMove, function (f) {
        f.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
      }),
      onPointerLeave: Z(e.onPointerLeave, function () {
        o.onTriggerLeave(), u.current = !1;
      }),
      onPointerDown: Z(e.onPointerDown, function () {
        l.current = !0, document.addEventListener("pointerup", d, {
          once: !0
        });
      }),
      onFocus: Z(e.onFocus, function () {
        l.current || o.onOpen();
      }),
      onBlur: Z(e.onBlur, o.onClose),
      onClick: Z(e.onClick, o.onClose)
    })));
  }),
  tf = "TooltipPortal",
  _uo5 = uo(tf, {
    forceMount: void 0
  }),
  _uo6 = _slicedToArray(_uo5, 2),
  UC = _uo6[0],
  YC = _uo6[1],
  KC = function KC(e) {
    var t = e.__scopeTooltip,
      n = e.forceMount,
      r = e.children,
      o = e.container,
      a = dr(tf, t);
    return /* @__PURE__ */C(UC, {
      scope: t,
      forceMount: n
    }, /* @__PURE__ */C(et, {
      present: n || a.open
    }, /* @__PURE__ */C(Yn, {
      asChild: !0,
      container: o
    }, r)));
  },
  Hn = "TooltipContent",
  GC = /* @__PURE__ */x(function (e, t) {
    var n = YC(Hn, e.__scopeTooltip),
      _e$forceMount5 = e.forceMount,
      r = _e$forceMount5 === void 0 ? n.forceMount : _e$forceMount5,
      _e$side2 = e.side,
      o = _e$side2 === void 0 ? "top" : _e$side2,
      a = _objectWithoutProperties(e, _excluded229),
      i = dr(Hn, e.__scopeTooltip);
    return /* @__PURE__ */C(et, {
      present: r || i.open
    }, i.disableHoverableContent ? /* @__PURE__ */C(nf, S({
      side: o
    }, a, {
      ref: t
    })) : /* @__PURE__ */C(zC, S({
      side: o
    }, a, {
      ref: t
    })));
  }),
  zC = /* @__PURE__ */x(function (e, t) {
    var n = dr(Hn, e.__scopeTooltip),
      r = Zi(Hn, e.__scopeTooltip),
      o = k(null),
      a = Ce(t, o),
      _te93 = te(null),
      _te94 = _slicedToArray(_te93, 2),
      i = _te94[0],
      s = _te94[1],
      c = n.trigger,
      l = n.onClose,
      u = o.current,
      d = r.onPointerInTransitChange,
      f = X(function () {
        s(null), d(!1);
      }, [d]),
      m = X(function (h, v) {
        var g = h.currentTarget,
          b = {
            x: h.clientX,
            y: h.clientY
          },
          y = JC(b, g.getBoundingClientRect()),
          w = eT(b, y),
          I = tT(v.getBoundingClientRect()),
          P = rT([].concat(_toConsumableArray(w), _toConsumableArray(I)));
        s(P), d(!0);
      }, [d]);
    return V(function () {
      return function () {
        return f();
      };
    }, [f]), V(function () {
      if (c && u) {
        var h = function h(g) {
            return m(g, u);
          },
          v = function v(g) {
            return m(g, c);
          };
        return c.addEventListener("pointerleave", h), u.addEventListener("pointerleave", v), function () {
          c.removeEventListener("pointerleave", h), u.removeEventListener("pointerleave", v);
        };
      }
    }, [c, u, m, f]), V(function () {
      if (i) {
        var h = function h(v) {
          var g = v.target,
            b = {
              x: v.clientX,
              y: v.clientY
            },
            y = (c == null ? void 0 : c.contains(g)) || (u == null ? void 0 : u.contains(g)),
            w = !nT(b, i);
          y ? f() : w && (f(), l());
        };
        return document.addEventListener("pointermove", h), function () {
          return document.removeEventListener("pointermove", h);
        };
      }
    }, [c, u, i, l, f]), /* @__PURE__ */C(nf, S({}, e, {
      ref: a
    }));
  }),
  _uo7 = uo(Ji, {
    isInside: !1
  }),
  _uo8 = _slicedToArray(_uo7, 2),
  qC = _uo8[0],
  XC = _uo8[1],
  nf = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTooltip,
      r = e.children,
      o = e["aria-label"],
      a = e.onEscapeKeyDown,
      i = e.onPointerDownOutside,
      s = _objectWithoutProperties(e, _excluded230),
      c = dr(Hn, n),
      l = fo(n),
      u = c.onClose;
    return V(function () {
      return document.addEventListener(ua, u), function () {
        return document.removeEventListener(ua, u);
      };
    }, [u]), V(function () {
      if (c.trigger) {
        var d = function d(f) {
          var m = f.target;
          m != null && m.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", d, {
          capture: !0
        }), function () {
          return window.removeEventListener("scroll", d, {
            capture: !0
          });
        };
      }
    }, [c.trigger, u]), /* @__PURE__ */C(Un, {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      onFocusOutside: function onFocusOutside(d) {
        return d.preventDefault();
      },
      onDismiss: u
    }, /* @__PURE__ */C(za, S({
      "data-state": c.stateAttribute
    }, l, s, {
      ref: t,
      style: _objectSpread(_objectSpread({}, s.style), {}, {
        "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
        "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
        "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
      })
    }), /* @__PURE__ */C(Pc, null, r), /* @__PURE__ */C(qC, {
      scope: n,
      isInside: !0
    }, /* @__PURE__ */C(sC, {
      id: c.contentId,
      role: "tooltip"
    }, o || r))));
  }),
  QC = "TooltipArrow",
  ZC = /* @__PURE__ */x(function (e, t) {
    var n = e.__scopeTooltip,
      r = _objectWithoutProperties(e, _excluded231),
      o = fo(n);
    return XC(QC, n).isInside ? null : /* @__PURE__ */C(zl, S({}, o, r, {
      ref: t
    }));
  });
function JC(e, t) {
  var n = Math.abs(t.top - e.y),
    r = Math.abs(t.bottom - e.y),
    o = Math.abs(t.right - e.x),
    a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function eT(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function tT(e) {
  var t = e.top,
    n = e.right,
    r = e.bottom,
    o = e.left;
  return [{
    x: o,
    y: t
  }, {
    x: n,
    y: t
  }, {
    x: n,
    y: r
  }, {
    x: o,
    y: r
  }];
}
function nT(e, t) {
  var n = e.x,
    r = e.y;
  var o = !1;
  for (var a = 0, i = t.length - 1; a < t.length; i = a++) {
    var s = t[a].x,
      c = t[a].y,
      l = t[i].x,
      u = t[i].y;
    c > r != u > r && n < (l - s) * (r - c) / (u - c) + s && (o = !o);
  }
  return o;
}
function rT(e) {
  var t = e.slice();
  return t.sort(function (n, r) {
    return n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0;
  }), oT(t);
}
function oT(e) {
  if (e.length <= 1) return e.slice();
  var t = [];
  for (var r = 0; r < e.length; r++) {
    var o = e[r];
    for (; t.length >= 2;) {
      var a = t[t.length - 1],
        i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) t.pop();else break;
    }
    t.push(o);
  }
  t.pop();
  var n = [];
  for (var _r5 = e.length - 1; _r5 >= 0; _r5--) {
    var _o3 = e[_r5];
    for (; n.length >= 2;) {
      var _a5 = n[n.length - 1],
        _i3 = n[n.length - 2];
      if ((_a5.x - _i3.x) * (_o3.y - _i3.y) >= (_a5.y - _i3.y) * (_o3.x - _i3.x)) n.pop();else break;
    }
    n.push(_o3);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var aT = WC,
  iT = BC,
  sT = VC,
  cT = KC,
  lT = GC,
  dc = ZC,
  uT = x(function (_ref233, l) {
    var _ref233$as = _ref233.as,
      t = _ref233$as === void 0 ? "div" : _ref233$as,
      n = _ref233.children,
      r = _ref233.className,
      _ref233$side = _ref233.side,
      o = _ref233$side === void 0 ? "right" : _ref233$side,
      _ref233$sideOffset = _ref233.sideOffset,
      a = _ref233$sideOffset === void 0 ? 4 : _ref233$sideOffset,
      _ref233$mode = _ref233.mode,
      i = _ref233$mode === void 0 ? "default" : _ref233$mode,
      _ref233$portalProps = _ref233.portalProps,
      s = _ref233$portalProps === void 0 ? {} : _ref233$portalProps,
      c = _objectWithoutProperties(_ref233, _excluded232);
    return /* @__PURE__ */p.jsx(cT, _objectSpread(_objectSpread({}, s), {}, {
      children: /* @__PURE__ */p.jsx(lT, _objectSpread(_objectSpread({}, c), {}, {
        asChild: !0,
        className: T("goat-Tooltip", "goat-Tooltip_".concat(i), r),
        side: o,
        sideOffset: a,
        ref: l,
        children: /* @__PURE__ */p.jsxs(t, {
          children: [i === "light" && /* @__PURE__ */p.jsx(dc, {
            className: T("goat-Tooltip__ArrowStroke_light", r),
            height: 7,
            width: 11
          }), /* @__PURE__ */p.jsx(dc, {
            className: T("goat-Tooltip__Arrow_".concat(i), r),
            height: 6,
            width: 11
          }), n]
        })
      }))
    }));
  }),
  dT = x(function (_ref234, r) {
    var t = _ref234.className,
      n = _objectWithoutProperties(_ref234, _excluded233);
    return /* @__PURE__ */p.jsx("button", _objectSpread(_objectSpread({}, n), {}, {
      className: T("goat-Tooltip__Trigger", t),
      ref: r,
      type: "button"
    }));
  }),
  fT = x(function (_ref235, o) {
    var _ref235$as = _ref235.as,
      t = _ref235$as === void 0 ? dT : _ref235$as,
      n = _ref235.children,
      r = _objectWithoutProperties(_ref235, _excluded234);
    return /* @__PURE__ */p.jsx(sT, _objectSpread(_objectSpread({}, r), {}, {
      asChild: !0,
      ref: o,
      children: /* @__PURE__ */p.jsx(t, {
        children: n
      })
    }));
  });
var rf = function rf(_ref236) {
  var e = _ref236.children,
    t = _ref236.disabled,
    _ref236$delayDuration = _ref236.delayDuration,
    n = _ref236$delayDuration === void 0 ? 100 : _ref236$delayDuration,
    r = _ref236.open,
    o = _objectWithoutProperties(_ref236, _excluded235);
  return /* @__PURE__ */p.jsx(aT, {
    children: /* @__PURE__ */p.jsx(iT, _objectSpread(_objectSpread({}, o), {}, {
      delayDuration: n,
      open: r !== null && r !== void 0 ? r : t ? !1 : void 0,
      children: e
    }))
  });
};
rf.Trigger = fT;
rf.Content = uT;
var S_ = function S_(_ref237) {
  var e = _ref237.percentage,
    _ref237$trend = _ref237.trend,
    t = _ref237$trend === void 0 ? "increase" : _ref237$trend,
    _ref237$mode = _ref237.mode,
    n = _ref237$mode === void 0 ? "default" : _ref237$mode,
    r = _ref237.className,
    o = _objectWithoutProperties(_ref237, _excluded236);
  var a = T("goat-TrendTag", "goat-TrendTag_".concat(n), r);
  return /* @__PURE__ */p.jsxs("div", _objectSpread(_objectSpread({
    className: a
  }, o), {}, {
    children: [/* @__PURE__ */p.jsx("div", {
      className: T("goat-TrendTag_".concat(t)),
      children: /* @__PURE__ */p.jsx("svg", {
        width: "12",
        height: "10",
        viewBox: "0 0 12 10",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */p.jsx("path", {
          d: "M0.596591 10L6.05114 0.727272L11.5057 10H0.596591Z"
        })
      })
    }), e, "%"]
  }));
};
var E_ = x(function (_ref238, s) {
    var _i$id;
    var _ref238$as = _ref238.as,
      t = _ref238$as === void 0 ? "p" : _ref238$as,
      n = _ref238.children,
      r = _ref238.className,
      o = _ref238.if,
      _ref238$sentiment = _ref238.sentiment,
      a = _ref238$sentiment === void 0 ? o && o !== "valid" ? "negative" : "neutral" : _ref238$sentiment,
      i = _objectWithoutProperties(_ref238, _excluded237);
    var c = dt(),
      l = rl(),
      u = (_i$id = i.id) !== null && _i$id !== void 0 ? _i$id : l;
    return V(function () {
      return c.addDescribedById(u);
    }, [u]), pT(c, o) ? null : /* @__PURE__ */p.jsx(t, _objectSpread(_objectSpread({}, i), {}, {
      className: T("goat-Validation", "goat-Validation_".concat(a), r),
      id: u,
      ref: s,
      children: n || vT(o, c)
    }));
  }),
  vT = function vT(e, t) {
    return e === "customError" && t.validity.customError && t.validationMessage;
  };
function pT(e, t) {
  return t ? t === "valid" ? e.touched && !e.validity.valid : e.touched ? t === "invalid" ? e.validity.valid : !e.validity[t] : !0 : !1;
}
var of = he({
    header: null,
    top: 0
  }),
  mT = function mT() {
    var e = ce(of);
    if (!e) throw new Error("VirtualTable compound components cannot be rendered outside the VirtualTable component");
    return e;
  };
function da() {
  return da = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, da.apply(this, arguments);
}
function fc(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fa(e, t) {
  return fa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (r, o) {
    return r.__proto__ = o, r;
  }, fa(e, t);
}
function hT(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, fa(e, t);
}
var vc = Number.isNaN || function (t) {
  return typeof t == "number" && t !== t;
};
function gT(e, t) {
  return !!(e === t || vc(e) && vc(t));
}
function bT(e, t) {
  if (e.length !== t.length) return !1;
  for (var n = 0; n < e.length; n++) if (!gT(e[n], t[n])) return !1;
  return !0;
}
function Fo(e, t) {
  t === void 0 && (t = bT);
  var n,
    r = [],
    o,
    a = !1;
  function i() {
    for (var s = [], c = 0; c < arguments.length; c++) s[c] = arguments[c];
    return a && n === this && t(s, r) || (o = e.apply(this, s), a = !0, n = this, r = s), o;
  }
  return i;
}
var yT = typeof performance == "object" && typeof performance.now == "function",
  pc = yT ? function () {
    return performance.now();
  } : function () {
    return Date.now();
  };
function mc(e) {
  cancelAnimationFrame(e.id);
}
function wT(e, t) {
  var n = pc();
  function r() {
    pc() - n >= t ? e.call(null) : o.id = requestAnimationFrame(r);
  }
  var o = {
    id: requestAnimationFrame(r)
  };
  return o;
}
var Wo = -1;
function hc(e) {
  if (e === void 0 && (e = !1), Wo === -1 || e) {
    var t = document.createElement("div"),
      n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", document.body.appendChild(t), Wo = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Wo;
}
var sn = null;
function gc(e) {
  if (e === void 0 && (e = !1), sn === null || e) {
    var t = document.createElement("div"),
      n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    var r = document.createElement("div"),
      o = r.style;
    return o.width = "100px", o.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? sn = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? sn = "negative" : sn = "positive-ascending"), document.body.removeChild(t), sn;
  }
  return sn;
}
var xT = 150,
  $T = function $T(t, n) {
    return t;
  };
function CT(e) {
  var t,
    n = e.getItemOffset,
    r = e.getEstimatedTotalSize,
    o = e.getItemSize,
    a = e.getOffsetForIndexAndAlignment,
    i = e.getStartIndexForOffset,
    s = e.getStopIndexForStartIndex,
    c = e.initInstanceProps,
    l = e.shouldResetStyleCacheOnItemSizeChange,
    u = e.validateProps;
  return t = /* @__PURE__ */function (d) {
    hT(f, d);
    function f(h) {
      var v;
      return v = d.call(this, h) || this, v._instanceProps = c(v.props, fc(v)), v._outerRef = void 0, v._resetIsScrollingTimeoutId = null, v.state = {
        instance: fc(v),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof v.props.initialScrollOffset == "number" ? v.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, v._callOnItemsRendered = void 0, v._callOnItemsRendered = Fo(function (g, b, y, w) {
        return v.props.onItemsRendered({
          overscanStartIndex: g,
          overscanStopIndex: b,
          visibleStartIndex: y,
          visibleStopIndex: w
        });
      }), v._callOnScroll = void 0, v._callOnScroll = Fo(function (g, b, y) {
        return v.props.onScroll({
          scrollDirection: g,
          scrollOffset: b,
          scrollUpdateWasRequested: y
        });
      }), v._getItemStyle = void 0, v._getItemStyle = function (g) {
        var b = v.props,
          y = b.direction,
          w = b.itemSize,
          I = b.layout,
          P = v._getItemStyleCache(l && w, l && I, l && y),
          D;
        if (P.hasOwnProperty(g)) D = P[g];else {
          var E = n(v.props, g, v._instanceProps),
            _ = o(v.props, g, v._instanceProps),
            O = y === "horizontal" || I === "horizontal",
            A = y === "rtl",
            M = O ? E : 0;
          P[g] = D = {
            position: "absolute",
            left: A ? void 0 : M,
            right: A ? M : void 0,
            top: O ? 0 : E,
            height: O ? "100%" : _,
            width: O ? _ : "100%"
          };
        }
        return D;
      }, v._getItemStyleCache = void 0, v._getItemStyleCache = Fo(function (g, b, y) {
        return {};
      }), v._onScrollHorizontal = function (g) {
        var b = g.currentTarget,
          y = b.clientWidth,
          w = b.scrollLeft,
          I = b.scrollWidth;
        v.setState(function (P) {
          if (P.scrollOffset === w) return null;
          var D = v.props.direction,
            E = w;
          if (D === "rtl") switch (gc()) {
            case "negative":
              E = -w;
              break;
            case "positive-descending":
              E = I - y - w;
              break;
          }
          return E = Math.max(0, Math.min(E, I - y)), {
            isScrolling: !0,
            scrollDirection: P.scrollOffset < w ? "forward" : "backward",
            scrollOffset: E,
            scrollUpdateWasRequested: !1
          };
        }, v._resetIsScrollingDebounced);
      }, v._onScrollVertical = function (g) {
        var b = g.currentTarget,
          y = b.clientHeight,
          w = b.scrollHeight,
          I = b.scrollTop;
        v.setState(function (P) {
          if (P.scrollOffset === I) return null;
          var D = Math.max(0, Math.min(I, w - y));
          return {
            isScrolling: !0,
            scrollDirection: P.scrollOffset < D ? "forward" : "backward",
            scrollOffset: D,
            scrollUpdateWasRequested: !1
          };
        }, v._resetIsScrollingDebounced);
      }, v._outerRefSetter = function (g) {
        var b = v.props.outerRef;
        v._outerRef = g, typeof b == "function" ? b(g) : b != null && typeof b == "object" && b.hasOwnProperty("current") && (b.current = g);
      }, v._resetIsScrollingDebounced = function () {
        v._resetIsScrollingTimeoutId !== null && mc(v._resetIsScrollingTimeoutId), v._resetIsScrollingTimeoutId = wT(v._resetIsScrolling, xT);
      }, v._resetIsScrolling = function () {
        v._resetIsScrollingTimeoutId = null, v.setState({
          isScrolling: !1
        }, function () {
          v._getItemStyleCache(-1, null);
        });
      }, v;
    }
    f.getDerivedStateFromProps = function (v, g) {
      return TT(v, g), u(v), null;
    };
    var m = f.prototype;
    return m.scrollTo = function (v) {
      v = Math.max(0, v), this.setState(function (g) {
        return g.scrollOffset === v ? null : {
          scrollDirection: g.scrollOffset < v ? "forward" : "backward",
          scrollOffset: v,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, m.scrollToItem = function (v, g) {
      g === void 0 && (g = "auto");
      var b = this.props,
        y = b.itemCount,
        w = b.layout,
        I = this.state.scrollOffset;
      v = Math.max(0, Math.min(v, y - 1));
      var P = 0;
      if (this._outerRef) {
        var D = this._outerRef;
        w === "vertical" ? P = D.scrollWidth > D.clientWidth ? hc() : 0 : P = D.scrollHeight > D.clientHeight ? hc() : 0;
      }
      this.scrollTo(a(this.props, v, g, I, this._instanceProps, P));
    }, m.componentDidMount = function () {
      var v = this.props,
        g = v.direction,
        b = v.initialScrollOffset,
        y = v.layout;
      if (typeof b == "number" && this._outerRef != null) {
        var w = this._outerRef;
        g === "horizontal" || y === "horizontal" ? w.scrollLeft = b : w.scrollTop = b;
      }
      this._callPropsCallbacks();
    }, m.componentDidUpdate = function () {
      var v = this.props,
        g = v.direction,
        b = v.layout,
        y = this.state,
        w = y.scrollOffset,
        I = y.scrollUpdateWasRequested;
      if (I && this._outerRef != null) {
        var P = this._outerRef;
        if (g === "horizontal" || b === "horizontal") {
          if (g === "rtl") switch (gc()) {
            case "negative":
              P.scrollLeft = -w;
              break;
            case "positive-ascending":
              P.scrollLeft = w;
              break;
            default:
              var D = P.clientWidth,
                E = P.scrollWidth;
              P.scrollLeft = E - D - w;
              break;
          } else P.scrollLeft = w;
        } else P.scrollTop = w;
      }
      this._callPropsCallbacks();
    }, m.componentWillUnmount = function () {
      this._resetIsScrollingTimeoutId !== null && mc(this._resetIsScrollingTimeoutId);
    }, m.render = function () {
      var v = this.props,
        g = v.children,
        b = v.className,
        y = v.direction,
        w = v.height,
        I = v.innerRef,
        P = v.innerElementType,
        D = v.innerTagName,
        E = v.itemCount,
        _ = v.itemData,
        O = v.itemKey,
        A = O === void 0 ? $T : O,
        M = v.layout,
        B = v.outerElementType,
        G = v.outerTagName,
        N = v.style,
        j = v.useIsScrolling,
        U = v.width,
        L = this.state.isScrolling,
        R = y === "horizontal" || M === "horizontal",
        Y = R ? this._onScrollHorizontal : this._onScrollVertical,
        re = this._getRangeToRender(),
        ae = re[0],
        se = re[1],
        le = [];
      if (E > 0) for (var fe = ae; fe <= se; fe++) le.push(C(g, {
        data: _,
        key: A(fe, _),
        index: fe,
        isScrolling: j ? L : void 0,
        style: this._getItemStyle(fe)
      }));
      var xe = r(this.props, this._instanceProps);
      return C(B || G || "div", {
        className: b,
        onScroll: Y,
        ref: this._outerRefSetter,
        style: da({
          position: "relative",
          height: w,
          width: U,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: y
        }, N)
      }, C(P || D || "div", {
        children: le,
        ref: I,
        style: {
          height: R ? "100%" : xe,
          pointerEvents: L ? "none" : void 0,
          width: R ? xe : "100%"
        }
      }));
    }, m._callPropsCallbacks = function () {
      if (typeof this.props.onItemsRendered == "function") {
        var v = this.props.itemCount;
        if (v > 0) {
          var g = this._getRangeToRender(),
            b = g[0],
            y = g[1],
            w = g[2],
            I = g[3];
          this._callOnItemsRendered(b, y, w, I);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var P = this.state,
          D = P.scrollDirection,
          E = P.scrollOffset,
          _ = P.scrollUpdateWasRequested;
        this._callOnScroll(D, E, _);
      }
    }, m._getRangeToRender = function () {
      var v = this.props,
        g = v.itemCount,
        b = v.overscanCount,
        y = this.state,
        w = y.isScrolling,
        I = y.scrollDirection,
        P = y.scrollOffset;
      if (g === 0) return [0, 0, 0, 0];
      var D = i(this.props, P, this._instanceProps),
        E = s(this.props, D, P, this._instanceProps),
        _ = !w || I === "backward" ? Math.max(1, b) : 1,
        O = !w || I === "forward" ? Math.max(1, b) : 1;
      return [Math.max(0, D - _), Math.max(0, Math.min(g - 1, E + O)), D, E];
    }, f;
  }(cf), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var TT = function TT(t, n) {
    t.children, t.direction, t.height, t.layout, t.innerTagName, t.outerTagName, t.width, n.instance;
  },
  _T = /* @__PURE__ */CT({
    getItemOffset: function getItemOffset(t, n) {
      var r = t.itemSize;
      return n * r;
    },
    getItemSize: function getItemSize(t, n) {
      var r = t.itemSize;
      return r;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(t) {
      var n = t.itemCount,
        r = t.itemSize;
      return r * n;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(t, n, r, o, a, i) {
      var s = t.direction,
        c = t.height,
        l = t.itemCount,
        u = t.itemSize,
        d = t.layout,
        f = t.width,
        m = s === "horizontal" || d === "horizontal",
        h = m ? f : c,
        v = Math.max(0, l * u - h),
        g = Math.min(v, n * u),
        b = Math.max(0, n * u - h + u + i);
      switch (r === "smart" && (o >= b - h && o <= g + h ? r = "auto" : r = "center"), r) {
        case "start":
          return g;
        case "end":
          return b;
        case "center":
          {
            var y = Math.round(b + (g - b) / 2);
            return y < Math.ceil(h / 2) ? 0 : y > v + Math.floor(h / 2) ? v : y;
          }
        case "auto":
        default:
          return o >= b && o <= g ? o : o < b ? b : g;
      }
    },
    getStartIndexForOffset: function getStartIndexForOffset(t, n) {
      var r = t.itemCount,
        o = t.itemSize;
      return Math.max(0, Math.min(r - 1, Math.floor(n / o)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(t, n, r) {
      var o = t.direction,
        a = t.height,
        i = t.itemCount,
        s = t.itemSize,
        c = t.layout,
        l = t.width,
        u = o === "horizontal" || c === "horizontal",
        d = n * s,
        f = u ? l : a,
        m = Math.ceil((f + r - d) / s);
      return Math.max(0, Math.min(i - 1, n + m - 1
      // -1 is because stop index is inclusive
      ));
    },

    initInstanceProps: function initInstanceProps(t) {},
    shouldResetStyleCacheOnItemSizeChange: !0,
    validateProps: function validateProps(t) {
      t.itemSize;
    }
  });
var IT = x(function (_ref239, a) {
    var t = _ref239.children,
      n = _ref239.as,
      r = _ref239.className,
      o = _objectWithoutProperties(_ref239, _excluded238);
    var i = T("goat-VirtualTable_Footer", r),
      s = n !== null && n !== void 0 ? n : "div";
    return /* @__PURE__ */p.jsx(s, _objectSpread(_objectSpread({}, o), {}, {
      className: i,
      ref: a,
      children: t
    }));
  }),
  PT = x(function (_ref240, a) {
    var t = _ref240.children,
      n = _ref240.as,
      r = _ref240.className,
      o = _objectWithoutProperties(_ref240, _excluded239);
    var i = T("goat-VirtualTable_Layout", r),
      s = n !== null && n !== void 0 ? n : "figure";
    return /* @__PURE__ */p.jsx(s, _objectSpread(_objectSpread({}, o), {}, {
      className: i,
      ref: a,
      children: t
    }));
  }),
  DT = x(function (_ref241, r) {
    var t = _ref241.children,
      n = _objectWithoutProperties(_ref241, _excluded240);
    var _mT = mT(),
      o = _mT.top,
      a = _mT.header,
      i = _mT.tableProps,
      s = _mT.footer;
    return /* @__PURE__ */p.jsx("div", _objectSpread(_objectSpread({}, n), {}, {
      children: /* @__PURE__ */p.jsxs($r.Root, _objectSpread(_objectSpread({}, i), {}, {
        ref: r,
        style: {
          top: o,
          position: "absolute",
          width: "100%"
        },
        children: [/* @__PURE__ */p.jsx($r.Head, {
          children: a
        }), /* @__PURE__ */p.jsx($r.Body, {
          children: t
        }), s && /* @__PURE__ */p.jsx($r.Footer, {
          children: s
        })]
      }))
    }));
  });
var ST = 56,
  ET = x(function (_ref242, c) {
    var t = _ref242.children,
      n = _ref242.tableProps,
      r = _ref242.header,
      o = _ref242.footer,
      a = _ref242.onItemsRendered,
      i = _ref242.itemCount,
      s = _objectWithoutProperties(_ref242, _excluded241);
    var l = k(),
      u = Kr(c, l),
      _te95 = te(0),
      _te96 = _slicedToArray(_te95, 2),
      d = _te96[0],
      f = _te96[1];
    return /* @__PURE__ */p.jsx(of.Provider, {
      value: {
        header: r,
        top: d,
        footer: o,
        tableProps: n
      },
      children: /* @__PURE__ */p.jsx(_T, _objectSpread(_objectSpread({}, s), {}, {
        itemCount: i,
        width: "100%",
        itemSize: ST,
        onItemsRendered: function onItemsRendered(m) {
          var h = l.current &&
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          l.current._getItemStyle(m.overscanStartIndex);
          h && f(h.top), a && a(m);
        },
        ref: u,
        children: t
      }))
    });
  }),
  O_ = {
    Table: ET,
    Root: DT,
    Layout: PT,
    Footer: IT
  };
export { Gr as Accordion, zr as AppTopbar, Vc as Badge, Sa as Box, Av as BrandIcon, jv as BrandTag, Zc as Breadcrumb, Fe as Button, el as ButtonGroup, Kv as Card, sl as Checkbox, UT as Chip, KT as Col, Kn as Collapsible, t_ as DatePicker, n_ as Dialog, Vt as Drawer, BT as Field, r_ as Fieldset, o_ as Form, a_ as Grid, zT as H1, ay as H2, qT as H3, XT as H4, QT as H5, je as Icon, Qe as IconButton, jr as Input, i_ as InputWithTags, fi as Label, s_ as Legend, uw as Link, Tn as ListItem, Hv as Loader, mi as Menu, l_ as Notification, ZT as P, hi as Pagination, yt as Panel, y1 as PanelLayout, d_ as PopoverClose, f_ as PopoverContent, v_ as PopoverFooter, p_ as PopoverHeader, m_ as PopoverRoot, h_ as PopoverTrigger, HT as PrimerLoader, b_ as ProgressBar, y_ as Radio, w_ as Row, R1 as Search, rt as Select, Ut as Sidebar, JT as Span, x_ as Square, d$ as StatusTag, zi as Summary, jd as SummaryCollapsible, C_ as Switch, __ as Tab, tC as TabContent, aC as TabList, iC as TabRoot, nC as TabTrigger, $r as Table, I_ as Tabs, vn as Tag, Ge as Text, ur as Toast, No as Toggle, rf as Tooltip, Da as Topbar, S_ as TrendTag, E_ as Validation, O_ as VirtualTable, LT as animationTimingFunction, vv as borderRadius, yn as color, _a as composeRefs, AT as contrasts, T as cx, RT as sentiments, Uo as setInputValue, fv as shallowClone, Fc as shallowEquals, Wc as space, Ta as sx, jT as time, FT as typography, VT as useCheckboxGroup, Kr as useComposedRefs, rs as useControllableState, Iv as useDebounce, dt as useField, Pa as useForwardedRef, u_ as usePagination, Hc as usePrevious, Bc as useReRender, WT as useReRenderEffect, Et as useSelectContext, mT as useVirtualTableContext };